(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["vue"], factory);
	else if(typeof exports === 'object')
		exports["KendoAllVueWrapper"] = factory(require("vue"));
	else
		root["KendoAllVueWrapper"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 136);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KendoSharedMethods = exports.KendoBaseInputComponent = exports.KendoBaseDatasourceComponent = exports.KendoBaseComponent = undefined;

var _kendoBaseComponent = __webpack_require__(139);

var _kendoBaseComponent2 = _interopRequireDefault(_kendoBaseComponent);

var _kendoBaseDatasourceComponent = __webpack_require__(140);

var _kendoBaseDatasourceComponent2 = _interopRequireDefault(_kendoBaseDatasourceComponent);

var _kendoBaseInputComponent = __webpack_require__(141);

var _kendoBaseInputComponent2 = _interopRequireDefault(_kendoBaseInputComponent);

var _kendoSharedMethods = __webpack_require__(142);

var _kendoSharedMethods2 = _interopRequireDefault(_kendoSharedMethods);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoBaseComponent = _kendoBaseComponent2.default;
exports.KendoBaseDatasourceComponent = _kendoBaseDatasourceComponent2.default;
exports.KendoBaseInputComponent = _kendoBaseInputComponent2.default;
exports.KendoSharedMethods = _kendoSharedMethods2.default;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        filterField: {
            type: String,
            default: undefined,
            kComposite: 'filter.field'
        },
        filterFilters: {
            type: Array,
            default: undefined,
            kComposite: 'filter.filters'
        },
        filterLogic: {
            type: String,
            default: undefined,
            kComposite: 'filter.logic'
        },
        filterOperator: {
            type: [String, Function],
            default: undefined,
            kComposite: 'filter.operator'
        },
        filterValue: {
            type: [Object, Date, Number, String],
            default: undefined,
            kComposite: 'filter.value'
        }
    }
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        groupAggregates: {
            type: Array,
            default: undefined,
            kComposite: 'group.aggregates'
        },
        groupDir: {
            type: String,
            default: undefined,
            kComposite: 'group.dir'
        },
        groupField: {
            type: String,
            default: undefined,
            kComposite: 'group.field'
        }
    }
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        sortDir: {
            type: String,
            default: undefined,
            kComposite: 'sort.dir'
        },
        sortField: {
            type: String,
            default: undefined,
            kComposite: 'sort.field'
        },
        sortCompare: {
            type: Function,
            default: undefined,
            kComposite: 'sort.compare'
        }
    }
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoDataSourceBaseMixin = __webpack_require__(187);

var _KendoDataSourceBaseMixin2 = _interopRequireDefault(_KendoDataSourceBaseMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-datasource',
    mixins: [_KendoDataSourceBaseMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('div');
    }
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        transportCreate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.create'
        },
        transportCreateCache: {
            type: Boolean,
            default: undefined,
            kComposite: 'transport.create.cache'
        },
        transportCreateContentType: {
            type: String,
            default: undefined,
            kComposite: 'transport.create.contentType'
        },
        transportCreateData: {
            type: [Object, Function],
            default: undefined,
            kComposite: 'transport.create.data'
        },
        transportCreateDataType: {
            type: String,
            default: undefined,
            kComposite: 'transport.create.dataType'
        },
        transportCreateType: {
            type: String,
            default: undefined,
            kComposite: 'transport.create.type'
        },
        transportCreateUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.create.url'
        },
        transportDestroy: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.destroy'
        },
        transportDestroyCache: {
            type: Boolean,
            default: undefined,
            kComposite: 'transport.destroy.cache'
        },
        transportDestroyContentType: {
            type: String,
            default: undefined,
            kComposite: 'transport.destroy.contentType'
        },
        transportDestroyData: {
            type: [Object, Function],
            default: undefined,
            kComposite: 'transport.destroy.data'
        },
        transportDestroyDataType: {
            type: String,
            default: undefined,
            kComposite: 'transport.destroy.dataType'
        },
        transportDestroyType: {
            type: String,
            default: undefined,
            kComposite: 'transport.destroy.type'
        },
        transportDestroyUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.destroy.url'
        },
        transportParameterMap: {
            type: Function,
            default: undefined,
            kComposite: 'transport.parameterMap'
        },
        transportPush: {
            type: Function,
            default: undefined,
            kComposite: 'transport.push'
        },
        transportRead: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.read'
        },
        transportReadCache: {
            type: Boolean,
            default: undefined,
            kComposite: 'transport.read.cache'
        },
        transportReadContentType: {
            type: String,
            default: undefined,
            kComposite: 'transport.read.contentType'
        },
        transportReadData: {
            type: [Object, Function],
            default: undefined,
            kComposite: 'transport.read.data'
        },
        transportReadDataType: {
            type: String,
            default: undefined,
            kComposite: 'transport.read.dataType'
        },
        transportReadType: {
            type: String,
            default: undefined,
            kComposite: 'transport.read.type'
        },
        transportReadUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.read.url'
        },
        transportSignalrClientCreate: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.client.create'
        },
        transportSignalrClientDestroy: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.client.destroy'
        },
        transportSignalrClientRead: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.client.read'
        },
        transportSignalrClientUpdate: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.client.update'
        },
        transportSignalrHub: {
            type: Object,
            default: undefined,
            kComposite: 'transport.signalr.hub'
        },
        transportSignalrPromise: {
            type: Object,
            default: undefined,
            kComposite: 'transport.signalr.promise'
        },
        transportSignalrServerCreate: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.server.create'
        },
        transportSignalrServerDestroy: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.server.destroy'
        },
        transportSignalrServerRead: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.server.read'
        },
        transportSignalrServerUpdate: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.server.update'
        },
        transportSubmit: {
            type: Function,
            default: undefined,
            kComposite: 'transport.submit'
        },
        transportUpdate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.update'
        },
        transportUpdateCache: {
            type: Boolean,
            default: undefined,
            kComposite: 'transport.update.cache'
        },
        transportUpdateContentType: {
            type: String,
            default: undefined,
            kComposite: 'transport.update.contentType'
        },
        transportUpdateData: {
            type: [Object, Function],
            default: undefined,
            kComposite: 'transport.update.data'
        },
        transportUpdateDataType: {
            type: String,
            default: undefined,
            kComposite: 'transport.update.dataType'
        },
        transportUpdateType: {
            type: String,
            default: undefined,
            kComposite: 'transport.update.type'
        },
        transportUpdateUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.update.url'
        }
    }
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        animationCloseEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.close.effects'
        },
        animationCloseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.close.duration'
        },
        animationOpenEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.open.effects'
        },
        animationOpenDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.open.duration'
        }
    }
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        virtualItemHeight: {
            type: Number,
            default: undefined,
            kComposite: 'virtual.itemHeight'
        },
        virtualMapValueTo: {
            type: String,
            default: undefined,
            kComposite: 'virtual.mapValueTo'
        },
        virtualValueMapper: {
            type: Function,
            default: undefined,
            kComposite: 'virtual.valueMapper'
        }
    }
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        popupAppendTo: {
            type: String,
            default: undefined,
            kComposite: 'popup.appendTo'
        },
        popupOrigin: {
            type: String,
            default: undefined,
            kComposite: 'popup.origin'
        },
        popupPosition: {
            type: String,
            default: undefined,
            kComposite: 'popup.position'
        }
    }
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Items = __webpack_require__(158);

var _Items2 = _interopRequireDefault(_Items);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'kendo-toolbar-item',
    render: function render() {
        return null;
    },

    mixins: [_Items2.default]
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Series = __webpack_require__(164);

var _Series2 = _interopRequireDefault(_Series);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoChartSeriesItem = {
    name: 'kendo-chart-series-item',
    render: function render() {
        return null;
    },

    mixins: [_Series2.default]
};

exports.default = KendoChartSeriesItem;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SeriesProps = __webpack_require__(170);

var _SeriesProps2 = _interopRequireDefault(_SeriesProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoSparklineSeriesItem = {
    name: 'kendo-sparkline-series-item',
    render: function render() {
        return null;
    },

    mixins: [_SeriesProps2.default]
};

exports.default = KendoSparklineSeriesItem;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;

exports.default = {
    name: 'kendo-chat-toolbar-button',
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render() {
        return null;
    },

    props: {
        name: {
            type: String,
            default: undefined
        },
        text: {
            type: String,
            default: undefined
        },
        iconClass: {
            type: String,
            default: undefined
        },
        attr: {
            type: Object,
            default: undefined
        }
    },
    watch: {
        $attrs: function $attrs() {
            this.mergeAttrs();
        }
    },
    mounted: function mounted() {
        if (!this.v3) {
            this.mergeAttrs();
        }
    },

    methods: {
        mergeAttrs: function mergeAttrs() {
            if (this.$options.propsData.attr) {
                this.attr = Object.assign(this.attr, this.$attrs);
            } else {
                this.$options.propsData.attr = Object.assign({}, this.attr, this.$attrs);
            }
        }
    }
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Columns = __webpack_require__(204);

var _Columns2 = _interopRequireDefault(_Columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoPivotGridColumn = {
    name: 'kendo-pivot-column',
    render: function render() {
        return null;
    },

    mixins: [_Columns2.default]
};

exports.default = KendoPivotGridColumn;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Measures = __webpack_require__(205);

var _Measures2 = _interopRequireDefault(_Measures);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoPivotGridMeasure = {
    name: 'kendo-pivot-measure',
    render: function render() {
        return null;
    },

    mixins: [_Measures2.default]
};

exports.default = KendoPivotGridMeasure;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Rows = __webpack_require__(206);

var _Rows2 = _interopRequireDefault(_Rows);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoPivotGridRow = {
    name: 'kendo-pivot-row',
    render: function render() {
        return null;
    },

    mixins: [_Rows2.default]
};

exports.default = KendoPivotGridRow;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        monthContent: {
            type: String,
            default: undefined,
            kComposite: 'month.content'
        },
        monthWeekNumber: {
            type: String,
            default: undefined,
            kComposite: 'month.weekNumber'
        },
        monthEmpty: {
            type: String,
            default: undefined,
            kComposite: 'month.empty'
        }
    }
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        animationCloseEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.close.effects'
        },
        animationCloseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.close.duration'
        },
        animationOpenEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.open.effects'
        },
        animationOpenDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.open.duration'
        }
    }
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ConnectionProps = __webpack_require__(237);

var _ConnectionProps2 = _interopRequireDefault(_ConnectionProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'kendo-diagram-connection',
    render: function render() {
        return null;
    },

    mixins: [_ConnectionProps2.default]
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ShapeProps = __webpack_require__(238);

var _ShapeProps2 = _interopRequireDefault(_ShapeProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'kendo-diagram-shape',
    render: function render() {
        return null;
    },

    mixins: [_ShapeProps2.default]
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ActionProps = __webpack_require__(250);

var _ActionProps2 = _interopRequireDefault(_ActionProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoDialogAction = {
    name: 'kendo-dialog-action',
    render: function render() {
        return null;
    },

    mixins: [_ActionProps2.default]
};

exports.default = KendoDialogAction;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Columns = __webpack_require__(264);

var _Columns2 = _interopRequireDefault(_Columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoGridColumn = {
    name: 'kendo-multicolumncombobox-column',
    render: function render() {
        return null;
    },

    mixins: [_Columns2.default]
};

exports.default = KendoGridColumn;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Tools = __webpack_require__(279);

var _Tools2 = _interopRequireDefault(_Tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoEditorTool = {
    name: 'kendo-editor-tool',
    render: function render() {
        return null;
    },

    mixins: [_Tools2.default]
};

exports.default = KendoEditorTool;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Columns = __webpack_require__(293);

var _Columns2 = _interopRequireDefault(_Columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoGanttColumn = {
    name: 'kendo-gantt-column',
    render: function render() {
        return null;
    },

    mixins: [_Columns2.default]
};

exports.default = KendoGanttColumn;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Views = __webpack_require__(294);

var _Views2 = _interopRequireDefault(_Views);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoGanttView = {
    name: 'kendo-gantt-view',
    render: function render() {
        return null;
    },

    mixins: [_Views2.default]
};

exports.default = KendoGanttView;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ColorsProps = __webpack_require__(308);

var _ColorsProps2 = _interopRequireDefault(_ColorsProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoArcGaugeColor = {
    name: 'kendo-arcgauge-color',
    render: function render() {
        return null;
    },

    mixins: [_ColorsProps2.default]
};

exports.default = KendoArcGaugeColor;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        gaugeAreaBackground: {
            type: Object,
            default: undefined,
            kComposite: 'gaugeArea.background'
        },
        gaugeAreaBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'gaugeArea.border.color'
        },
        gaugeAreaBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'gaugeArea.border.dashType'
        },
        gaugeAreaBorderOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'gaugeArea.border.opacity'
        },
        gaugeAreaBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'gaugeArea.border.width'
        },
        gaugeAreaHeight: {
            type: Number,
            default: undefined,
            kComposite: 'gaugeArea.height'
        },
        gaugeAreaMargin: {
            type: Number,
            default: undefined,
            kComposite: 'gaugeArea.margin'
        },
        gaugeAreaMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'gaugeArea.margin.top'
        },
        gaugeAreaMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'gaugeArea.margin.bottom'
        },
        gaugeAreaMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'gaugeArea.margin.left'
        },
        gaugeAreaMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'gaugeArea.margin.right'
        },
        gaugeAreaWidth: {
            type: Number,
            default: undefined,
            kComposite: 'gaugeArea.width'
        }
    }
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PointerProps = __webpack_require__(312);

var _PointerProps2 = _interopRequireDefault(_PointerProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoLinearGaugePointer = {
    name: 'kendo-lineargauge-pointer',
    render: function render() {
        return null;
    },

    mixins: [_PointerProps2.default]
};

exports.default = KendoLinearGaugePointer;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PointerProps = __webpack_require__(316);

var _PointerProps2 = _interopRequireDefault(_PointerProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoRadialGaugePointer = {
    name: 'kendo-radialgauge-pointer',
    render: function render() {
        return null;
    },

    mixins: [_PointerProps2.default]
};

exports.default = KendoRadialGaugePointer;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Columns = __webpack_require__(321);

var _Columns2 = _interopRequireDefault(_Columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoGridColumn = {
    name: 'kendo-grid-column',
    render: function render() {
        return null;
    },

    mixins: [_Columns2.default]
};

exports.default = KendoGridColumn;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        scrollableDistance: {
            type: Number,
            default: undefined,
            kComposite: 'scrollable.distance'
        }
    }
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PaneProps = __webpack_require__(374);

var _PaneProps2 = _interopRequireDefault(_PaneProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoSplitterPane = {
    name: 'kendo-splitter-pane',
    render: function render() {
        return null;
    },

    mixins: [_PaneProps2.default]
};

exports.default = KendoSplitterPane;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _MarkerProps = __webpack_require__(393);

var _MarkerProps2 = _interopRequireDefault(_MarkerProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'kendo-map-marker',
    render: function render() {
        return null;
    },

    mixins: [_MarkerProps2.default]
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LayerProps = __webpack_require__(394);

var _LayerProps2 = _interopRequireDefault(_LayerProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'kendo-map-layer',
    render: function render() {
        return null;
    },

    mixins: [_LayerProps2.default]
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Resources = __webpack_require__(427);

var _Resources2 = _interopRequireDefault(_Resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoSchedulerResource = {
    name: 'kendo-scheduler-resource',
    render: function render() {
        return null;
    },

    mixins: [_Resources2.default]
};

exports.default = KendoSchedulerResource;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Views = __webpack_require__(428);

var _Views2 = _interopRequireDefault(_Views);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoSchedulerView = {
    name: 'kendo-scheduler-view',
    render: function render() {
        return null;
    },

    mixins: [_Views2.default]
};

exports.default = KendoSchedulerView;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SheetProps = __webpack_require__(444);

var _SheetProps2 = _interopRequireDefault(_SheetProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'kendo-spreadsheet-sheet',
    render: function render() {
        return null;
    },

    mixins: [_SheetProps2.default]
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Columns = __webpack_require__(453);

var _Columns2 = _interopRequireDefault(_Columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoTreeListColumn = {
    name: 'kendo-treelist-column',
    render: function render() {
        return null;
    },

    mixins: [_Columns2.default]
};

exports.default = KendoTreeListColumn;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoBarcodeMixin = __webpack_require__(138);

var _KendoBarcodeMixin2 = _interopRequireDefault(_KendoBarcodeMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h; // eslint-disable-line
exports.default = {
    name: 'kendo-barcode',
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('span');
    },

    mixins: [_KendoBarcodeMixin2.default]
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoQRCodeMixin = __webpack_require__(147);

var _KendoQRCodeMixin2 = _interopRequireDefault(_KendoQRCodeMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-qrcode',
    mixins: [_KendoQRCodeMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('span');
    }
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoButtonMixin = __webpack_require__(152);

var _KendoButtonMixin2 = _interopRequireDefault(_KendoButtonMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue; // @ts-ignore

var gh = allVue.h;
exports.default = {
    name: 'kendo-button',
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('button', defaultSlot);
    },

    mixins: [_KendoButtonMixin2.default]
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoButtonGroupMixin = __webpack_require__(154);

var _KendoButtonGroupMixin2 = _interopRequireDefault(_KendoButtonGroupMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-buttongroup',
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('ul', defaultSlot);
    },

    mixins: [_KendoButtonGroupMixin2.default]
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;

exports.default = {
    name: 'kendo-buttongroup-button',
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;

        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('li', defaultSlot);
    }
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoToolBarMixin = __webpack_require__(156);

var _KendoToolBarMixin2 = _interopRequireDefault(_KendoToolBarMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-toolbar',
    mixins: [_KendoToolBarMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoChartMixin = __webpack_require__(161);

var _KendoChartMixin2 = _interopRequireDefault(_KendoChartMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-chart',
    mixins: [_KendoChartMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('div');
    }
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoChartMixinBase = __webpack_require__(162);

var _KendoChartMixinBase2 = _interopRequireDefault(_KendoChartMixinBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-chart',
    mixins: [_KendoChartMixinBase2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;

        return h('div', defaultSlot);
    }
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        axisDefaultsBackground: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.background'
        },
        axisDefaultsColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.color'
        },
        axisDefaultsCrosshairColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.color'
        },
        axisDefaultsCrosshairDashType: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.dashType'
        },
        axisDefaultsCrosshairOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.opacity'
        },
        axisDefaultsCrosshairTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.background'
        },
        axisDefaultsCrosshairTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.border.color'
        },
        axisDefaultsCrosshairTooltipBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.border.dashType'
        },
        axisDefaultsCrosshairTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.border.width'
        },
        axisDefaultsCrosshairTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.color'
        },
        axisDefaultsCrosshairTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.font'
        },
        axisDefaultsCrosshairTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.format'
        },
        axisDefaultsCrosshairTooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.padding'
        },
        axisDefaultsCrosshairTooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.padding.bottom'
        },
        axisDefaultsCrosshairTooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.padding.left'
        },
        axisDefaultsCrosshairTooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.padding.right'
        },
        axisDefaultsCrosshairTooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.padding.top'
        },
        axisDefaultsCrosshairTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.template'
        },
        axisDefaultsCrosshairTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.visible'
        },
        axisDefaultsCrosshairVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.visible'
        },
        axisDefaultsCrosshairWidth: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.width'
        },
        axisDefaultsLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.labels.font'
        },
        axisDefaultsLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.labels.format'
        },
        axisDefaultsLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.margin'
        },
        axisDefaultsLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.margin.bottom'
        },
        axisDefaultsLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.margin.left'
        },
        axisDefaultsLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.margin.right'
        },
        axisDefaultsLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.margin.top'
        },
        axisDefaultsLabelsMirror: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.labels.mirror'
        },
        axisDefaultsLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.padding'
        },
        axisDefaultsLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.padding.bottom'
        },
        axisDefaultsLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.padding.left'
        },
        axisDefaultsLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.padding.right'
        },
        axisDefaultsLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.padding.top'
        },
        axisDefaultsLabelsRotation: {
            type: [Number, String],
            default: undefined,
            kComposite: 'axisDefaults.labels.rotation'
        },
        axisDefaultsLabelsRotationAlign: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.labels.rotation.align'
        },
        axisDefaultsLabelsRotationAngle: {
            type: [Number, String],
            default: undefined,
            kComposite: 'axisDefaults.labels.rotation.angle'
        },
        axisDefaultsLabelsSkip: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.skip'
        },
        axisDefaultsLabelsStep: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.step'
        },
        axisDefaultsLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'axisDefaults.labels.template'
        },
        axisDefaultsLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.labels.visible'
        },
        axisDefaultsLabelsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'axisDefaults.labels.visual'
        },
        axisDefaultsLineColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.line.color'
        },
        axisDefaultsLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.line.dashType'
        },
        axisDefaultsLineVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.line.visible'
        },
        axisDefaultsLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.line.width'
        },
        axisDefaultsMajorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.majorGridLines.color'
        },
        axisDefaultsMajorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.majorGridLines.dashType'
        },
        axisDefaultsMajorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.majorGridLines.visible'
        },
        axisDefaultsMajorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.majorGridLines.width'
        },
        axisDefaultsMajorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.majorGridLines.step'
        },
        axisDefaultsMajorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.majorGridLines.skip'
        },
        axisDefaultsMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.majorTicks.color'
        },
        axisDefaultsMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.majorTicks.size'
        },
        axisDefaultsMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.majorTicks.visible'
        },
        axisDefaultsMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.majorTicks.width'
        },
        axisDefaultsMajorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.majorTicks.step'
        },
        axisDefaultsMajorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.majorTicks.skip'
        },
        axisDefaultsMinorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.minorGridLines.color'
        },
        axisDefaultsMinorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.minorGridLines.dashType'
        },
        axisDefaultsMinorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.minorGridLines.visible'
        },
        axisDefaultsMinorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.minorGridLines.width'
        },
        axisDefaultsMinorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.minorGridLines.step'
        },
        axisDefaultsMinorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.minorGridLines.skip'
        },
        axisDefaultsMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.minorTicks.color'
        },
        axisDefaultsMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.minorTicks.size'
        },
        axisDefaultsMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.minorTicks.visible'
        },
        axisDefaultsMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.minorTicks.width'
        },
        axisDefaultsMinorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.minorTicks.step'
        },
        axisDefaultsMinorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.minorTicks.skip'
        },
        axisDefaultsNarrowRange: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.narrowRange'
        },
        axisDefaultsPane: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.pane'
        },
        axisDefaultsPlotBands: {
            type: Array,
            default: undefined,
            kComposite: 'axisDefaults.plotBands'
        }, axisDefaultsReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.reverse'
        },
        axisDefaultsStartAngle: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.startAngle'
        },
        axisDefaultsTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.title.background'
        },
        axisDefaultsTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.title.border.color'
        },
        axisDefaultsTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.title.border.dashType'
        },
        axisDefaultsTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.border.width'
        },
        axisDefaultsTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.title.color'
        },
        axisDefaultsTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.title.font'
        },
        axisDefaultsTitleMargin: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.margin'
        },
        axisDefaultsTitleMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.margin.bottom'
        },
        axisDefaultsTitleMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.margin.left'
        },
        axisDefaultsTitleMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.margin.right'
        },
        axisDefaultsTitleMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.margin.top'
        },
        axisDefaultsTitlePadding: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.padding'
        },
        axisDefaultsTitlePaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.padding.bottom'
        },
        axisDefaultsTitlePaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.padding.left'
        },
        axisDefaultsTitlePaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.padding.right'
        },
        axisDefaultsTitlePaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.padding.top'
        },
        axisDefaultsTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.title.position'
        },
        axisDefaultsTitleRotation: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.rotation'
        },
        axisDefaultsTitleText: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.title.text'
        },
        axisDefaultsTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.title.visible'
        },
        axisDefaultsTitleVisual: {
            type: Function,
            default: undefined,
            kComposite: 'axisDefaults.title.visual'
        },
        axisDefaultsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.visible'
        }
    }
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        categoryAxisAutoBaseUnitStepsMilliseconds: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.autoBaseUnitSteps.milliseconds'
        },
        categoryAxisAutoBaseUnitStepsSeconds: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.autoBaseUnitSteps.seconds'
        },
        categoryAxisAutoBaseUnitStepsMinutes: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.autoBaseUnitSteps.minutes'
        },
        categoryAxisAutoBaseUnitStepsHours: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.autoBaseUnitSteps.hours'
        },
        categoryAxisAutoBaseUnitStepsDays: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.autoBaseUnitSteps.days'
        },
        categoryAxisAutoBaseUnitStepsWeeks: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.autoBaseUnitSteps.weeks'
        },
        categoryAxisAutoBaseUnitStepsMonths: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.autoBaseUnitSteps.months'
        },
        categoryAxisAutoBaseUnitStepsYears: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.autoBaseUnitSteps.years'
        },
        categoryAxisAxisCrossingValue: {
            type: [Object, Date, Array, String, Number],
            default: undefined,
            kComposite: 'categoryAxis.axisCrossingValue'
        },
        categoryAxisBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.background'
        },
        categoryAxisBaseUnit: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.baseUnit'
        },
        categoryAxisBaseUnitStep: {
            type: [Number, String],
            default: undefined,
            kComposite: 'categoryAxis.baseUnitStep'
        },
        categoryAxisCategories: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.categories'
        },
        categoryAxisColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.color'
        },
        categoryAxisCrosshairColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.color'
        },
        categoryAxisCrosshairDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.dashType'
        },
        categoryAxisCrosshairOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.opacity'
        },
        categoryAxisCrosshairTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.background'
        },
        categoryAxisCrosshairTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.border.color'
        },
        categoryAxisCrosshairTooltipBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.border.dashType'
        },
        categoryAxisCrosshairTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.border.width'
        },
        categoryAxisCrosshairTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.color'
        },
        categoryAxisCrosshairTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.font'
        },
        categoryAxisCrosshairTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.format'
        },
        categoryAxisCrosshairTooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.padding'
        },
        categoryAxisCrosshairTooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.padding.bottom'
        },
        categoryAxisCrosshairTooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.padding.left'
        },
        categoryAxisCrosshairTooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.padding.right'
        },
        categoryAxisCrosshairTooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.padding.top'
        },
        categoryAxisCrosshairTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.template'
        },
        categoryAxisCrosshairTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.tooltip.visible'
        },
        categoryAxisCrosshairVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.visible'
        },
        categoryAxisCrosshairWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.crosshair.width'
        },
        categoryAxisField: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.field'
        },
        categoryAxisJustified: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.justified'
        },
        categoryAxisLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.background'
        },
        categoryAxisLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.border.color'
        },
        categoryAxisLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.border.dashType'
        },
        categoryAxisLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.border.width'
        },
        categoryAxisLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.color'
        },
        categoryAxisLabelsCulture: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.culture'
        },
        categoryAxisLabelsDateFormatsDays: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.dateFormats.days'
        },
        categoryAxisLabelsDateFormatsHours: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.dateFormats.hours'
        },
        categoryAxisLabelsDateFormatsMonths: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.dateFormats.months'
        },
        categoryAxisLabelsDateFormatsWeeks: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.dateFormats.weeks'
        },
        categoryAxisLabelsDateFormatsYears: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.dateFormats.years'
        },
        categoryAxisLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.font'
        },
        categoryAxisLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.format'
        },
        categoryAxisLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.margin'
        },
        categoryAxisLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.margin.bottom'
        },
        categoryAxisLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.margin.left'
        },
        categoryAxisLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.margin.right'
        },
        categoryAxisLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.margin.top'
        },
        categoryAxisLabelsMirror: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.labels.mirror'
        },
        categoryAxisLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.padding'
        },
        categoryAxisLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.padding.bottom'
        },
        categoryAxisLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.padding.left'
        },
        categoryAxisLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.padding.right'
        },
        categoryAxisLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.padding.top'
        },
        categoryAxisLabelsRotation: {
            type: [Number, String],
            default: undefined,
            kComposite: 'categoryAxis.labels.rotation'
        },
        categoryAxisLabelsRotationAlign: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.labels.rotation.align'
        },
        categoryAxisLabelsRotationAngle: {
            type: [Number, String],
            default: undefined,
            kComposite: 'categoryAxis.labels.rotation.angle'
        },
        categoryAxisLabelsSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.skip'
        },
        categoryAxisLabelsStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.labels.step'
        },
        categoryAxisLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'categoryAxis.labels.template'
        },
        categoryAxisLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.labels.visible'
        },
        categoryAxisLabelsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'categoryAxis.labels.visual'
        },
        categoryAxisLineColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.line.color'
        },
        categoryAxisLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.line.dashType'
        },
        categoryAxisLineVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.line.visible'
        },
        categoryAxisLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.line.width'
        },
        categoryAxisMajorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.majorGridLines.color'
        },
        categoryAxisMajorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.majorGridLines.dashType'
        },
        categoryAxisMajorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.majorGridLines.visible'
        },
        categoryAxisMajorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.majorGridLines.width'
        },
        categoryAxisMajorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.majorGridLines.step'
        },
        categoryAxisMajorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.majorGridLines.skip'
        },
        categoryAxisMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.majorTicks.color'
        },
        categoryAxisMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.majorTicks.size'
        },
        categoryAxisMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.majorTicks.visible'
        },
        categoryAxisMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.majorTicks.width'
        },
        categoryAxisMajorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.majorTicks.step'
        },
        categoryAxisMajorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.majorTicks.skip'
        },
        categoryAxisMax: {
            type: [Object, Number],
            default: undefined,
            kComposite: 'categoryAxis.max'
        },
        categoryAxisMaxDateGroups: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.maxDateGroups'
        },
        categoryAxisMin: {
            type: [Object, Number],
            default: undefined,
            kComposite: 'categoryAxis.min'
        },
        categoryAxisMinorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.minorGridLines.color'
        },
        categoryAxisMinorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.minorGridLines.dashType'
        },
        categoryAxisMinorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.minorGridLines.visible'
        },
        categoryAxisMinorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.minorGridLines.width'
        },
        categoryAxisMinorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.minorGridLines.step'
        },
        categoryAxisMinorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.minorGridLines.skip'
        },
        categoryAxisMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.minorTicks.color'
        },
        categoryAxisMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.minorTicks.size'
        },
        categoryAxisMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.minorTicks.visible'
        },
        categoryAxisMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.minorTicks.width'
        },
        categoryAxisMinorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.minorTicks.step'
        },
        categoryAxisMinorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.minorTicks.skip'
        },
        categoryAxisName: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.name'
        },
        categoryAxisPane: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.pane'
        },
        categoryAxisPlotBands: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.plotBands'
        }, categoryAxisReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.reverse'
        },
        categoryAxisRoundToBaseUnit: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.roundToBaseUnit'
        },
        categoryAxisSelectFrom: {
            type: Object,
            default: undefined,
            kComposite: 'categoryAxis.select.from'
        },
        categoryAxisSelectMax: {
            type: [Object, Number],
            default: undefined,
            kComposite: 'categoryAxis.select.max'
        },
        categoryAxisSelectMin: {
            type: [Object, Number],
            default: undefined,
            kComposite: 'categoryAxis.select.min'
        },
        categoryAxisSelectMousewheelReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.select.mousewheel.reverse'
        },
        categoryAxisSelectMousewheelZoom: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.select.mousewheel.zoom'
        },
        categoryAxisSelectTo: {
            type: Object,
            default: undefined,
            kComposite: 'categoryAxis.select.to'
        },
        categoryAxisStartAngle: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.startAngle'
        },
        categoryAxisTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.title.background'
        },
        categoryAxisTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.title.border.color'
        },
        categoryAxisTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.title.border.dashType'
        },
        categoryAxisTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.border.width'
        },
        categoryAxisTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.title.color'
        },
        categoryAxisTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.title.font'
        },
        categoryAxisTitleMargin: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.margin'
        },
        categoryAxisTitleMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.margin.bottom'
        },
        categoryAxisTitleMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.margin.left'
        },
        categoryAxisTitleMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.margin.right'
        },
        categoryAxisTitleMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.margin.top'
        },
        categoryAxisTitlePadding: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.padding'
        },
        categoryAxisTitlePaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.padding.bottom'
        },
        categoryAxisTitlePaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.padding.left'
        },
        categoryAxisTitlePaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.padding.right'
        },
        categoryAxisTitlePaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.padding.top'
        },
        categoryAxisTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.title.position'
        },
        categoryAxisTitleRotation: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.title.rotation'
        },
        categoryAxisTitleText: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.title.text'
        },
        categoryAxisTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.title.visible'
        },
        categoryAxisTitleVisual: {
            type: Function,
            default: undefined,
            kComposite: 'categoryAxis.title.visual'
        },
        categoryAxisType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.type'
        },
        categoryAxisVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.visible'
        },
        categoryAxisWeekStartDay: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.weekStartDay'
        },
        categoryAxisNotesPosition: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.position'
        },
        categoryAxisNotesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.icon.background'
        },
        categoryAxisNotesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.icon.border.color'
        },
        categoryAxisNotesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.notes.icon.border.width'
        },
        categoryAxisNotesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.notes.icon.size'
        },
        categoryAxisNotesIconType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.icon.type'
        },
        categoryAxisNotesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.notes.icon.visible'
        },
        categoryAxisNotesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.background'
        },
        categoryAxisNotesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.border.color'
        },
        categoryAxisNotesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.border.dashType'
        },
        categoryAxisNotesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.border.width'
        },
        categoryAxisNotesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.color'
        },
        categoryAxisNotesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.font'
        },
        categoryAxisNotesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'categoryAxis.notes.label.template'
        },
        categoryAxisNotesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.visible'
        },
        categoryAxisNotesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.rotation'
        },
        categoryAxisNotesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.format'
        },
        categoryAxisNotesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.label.position'
        },
        categoryAxisNotesLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.line.dashType'
        },
        categoryAxisNotesLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.notes.line.width'
        },
        categoryAxisNotesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.notes.line.color'
        },
        categoryAxisNotesLineLength: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.notes.line.length'
        },
        categoryAxisNotesData: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.notes.data'
        }, categoryAxisNotesVisual: {
            type: Function,
            default: undefined,
            kComposite: 'categoryAxis.notes.visual'
        }
    }
};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        chartAreaBackground: {
            type: String,
            default: undefined,
            kComposite: 'chartArea.background'
        },
        chartAreaBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'chartArea.border.color'
        },
        chartAreaBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'chartArea.border.dashType'
        },
        chartAreaBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.border.width'
        },
        chartAreaHeight: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.height'
        },
        chartAreaMargin: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.margin'
        },
        chartAreaMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.margin.bottom'
        },
        chartAreaMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.margin.left'
        },
        chartAreaMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.margin.right'
        },
        chartAreaMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.margin.top'
        },
        chartAreaOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.opacity'
        },
        chartAreaWidth: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.width'
        }
    }
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        legendAlign: {
            type: String,
            default: undefined,
            kComposite: 'legend.align'
        },
        legendBackground: {
            type: String,
            default: undefined,
            kComposite: 'legend.background'
        },
        legendBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'legend.border.color'
        },
        legendBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'legend.border.dashType'
        },
        legendBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'legend.border.width'
        },
        legendHeight: {
            type: Number,
            default: undefined,
            kComposite: 'legend.height'
        },
        legendInactiveItemsLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'legend.inactiveItems.labels.color'
        },
        legendInactiveItemsLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'legend.inactiveItems.labels.font'
        },
        legendInactiveItemsLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'legend.inactiveItems.labels.template'
        },
        legendItemCursor: {
            type: String,
            default: undefined,
            kComposite: 'legend.item.cursor'
        },
        legendItemVisual: {
            type: Function,
            default: undefined,
            kComposite: 'legend.item.visual'
        },
        legendLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'legend.labels.color'
        },
        legendLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'legend.labels.font'
        },
        legendLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.margin'
        },
        legendLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.margin.bottom'
        },
        legendLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.margin.left'
        },
        legendLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.margin.right'
        },
        legendLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.margin.top'
        },
        legendLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.padding'
        },
        legendLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.padding.bottom'
        },
        legendLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.padding.left'
        },
        legendLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.padding.right'
        },
        legendLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'legend.labels.padding.top'
        },
        legendLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'legend.labels.template'
        },
        legendMargin: {
            type: Number,
            default: undefined,
            kComposite: 'legend.margin'
        },
        legendMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'legend.margin.bottom'
        },
        legendMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'legend.margin.left'
        },
        legendMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'legend.margin.right'
        },
        legendMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'legend.margin.top'
        },
        legendOffsetX: {
            type: Number,
            default: undefined,
            kComposite: 'legend.offsetX'
        },
        legendOffsetY: {
            type: Number,
            default: undefined,
            kComposite: 'legend.offsetY'
        },
        legendOrientation: {
            type: String,
            default: undefined,
            kComposite: 'legend.orientation'
        },
        legendPadding: {
            type: Number,
            default: undefined,
            kComposite: 'legend.padding'
        },
        legendPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'legend.padding.bottom'
        },
        legendPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'legend.padding.left'
        },
        legendPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'legend.padding.right'
        },
        legendPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'legend.padding.top'
        },
        legendPosition: {
            type: String,
            default: undefined,
            kComposite: 'legend.position'
        },
        legendReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'legend.reverse'
        },
        legendVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'legend.visible'
        },
        legendWidth: {
            type: Number,
            default: undefined,
            kComposite: 'legend.width'
        }
    }
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        panesBackground: {
            type: String,
            default: undefined,
            kComposite: 'panes.background'
        },
        panesBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'panes.border.color'
        },
        panesBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'panes.border.dashType'
        },
        panesBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'panes.border.width'
        },
        panesClip: {
            type: Boolean,
            default: undefined,
            kComposite: 'panes.clip'
        },
        panesHeight: {
            type: Number,
            default: undefined,
            kComposite: 'panes.height'
        },
        panesMargin: {
            type: Number,
            default: undefined,
            kComposite: 'panes.margin'
        },
        panesMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'panes.margin.bottom'
        },
        panesMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'panes.margin.left'
        },
        panesMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'panes.margin.right'
        },
        panesMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'panes.margin.top'
        },
        panesName: {
            type: String,
            default: undefined,
            kComposite: 'panes.name'
        },
        panesPadding: {
            type: Number,
            default: undefined,
            kComposite: 'panes.padding'
        },
        panesPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'panes.padding.bottom'
        },
        panesPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'panes.padding.left'
        },
        panesPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'panes.padding.right'
        },
        panesPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'panes.padding.top'
        },
        panesTitle: {
            type: String,
            default: undefined,
            kComposite: 'panes.title'
        },
        panesTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'panes.title.background'
        },
        panesTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'panes.title.border.color'
        },
        panesTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'panes.title.border.dashType'
        },
        panesTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'panes.title.border.width'
        },
        panesTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'panes.title.color'
        },
        panesTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'panes.title.font'
        },
        panesTitleMargin: {
            type: Number,
            default: undefined,
            kComposite: 'panes.title.margin'
        },
        panesTitleMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'panes.title.margin.bottom'
        },
        panesTitleMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'panes.title.margin.left'
        },
        panesTitleMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'panes.title.margin.right'
        },
        panesTitleMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'panes.title.margin.top'
        },
        panesTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'panes.title.position'
        },
        panesTitleText: {
            type: String,
            default: undefined,
            kComposite: 'panes.title.text'
        },
        panesTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'panes.title.visible'
        },
        panesTitleVisual: {
            type: Function,
            default: undefined,
            kComposite: 'panes.title.visual'
        }
    }
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        pannableKey: {
            type: String,
            default: undefined,
            kComposite: 'pannable.key'
        },
        pannableLock: {
            type: String,
            default: undefined,
            kComposite: 'pannable.lock'
        }
    }
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        pdfAuthor: {
            type: String,
            default: undefined,
            kComposite: 'pdf.author'
        },
        pdfCreator: {
            type: String,
            default: undefined,
            kComposite: 'pdf.creator'
        },
        pdfDate: {
            type: Date,
            default: undefined,
            kComposite: 'pdf.date'
        },
        pdfForceProxy: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.forceProxy'
        },
        pdfFileName: {
            type: String,
            default: undefined,
            kComposite: 'pdf.fileName'
        },
        pdfKeywords: {
            type: String,
            default: undefined,
            kComposite: 'pdf.keywords'
        },
        pdfLandscape: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.landscape'
        },
        pdfMarginBottom: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.bottom'
        },
        pdfMarginLeft: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.left'
        },
        pdfMarginRight: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.right'
        },
        pdfMarginTop: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.top'
        },
        pdfPaperSize: {
            type: [String, Array],
            default: undefined,
            kComposite: 'pdf.paperSize'
        },
        pdfProxyURL: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyURL'
        },
        pdfProxyTarget: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyTarget'
        },
        pdfSubject: {
            type: String,
            default: undefined,
            kComposite: 'pdf.subject'
        },
        pdfTitle: {
            type: String,
            default: undefined,
            kComposite: 'pdf.title'
        }
    }
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        plotAreaBackground: {
            type: String,
            default: undefined,
            kComposite: 'plotArea.background'
        },
        plotAreaBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'plotArea.border.color'
        },
        plotAreaBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'plotArea.border.dashType'
        },
        plotAreaBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.border.width'
        },
        plotAreaMargin: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.margin'
        },
        plotAreaMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.margin.bottom'
        },
        plotAreaMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.margin.left'
        },
        plotAreaMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.margin.right'
        },
        plotAreaMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.margin.top'
        },
        plotAreaOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.opacity'
        },
        plotAreaPadding: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.padding'
        },
        plotAreaPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.padding.bottom'
        },
        plotAreaPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.padding.left'
        },
        plotAreaPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.padding.right'
        },
        plotAreaPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.padding.top'
        }
    }
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        seriesAggregate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.aggregate'
        },
        seriesAxis: {
            type: String,
            default: undefined,
            kComposite: 'series.axis'
        },
        seriesBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.border.color'
        },
        seriesBorderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.border.dashType'
        },
        seriesBorderOpacity: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.border.opacity'
        },
        seriesBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.border.width'
        },
        seriesCategoryAxis: {
            type: String,
            default: undefined,
            kComposite: 'series.categoryAxis'
        },
        seriesCategoryField: {
            type: String,
            default: undefined,
            kComposite: 'series.categoryField'
        },
        seriesCloseField: {
            type: String,
            default: undefined,
            kComposite: 'series.closeField'
        },
        seriesColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.color'
        },
        seriesColorField: {
            type: String,
            default: undefined,
            kComposite: 'series.colorField'
        },
        seriesConnectorsColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.connectors.color'
        },
        seriesConnectorsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'series.connectors.padding'
        },
        seriesConnectorsWidth: {
            type: Number,
            default: undefined,
            kComposite: 'series.connectors.width'
        },
        seriesCurrentField: {
            type: String,
            default: undefined,
            kComposite: 'series.currentField'
        },
        seriesDashType: {
            type: String,
            default: undefined,
            kComposite: 'series.dashType'
        },
        seriesData: {
            type: Array,
            default: undefined,
            kComposite: 'series.data'
        },
        seriesDownColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.downColor'
        },
        seriesDownColorField: {
            type: String,
            default: undefined,
            kComposite: 'series.downColorField'
        },
        seriesSegmentSpacing: {
            type: Number,
            default: undefined,
            kComposite: 'series.segmentSpacing'
        },
        seriesSummaryField: {
            type: String,
            default: undefined,
            kComposite: 'series.summaryField'
        },
        seriesNeckRatio: {
            type: Number,
            default: undefined,
            kComposite: 'series.neckRatio'
        },
        seriesDynamicSlope: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.dynamicSlope'
        },
        seriesDynamicHeight: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.dynamicHeight'
        },
        seriesErrorBarsValue: {
            type: [String, Number, Array, Function],
            default: undefined,
            kComposite: 'series.errorBars.value'
        },
        seriesErrorBarsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'series.errorBars.visual'
        },
        seriesErrorBarsXValue: {
            type: [String, Number, Array, Function],
            default: undefined,
            kComposite: 'series.errorBars.xValue'
        },
        seriesErrorBarsYValue: {
            type: [String, Number, Array, Function],
            default: undefined,
            kComposite: 'series.errorBars.yValue'
        },
        seriesErrorBarsEndCaps: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.errorBars.endCaps'
        },
        seriesErrorBarsColor: {
            type: String,
            default: undefined,
            kComposite: 'series.errorBars.color'
        },
        seriesErrorBarsLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'series.errorBars.line.width'
        },
        seriesErrorBarsLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'series.errorBars.line.dashType'
        },
        seriesErrorLowField: {
            type: String,
            default: undefined,
            kComposite: 'series.errorLowField'
        },
        seriesErrorHighField: {
            type: String,
            default: undefined,
            kComposite: 'series.errorHighField'
        },
        seriesXErrorLowField: {
            type: String,
            default: undefined,
            kComposite: 'series.xErrorLowField'
        },
        seriesXErrorHighField: {
            type: String,
            default: undefined,
            kComposite: 'series.xErrorHighField'
        },
        seriesYErrorLowField: {
            type: String,
            default: undefined,
            kComposite: 'series.yErrorLowField'
        },
        seriesYErrorHighField: {
            type: String,
            default: undefined,
            kComposite: 'series.yErrorHighField'
        },
        seriesExplodeField: {
            type: String,
            default: undefined,
            kComposite: 'series.explodeField'
        },
        seriesField: {
            type: String,
            default: undefined,
            kComposite: 'series.field'
        },
        seriesFromField: {
            type: String,
            default: undefined,
            kComposite: 'series.fromField'
        },
        seriesToField: {
            type: String,
            default: undefined,
            kComposite: 'series.toField'
        },
        seriesNoteTextField: {
            type: String,
            default: undefined,
            kComposite: 'series.noteTextField'
        },
        seriesLowerField: {
            type: String,
            default: undefined,
            kComposite: 'series.lowerField'
        },
        seriesQ1Field: {
            type: String,
            default: undefined,
            kComposite: 'series.q1Field'
        },
        seriesMedianField: {
            type: String,
            default: undefined,
            kComposite: 'series.medianField'
        },
        seriesQ3Field: {
            type: String,
            default: undefined,
            kComposite: 'series.q3Field'
        },
        seriesUpperField: {
            type: String,
            default: undefined,
            kComposite: 'series.upperField'
        },
        seriesMeanField: {
            type: String,
            default: undefined,
            kComposite: 'series.meanField'
        },
        seriesOutliersField: {
            type: String,
            default: undefined,
            kComposite: 'series.outliersField'
        },
        seriesGap: {
            type: Number,
            default: undefined,
            kComposite: 'series.gap'
        },
        seriesHighField: {
            type: String,
            default: undefined,
            kComposite: 'series.highField'
        },
        seriesHighlightBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'series.highlight.border.color'
        },
        seriesHighlightBorderOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'series.highlight.border.opacity'
        },
        seriesHighlightBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'series.highlight.border.width'
        },
        seriesHighlightColor: {
            type: String,
            default: undefined,
            kComposite: 'series.highlight.color'
        },
        seriesHighlightLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'series.highlight.line.dashType'
        },
        seriesHighlightLineColor: {
            type: String,
            default: undefined,
            kComposite: 'series.highlight.line.color'
        },
        seriesHighlightLineOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'series.highlight.line.opacity'
        },
        seriesHighlightLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'series.highlight.line.width'
        },
        seriesHighlightOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'series.highlight.opacity'
        },
        seriesHighlightToggle: {
            type: Function,
            default: undefined,
            kComposite: 'series.highlight.toggle'
        },
        seriesHighlightVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.highlight.visible'
        },
        seriesHighlightVisual: {
            type: Function,
            default: undefined,
            kComposite: 'series.highlight.visual'
        },
        seriesHoleSize: {
            type: Number,
            default: undefined,
            kComposite: 'series.holeSize'
        },
        seriesLabelsAlign: {
            type: String,
            default: undefined,
            kComposite: 'series.labels.align'
        },
        seriesLabelsBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.background'
        },
        seriesLabelsBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.border.color'
        },
        seriesLabelsBorderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.border.dashType'
        },
        seriesLabelsBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.labels.border.width'
        },
        seriesLabelsColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.color'
        },
        seriesLabelsDistance: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.distance'
        },
        seriesLabelsFont: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.font'
        },
        seriesLabelsFormat: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.format'
        },
        seriesLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.margin'
        },
        seriesLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.margin.bottom'
        },
        seriesLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.margin.left'
        },
        seriesLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.margin.right'
        },
        seriesLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.margin.top'
        },
        seriesLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.padding'
        },
        seriesLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.padding.bottom'
        },
        seriesLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.padding.left'
        },
        seriesLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.padding.right'
        },
        seriesLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.padding.top'
        },
        seriesLabelsPosition: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.position'
        },
        seriesLabelsRotation: {
            type: [String, Number],
            default: undefined,
            kComposite: 'series.labels.rotation'
        },
        seriesLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.template'
        },
        seriesLabelsVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'series.labels.visible'
        },
        seriesLabelsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'series.labels.visual'
        },
        seriesLabelsFromBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.from.background'
        },
        seriesLabelsFromBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.from.border.color'
        },
        seriesLabelsFromBorderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.from.border.dashType'
        },
        seriesLabelsFromBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.labels.from.border.width'
        },
        seriesLabelsFromColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.from.color'
        },
        seriesLabelsFromFont: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.from.font'
        },
        seriesLabelsFromFormat: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.from.format'
        },
        seriesLabelsFromMargin: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.margin'
        },
        seriesLabelsFromMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.margin.bottom'
        },
        seriesLabelsFromMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.margin.left'
        },
        seriesLabelsFromMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.margin.right'
        },
        seriesLabelsFromMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.margin.top'
        },
        seriesLabelsFromPadding: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.padding'
        },
        seriesLabelsFromPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.padding.bottom'
        },
        seriesLabelsFromPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.padding.left'
        },
        seriesLabelsFromPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.padding.right'
        },
        seriesLabelsFromPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.from.padding.top'
        },
        seriesLabelsFromPosition: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.from.position'
        },
        seriesLabelsFromTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.from.template'
        },
        seriesLabelsFromVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'series.labels.from.visible'
        },
        seriesLabelsToBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.to.background'
        },
        seriesLabelsToBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.to.border.color'
        },
        seriesLabelsToBorderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.to.border.dashType'
        },
        seriesLabelsToBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.labels.to.border.width'
        },
        seriesLabelsToColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.to.color'
        },
        seriesLabelsToFont: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.to.font'
        },
        seriesLabelsToFormat: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.to.format'
        },
        seriesLabelsToMargin: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.margin'
        },
        seriesLabelsToMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.margin.bottom'
        },
        seriesLabelsToMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.margin.left'
        },
        seriesLabelsToMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.margin.right'
        },
        seriesLabelsToMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.margin.top'
        },
        seriesLabelsToPadding: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.padding'
        },
        seriesLabelsToPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.padding.bottom'
        },
        seriesLabelsToPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.padding.left'
        },
        seriesLabelsToPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.padding.right'
        },
        seriesLabelsToPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'series.labels.to.padding.top'
        },
        seriesLabelsToPosition: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.to.position'
        },
        seriesLabelsToTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.labels.to.template'
        },
        seriesLabelsToVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'series.labels.to.visible'
        },
        seriesLine: {
            type: String,
            default: undefined,
            kComposite: 'series.line'
        },
        seriesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'series.line.color'
        },
        seriesLineOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'series.line.opacity'
        },
        seriesLineWidth: {
            type: String,
            default: undefined,
            kComposite: 'series.line.width'
        },
        seriesLineStyle: {
            type: String,
            default: undefined,
            kComposite: 'series.line.style'
        },
        seriesLowField: {
            type: String,
            default: undefined,
            kComposite: 'series.lowField'
        },
        seriesMargin: {
            type: Number,
            default: undefined,
            kComposite: 'series.margin'
        },
        seriesMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'series.margin.bottom'
        },
        seriesMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'series.margin.left'
        },
        seriesMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'series.margin.right'
        },
        seriesMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'series.margin.top'
        },
        seriesMarkersBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.markers.background'
        },
        seriesMarkersBorder: {
            type: Function,
            default: undefined,
            kComposite: 'series.markers.border'
        },
        seriesMarkersBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.markers.border.color'
        },
        seriesMarkersBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.markers.border.width'
        },
        seriesMarkersFromBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.markers.from.background'
        },
        seriesMarkersFromBorder: {
            type: Function,
            default: undefined,
            kComposite: 'series.markers.from.border'
        },
        seriesMarkersFromBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.markers.from.border.color'
        },
        seriesMarkersFromBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.markers.from.border.width'
        },
        seriesMarkersFromSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.markers.from.size'
        },
        seriesMarkersFromType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.markers.from.type'
        },
        seriesMarkersFromVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'series.markers.from.visible'
        },
        seriesMarkersFromVisual: {
            type: Function,
            default: undefined,
            kComposite: 'series.markers.from.visual'
        },
        seriesMarkersFromRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.markers.from.rotation'
        },
        seriesMarkersSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.markers.size'
        },
        seriesMarkersToBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.markers.to.background'
        },
        seriesMarkersToBorder: {
            type: Function,
            default: undefined,
            kComposite: 'series.markers.to.border'
        },
        seriesMarkersToBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.markers.to.border.color'
        },
        seriesMarkersToBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.markers.to.border.width'
        },
        seriesMarkersToSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.markers.to.size'
        },
        seriesMarkersToType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.markers.to.type'
        },
        seriesMarkersToVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'series.markers.to.visible'
        },
        seriesMarkersToVisual: {
            type: Function,
            default: undefined,
            kComposite: 'series.markers.to.visual'
        },
        seriesMarkersToRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.markers.to.rotation'
        },
        seriesMarkersType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.markers.type'
        },
        seriesMarkersVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'series.markers.visible'
        },
        seriesMarkersVisual: {
            type: Function,
            default: undefined,
            kComposite: 'series.markers.visual'
        },
        seriesMarkersRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.markers.rotation'
        },
        seriesOutliersBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.outliers.background'
        },
        seriesOutliersBorder: {
            type: Function,
            default: undefined,
            kComposite: 'series.outliers.border'
        },
        seriesOutliersBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.outliers.border.color'
        },
        seriesOutliersBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.outliers.border.width'
        },
        seriesOutliersSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.outliers.size'
        },
        seriesOutliersType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.outliers.type'
        },
        seriesOutliersRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.outliers.rotation'
        },
        seriesExtremesBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.extremes.background'
        },
        seriesExtremesBorder: {
            type: Function,
            default: undefined,
            kComposite: 'series.extremes.border'
        },
        seriesExtremesBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.extremes.border.color'
        },
        seriesExtremesBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.extremes.border.width'
        },
        seriesExtremesSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.extremes.size'
        },
        seriesExtremesType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.extremes.type'
        },
        seriesExtremesRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.extremes.rotation'
        },
        seriesMaxSize: {
            type: Number,
            default: undefined,
            kComposite: 'series.maxSize'
        },
        seriesMinSize: {
            type: Number,
            default: undefined,
            kComposite: 'series.minSize'
        },
        seriesMissingValues: {
            type: String,
            default: undefined,
            kComposite: 'series.missingValues'
        },
        seriesStyle: {
            type: String,
            default: undefined,
            kComposite: 'series.style'
        },
        seriesName: {
            type: String,
            default: undefined,
            kComposite: 'series.name'
        },
        seriesNegativeColor: {
            type: String,
            default: undefined,
            kComposite: 'series.negativeColor'
        },
        seriesNegativeValuesColor: {
            type: String,
            default: undefined,
            kComposite: 'series.negativeValues.color'
        },
        seriesNegativeValuesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.negativeValues.visible'
        },
        seriesOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'series.opacity'
        },
        seriesOpenField: {
            type: String,
            default: undefined,
            kComposite: 'series.openField'
        },
        seriesOverlayGradient: {
            type: String,
            default: undefined,
            kComposite: 'series.overlay.gradient'
        },
        seriesPadding: {
            type: Number,
            default: undefined,
            kComposite: 'series.padding'
        },
        seriesSize: {
            type: Number,
            default: undefined,
            kComposite: 'series.size'
        },
        seriesSizeField: {
            type: String,
            default: undefined,
            kComposite: 'series.sizeField'
        },
        seriesSpacing: {
            type: Number,
            default: undefined,
            kComposite: 'series.spacing'
        },
        seriesStack: {
            type: [Boolean, String],
            default: undefined,
            kComposite: 'series.stack'
        },
        seriesStackType: {
            type: String,
            default: undefined,
            kComposite: 'series.stack.type'
        },
        seriesStackGroup: {
            type: String,
            default: undefined,
            kComposite: 'series.stack.group'
        },
        seriesStartAngle: {
            type: Number,
            default: undefined,
            kComposite: 'series.startAngle'
        },
        seriesTargetBorder: {
            type: Function,
            default: undefined,
            kComposite: 'series.target.border'
        },
        seriesTargetBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.target.border.color'
        },
        seriesTargetBorderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.target.border.dashType'
        },
        seriesTargetBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'series.target.border.width'
        },
        seriesTargetColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.target.color'
        },
        seriesTargetLineWidth: {
            type: [Object, Function],
            default: undefined,
            kComposite: 'series.target.line.width'
        },
        seriesTargetField: {
            type: String,
            default: undefined,
            kComposite: 'series.targetField'
        },
        seriesTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'series.tooltip.background'
        },
        seriesTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'series.tooltip.border.color'
        },
        seriesTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'series.tooltip.border.width'
        },
        seriesTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'series.tooltip.color'
        },
        seriesTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'series.tooltip.font'
        },
        seriesTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'series.tooltip.format'
        },
        seriesTooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'series.tooltip.padding'
        },
        seriesTooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'series.tooltip.padding.bottom'
        },
        seriesTooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'series.tooltip.padding.left'
        },
        seriesTooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'series.tooltip.padding.right'
        },
        seriesTooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'series.tooltip.padding.top'
        },
        seriesTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.tooltip.template'
        },
        seriesTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.tooltip.visible'
        },
        seriesType: {
            type: String,
            default: undefined,
            kComposite: 'series.type'
        },
        seriesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.visible'
        },
        seriesVisibleInLegend: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.visibleInLegend'
        },
        seriesVisibleInLegendField: {
            type: String,
            default: undefined,
            kComposite: 'series.visibleInLegendField'
        },
        seriesVisual: {
            type: Function,
            default: undefined,
            kComposite: 'series.visual'
        },
        seriesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'series.width'
        },
        seriesXAxis: {
            type: String,
            default: undefined,
            kComposite: 'series.xAxis'
        },
        seriesXField: {
            type: String,
            default: undefined,
            kComposite: 'series.xField'
        },
        seriesYAxis: {
            type: String,
            default: undefined,
            kComposite: 'series.yAxis'
        },
        seriesYField: {
            type: String,
            default: undefined,
            kComposite: 'series.yField'
        },
        seriesNotesPosition: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.position'
        },
        seriesNotesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.icon.background'
        },
        seriesNotesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.icon.border.color'
        },
        seriesNotesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'series.notes.icon.border.width'
        },
        seriesNotesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'series.notes.icon.size'
        },
        seriesNotesIconType: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.icon.type'
        },
        seriesNotesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.notes.icon.visible'
        },
        seriesNotesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.label.background'
        },
        seriesNotesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.label.border.color'
        },
        seriesNotesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.label.border.dashType'
        },
        seriesNotesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'series.notes.label.border.width'
        },
        seriesNotesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.label.color'
        },
        seriesNotesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.label.font'
        },
        seriesNotesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'series.notes.label.template'
        },
        seriesNotesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'series.notes.label.visible'
        },
        seriesNotesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'series.notes.label.rotation'
        },
        seriesNotesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.label.format'
        },
        seriesNotesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.label.position'
        },
        seriesNotesLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.line.dashType'
        },
        seriesNotesLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'series.notes.line.width'
        },
        seriesNotesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'series.notes.line.color'
        },
        seriesNotesLineLength: {
            type: Number,
            default: undefined,
            kComposite: 'series.notes.line.length'
        },
        seriesNotesVisual: {
            type: Function,
            default: undefined,
            kComposite: 'series.notes.visual'
        },
        seriesZIndex: {
            type: Number,
            default: undefined,
            kComposite: 'series.zIndex'
        }
    }
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        seriesDefaultsArea: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.area'
        },
        seriesDefaultsBar: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.bar'
        },
        seriesDefaultsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.border.color'
        },
        seriesDefaultsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.border.dashType'
        },
        seriesDefaultsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.border.width'
        },
        seriesDefaultsBubble: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.bubble'
        },
        seriesDefaultsCandlestick: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.candlestick'
        },
        seriesDefaultsColumn: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.column'
        },
        seriesDefaultsDonut: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.donut'
        },
        seriesDefaultsGap: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.gap'
        },
        seriesDefaultsLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.background'
        },
        seriesDefaultsLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.border.color'
        },
        seriesDefaultsLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.border.dashType'
        },
        seriesDefaultsLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.border.width'
        },
        seriesDefaultsLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.color'
        },
        seriesDefaultsLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.font'
        },
        seriesDefaultsLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.format'
        },
        seriesDefaultsLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.margin'
        },
        seriesDefaultsLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.margin.bottom'
        },
        seriesDefaultsLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.margin.left'
        },
        seriesDefaultsLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.margin.right'
        },
        seriesDefaultsLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.margin.top'
        },
        seriesDefaultsLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.padding'
        },
        seriesDefaultsLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.padding.bottom'
        },
        seriesDefaultsLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.padding.left'
        },
        seriesDefaultsLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.padding.right'
        },
        seriesDefaultsLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.padding.top'
        },
        seriesDefaultsLabelsRotation: {
            type: [String, Number],
            default: undefined,
            kComposite: 'seriesDefaults.labels.rotation'
        },
        seriesDefaultsLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'seriesDefaults.labels.template'
        },
        seriesDefaultsLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.labels.visible'
        },
        seriesDefaultsLabelsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'seriesDefaults.labels.visual'
        },
        seriesDefaultsLabelsFromBackground: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.background'
        },
        seriesDefaultsLabelsFromBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.border.color'
        },
        seriesDefaultsLabelsFromBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.border.dashType'
        },
        seriesDefaultsLabelsFromBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.border.width'
        },
        seriesDefaultsLabelsFromColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.color'
        },
        seriesDefaultsLabelsFromFont: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.font'
        },
        seriesDefaultsLabelsFromFormat: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.format'
        },
        seriesDefaultsLabelsFromMargin: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.margin'
        },
        seriesDefaultsLabelsFromMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.margin.bottom'
        },
        seriesDefaultsLabelsFromMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.margin.left'
        },
        seriesDefaultsLabelsFromMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.margin.right'
        },
        seriesDefaultsLabelsFromMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.margin.top'
        },
        seriesDefaultsLabelsFromPadding: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.padding'
        },
        seriesDefaultsLabelsFromPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.padding.bottom'
        },
        seriesDefaultsLabelsFromPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.padding.left'
        },
        seriesDefaultsLabelsFromPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.padding.right'
        },
        seriesDefaultsLabelsFromPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.padding.top'
        },
        seriesDefaultsLabelsFromTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.template'
        },
        seriesDefaultsLabelsFromVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.visible'
        },
        seriesDefaultsLabelsToBackground: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.background'
        },
        seriesDefaultsLabelsToBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.border.color'
        },
        seriesDefaultsLabelsToBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.border.dashType'
        },
        seriesDefaultsLabelsToBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.border.width'
        },
        seriesDefaultsLabelsToColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.color'
        },
        seriesDefaultsLabelsToFont: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.font'
        },
        seriesDefaultsLabelsToFormat: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.format'
        },
        seriesDefaultsLabelsToMargin: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.margin'
        },
        seriesDefaultsLabelsToMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.margin.bottom'
        },
        seriesDefaultsLabelsToMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.margin.left'
        },
        seriesDefaultsLabelsToMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.margin.right'
        },
        seriesDefaultsLabelsToMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.margin.top'
        },
        seriesDefaultsLabelsToPadding: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.padding'
        },
        seriesDefaultsLabelsToPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.padding.bottom'
        },
        seriesDefaultsLabelsToPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.padding.left'
        },
        seriesDefaultsLabelsToPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.padding.right'
        },
        seriesDefaultsLabelsToPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.padding.top'
        },
        seriesDefaultsLabelsToTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.template'
        },
        seriesDefaultsLabelsToVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.visible'
        },
        seriesDefaultsLine: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.line'
        },
        seriesDefaultsOhlc: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.ohlc'
        },
        seriesDefaultsOverlayGradient: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.overlay.gradient'
        },
        seriesDefaultsPie: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.pie'
        },
        seriesDefaultsRangeArea: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.rangeArea'
        },
        seriesDefaultsScatter: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.scatter'
        },
        seriesDefaultsScatterLine: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.scatterLine'
        },
        seriesDefaultsSpacing: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.spacing'
        },
        seriesDefaultsStack: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.stack'
        },
        seriesDefaultsStackType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.stack.type'
        },
        seriesDefaultsType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.type'
        },
        seriesDefaultsTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.background'
        },
        seriesDefaultsTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.border.color'
        },
        seriesDefaultsTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.border.width'
        },
        seriesDefaultsTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.color'
        },
        seriesDefaultsTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.font'
        },
        seriesDefaultsTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.format'
        },
        seriesDefaultsTooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.padding'
        },
        seriesDefaultsTooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.padding.bottom'
        },
        seriesDefaultsTooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.padding.left'
        },
        seriesDefaultsTooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.padding.right'
        },
        seriesDefaultsTooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.padding.top'
        },
        seriesDefaultsTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.template'
        },
        seriesDefaultsTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.visible'
        },
        seriesDefaultsVerticalArea: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.verticalArea'
        },
        seriesDefaultsVerticalLine: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.verticalLine'
        },
        seriesDefaultsVerticalRangeArea: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.verticalRangeArea'
        },
        seriesDefaultsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'seriesDefaults.visual'
        },
        seriesDefaultsNotesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.icon.background'
        },
        seriesDefaultsNotesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.icon.border.color'
        },
        seriesDefaultsNotesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.notes.icon.border.width'
        },
        seriesDefaultsNotesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.notes.icon.size'
        },
        seriesDefaultsNotesIconType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.icon.type'
        },
        seriesDefaultsNotesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.notes.icon.visible'
        },
        seriesDefaultsNotesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.background'
        },
        seriesDefaultsNotesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.border.color'
        },
        seriesDefaultsNotesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.border.dashType'
        },
        seriesDefaultsNotesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.border.width'
        },
        seriesDefaultsNotesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.color'
        },
        seriesDefaultsNotesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.font'
        },
        seriesDefaultsNotesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.template'
        },
        seriesDefaultsNotesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.visible'
        },
        seriesDefaultsNotesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.rotation'
        },
        seriesDefaultsNotesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.format'
        },
        seriesDefaultsNotesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.position'
        },
        seriesDefaultsNotesLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.line.dashType'
        },
        seriesDefaultsNotesLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.notes.line.width'
        },
        seriesDefaultsNotesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.line.color'
        },
        seriesDefaultsNotesLineLength: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.notes.line.length'
        },
        seriesDefaultsNotesVisual: {
            type: Function,
            default: undefined,
            kComposite: 'seriesDefaults.notes.visual'
        },
        seriesDefaultsDynamicSlope: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.dynamicSlope'
        },
        seriesDefaultsDynamicHeight: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.dynamicHeight'
        },
        seriesDefaultsStartAngle: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.startAngle'
        },
        seriesDefaultsStyle: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.style'
        }
    }
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        titleAlign: {
            type: String,
            default: undefined,
            kComposite: 'title.align'
        },
        titleBackground: {
            type: String,
            default: undefined,
            kComposite: 'title.background'
        },
        titleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'title.border.color'
        },
        titleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'title.border.dashType'
        },
        titleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'title.border.width'
        },
        titleColor: {
            type: String,
            default: undefined,
            kComposite: 'title.color'
        },
        titleFont: {
            type: String,
            default: undefined,
            kComposite: 'title.font'
        },
        titleMargin: {
            type: Number,
            default: undefined,
            kComposite: 'title.margin'
        },
        titleMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'title.margin.bottom'
        },
        titleMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'title.margin.left'
        },
        titleMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'title.margin.right'
        },
        titleMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'title.margin.top'
        },
        titlePadding: {
            type: Number,
            default: undefined,
            kComposite: 'title.padding'
        },
        titlePaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'title.padding.bottom'
        },
        titlePaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'title.padding.left'
        },
        titlePaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'title.padding.right'
        },
        titlePaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'title.padding.top'
        },
        titlePosition: {
            type: String,
            default: undefined,
            kComposite: 'title.position'
        },
        titleText: {
            type: String,
            default: undefined,
            kComposite: 'title.text'
        },
        titleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'title.visible'
        }
    }
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        tooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.background'
        },
        tooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.border.color'
        },
        tooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.border.width'
        },
        tooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.color'
        },
        tooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.font'
        },
        tooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.format'
        },
        tooltipOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.opacity'
        },
        tooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding'
        },
        tooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding.bottom'
        },
        tooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding.left'
        },
        tooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding.right'
        },
        tooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding.top'
        },
        tooltipShared: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.shared'
        },
        tooltipSharedTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'tooltip.sharedTemplate'
        },
        tooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'tooltip.template'
        },
        tooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.visible'
        }
    }
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        valueAxisAxisCrossingValue: {
            type: [Object, Date, Array, String, Number],
            default: undefined,
            kComposite: 'valueAxis.axisCrossingValue'
        },
        valueAxisBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.background'
        },
        valueAxisColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.color'
        },
        valueAxisCrosshairColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.crosshair.color'
        },
        valueAxisCrosshairOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.crosshair.opacity'
        },
        valueAxisCrosshairTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.background'
        },
        valueAxisCrosshairTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.border.color'
        },
        valueAxisCrosshairTooltipBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.border.dashType'
        },
        valueAxisCrosshairTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.border.width'
        },
        valueAxisCrosshairTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.color'
        },
        valueAxisCrosshairTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.font'
        },
        valueAxisCrosshairTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.format'
        },
        valueAxisCrosshairTooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.padding'
        },
        valueAxisCrosshairTooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.padding.bottom'
        },
        valueAxisCrosshairTooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.padding.left'
        },
        valueAxisCrosshairTooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.padding.right'
        },
        valueAxisCrosshairTooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.padding.top'
        },
        valueAxisCrosshairTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.template'
        },
        valueAxisCrosshairTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.visible'
        },
        valueAxisCrosshairVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.crosshair.visible'
        },
        valueAxisCrosshairWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.crosshair.width'
        },
        valueAxisLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.labels.background'
        },
        valueAxisLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.labels.border.color'
        },
        valueAxisLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.labels.border.dashType'
        },
        valueAxisLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.border.width'
        },
        valueAxisLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.labels.color'
        },
        valueAxisLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.labels.font'
        },
        valueAxisLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.labels.format'
        },
        valueAxisLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.margin'
        },
        valueAxisLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.margin.bottom'
        },
        valueAxisLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.margin.left'
        },
        valueAxisLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.margin.right'
        },
        valueAxisLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.margin.top'
        },
        valueAxisLabelsMirror: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.labels.mirror'
        },
        valueAxisLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.padding'
        },
        valueAxisLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.padding.bottom'
        },
        valueAxisLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.padding.left'
        },
        valueAxisLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.padding.right'
        },
        valueAxisLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.padding.top'
        },
        valueAxisLabelsRotation: {
            type: [Number, String],
            default: undefined,
            kComposite: 'valueAxis.labels.rotation'
        },
        valueAxisLabelsRotationAlign: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.labels.rotation.align'
        },
        valueAxisLabelsRotationAngle: {
            type: [Number, String],
            default: undefined,
            kComposite: 'valueAxis.labels.rotation.angle'
        },
        valueAxisLabelsSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.skip'
        },
        valueAxisLabelsStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.step'
        },
        valueAxisLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'valueAxis.labels.template'
        },
        valueAxisLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.labels.visible'
        },
        valueAxisLabelsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'valueAxis.labels.visual'
        },
        valueAxisLineColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.line.color'
        },
        valueAxisLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.line.dashType'
        },
        valueAxisLineVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.line.visible'
        },
        valueAxisLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.line.width'
        },
        valueAxisMajorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.majorGridLines.color'
        },
        valueAxisMajorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.majorGridLines.dashType'
        },
        valueAxisMajorGridLinesType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.majorGridLines.type'
        },
        valueAxisMajorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.majorGridLines.visible'
        },
        valueAxisMajorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.majorGridLines.width'
        },
        valueAxisMajorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.majorGridLines.step'
        },
        valueAxisMajorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.majorGridLines.skip'
        },
        valueAxisMajorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.majorUnit'
        },
        valueAxisMax: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.max'
        },
        valueAxisMin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'valueAxis.min'
        },
        valueAxisMinorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.minorGridLines.color'
        },
        valueAxisMinorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.minorGridLines.dashType'
        },
        valueAxisMinorGridLinesType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.minorGridLines.type'
        },
        valueAxisMinorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.minorGridLines.visible'
        },
        valueAxisMinorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.minorGridLines.width'
        },
        valueAxisMinorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.minorGridLines.step'
        },
        valueAxisMinorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.minorGridLines.skip'
        },
        valueAxisMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.majorTicks.color'
        },
        valueAxisMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.majorTicks.size'
        },
        valueAxisMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.majorTicks.visible'
        },
        valueAxisMajorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.majorTicks.step'
        },
        valueAxisMajorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.majorTicks.skip'
        },
        valueAxisMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.minorTicks.color'
        },
        valueAxisMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.minorTicks.size'
        },
        valueAxisMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.minorTicks.visible'
        },
        valueAxisMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.minorTicks.width'
        },
        valueAxisMinorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.minorTicks.step'
        },
        valueAxisMinorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.minorTicks.skip'
        },
        valueAxisMinorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.minorUnit'
        },
        valueAxisName: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.name'
        },
        valueAxisNarrowRange: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.narrowRange'
        },
        valueAxisPane: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.pane'
        },
        valueAxisPlotBands: {
            type: Array,
            default: undefined,
            kComposite: 'valueAxis.plotBands'
        }, valueAxisReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.reverse'
        },
        valueAxisTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.title.background'
        },
        valueAxisTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.title.border.color'
        },
        valueAxisTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.title.border.dashType'
        },
        valueAxisTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.border.width'
        },
        valueAxisTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.title.color'
        },
        valueAxisTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.title.font'
        },
        valueAxisTitleMargin: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.margin'
        },
        valueAxisTitleMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.margin.bottom'
        },
        valueAxisTitleMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.margin.left'
        },
        valueAxisTitleMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.margin.right'
        },
        valueAxisTitleMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.margin.top'
        },
        valueAxisTitlePadding: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.padding'
        },
        valueAxisTitlePaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.padding.bottom'
        },
        valueAxisTitlePaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.padding.left'
        },
        valueAxisTitlePaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.padding.right'
        },
        valueAxisTitlePaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.padding.top'
        },
        valueAxisTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.title.position'
        },
        valueAxisTitleRotation: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.rotation'
        },
        valueAxisTitleText: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.title.text'
        },
        valueAxisTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.title.visible'
        },
        valueAxisTitleVisual: {
            type: Function,
            default: undefined,
            kComposite: 'valueAxis.title.visual'
        },
        valueAxisType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.type'
        },
        valueAxisVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.visible'
        },
        valueAxisNotesPosition: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.position'
        },
        valueAxisNotesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.icon.background'
        },
        valueAxisNotesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.icon.border.color'
        },
        valueAxisNotesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.notes.icon.border.width'
        },
        valueAxisNotesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.notes.icon.size'
        },
        valueAxisNotesIconType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.icon.type'
        },
        valueAxisNotesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.notes.icon.visible'
        },
        valueAxisNotesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.label.background'
        },
        valueAxisNotesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.label.border.color'
        },
        valueAxisNotesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.label.border.dashType'
        },
        valueAxisNotesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.notes.label.border.width'
        },
        valueAxisNotesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.label.color'
        },
        valueAxisNotesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.label.font'
        },
        valueAxisNotesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'valueAxis.notes.label.template'
        },
        valueAxisNotesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.notes.label.visible'
        },
        valueAxisNotesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.notes.label.rotation'
        },
        valueAxisNotesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.label.format'
        },
        valueAxisNotesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.label.position'
        },
        valueAxisNotesLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.line.dashType'
        },
        valueAxisNotesLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.notes.line.width'
        },
        valueAxisNotesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.line.color'
        },
        valueAxisNotesLineLength: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.notes.line.length'
        },
        valueAxisNotesData: {
            type: Array,
            default: undefined,
            kComposite: 'valueAxis.notes.data'
        }, valueAxisNotesVisual: {
            type: Function,
            default: undefined,
            kComposite: 'valueAxis.notes.visual'
        }
    }
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        xAxisAxisCrossingValue: {
            type: [Object, Date, Array, String, Number],
            default: undefined,
            kComposite: 'xAxis.axisCrossingValue'
        },
        xAxisBackground: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.background'
        },
        xAxisBaseUnit: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.baseUnit'
        },
        xAxisColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.color'
        },
        xAxisCrosshairColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.crosshair.color'
        },
        xAxisCrosshairOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.crosshair.opacity'
        },
        xAxisCrosshairTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.background'
        },
        xAxisCrosshairTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.border.color'
        },
        xAxisCrosshairTooltipBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.border.dashType'
        },
        xAxisCrosshairTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.border.width'
        },
        xAxisCrosshairTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.color'
        },
        xAxisCrosshairTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.font'
        },
        xAxisCrosshairTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.format'
        },
        xAxisCrosshairTooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.padding'
        },
        xAxisCrosshairTooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.padding.bottom'
        },
        xAxisCrosshairTooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.padding.left'
        },
        xAxisCrosshairTooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.padding.right'
        },
        xAxisCrosshairTooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.padding.top'
        },
        xAxisCrosshairTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.template'
        },
        xAxisCrosshairTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.crosshair.tooltip.visible'
        },
        xAxisCrosshairVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.crosshair.visible'
        },
        xAxisCrosshairWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.crosshair.width'
        },
        xAxisLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.background'
        },
        xAxisLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.border.color'
        },
        xAxisLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.border.dashType'
        },
        xAxisLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.border.width'
        },
        xAxisLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.color'
        },
        xAxisLabelsCulture: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.culture'
        },
        xAxisLabelsDateFormatsDays: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.dateFormats.days'
        },
        xAxisLabelsDateFormatsHours: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.dateFormats.hours'
        },
        xAxisLabelsDateFormatsMonths: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.dateFormats.months'
        },
        xAxisLabelsDateFormatsWeeks: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.dateFormats.weeks'
        },
        xAxisLabelsDateFormatsYears: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.dateFormats.years'
        },
        xAxisLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.font'
        },
        xAxisLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.format'
        },
        xAxisLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.margin'
        },
        xAxisLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.margin.bottom'
        },
        xAxisLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.margin.left'
        },
        xAxisLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.margin.right'
        },
        xAxisLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.margin.top'
        },
        xAxisLabelsMirror: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.labels.mirror'
        },
        xAxisLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.padding'
        },
        xAxisLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.padding.bottom'
        },
        xAxisLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.padding.left'
        },
        xAxisLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.padding.right'
        },
        xAxisLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.padding.top'
        },
        xAxisLabelsRotation: {
            type: [Number, String],
            default: undefined,
            kComposite: 'xAxis.labels.rotation'
        },
        xAxisLabelsRotationAlign: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.labels.rotation.align'
        },
        xAxisLabelsRotationAngle: {
            type: [Number, String],
            default: undefined,
            kComposite: 'xAxis.labels.rotation.angle'
        },
        xAxisLabelsSkip: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.skip'
        },
        xAxisLabelsStep: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.labels.step'
        },
        xAxisLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'xAxis.labels.template'
        },
        xAxisLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.labels.visible'
        },
        xAxisLabelsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'xAxis.labels.visual'
        },
        xAxisLineColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.line.color'
        },
        xAxisLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.line.dashType'
        },
        xAxisLineVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.line.visible'
        },
        xAxisLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.line.width'
        },
        xAxisMajorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.majorGridLines.color'
        },
        xAxisMajorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.majorGridLines.dashType'
        },
        xAxisMajorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.majorGridLines.visible'
        },
        xAxisMajorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.majorGridLines.width'
        },
        xAxisMajorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.majorGridLines.step'
        },
        xAxisMajorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.majorGridLines.skip'
        },
        xAxisMinorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.minorGridLines.color'
        },
        xAxisMinorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.minorGridLines.dashType'
        },
        xAxisMinorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.minorGridLines.visible'
        },
        xAxisMinorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.minorGridLines.width'
        },
        xAxisMinorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.minorGridLines.step'
        },
        xAxisMinorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.minorGridLines.skip'
        },
        xAxisMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.minorTicks.color'
        },
        xAxisMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.minorTicks.size'
        },
        xAxisMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.minorTicks.visible'
        },
        xAxisMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.minorTicks.width'
        },
        xAxisMinorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.minorTicks.step'
        },
        xAxisMinorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.minorTicks.skip'
        },
        xAxisMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.majorTicks.color'
        },
        xAxisMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.majorTicks.size'
        },
        xAxisMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.majorTicks.visible'
        },
        xAxisMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.majorTicks.width'
        },
        xAxisMajorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.majorTicks.step'
        },
        xAxisMajorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.majorTicks.skip'
        },
        xAxisMajorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.majorUnit'
        },
        xAxisMax: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.max'
        },
        xAxisMin: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.min'
        },
        xAxisMinorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.minorUnit'
        },
        xAxisName: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.name'
        },
        xAxisNarrowRange: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.narrowRange'
        },
        xAxisPane: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.pane'
        },
        xAxisPlotBands: {
            type: Array,
            default: undefined,
            kComposite: 'xAxis.plotBands'
        },
        xAxisReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.reverse'
        },
        xAxisStartAngle: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.startAngle'
        },
        xAxisTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.title.background'
        },
        xAxisTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.title.border.color'
        },
        xAxisTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.title.border.dashType'
        },
        xAxisTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.border.width'
        },
        xAxisTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.title.color'
        },
        xAxisTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.title.font'
        },
        xAxisTitleMargin: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.margin'
        },
        xAxisTitleMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.margin.bottom'
        },
        xAxisTitleMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.margin.left'
        },
        xAxisTitleMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.margin.right'
        },
        xAxisTitleMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.margin.top'
        },
        xAxisTitlePadding: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.padding'
        },
        xAxisTitlePaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.padding.bottom'
        },
        xAxisTitlePaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.padding.left'
        },
        xAxisTitlePaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.padding.right'
        },
        xAxisTitlePaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.padding.top'
        },
        xAxisTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.title.position'
        },
        xAxisTitleRotation: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.title.rotation'
        },
        xAxisTitleText: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.title.text'
        },
        xAxisTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.title.visible'
        },
        xAxisTitleVisual: {
            type: Function,
            default: undefined,
            kComposite: 'xAxis.title.visual'
        },
        xAxisType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.type'
        },
        xAxisVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.visible'
        },
        xAxisNotesPosition: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.position'
        },
        xAxisNotesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.icon.background'
        },
        xAxisNotesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.icon.border.color'
        },
        xAxisNotesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.notes.icon.border.width'
        },
        xAxisNotesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.notes.icon.size'
        },
        xAxisNotesIconType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.icon.type'
        },
        xAxisNotesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.notes.icon.visible'
        },
        xAxisNotesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.label.background'
        },
        xAxisNotesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.label.border.color'
        },
        xAxisNotesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.label.border.dashType'
        },
        xAxisNotesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.notes.label.border.width'
        },
        xAxisNotesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.label.color'
        },
        xAxisNotesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.label.font'
        },
        xAxisNotesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'xAxis.notes.label.template'
        },
        xAxisNotesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'xAxis.notes.label.visible'
        },
        xAxisNotesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.notes.label.rotation'
        },
        xAxisNotesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.label.format'
        },
        xAxisNotesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.label.position'
        },
        xAxisNotesLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.line.dashType'
        },
        xAxisNotesLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.notes.line.width'
        },
        xAxisNotesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'xAxis.notes.line.color'
        },
        xAxisNotesLineLength: {
            type: Number,
            default: undefined,
            kComposite: 'xAxis.notes.line.length'
        },
        xAxisNotesData: {
            type: Array,
            default: undefined,
            kComposite: 'xAxis.notes.data'
        }, xAxisNotesVisual: {
            type: Function,
            default: undefined,
            kComposite: 'xAxis.notes.visual'
        }
    }
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        yAxisAxisCrossingValue: {
            type: [Object, Date, Array, String, Number],
            default: undefined,
            kComposite: 'yAxis.axisCrossingValue'
        },
        yAxisBackground: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.background'
        },
        yAxisBaseUnit: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.baseUnit'
        },
        yAxisColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.color'
        },
        yAxisCrosshairColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.crosshair.color'
        },
        yAxisCrosshairOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.crosshair.opacity'
        },
        yAxisCrosshairTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.background'
        },
        yAxisCrosshairTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.border.color'
        },
        yAxisCrosshairTooltipBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.border.dashType'
        },
        yAxisCrosshairTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.border.width'
        },
        yAxisCrosshairTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.color'
        },
        yAxisCrosshairTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.font'
        },
        yAxisCrosshairTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.format'
        },
        yAxisCrosshairTooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.padding'
        },
        yAxisCrosshairTooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.padding.bottom'
        },
        yAxisCrosshairTooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.padding.left'
        },
        yAxisCrosshairTooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.padding.right'
        },
        yAxisCrosshairTooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.padding.top'
        },
        yAxisCrosshairTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.template'
        },
        yAxisCrosshairTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.crosshair.tooltip.visible'
        },
        yAxisCrosshairVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.crosshair.visible'
        },
        yAxisCrosshairWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.crosshair.width'
        },
        yAxisLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.background'
        },
        yAxisLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.border.color'
        },
        yAxisLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.border.dashType'
        },
        yAxisLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.border.width'
        },
        yAxisLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.color'
        },
        yAxisLabelsCulture: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.culture'
        },
        yAxisLabelsDateFormatsDays: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.dateFormats.days'
        },
        yAxisLabelsDateFormatsHours: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.dateFormats.hours'
        },
        yAxisLabelsDateFormatsMonths: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.dateFormats.months'
        },
        yAxisLabelsDateFormatsWeeks: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.dateFormats.weeks'
        },
        yAxisLabelsDateFormatsYears: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.dateFormats.years'
        },
        yAxisLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.font'
        },
        yAxisLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.format'
        },
        yAxisLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.margin'
        },
        yAxisLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.margin.bottom'
        },
        yAxisLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.margin.left'
        },
        yAxisLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.margin.right'
        },
        yAxisLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.margin.top'
        },
        yAxisLabelsMirror: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.labels.mirror'
        },
        yAxisLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.padding'
        },
        yAxisLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.padding.bottom'
        },
        yAxisLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.padding.left'
        },
        yAxisLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.padding.right'
        },
        yAxisLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.padding.top'
        },
        yAxisLabelsRotation: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.rotation'
        },
        yAxisLabelsRotationAlign: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.labels.rotation.align'
        },
        yAxisLabelsRotationAngle: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.rotation.angle'
        },
        yAxisLabelsSkip: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.skip'
        },
        yAxisLabelsStep: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.labels.step'
        },
        yAxisLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'yAxis.labels.template'
        },
        yAxisLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.labels.visible'
        },
        yAxisLabelsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'yAxis.labels.visual'
        },
        yAxisLineColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.line.color'
        },
        yAxisLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.line.dashType'
        },
        yAxisLineVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.line.visible'
        },
        yAxisLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.line.width'
        },
        yAxisMajorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.majorGridLines.color'
        },
        yAxisMajorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.majorGridLines.dashType'
        },
        yAxisMajorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.majorGridLines.visible'
        },
        yAxisMajorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.majorGridLines.width'
        },
        yAxisMajorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.majorGridLines.step'
        },
        yAxisMajorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.majorGridLines.skip'
        },
        yAxisMinorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.minorGridLines.color'
        },
        yAxisMinorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.minorGridLines.dashType'
        },
        yAxisMinorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.minorGridLines.visible'
        },
        yAxisMinorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.minorGridLines.width'
        },
        yAxisMinorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.minorGridLines.step'
        },
        yAxisMinorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.minorGridLines.skip'
        },
        yAxisMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.minorTicks.color'
        },
        yAxisMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.minorTicks.size'
        },
        yAxisMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.minorTicks.visible'
        },
        yAxisMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.minorTicks.width'
        },
        yAxisMinorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.minorTicks.step'
        },
        yAxisMinorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.minorTicks.skip'
        },
        yAxisMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.majorTicks.color'
        },
        yAxisMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.majorTicks.size'
        },
        yAxisMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.majorTicks.visible'
        },
        yAxisMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.majorTicks.width'
        },
        yAxisMajorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.majorTicks.step'
        },
        yAxisMajorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.majorTicks.skip'
        },
        yAxisMajorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.majorUnit'
        },
        yAxisMax: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.max'
        },
        yAxisMin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'yAxis.min'
        },
        yAxisMinorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.minorUnit'
        },
        yAxisName: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.name'
        },
        yAxisNarrowRange: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.narrowRange'
        },
        yAxisPane: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.pane'
        },
        yAxisPlotBands: {
            type: Array,
            default: undefined,
            kComposite: 'yAxis.plotBands'
        }, yAxisReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.reverse'
        },
        yAxisTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.title.background'
        },
        yAxisTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.title.border.color'
        },
        yAxisTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.title.border.dashType'
        },
        yAxisTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.border.width'
        },
        yAxisTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.title.color'
        },
        yAxisTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.title.font'
        },
        yAxisTitleMargin: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.margin'
        },
        yAxisTitleMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.margin.bottom'
        },
        yAxisTitleMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.margin.left'
        },
        yAxisTitleMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.margin.right'
        },
        yAxisTitleMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.margin.top'
        },
        yAxisTitlePadding: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.padding'
        },
        yAxisTitlePaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.padding.bottom'
        },
        yAxisTitlePaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.padding.left'
        },
        yAxisTitlePaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.padding.right'
        },
        yAxisTitlePaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.padding.top'
        },
        yAxisTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.title.position'
        },
        yAxisTitleRotation: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.title.rotation'
        },
        yAxisTitleText: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.title.text'
        },
        yAxisTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.title.visible'
        },
        yAxisTitleVisual: {
            type: Function,
            default: undefined,
            kComposite: 'yAxis.title.visual'
        },
        yAxisType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.type'
        },
        yAxisVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.visible'
        },
        yAxisNotesPosition: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.position'
        },
        yAxisNotesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.icon.background'
        },
        yAxisNotesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.icon.border.color'
        },
        yAxisNotesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.notes.icon.border.width'
        },
        yAxisNotesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.notes.icon.size'
        },
        yAxisNotesIconType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.icon.type'
        },
        yAxisNotesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.notes.icon.visible'
        },
        yAxisNotesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.label.background'
        },
        yAxisNotesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.label.border.color'
        },
        yAxisNotesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.label.border.dashType'
        },
        yAxisNotesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.notes.label.border.width'
        },
        yAxisNotesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.label.color'
        },
        yAxisNotesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.label.font'
        },
        yAxisNotesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'yAxis.notes.label.template'
        },
        yAxisNotesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'yAxis.notes.label.visible'
        },
        yAxisNotesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.notes.label.rotation'
        },
        yAxisNotesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.label.format'
        },
        yAxisNotesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.label.position'
        },
        yAxisNotesLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.line.dashType'
        },
        yAxisNotesLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.notes.line.width'
        },
        yAxisNotesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'yAxis.notes.line.color'
        },
        yAxisNotesLineLength: {
            type: Number,
            default: undefined,
            kComposite: 'yAxis.notes.line.length'
        },
        yAxisNotesData: {
            type: Array,
            default: undefined,
            kComposite: 'yAxis.notes.data'
        }, yAxisNotesVisual: {
            type: Function,
            default: undefined,
            kComposite: 'yAxis.notes.visual'
        }
    }
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        zoomableMousewheel: {
            type: Boolean,
            default: undefined,
            kComposite: 'zoomable.mousewheel'
        },
        zoomableMousewheelLock: {
            type: String,
            default: undefined,
            kComposite: 'zoomable.mousewheel.lock'
        },
        zoomableSelection: {
            type: Boolean,
            default: undefined,
            kComposite: 'zoomable.selection'
        },
        zoomableSelectionKey: {
            type: String,
            default: undefined,
            kComposite: 'zoomable.selection.key'
        },
        zoomableSelectionLock: {
            type: String,
            default: undefined,
            kComposite: 'zoomable.selection.lock'
        }
    }
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoStockChartMixin = __webpack_require__(165);

var _KendoStockChartMixin2 = _interopRequireDefault(_KendoStockChartMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-stockchart',
    mixins: [_KendoStockChartMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoSparklineMixin = __webpack_require__(168);

var _KendoSparklineMixin2 = _interopRequireDefault(_KendoSparklineMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-sparkline',
    mixins: [_KendoSparklineMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('span', defaultSlot);
    }
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoChatMixin = __webpack_require__(179);

var _KendoChatMixin2 = _interopRequireDefault(_KendoChatMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-chat',
    mixins: [_KendoChatMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoDataSourceMixin = __webpack_require__(186);

var _KendoDataSourceMixin2 = _interopRequireDefault(_KendoDataSourceMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-datasource',
    mixins: [_KendoDataSourceMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('div');
    }
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        schemaAggregates: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.aggregates'
        },
        schemaData: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.data'
        },
        schemaErrors: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.errors'
        },
        schemaGroups: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.groups'
        },
        schemaModel: {
            type: Object,
            default: undefined,
            kComposite: 'schema.model'
        },
        schemaModelId: {
            type: String,
            default: undefined,
            kComposite: 'schema.model.id'
        },
        schemaModelFields: {
            type: Object,
            default: undefined,
            kComposite: 'schema.model.fields'
        },
        schemaParse: {
            type: Function,
            default: undefined,
            kComposite: 'schema.parse'
        },
        schemaTotal: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.total'
        },
        schemaType: {
            type: String,
            default: undefined,
            kComposite: 'schema.type'
        }
    }
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoHierarchicalDataSourceMixin = __webpack_require__(189);

var _KendoHierarchicalDataSourceMixin2 = _interopRequireDefault(_KendoHierarchicalDataSourceMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-hierarchicaldatasource',
    mixins: [_KendoHierarchicalDataSourceMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('div');
    }
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoSchedulerDataSourceMixin = __webpack_require__(191);

var _KendoSchedulerDataSourceMixin2 = _interopRequireDefault(_KendoSchedulerDataSourceMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-schedulerdatasource',
    mixins: [_KendoSchedulerDataSourceMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('div');
    }
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoTreeListDataSourceMixin = __webpack_require__(193);

var _KendoTreeListDataSourceMixin2 = _interopRequireDefault(_KendoTreeListDataSourceMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-treelistdatasource',
    mixins: [_KendoTreeListDataSourceMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('div');
    }
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoGanttDataSourceMixin = __webpack_require__(196);

var _KendoGanttDataSourceMixin2 = _interopRequireDefault(_KendoGanttDataSourceMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-ganttdatasource',
    mixins: [_KendoGanttDataSourceMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('div');
    }
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoGanttDependencyDataSourceMixin = __webpack_require__(199);

var _KendoGanttDependencyDataSourceMixin2 = _interopRequireDefault(_KendoGanttDependencyDataSourceMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-ganttdependencydatasource',
    mixins: [_KendoGanttDependencyDataSourceMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('div');
    }
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoPivotDataSourceMixin = __webpack_require__(202);

var _KendoPivotDataSourceMixin2 = _interopRequireDefault(_KendoPivotDataSourceMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-pivotdatasource',
    mixins: [_KendoPivotDataSourceMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoCalendarMixin = __webpack_require__(212);

var _KendoCalendarMixin2 = _interopRequireDefault(_KendoCalendarMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-calendar',
    mixins: [_KendoCalendarMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('div');
    }
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoDateInputMixin = __webpack_require__(215);

var _KendoDateInputMixin2 = _interopRequireDefault(_KendoDateInputMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-dateinput',
    mixins: [_KendoDateInputMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('input', {
            props: {
                value: this.value
            }
        });
    }
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoDatePickerMixin = __webpack_require__(218);

var _KendoDatePickerMixin2 = _interopRequireDefault(_KendoDatePickerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-datepicker',
    mixins: [_KendoDatePickerMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('input', {
            props: {
                value: this.value
            }
        });
    }
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoDateTimePickerMixin = __webpack_require__(220);

var _KendoDateTimePickerMixin2 = _interopRequireDefault(_KendoDateTimePickerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-datetimepicker',
    mixins: [_KendoDateTimePickerMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('input', {
            props: {
                value: this.value
            }
        });
    }
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoTimePickerMixin = __webpack_require__(222);

var _KendoTimePickerMixin2 = _interopRequireDefault(_KendoTimePickerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-timepicker',
    mixins: [_KendoTimePickerMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('input', {
            props: {
                value: this.value
            }
        });
    }
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoMultiViewCalendarMixin = __webpack_require__(224);

var _KendoMultiViewCalendarMixin2 = _interopRequireDefault(_KendoMultiViewCalendarMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-multiviewcalendar',
    mixins: [_KendoMultiViewCalendarMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('div');
    }
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoDateRangePickerMixin = __webpack_require__(229);

var _KendoDateRangePickerMixin2 = _interopRequireDefault(_KendoDateRangePickerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-daterangepicker',
    mixins: [_KendoDateRangePickerMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('div');
    }
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoDiagramMixin = __webpack_require__(235);

var _KendoDiagramMixin2 = _interopRequireDefault(_KendoDiagramMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-diagram',
    mixins: [_KendoDiagramMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoDialogMixin = __webpack_require__(248);

var _KendoDialogMixin2 = _interopRequireDefault(_KendoDialogMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-dialog',
    mixins: [_KendoDialogMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoAutoCompleteMixin = __webpack_require__(256);

var _KendoAutoCompleteMixin2 = _interopRequireDefault(_KendoAutoCompleteMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-autocomplete',
    mixins: [_KendoAutoCompleteMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('input', [this.$slots['kendo-datasource']]);
    }
};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoDropDownListMixin = __webpack_require__(258);

var _KendoDropDownListMixin2 = _interopRequireDefault(_KendoDropDownListMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-dropdownlist',
    mixins: [_KendoDropDownListMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('input', [this.$slots['kendo-datasource']]);
    }
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoComboBoxMixin = __webpack_require__(260);

var _KendoComboBoxMixin2 = _interopRequireDefault(_KendoComboBoxMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-combobox',
    mixins: [_KendoComboBoxMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('input', [this.$slots['kendo-datasource']]);
    }
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoMultiColumnComboBoxMixin = __webpack_require__(262);

var _KendoMultiColumnComboBoxMixin2 = _interopRequireDefault(_KendoMultiColumnComboBoxMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-multicolumncombobox',
    mixins: [_KendoMultiColumnComboBoxMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('input', [this.$slots['kendo-datasource'], defaultSlot]);
    }
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoMultiSelectMixin = __webpack_require__(265);

var _KendoMultiSelectMixin2 = _interopRequireDefault(_KendoMultiSelectMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-multiselect',
    mixins: [_KendoMultiSelectMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('input', [this.$slots['kendo-datasource']]);
    }
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoDropDownTreeMixin = __webpack_require__(269);

var _KendoDropDownTreeMixin2 = _interopRequireDefault(_KendoDropDownTreeMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-dropdowntree',
    mixins: [_KendoDropDownTreeMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;

        var tagName = this.$props.checkboxes || this.$props.checkboxesCheckChildren || this.$props.checkboxesName || this.$props.checkboxesTemplate ? 'select' : 'input';

        return h(tagName, [this.$slots['kendo-hierarchicaldatasource']]);
    }
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoEditorMixin = __webpack_require__(277);

var _KendoEditorMixin2 = _interopRequireDefault(_KendoEditorMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-editor',
    mixins: [_KendoEditorMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var tagName = this.tag || 'textarea';
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h(tagName, defaultSlot);
    }
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoGanttMixin = __webpack_require__(291);

var _KendoGanttMixin2 = _interopRequireDefault(_KendoGanttMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-gantt',
    mixins: [_KendoGanttMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', [this.$slots['kendo-datasource'], defaultSlot]);
    }
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Toolbar = __webpack_require__(295);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoGanttColumn = {
    name: 'kendo-gantt-toolbar-item',
    render: function render() {
        return null;
    },

    mixins: [_Toolbar2.default]
};

exports.default = KendoGanttColumn;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoArcGaugeMixin = __webpack_require__(306);

var _KendoArcGaugeMixin2 = _interopRequireDefault(_KendoArcGaugeMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-arcgauge',
    mixins: [_KendoArcGaugeMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoLinearGaugeMixin = __webpack_require__(310);

var _KendoLinearGaugeMixin2 = _interopRequireDefault(_KendoLinearGaugeMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-lineargauge',
    mixins: [_KendoLinearGaugeMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoRadialGaugeMixin = __webpack_require__(314);

var _KendoRadialGaugeMixin2 = _interopRequireDefault(_KendoRadialGaugeMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-radialgauge',
    mixins: [_KendoRadialGaugeMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoGridMixin = __webpack_require__(320);

var _KendoGridMixin2 = _interopRequireDefault(_KendoGridMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-grid',
    mixins: [_KendoGridMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', [this.$slots['kendo-datasource'], defaultSlot]);
    }
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Toolbar = __webpack_require__(322);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KendoGridToolbar = {
    name: 'kendo-grid-toolbar-item',
    render: function render() {
        return null;
    },

    mixins: [_Toolbar2.default]
};

exports.default = KendoGridToolbar;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoNumericTextBoxMixin = __webpack_require__(339);

var _KendoNumericTextBoxMixin2 = _interopRequireDefault(_KendoNumericTextBoxMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-numerictextbox',
    mixins: [_KendoNumericTextBoxMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        if (this.v3) {
            return h('input', {
                value: this.value
            });
        } else {
            return h('input', {
                props: {
                    value: this.value
                }
            });
        }
    }
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoColorPickerMixin = __webpack_require__(341);

var _KendoColorPickerMixin2 = _interopRequireDefault(_KendoColorPickerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-colorpicker',
    mixins: [_KendoColorPickerMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        if (this.v3) {
            return h('input', {
                value: this.value
            });
        } else {
            return h('input', {
                props: {
                    value: this.value
                }
            });
        }
    }
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        tileSizeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'tileSize.width'
        },
        tileSizeHeight: {
            type: Number,
            default: undefined,
            kComposite: 'tileSize.height'
        }
    }
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoColorPaletteMixin = __webpack_require__(344);

var _KendoColorPaletteMixin2 = _interopRequireDefault(_KendoColorPaletteMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-colorpalette',
    mixins: [_KendoColorPaletteMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('div');
    }
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoFlatColorPickerMixin = __webpack_require__(346);

var _KendoFlatColorPickerMixin2 = _interopRequireDefault(_KendoFlatColorPickerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-flatcolorpicker',
    mixins: [_KendoFlatColorPickerMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('div');
    }
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoMaskedTextBoxMixin = __webpack_require__(349);

var _KendoMaskedTextBoxMixin2 = _interopRequireDefault(_KendoMaskedTextBoxMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-maskedtextbox',
    mixins: [_KendoMaskedTextBoxMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        if (this.v3) {
            return h('input', {
                value: this.value
            });
        } else {
            return h('input', {
                props: {
                    value: this.value
                }
            });
        }
    }
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoSliderMixin = __webpack_require__(351);

var _KendoSliderMixin2 = _interopRequireDefault(_KendoSliderMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-slider',
    mixins: [_KendoSliderMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        if (this.v3) {
            return h('input', {
                value: this.value
            });
        } else {
            return h('input', {
                props: {
                    value: this.value
                }
            });
        }
    }
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        tooltipEnabled: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.enabled'
        },
        tooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.format'
        },
        tooltipTemplate: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.template'
        }
    }
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoRangeSliderMixin = __webpack_require__(353);

var _KendoRangeSliderMixin2 = _interopRequireDefault(_KendoRangeSliderMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-rangeslider',
    mixins: [_KendoRangeSliderMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;

        if (this.v3) {
            return h('div', [h('input', {
                name: this.selectionStartName
            }), h('input', {
                name: this.selectionEndName
            })]);
        } else {
            return h('div', [h('input', {
                props: {
                    name: this.selectionStartName
                }
            }), h('input', {
                props: {
                    name: this.selectionEndName
                }
            })]);
        }
    }
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoSwitchMixin = __webpack_require__(355);

var _KendoSwitchMixin2 = _interopRequireDefault(_KendoSwitchMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-switch',
    mixins: [_KendoSwitchMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        if (this.v3) {
            return h('input', {
                type: 'checkbox'
            });
        } else {
            return h('input', {
                attrs: {
                    type: 'checkbox'
                }
            });
        }
    }
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoMenuMixin = __webpack_require__(360);

var _KendoMenuMixin2 = _interopRequireDefault(_KendoMenuMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-menu',
    mixins: [_KendoMenuMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('ul', defaultSlot);
    }
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        animationCloseEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.close.effects'
        },
        animationCloseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.close.duration'
        },
        animationOpenEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.open.effects'
        },
        animationOpenDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.open.duration'
        }
    }
};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-menu-item',
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('span', defaultSlot);
    },

    mixins: [_kendoBaseComponentsVueWrapper.KendoSharedMethods],
    props: {
        text: {
            type: String,
            default: undefined
        },
        cssClass: {
            type: String,
            default: undefined
        },
        url: {
            type: String,
            default: undefined
        },
        attr: {
            type: Object,
            default: undefined
        },
        encoded: {
            type: Boolean,
            default: undefined
        },
        content: {
            type: String,
            default: undefined
        },
        contentAttr: {
            type: Object,
            default: undefined
        },
        imageAttr: {
            type: Object,
            default: undefined
        },
        imageUrl: {
            type: String,
            default: undefined
        },
        items: {
            type: Array,
            default: undefined
        },
        spriteCssClass: {
            type: String,
            default: undefined
        },
        select: Function
    },
    mounted: function mounted() {
        this._resolveInnerChildren();
    },

    methods: {
        _resolveInnerChildren: function _resolveInnerChildren() {
            var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
            var hasItems = this.v3 ? !this.$props.items : this.$options.propsData && !this.$options.propsData['items'];
            if (hasItems && defaultSlot) {
                var items = this.resolveInnerTags('kendo-menu-item');
                this.subitems = items;
            }
        }
    }
};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoContextMenuMixin = __webpack_require__(363);

var _KendoContextMenuMixin2 = _interopRequireDefault(_KendoContextMenuMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-contextmenu',
    mixins: [_KendoContextMenuMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('ul', defaultSlot);
    }
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoPanelBarMixin = __webpack_require__(366);

var _KendoPanelBarMixin2 = _interopRequireDefault(_KendoPanelBarMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-panelbar',
    mixins: [_KendoPanelBarMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-panelbar-item',
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('span', defaultSlot);
    },

    mixins: [_kendoBaseComponentsVueWrapper.KendoSharedMethods],
    props: {
        text: {
            type: String,
            default: undefined
        },
        cssClass: {
            type: String,
            default: undefined
        },
        url: {
            type: String,
            default: undefined
        },
        encoded: {
            type: Boolean,
            default: undefined
        },
        content: {
            type: String,
            default: undefined
        },
        contentUrl: {
            type: String,
            default: undefined
        },
        imageUrl: {
            type: String,
            default: undefined
        },
        items: {
            type: Array,
            default: undefined
        },
        expanded: {
            type: Boolean,
            default: undefined
        },
        spriteCssClass: {
            type: String,
            default: undefined
        }
    },
    mounted: function mounted() {
        this._resolveInnerChildren();
    },

    methods: {
        _resolveInnerChildren: function _resolveInnerChildren() {
            var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
            var hasItems = this.v3 ? !this.$props.items : this.$options.propsData && !this.$options.propsData['items'];
            if (hasItems && defaultSlot) {
                var items = this.resolveInnerTags('kendo-panelbar-item');
                this.subitems = items;
            }
        }
    }
};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoTabStripMixin = __webpack_require__(370);

var _KendoTabStripMixin2 = _interopRequireDefault(_KendoTabStripMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-tabstrip',
    mixins: [_KendoTabStripMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoSplitterMixin = __webpack_require__(372);

var _KendoSplitterMixin2 = _interopRequireDefault(_KendoSplitterMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-splitter',
    mixins: [_KendoSplitterMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoListBoxMixin = __webpack_require__(377);

var _KendoListBoxMixin2 = _interopRequireDefault(_KendoListBoxMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-listbox',
    mixins: [_KendoListBoxMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('select', defaultSlot);
    }
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoListViewMixin = __webpack_require__(384);

var _KendoListViewMixin2 = _interopRequireDefault(_KendoListViewMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-listview',
    mixins: [_KendoListViewMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoPagerMixin = __webpack_require__(386);

var _KendoPagerMixin2 = _interopRequireDefault(_KendoPagerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-pager',
    mixins: [_KendoPagerMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoMapMixin = __webpack_require__(391);

var _KendoMapMixin2 = _interopRequireDefault(_KendoMapMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-map',
    mixins: [_KendoMapMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoMediaPlayerMixin = __webpack_require__(400);

var _KendoMediaPlayerMixin2 = _interopRequireDefault(_KendoMediaPlayerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-mediaplayer',
    mixins: [_KendoMediaPlayerMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoPivotGridMixin = __webpack_require__(406);

var _KendoPivotGridMixin2 = _interopRequireDefault(_KendoPivotGridMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-pivotgrid',
    mixins: [_KendoPivotGridMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        sortableAllowUnsort: {
            type: Boolean,
            default: undefined,
            kComposite: 'sortable.allowUnsort'
        }
    }
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoPivotConfiguratorMixin = __webpack_require__(411);

var _KendoPivotConfiguratorMixin2 = _interopRequireDefault(_KendoPivotConfiguratorMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-pivotconfigurator',
    mixins: [_KendoPivotConfiguratorMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoNotificationMixin = __webpack_require__(416);

var _KendoNotificationMixin2 = _interopRequireDefault(_KendoNotificationMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-notification',
    mixins: [_KendoNotificationMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('span');
    }
};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        animationCloseEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.close.effects'
        },
        animationCloseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.close.duration'
        },
        animationOpenEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.open.effects'
        },
        animationOpenDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.open.duration'
        }
    }
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoTooltipMixin = __webpack_require__(420);

var _KendoTooltipMixin2 = _interopRequireDefault(_KendoTooltipMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-tooltip',
    mixins: [_KendoTooltipMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoSchedulerMixin = __webpack_require__(425);

var _KendoSchedulerMixin2 = _interopRequireDefault(_KendoSchedulerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-scheduler',
    mixins: [_KendoSchedulerMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoScrollViewMixin = __webpack_require__(438);

var _KendoScrollViewMixin2 = _interopRequireDefault(_KendoScrollViewMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-scrollview',
    mixins: [_KendoScrollViewMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoSpreadsheetMixin = __webpack_require__(442);

var _KendoSpreadsheetMixin2 = _interopRequireDefault(_KendoSpreadsheetMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-spreadsheet',
    mixins: [_KendoSpreadsheetMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoTreeListMixin = __webpack_require__(451);

var _KendoTreeListMixin2 = _interopRequireDefault(_KendoTreeListMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-treelist',
    mixins: [_KendoTreeListMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoTreeMapMixin = __webpack_require__(465);

var _KendoTreeMapMixin2 = _interopRequireDefault(_KendoTreeMapMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-treemap',
    mixins: [_KendoTreeMapMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoTreeViewMixin = __webpack_require__(469);

var _KendoTreeViewMixin2 = _interopRequireDefault(_KendoTreeViewMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-treeview',
    mixins: [_KendoTreeViewMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('ul', defaultSlot);
    }
};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-treeview-item',
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
        return h('li', defaultSlot);
    },

    mixins: [_kendoBaseComponentsVueWrapper.KendoSharedMethods],
    props: {
        text: {
            type: String,
            default: undefined
        },
        cssClass: {
            type: String,
            default: undefined
        },
        url: {
            type: String,
            default: undefined
        },
        encoded: {
            type: Boolean,
            default: undefined
        },
        content: {
            type: String,
            default: undefined
        },
        contentUrl: {
            type: String,
            default: undefined
        },
        imageUrl: {
            type: String,
            default: undefined
        },
        items: {
            type: Array,
            default: undefined
        },
        expanded: {
            type: Boolean,
            default: undefined
        },
        spriteCssClass: {
            type: String,
            default: undefined
        }
    },
    mounted: function mounted() {
        this._resolveInnerChildren();
    },

    methods: {
        _resolveInnerChildren: function _resolveInnerChildren() {
            var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
            var hasItems = this.v3 ? !this.$props.items : this.$options.propsData && !this.$options.propsData['items'];
            if (hasItems && defaultSlot) {
                var items = this.resolveInnerTags('kendo-treeview-item');
                this.subitems = items;
            }
        }
    }
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoUploadMixin = __webpack_require__(476);

var _KendoUploadMixin2 = _interopRequireDefault(_KendoUploadMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-upload',
    mixins: [_KendoUploadMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;

        if (this.v3) {
            return h('input', {
                type: 'file'
            });
        } else {
            return h('input', {
                attrs: {
                    type: 'file'
                }
            });
        }
    }
};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'kendo-validator',
    bind: function bind(el, binding, vnode) {
        vnode.context.kendoValidator = kendo.jQuery(el).kendoValidator(binding.value).getKendoValidator();
    },
    beforeMount: function beforeMount(el, binding) {
        kendo.jQuery(el).kendoValidator(binding.value).getKendoValidator();
    }
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _KendoWindowMixin = __webpack_require__(486);

var _KendoWindowMixin2 = _interopRequireDefault(_KendoWindowMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    name: 'kendo-window',
    mixins: [_KendoWindowMixin2.default],
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    render: function render(createElement) {
        var h = gh || createElement;
        var defaultSlot = this.v3 && this.$slots.default ? this.$slots.default() : this.$slots.default;
        return h('div', defaultSlot);
    }
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _kendoBarcodesVueWrapper = __webpack_require__(137);

Object.keys(_kendoBarcodesVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoBarcodesVueWrapper[key];
    }
  });
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

Object.keys(_kendoBaseComponentsVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoBaseComponentsVueWrapper[key];
    }
  });
});

var _kendoButtonsVueWrapper = __webpack_require__(151);

Object.keys(_kendoButtonsVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoButtonsVueWrapper[key];
    }
  });
});

var _kendoChartsVueWrapper = __webpack_require__(160);

Object.keys(_kendoChartsVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoChartsVueWrapper[key];
    }
  });
});

var _kendoChatVueWrapper = __webpack_require__(178);

Object.keys(_kendoChatVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoChatVueWrapper[key];
    }
  });
});

var _kendoDatasourceVueWrapper = __webpack_require__(185);

Object.keys(_kendoDatasourceVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoDatasourceVueWrapper[key];
    }
  });
});

var _kendoDateinputsVueWrapper = __webpack_require__(210);

Object.keys(_kendoDateinputsVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoDateinputsVueWrapper[key];
    }
  });
});

var _kendoDiagramVueWrapper = __webpack_require__(234);

Object.keys(_kendoDiagramVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoDiagramVueWrapper[key];
    }
  });
});

var _kendoDialogVueWrapper = __webpack_require__(247);

Object.keys(_kendoDialogVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoDialogVueWrapper[key];
    }
  });
});

var _kendoDropdownsVueWrapper = __webpack_require__(255);

Object.keys(_kendoDropdownsVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoDropdownsVueWrapper[key];
    }
  });
});

var _kendoDropdowntreeVueWrapper = __webpack_require__(268);

Object.keys(_kendoDropdowntreeVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoDropdowntreeVueWrapper[key];
    }
  });
});

var _kendoEditorVueWrapper = __webpack_require__(276);

Object.keys(_kendoEditorVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoEditorVueWrapper[key];
    }
  });
});

var _kendoGanttVueWrapper = __webpack_require__(290);

Object.keys(_kendoGanttVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoGanttVueWrapper[key];
    }
  });
});

var _kendoGaugesVueWrapper = __webpack_require__(305);

Object.keys(_kendoGaugesVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoGaugesVueWrapper[key];
    }
  });
});

var _kendoGridVueWrapper = __webpack_require__(319);

Object.keys(_kendoGridVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoGridVueWrapper[key];
    }
  });
});

var _kendoInputsVueWrapper = __webpack_require__(337);

Object.keys(_kendoInputsVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoInputsVueWrapper[key];
    }
  });
});

var _kendoLayoutVueWrapper = __webpack_require__(359);

Object.keys(_kendoLayoutVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoLayoutVueWrapper[key];
    }
  });
});

var _kendoListboxVueWrapper = __webpack_require__(376);

Object.keys(_kendoListboxVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoListboxVueWrapper[key];
    }
  });
});

var _kendoListviewVueWrapper = __webpack_require__(383);

Object.keys(_kendoListviewVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoListviewVueWrapper[key];
    }
  });
});

var _kendoMapVueWrapper = __webpack_require__(390);

Object.keys(_kendoMapVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoMapVueWrapper[key];
    }
  });
});

var _kendoMediaplayerVueWrapper = __webpack_require__(399);

Object.keys(_kendoMediaplayerVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoMediaplayerVueWrapper[key];
    }
  });
});

var _kendoPivotgridVueWrapper = __webpack_require__(405);

Object.keys(_kendoPivotgridVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoPivotgridVueWrapper[key];
    }
  });
});

var _kendoPopupsVueWrapper = __webpack_require__(415);

Object.keys(_kendoPopupsVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoPopupsVueWrapper[key];
    }
  });
});

var _kendoSchedulerVueWrapper = __webpack_require__(424);

Object.keys(_kendoSchedulerVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoSchedulerVueWrapper[key];
    }
  });
});

var _kendoScrollviewVueWrapper = __webpack_require__(437);

Object.keys(_kendoScrollviewVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoScrollviewVueWrapper[key];
    }
  });
});

var _kendoSpreadsheetVueWrapper = __webpack_require__(441);

Object.keys(_kendoSpreadsheetVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoSpreadsheetVueWrapper[key];
    }
  });
});

var _kendoTreelistVueWrapper = __webpack_require__(450);

Object.keys(_kendoTreelistVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoTreelistVueWrapper[key];
    }
  });
});

var _kendoTreemapVueWrapper = __webpack_require__(464);

Object.keys(_kendoTreemapVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoTreemapVueWrapper[key];
    }
  });
});

var _kendoTreeviewVueWrapper = __webpack_require__(468);

Object.keys(_kendoTreeviewVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoTreeviewVueWrapper[key];
    }
  });
});

var _kendoUploadVueWrapper = __webpack_require__(475);

Object.keys(_kendoUploadVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoUploadVueWrapper[key];
    }
  });
});

var _kendoValidatorVueWrapper = __webpack_require__(483);

Object.keys(_kendoValidatorVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoValidatorVueWrapper[key];
    }
  });
});

var _kendoWindowVueWrapper = __webpack_require__(485);

Object.keys(_kendoWindowVueWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _kendoWindowVueWrapper[key];
    }
  });
});

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BarcodesInstaller = exports.KendoBarcodesInstaller = exports.QRCode = exports.KendoQRCode = exports.Barcode = exports.KendoBarcode = undefined;

var _KendoBarcode = __webpack_require__(39);

var _KendoBarcode2 = _interopRequireDefault(_KendoBarcode);

var _KendoQRCode = __webpack_require__(40);

var _KendoQRCode2 = _interopRequireDefault(_KendoQRCode);

var _kendoBarcodesInstaller = __webpack_require__(150);

var _kendoBarcodesInstaller2 = _interopRequireDefault(_kendoBarcodesInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoBarcode = _KendoBarcode2.default;
exports.Barcode = _KendoBarcode2.default;
exports.KendoQRCode = _KendoQRCode2.default;
exports.QRCode = _KendoQRCode2.default;
exports.KendoBarcodesInstaller = _kendoBarcodesInstaller2.default;
exports.BarcodesInstaller = _kendoBarcodesInstaller2.default;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _BarcodeProps = __webpack_require__(143);

var _BarcodeProps2 = _interopRequireDefault(_BarcodeProps);

var _Border = __webpack_require__(144);

var _Border2 = _interopRequireDefault(_Border);

var _Padding = __webpack_require__(145);

var _Padding2 = _interopRequireDefault(_Padding);

var _Text = __webpack_require__(146);

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _BarcodeProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _Border2.default, _Padding2.default, _Text2.default],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoBarcode(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoBarcode();
        }
    }
};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _vue = __webpack_require__(0);

var aVue = _interopRequireWildcard(_vue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var allVue = aVue;
var gh = allVue.h;
var createApp = allVue.createApp;
exports.default = {
    name: 'baseComponent',
    props: {
        disabled: {
            type: Boolean,
            default: undefined
        },
        readonly: {
            type: Boolean,
            default: undefined
        }
    },
    render: function render(createElement) {
        var h = gh || createElement;
        return h('div');
    },
    created: function created() {
        this.createdMethod();
    },

    beforeDestroy: gh ? undefined : function () {
        this.destroyKendoWidget();
    },
    beforeUnmount: function beforeUnmount() {
        this.destroyKendoWidget();
    },
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },

    beforeMount: function beforeMount() {
        if (this.v3) {
            this.createdMethod();
            var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
            var hasDataSource = !this.$props.dataSource;
            if (hasDataSource && defaultSlot) {
                var innerDatasource = defaultSlot.find(function (slot) {
                    return slot.type && slot.type.name && slot.type.name.indexOf('datasource') !== -1;
                });
                if (innerDatasource) {
                    var dataSourceOptions = this.parseOptions(innerDatasource, innerDatasource.type.mixins[0].mixins);
                    this.widgetOptions.dataSource = dataSourceOptions;
                }
            }
        }
    },
    updated: function updated() {
        if (this.modelValue) {
            this.changeValue(this.modelValue);
        }
    },
    mounted: function mounted() {
        if (this.$el.classList && this.$el.classList.length > 0) {
            this.nativeClasses = [].concat(_toConsumableArray(this.$el.classList));
        } else {
            this.nativeClasses = [];
        }
        var props = this.v3 ? this.$props : this.$options.propsData;
        for (var key in props) {
            var that = this;

            if (key.toLowerCase().indexOf('template') !== -1) {
                var isFunction = this.widgetOptions[key] instanceof Function;

                if (isFunction) {
                    this.widgetOptions[key] = this.transformTemplate(key);
                }
            }

            if (key === 'value') {
                that.$watch(key, function (newValue) {
                    that.changeValue(newValue);
                });
            } else if (key === 'disabled') {
                that.$watch(key, function (newValue) {
                    that.makeDisabled(newValue);
                });
            } else if (key === 'readonly') {
                that.$watch(key, function (newValue) {
                    that.makeReadonly(newValue);
                });
            } else {
                that.$watch(key, function (newValue, oldValue) {
                    // Vue always dispatches a change when inline complex objects are bound
                    // https://github.com/telerik/kendo-ui-core/issues/3952
                    if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
                        that.updateWidget();
                    }
                });
            }
        }
    },

    watch: {
        $attrs: function $attrs() {
            this.toggleClasses();
        }
    },
    methods: {
        createdMethod: function createdMethod() {
            this.resolveWidgetOptions();
            this.$_nativeTemplates = [];
            if (!this.v3) {
                this.$on('kendowidgetready', this.ready);
            }
        },
        destroyKendoWidget: function destroyKendoWidget() {
            if (this.kendoWidget() && this.kendoWidget().destroy) {
                this.kendoWidget().destroy();
                if (this.$_nativeTemplates.length) {
                    for (var i = 0; i < this.$_nativeTemplates.length; i++) {
                        var currentTemplate = this.$_nativeTemplates[i];
                        if (currentTemplate.unmount) {
                            currentTemplate.unmount();
                        } else {
                            currentTemplate.$destroy();
                        }
                    }
                }
            }
        },
        toggleClasses: function toggleClasses() {
            var that = this;
            var $element = kendo.jQuery(that.$el);
            var $wrapper = that.kendoWidget().wrapper;

            if ($wrapper && $wrapper[0] !== $element[0]) {
                that.nativeClasses.forEach(function (item) {
                    $wrapper.removeClass(item);
                });

                // Add to wrapper only the custom classes without the default Kendo ones
                if (that.kendoClasses) {
                    that.nativeClasses = [].concat(_toConsumableArray(that.$el.classList)).filter(function (item) {
                        return that.kendoClasses.indexOf(item) < 0;
                    });
                } else {
                    that.nativeClasses = [].concat(_toConsumableArray(that.$el.classList));
                }

                that.nativeClasses.forEach(function (item) {
                    $wrapper.addClass(item);
                });
            }

            if (that.kendoClasses) {
                that.kendoClasses.forEach(function (item) {
                    $element.addClass(item);
                });
            }
        },
        updateWidget: function updateWidget() {
            var that = this;

            that.resolveWidgetOptions();

            if (that._resolveChildren) {
                that._resolveChildren();
            }

            var currentWidget = that.kendoWidget();

            if (currentWidget && currentWidget.setOptions) {
                currentWidget.setOptions(that.widgetOptions);
            }
        },

        transformTemplate: function transformTemplate(key, val) {
            var that = this;
            var object;
            var props = that.v3 ? that.$props : that.$options.propsData;
            var templateDefinition = val || props[key];
            try {
                object = templateDefinition.call(that, {});
            } catch (e) {
                return templateDefinition;
            }

            if (!object.template) {
                return templateDefinition;
            }

            return function () {
                object = templateDefinition.apply(this, arguments);
                var kendoguid;
                if (that.v3) {
                    var newTemplateArgs = typeof object.templateArgs === 'string' ? object.templateArgs : Object.assign({}, object.templateArgs);
                    var tempComponent = (0, createApp)(Object.assign({}, object.template, {
                        data: function data() {
                            return Object.assign({}, object.template.data ? object.template.data() : {}, {
                                templateArgs: newTemplateArgs
                            });
                        }
                    }));
                    kendoguid = 'kendo' + kendo.guid();

                    that.$nextTick(function () {
                        if (document.getElementById(kendoguid)) {
                            tempComponent.mount('#' + kendoguid);
                            that.$_nativeTemplates.push(tempComponent);
                        }
                    });
                } else {
                    var newVue = allVue.default.extend(object);
                    var vueObject = new newVue(object.template);
                    vueObject.$data.templateArgs = object.templateArgs;
                    kendoguid = 'kendo' + kendo.guid();
                    that.$nextTick(function () {
                        if (document.getElementById(kendoguid)) {
                            vueObject.$mount('#' + kendoguid);
                            that.$_nativeTemplates.push(vueObject);
                        }
                    });
                }

                return '<div id="' + kendoguid + '"></div>';
            };
        },
        resolveChildren: function resolveChildren(prop, name) {
            var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
            if (!this.widgetOptions[prop] && defaultSlot) {
                var items = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = defaultSlot[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var childSlot = _step.value;

                        if (childSlot.tag && childSlot.tag.indexOf(name) !== -1 || childSlot.type && childSlot.type.name && childSlot.type.name.toLowerCase().indexOf(name) !== -1) {
                            var childInstance = this.v3 ? childSlot : childSlot.componentInstance;
                            var itemOptions = this.parseOptions(childInstance);

                            if (itemOptions.dataSourceRef) {
                                this.setInnerDataSource('dataSourceRef', 'dataSource', itemOptions);
                            }

                            items.push(itemOptions);
                            this.handleWatcher(childInstance);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                if (items.length) {
                    this.widgetOptions[prop] = items;
                }
            }
        },
        handleWatcher: function handleWatcher(childInstance) {
            var that = this;
            childInstance.stashedPropsData = JSON.stringify(that.v3 ? childInstance.$props : childInstance.$options.propsData);

            if (!that.v3 && !childInstance._isWatchAttached) {
                childInstance.$watch('$props', function () {
                    var props = that.v3 ? childInstance.$props : childInstance.$options.propsData;
                    var propsAsJson = JSON.stringify(props);
                    var needsUpdate = childInstance.stashedPropsData !== propsAsJson;

                    if (that.updateWidget && needsUpdate) {
                        that.updateWidget();
                    } else if (that._resolveInnerChildren) {
                        that._resolveInnerChildren();
                    }

                    childInstance.stashedPropsData = propsAsJson;
                }, { deep: true });

                childInstance._isWatchAttached = true;
            }
        },
        makeDisabled: function makeDisabled(toDisable) {
            if (this.kendoWidget().enable) {
                this.kendoWidget().enable(!toDisable);
            }
        },
        makeReadonly: function makeReadonly(value) {
            if (this.kendoWidget().readonly) {
                this.kendoWidget().readonly(value);
            }
        },
        changeValue: function changeValue(newValue) {
            if (this.kendoWidget().value) {
                this.kendoWidget().value(newValue);
            }
        },
        resolveWidgetOptions: function resolveWidgetOptions() {
            this.widgetOptions = this.parseOptions();
        },
        getListeners: function getListeners() {
            if (this.v3) {
                var listeners = {};
                for (var key in this.$attrs) {
                    if (key.startsWith('on')) {
                        listeners[key] = this.$attrs[key];
                    }
                }

                return listeners;
            } else {
                return this.$listeners;
            }
        },
        parseOptions: function parseOptions(component, defaultMixins) {
            var _this = this;

            var that = component || this;
            var options = {};
            var props = this.v3 ? component ? that.props : that.$props : that.$options.propsData;

            var _loop = function _loop(_key) {
                propOptions = _this.v3 ? component ? undefined : that.$options.__props[0][0][_key] : that.$options.props[_key];
                val = props[_key];

                if (_this.v3 && _key.indexOf('-') !== -1) {
                    _key = _this.camelize(_key);
                }

                compositeProps = propOptions ? propOptions.kComposite : undefined;


                if (that.v3 || _this.v3) {
                    var mixins = component ? defaultMixins || component.type.mixins : that.$options.mixins;
                    if (mixins) {
                        mixins.forEach(function (mixin) {
                            if (mixin.props && mixin.name !== 'baseComponent' && mixin.name !== 'baseDataSourceComponent' && mixin.props[_key] !== undefined && (that.$props ? that.$props[_key] !== undefined : true)) {
                                compositeProps = mixin.props[_key].kComposite;
                            }
                        });
                    }
                }

                if (!compositeProps) {
                    if (_key.toLowerCase().indexOf('template') !== -1 && val instanceof Function) {
                        options[_key] = _this.transformTemplate(_key, val);
                    } else {
                        if (val !== undefined) {
                            options[_key] = val;
                        }
                    }
                } else {
                    if (val !== undefined) {
                        _this.addCompositeProperty(options, compositeProps.split('.'), val);
                    }
                }
                key = _key;
            };

            for (var key in props) {
                var propOptions;
                var val;
                var compositeProps;

                _loop(key);
            }

            if (that.getListeners) {
                if (this.v3) {
                    Object.keys(that.$attrs).forEach(function (event) {
                        var listeners = that.getListeners();
                        var eventName = _this.v3 ? event : event.toLowerCase();
                        if (listeners && listeners[eventName]) {
                            var kendoIndex = event.lastIndexOf('kendo');
                            var kendoEvent;
                            if (kendoIndex !== -1) {
                                kendoEvent = event.replace('kendo', '').toLowerCase();
                            }

                            if (_this.v3 && event.indexOf('onKendo') !== -1) {
                                kendoEvent = event.replace('onKendo', '').toLowerCase();
                            }
                            var kendoEventProp = Object.keys(that.$props).find(function (e) {
                                return e.toLowerCase() === _this.removeOn(event);
                            });
                            options[kendoEvent || kendoEventProp || _this.removeOn(event)] = listeners[eventName];
                        }
                    });
                } else {
                    Object.keys(that.$props).forEach(function (event) {
                        var listeners = that.getListeners();
                        if (listeners && listeners[event.toLowerCase()]) {
                            var kendoIndex = event.lastIndexOf('kendo');
                            var kendoEvent;
                            if (kendoIndex !== -1) {
                                kendoEvent = event.replace('kendo', '').toLowerCase();
                            }

                            options[kendoEvent || event] = listeners[event.toLowerCase()];
                        }
                    });
                }
            }

            if (this.v3 && this.$props.modelValue) {
                options.value = this.$props.modelValue;
            }

            return options;
        },
        addCompositeProperty: function addCompositeProperty(obj, keys, val) {
            var lastKey = keys.pop();
            var lastObj = keys.reduce(function (obj, key) {
                obj[key] = _typeof(obj[key]) === 'object' ? obj[key] || {} : {};
                return obj[key];
            }, obj);

            if (lastKey.toLowerCase().indexOf('template') !== -1 && val instanceof Function) {
                lastObj[lastKey] = this.transformTemplate(lastKey, val);
            } else {
                lastObj[lastKey] = val;
            }
        },
        resolveInnerTags: function resolveInnerTags(tagName) {
            var items = [];
            var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = defaultSlot[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var childSlot = _step2.value;

                    if (childSlot.tag && childSlot.tag.indexOf(tagName) !== -1 || childSlot.type && childSlot.type.name && childSlot.type.name.toLowerCase().indexOf(tagName) !== -1) {
                        var childOptions = childSlot.componentOptions;
                        var childInstance = this.v3 ? childSlot : childSlot.componentInstance;
                        var item = this.v3 ? childInstance.$props || childInstance.props : childOptions.propsData;

                        if (this.v3) {
                            var itemKeys = Object.keys(item);
                            var _iteratorNormalCompletion3 = true;
                            var _didIteratorError3 = false;
                            var _iteratorError3 = undefined;

                            try {
                                for (var _iterator3 = itemKeys[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                    var propKey = _step3.value;

                                    if (propKey.indexOf('-') !== -1) {
                                        item[this.camelize(propKey)] = item[propKey];
                                    }
                                }
                            } catch (err) {
                                _didIteratorError3 = true;
                                _iteratorError3 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                        _iterator3.return();
                                    }
                                } finally {
                                    if (_didIteratorError3) {
                                        throw _iteratorError3;
                                    }
                                }
                            }
                        }

                        if (!item.items) {
                            item.items = childInstance.subitems;
                        }

                        items.push(item);
                        this.handleWatcher(childInstance);
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return items;
        },
        ready: function ready() {
            var that = this;

            if (this.$el.classList.length > 0) {
                that.kendoClasses = [].concat(_toConsumableArray(that.$el.classList)).filter(function (item) {
                    return that.nativeClasses.indexOf(item) < 0;
                });
            }
            var props = that.v3 ? that.$props : that.$options.propsData;
            if (props && props.disabled) {
                that.makeDisabled(true);
            }

            if (props && props.readonly) {
                that.makeReadonly(true);
            }
        },
        camelize: function camelize(str) {
            var arr = str.split('-');
            var capital = arr.map(function (item, index) {
                return index ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() : item;
            });
            var capitalString = capital.join('');

            return capitalString;
        },
        removeOn: function removeOn(str) {

            if (str.indexOf('onKendo') !== -1) {
                return str.replace('onKendo', '').toLowerCase();
            }

            return str.replace('on', '').toLowerCase();
        }
    }
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'baseDataSourceComponent',
    props: {
        dataSourceRef: {
            type: String,
            default: undefined
        }
    },
    render: function render(h) {
        return h('div');
    },

    methods: {
        findDataSource: function findDataSource() {
            var dataSource;
            if (this.$children) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.$children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var a = _step.value;

                        if (this.$children.length && a.kendoDataSource) {
                            dataSource = a.kendoDataSource;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            return dataSource;
        },
        setInnerDataSource: function setInnerDataSource() {
            var dataSourceRefProp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'dataSourceRef';
            var rootProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dataSource';
            var subProp = arguments[2];

            var innerDataSource = this.findDataSource();

            if (innerDataSource) {
                if (!subProp) {
                    this.widgetOptions[rootProp] = innerDataSource;
                } else {
                    subProp[rootProp] = innerDataSource;
                }
            } else {
                var refString = subProp ? subProp[dataSourceRefProp] : this[dataSourceRefProp];
                var referredDataSource = this.getParentsRef(refString);

                if (referredDataSource) {
                    this.attachEvents(referredDataSource);
                    if (!subProp) {
                        this.widgetOptions[rootProp] = referredDataSource.kendoDataSource;
                    } else {
                        subProp[rootProp] = referredDataSource.kendoDataSource;
                    }
                }
            }
        },
        getParentsRef: function getParentsRef(anchor) {
            var parent = this.$parent;

            while (parent && !parent.$refs[anchor]) {
                parent = parent.$parent;
            }

            return parent ? parent.$refs[anchor] : undefined;
        },
        setDataSource: function setDataSource(newValue) {
            var newDataSourceRef = this.getParentsRef(newValue);
            var kendoWidget = this.kendoWidget();

            if (kendoWidget.setDataSource && newDataSourceRef) {
                kendoWidget.setDataSource(newDataSourceRef.kendoDataSource);
            } else if (kendoWidget.setDataSource) {
                kendoWidget.setDataSource(newValue);
            }
        },
        attachEvents: function attachEvents(referredDataSource) {
            if (referredDataSource.kendoDataSource) {
                referredDataSource.kendoDataSource.bind('change', function (ev) {
                    if (referredDataSource.getListeners()['change']) {
                        referredDataSource.$emit('change', ev);
                    }
                });

                referredDataSource.kendoDataSource.bind('error', function (ev) {
                    if (referredDataSource.getListeners()['error']) {
                        referredDataSource.$emit('error', ev);
                    }
                });

                referredDataSource.kendoDataSource.bind('push', function (ev) {
                    if (referredDataSource.getListeners()['push']) {
                        referredDataSource.$emit('push', ev);
                    }
                });

                referredDataSource.kendoDataSource.bind('requestEnd', function (ev) {
                    if (referredDataSource.getListeners()['requestend']) {
                        referredDataSource.$emit('requestend', ev);
                    }
                });

                referredDataSource.kendoDataSource.bind('requestStart', function (ev) {
                    if (referredDataSource.getListeners()['requeststart']) {
                        referredDataSource.$emit('requeststart', ev);
                    }
                });

                referredDataSource.kendoDataSource.bind('sync', function (ev) {
                    if (referredDataSource.getListeners()['sync']) {
                        referredDataSource.$emit('sync', ev);
                    }
                });
            }
        }
    },
    mounted: function mounted() {
        var that = this;

        that.$watch('dataSourceRef', function (newValue) {
            that.setDataSource(newValue);
        });
        that.$watch('dataSource', function (newValue) {
            that.setDataSource(newValue);
        });

        that.setInnerDataSource();
    }
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue; // @ts-ignore

var gh = allVue.h;
exports.default = {
    render: function render(createElement) {
        var h = gh || createElement;
        return h('input', {
            ref: 'valueInput',
            props: {
                value: this.value
            }
        });
    },

    model: {
        event: 'changemodel'
    }
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    methods: {
        resolveInnerTags: function resolveInnerTags(tagName) {
            var items = [];
            var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = defaultSlot[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var childSlot = _step.value;

                    if (childSlot.tag && childSlot.tag.indexOf(tagName) !== -1 || childSlot.type && childSlot.type.name && childSlot.type.name.toLowerCase().indexOf(tagName) !== -1) {
                        var childOptions = childSlot.componentOptions;
                        var childInstance = this.v3 ? childSlot : childSlot.componentInstance;
                        var item = this.v3 ? childInstance.$props || childInstance.props : childOptions.propsData;

                        if (this.v3) {
                            var itemKeys = Object.keys(item);
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;

                            try {
                                for (var _iterator2 = itemKeys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    var propKey = _step2.value;

                                    if (propKey.indexOf('-') !== -1) {
                                        item[this.camelize(propKey)] = item[propKey];
                                    }
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                        _iterator2.return();
                                    }
                                } finally {
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        }

                        if (!item.items) {
                            item.items = childInstance.subitems;
                        }

                        items.push(item);
                        this.handleWatcher(childInstance);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return items;
        },
        handleWatcher: function handleWatcher(childInstance) {
            var that = this;

            if (!childInstance._isWatchAttached && childInstance.$watch) {
                childInstance.$watch('$props', function () {
                    if (that.updateWidget) {
                        that.updateWidget();
                    } else if (that._resolveInnerChildren) {
                        that._resolveInnerChildren();
                    }
                }, { deep: true });

                childInstance._isWatchAttached = true;
            }
        },
        camelize: function camelize(str) {
            var arr = str.split('-');
            var capital = arr.map(function (item, index) {
                return index ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() : item;
            });
            var capitalString = capital.join('');

            return capitalString;
        }
    }
};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    renderAs: {
        type: String,
        default: undefined
    },
    background: {
        type: String,
        default: undefined
    },
    border: {
        type: Object,
        default: undefined
    },
    checksum: {
        type: Boolean,
        default: undefined
    },
    color: {
        type: String,
        default: undefined
    },
    height: {
        type: Number,
        default: undefined
    },
    padding: {
        type: Object,
        default: undefined
    },
    text: {
        type: Object,
        default: undefined
    },
    type: {
        type: String,
        default: undefined
    },
    value: {
        type: [Number, String],
        default: undefined
    },
    width: {
        type: Number,
        default: undefined
    }
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        borderColor: {
            type: String,
            default: undefined,
            kComposite: 'border.color'
        },
        borderDashType: {
            type: String,
            default: undefined,
            kComposite: 'border.dashType'
        },
        borderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'border.width'
        }
    }
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        paddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'padding.bottom'
        },
        paddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'padding.left'
        },
        paddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'padding.right'
        },
        paddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'padding.top'
        }
    }
};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        textColor: {
            type: String,
            default: undefined,
            kComposite: 'text.color'
        },
        textFont: {
            type: String,
            default: undefined,
            kComposite: 'text.font'
        },
        textMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'text.margin.bottom'
        },
        textMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'text.margin.left'
        },
        textMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'text.margin.right'
        },
        textMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'text.margin.top'
        },
        textVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'text.visible'
        }
    }
};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _QRCodeProps = __webpack_require__(148);

var _QRCodeProps2 = _interopRequireDefault(_QRCodeProps);

var _Border = __webpack_require__(149);

var _Border2 = _interopRequireDefault(_Border);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _QRCodeProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _Border2.default],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoQRCode(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoQRCode();
        }
    }
};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    background: {
        type: String,
        default: undefined
    },
    border: {
        type: Object,
        default: undefined
    },
    color: {
        type: String,
        default: undefined
    },
    encoding: {
        type: String,
        default: undefined
    },
    errorCorrection: {
        type: String,
        default: undefined
    },
    padding: {
        type: Number,
        default: undefined
    },
    renderAs: {
        type: String,
        default: undefined
    },
    size: {
        type: [Number, String],
        default: undefined
    },
    value: {
        type: [Number, String],
        default: undefined

        // Events
    } };

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        borderColor: {
            type: String,
            default: undefined,
            kComposite: 'border.color'
        },
        borderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'border.width'
        }
    }
};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoBarcode = __webpack_require__(39);

var _KendoBarcode2 = _interopRequireDefault(_KendoBarcode);

var _KendoQRCode = __webpack_require__(40);

var _KendoQRCode2 = _interopRequireDefault(_KendoQRCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoBarcodesInstaller = function () {
    function KendoBarcodesInstaller() {
        _classCallCheck(this, KendoBarcodesInstaller);
    }

    _createClass(KendoBarcodesInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoBarcode2.default.name, _KendoBarcode2.default);
            Vue.component(_KendoQRCode2.default.name, _KendoQRCode2.default);
        }
    }]);

    return KendoBarcodesInstaller;
}();

exports.default = KendoBarcodesInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoBarcodesInstaller);
}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroupButton = exports.KendoButtonGroupButton = exports.ButtonsInstaller = exports.KendoButtonsInstaller = exports.ToolBarItem = exports.KendoToolBarItem = exports.ToolBar = exports.KendoToolBar = exports.ButtonGroup = exports.KendoButtonGroup = exports.Button = exports.KendoButton = undefined;

var _KendoButton = __webpack_require__(41);

var _KendoButton2 = _interopRequireDefault(_KendoButton);

var _KendoButtonGroup = __webpack_require__(42);

var _KendoButtonGroup2 = _interopRequireDefault(_KendoButtonGroup);

var _KendoButtonGroupButton = __webpack_require__(43);

var _KendoButtonGroupButton2 = _interopRequireDefault(_KendoButtonGroupButton);

var _KendoToolBar = __webpack_require__(44);

var _KendoToolBar2 = _interopRequireDefault(_KendoToolBar);

var _KendoToolBarItem = __webpack_require__(10);

var _KendoToolBarItem2 = _interopRequireDefault(_KendoToolBarItem);

var _kendoButtonsInstaller = __webpack_require__(159);

var _kendoButtonsInstaller2 = _interopRequireDefault(_kendoButtonsInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoButton = _KendoButton2.default;
exports.Button = _KendoButton2.default;
exports.KendoButtonGroup = _KendoButtonGroup2.default;
exports.ButtonGroup = _KendoButtonGroup2.default;
exports.KendoToolBar = _KendoToolBar2.default;
exports.ToolBar = _KendoToolBar2.default;
exports.KendoToolBarItem = _KendoToolBarItem2.default;
exports.ToolBarItem = _KendoToolBarItem2.default;
exports.KendoButtonsInstaller = _kendoButtonsInstaller2.default;
exports.ButtonsInstaller = _kendoButtonsInstaller2.default;
exports.KendoButtonGroupButton = _KendoButtonGroupButton2.default;
exports.ButtonGroupButton = _KendoButtonGroupButton2.default;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _ButtonProps = __webpack_require__(153);

var _ButtonProps2 = _interopRequireDefault(_ButtonProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _ButtonProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoButton(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoButton();
        }
    }
};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    enable: {
        type: Boolean,
        default: undefined
    },
    icon: {
        type: String,
        default: undefined
    },
    imageUrl: {
        type: String,
        default: undefined
    },
    spriteCssClass: {
        type: String,
        default: undefined
    },

    // Events
    click: Function
};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _ButtonGroupProps = __webpack_require__(155);

var _ButtonGroupProps2 = _interopRequireDefault(_ButtonGroupProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _ButtonGroupProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoButtonGroup(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoButtonGroup();
        }
    }
};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    enable: {
        type: Boolean,
        default: undefined
    },
    index: {
        type: Number,
        default: undefined
    },
    selection: {
        type: String,
        default: undefined
    },

    // Events
    select: Function
};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _ToolBarProps = __webpack_require__(157);

var _ToolBarProps2 = _interopRequireDefault(_ToolBarProps);

var _KendoToolBarItem = __webpack_require__(10);

var _KendoToolBarItem2 = _interopRequireDefault(_KendoToolBarItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _ToolBarProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent],
    mounted: function mounted() {
        this._resolveChildren();

        kendo.jQuery(this.$el).kendoToolBar(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoToolBar();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('items', _KendoToolBarItem2.default.name);
        }
    }
};

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    resizable: {
        type: Boolean,
        default: undefined
    },
    items: {
        type: Array,
        default: undefined
    },

    // Events
    click: {
        type: Function,
        default: undefined
    },
    close: {
        type: Function,
        default: undefined
    },
    open: {
        type: Function,
        default: undefined
    },
    toggle: {
        type: Function,
        default: undefined
    },
    overflowClose: {
        type: Function,
        default: undefined
    },
    overflowOpen: Function
};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        attributes: {
            type: Object,
            default: undefined
        },
        buttons: {
            type: Array,
            default: undefined
        },
        click: {
            type: Function,
            default: undefined
        },
        enable: {
            default: true,
            type: Boolean
        },
        group: {
            type: String,
            default: undefined
        },
        hidden: {
            type: Boolean,
            default: undefined
        },
        icon: {
            type: String,
            default: undefined
        },
        id: {
            type: String,
            default: undefined
        },
        imageUrl: {
            type: String,
            default: undefined
        },
        menuButtons: {
            type: Array
        },
        overflow: {
            type: String,
            default: undefined
        },
        overflowTemplate: {
            type: [String, Function],
            default: undefined
        },
        primary: {
            type: Boolean,
            default: undefined
        },
        selected: {
            type: Boolean,
            default: undefined
        },
        showIcon: {
            type: String
        },
        showText: {
            type: String,
            default: undefined
        },
        spriteCssClass: {
            type: String,
            default: undefined
        },
        template: {
            type: [String, Function],
            default: undefined
        },
        text: {
            type: String,
            default: undefined
        },
        togglable: {
            type: Boolean,
            default: undefined
        },
        toggle: {
            type: Function
        },
        type: {
            type: String,
            default: undefined
        },
        url: {
            type: String,
            default: undefined
        }
    }
};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoButton = __webpack_require__(41);

var _KendoButton2 = _interopRequireDefault(_KendoButton);

var _KendoButtonGroup = __webpack_require__(42);

var _KendoButtonGroup2 = _interopRequireDefault(_KendoButtonGroup);

var _KendoButtonGroupButton = __webpack_require__(43);

var _KendoButtonGroupButton2 = _interopRequireDefault(_KendoButtonGroupButton);

var _KendoToolBar = __webpack_require__(44);

var _KendoToolBar2 = _interopRequireDefault(_KendoToolBar);

var _KendoToolBarItem = __webpack_require__(10);

var _KendoToolBarItem2 = _interopRequireDefault(_KendoToolBarItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoButtonsInstaller = function () {
    function KendoButtonsInstaller() {
        _classCallCheck(this, KendoButtonsInstaller);
    }

    _createClass(KendoButtonsInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoButton2.default.name, _KendoButton2.default);
            Vue.component(_KendoButtonGroup2.default.name, _KendoButtonGroup2.default);
            Vue.component(_KendoButtonGroupButton2.default.name, _KendoButtonGroupButton2.default);
            Vue.component(_KendoToolBar2.default.name, _KendoToolBar2.default);
            Vue.component(_KendoToolBarItem2.default.name, _KendoToolBarItem2.default);
        }
    }]);

    return KendoButtonsInstaller;
}();

exports.default = KendoButtonsInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoButtonsInstaller);
}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartInstaller = exports.KendoChartInstaller = exports.SparklineSeriesItem = exports.KendoSparklineSeriesItem = exports.Sparkline = exports.KendoSparkline = exports.StockChart = exports.KendoStockChart = exports.ChartSeriesItem = exports.KendoChartSeriesItem = exports.Chart = exports.KendoChart = undefined;

var _KendoChart = __webpack_require__(45);

var _KendoChart2 = _interopRequireDefault(_KendoChart);

var _KendoChartSeriesItem = __webpack_require__(11);

var _KendoChartSeriesItem2 = _interopRequireDefault(_KendoChartSeriesItem);

var _KendoStockChart = __webpack_require__(63);

var _KendoStockChart2 = _interopRequireDefault(_KendoStockChart);

var _KendoSparkline = __webpack_require__(64);

var _KendoSparkline2 = _interopRequireDefault(_KendoSparkline);

var _KendoSparklineSeriesItem = __webpack_require__(12);

var _KendoSparklineSeriesItem2 = _interopRequireDefault(_KendoSparklineSeriesItem);

var _kendoChartInstaller = __webpack_require__(177);

var _kendoChartInstaller2 = _interopRequireDefault(_kendoChartInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoChart = _KendoChart2.default;
exports.Chart = _KendoChart2.default;
exports.KendoChartSeriesItem = _KendoChartSeriesItem2.default;
exports.ChartSeriesItem = _KendoChartSeriesItem2.default;
exports.KendoStockChart = _KendoStockChart2.default;
exports.StockChart = _KendoStockChart2.default;
exports.KendoSparkline = _KendoSparkline2.default;
exports.Sparkline = _KendoSparkline2.default;
exports.KendoSparklineSeriesItem = _KendoSparklineSeriesItem2.default;
exports.SparklineSeriesItem = _KendoSparklineSeriesItem2.default;
exports.KendoChartInstaller = _kendoChartInstaller2.default;
exports.ChartInstaller = _kendoChartInstaller2.default;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _KendoChartBase = __webpack_require__(46);

var _KendoChartBase2 = _interopRequireDefault(_KendoChartBase);

var _AxisDefaults = __webpack_require__(47);

var _AxisDefaults2 = _interopRequireDefault(_AxisDefaults);

var _CategoryAxis = __webpack_require__(48);

var _CategoryAxis2 = _interopRequireDefault(_CategoryAxis);

var _ChartArea = __webpack_require__(49);

var _ChartArea2 = _interopRequireDefault(_ChartArea);

var _Legend = __webpack_require__(50);

var _Legend2 = _interopRequireDefault(_Legend);

var _Panes = __webpack_require__(51);

var _Panes2 = _interopRequireDefault(_Panes);

var _Pannable = __webpack_require__(52);

var _Pannable2 = _interopRequireDefault(_Pannable);

var _Pdf = __webpack_require__(53);

var _Pdf2 = _interopRequireDefault(_Pdf);

var _PlotArea = __webpack_require__(54);

var _PlotArea2 = _interopRequireDefault(_PlotArea);

var _Series = __webpack_require__(55);

var _Series2 = _interopRequireDefault(_Series);

var _SeriesDefaults = __webpack_require__(56);

var _SeriesDefaults2 = _interopRequireDefault(_SeriesDefaults);

var _Title = __webpack_require__(57);

var _Title2 = _interopRequireDefault(_Title);

var _Tooltip = __webpack_require__(58);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _ValueAxis = __webpack_require__(59);

var _ValueAxis2 = _interopRequireDefault(_ValueAxis);

var _XAxis = __webpack_require__(60);

var _XAxis2 = _interopRequireDefault(_XAxis);

var _YAxis = __webpack_require__(61);

var _YAxis2 = _interopRequireDefault(_YAxis);

var _Zoomable = __webpack_require__(62);

var _Zoomable2 = _interopRequireDefault(_Zoomable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    mixins: [_KendoChartBase2.default, _kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _AxisDefaults2.default, _CategoryAxis2.default, _ChartArea2.default, _Legend2.default, _Panes2.default, _Pannable2.default, _Pdf2.default, _PlotArea2.default, _Series2.default, _SeriesDefaults2.default, _Title2.default, _Tooltip2.default, _ValueAxis2.default, _XAxis2.default, _YAxis2.default, _Zoomable2.default],
    emits: {
        'kendowidgetready': null
    },
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoChart(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    }
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(0);

var Vue = _interopRequireWildcard(_vue);

var _ChartProps = __webpack_require__(163);

var _ChartProps2 = _interopRequireDefault(_ChartProps);

var _KendoChartSeriesItem = __webpack_require__(11);

var _KendoChartSeriesItem2 = _interopRequireDefault(_KendoChartSeriesItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allVue = Vue;
var gh = allVue.h;
exports.default = {
    props: _ChartProps2.default,
    setup: function setup() {
        var v3 = !!gh;
        return {
            v3: v3
        };
    },
    mounted: function mounted() {
        this._resolveChildren();
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoChart();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('series', _KendoChartSeriesItem2.default.name);
        }
    }
};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    autoBind: {
        type: String,
        default: undefined
    },
    axisDefaults: {
        type: Object,
        default: undefined
    },
    categoryAxis: {
        type: [Array, Object],
        default: undefined
    },
    chartArea: {
        type: Object,
        default: undefined
    },
    dataSource: {
        type: [Array, Object],
        default: undefined
    },
    legend: {
        type: Object,
        default: undefined
    },
    panes: {
        type: [Array, Object],
        default: undefined
    },
    pannable: {
        type: [Boolean, Object],
        default: undefined
    },
    pdf: {
        type: Object,
        default: undefined
    },
    plotArea: {
        type: Object,
        default: undefined
    },
    renderAs: {
        type: String,
        default: undefined
    },
    series: {
        type: Array,
        default: undefined
    },
    seriesColors: {
        type: Array,
        default: undefined
    },
    seriesDefaults: {
        type: Object,
        default: undefined
    },
    theme: {
        type: String,
        default: undefined
    },
    title: {
        type: [String, Object],
        default: undefined
    },
    tooltip: {
        type: Object,
        default: undefined
    },
    transitions: {
        type: Boolean,
        default: undefined
    },
    valueAxis: {
        type: [Array, Object],
        default: undefined
    },
    xAxis: {
        type: [Array, Object],
        default: undefined
    },
    yAxis: {
        type: [Array, Object],
        default: undefined
    },
    zoomable: {
        type: [Boolean, Object],
        default: undefined
    },

    // Events
    axisLabelClick: {
        type: Function,
        default: undefined
    },
    dataBound: {
        type: Function,
        default: undefined
    },
    drag: {
        type: Function,
        default: undefined
    },
    dragEnd: {
        type: Function,
        default: undefined
    },
    dragStart: {
        type: Function,
        default: undefined
    },
    legendItemClick: {
        type: Function,
        default: undefined
    },
    legendItemHover: {
        type: Function,
        default: undefined
    },
    noteClick: {
        type: Function,
        default: undefined
    },
    noteHover: {
        type: Function,
        default: undefined
    },
    plotAreaClick: {
        type: Function,
        default: undefined
    },
    plotAreaHover: {
        type: Function,
        default: undefined
    },
    render: {
        type: Function,
        default: undefined
    },
    select: {
        type: Function,
        default: undefined
    },
    selectEnd: {
        type: Function,
        default: undefined
    },
    selectStart: {
        type: Function,
        default: undefined
    },
    seriesClick: {
        type: Function,
        default: undefined
    },
    seriesHover: {
        type: Function,
        default: undefined
    },
    seriesOver: {
        type: Function,
        default: undefined
    },
    zoom: {
        type: Function,
        default: undefined
    },
    zoomEnd: {
        type: Function,
        default: undefined
    },
    zoomStart: Function
};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        aggregate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'aggregate'
        },
        axis: {
            type: String,
            default: undefined,
            kComposite: 'axis'
        },
        borderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'border.color'
        },
        borderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'border.dashType'
        },
        borderOpacity: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'border.opacity'
        },
        borderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'border.width'
        },
        categoryAxis: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis'
        },
        categoryField: {
            type: String,
            default: undefined,
            kComposite: 'categoryField'
        },
        closeField: {
            type: String,
            default: undefined,
            kComposite: 'closeField'
        },
        color: {
            type: [String, Function],
            default: undefined,
            kComposite: 'color'
        },
        colorField: {
            type: String,
            default: undefined,
            kComposite: 'colorField'
        },
        connectorsColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'connectors.color'
        },
        connectorsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'connectors.padding'
        },
        connectorsWidth: {
            type: Number,
            default: undefined,
            kComposite: 'connectors.width'
        },
        currentField: {
            type: String,
            default: undefined,
            kComposite: 'currentField'
        },
        dashType: {
            type: String,
            default: undefined,
            kComposite: 'dashType'
        },
        data: {
            type: Array,
            default: undefined,
            kComposite: 'data'
        },
        downColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'downColor'
        },
        downColorField: {
            type: String,
            default: undefined,
            kComposite: 'downColorField'
        },
        segmentSpacing: {
            type: Number,
            default: undefined,
            kComposite: 'segmentSpacing'
        },
        summaryField: {
            type: String,
            default: undefined,
            kComposite: 'summaryField'
        },
        neckRatio: {
            type: Number,
            default: undefined,
            kComposite: 'neckRatio'
        },
        dynamicSlope: {
            type: Boolean,
            default: undefined,
            kComposite: 'dynamicSlope'
        },
        dynamicHeight: {
            type: Boolean,
            default: undefined,
            kComposite: 'dynamicHeight'
        },
        errorBarsValue: {
            type: [String, Number, Array, Function],
            default: undefined,
            kComposite: 'errorBars.value'
        },
        errorBarsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'errorBars.visual'
        },
        errorBarsXValue: {
            type: [String, Number, Array, Function],
            default: undefined,
            kComposite: 'errorBars.xValue'
        },
        errorBarsYValue: {
            type: [String, Number, Array, Function],
            default: undefined,
            kComposite: 'errorBars.yValue'
        },
        errorBarsEndCaps: {
            type: Boolean,
            default: undefined,
            kComposite: 'errorBars.endCaps'
        },
        errorBarsColor: {
            type: String,
            default: undefined,
            kComposite: 'errorBars.color'
        },
        errorBarslineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'errorBars.line.width'
        },
        errorBarslineDashType: {
            type: String,
            default: undefined,
            kComposite: 'errorBars.line.dashType'
        },
        errorLowField: {
            type: String,
            default: undefined,
            kComposite: 'errorLowField'
        },
        errorHighField: {
            type: String,
            default: undefined,
            kComposite: 'errorHighField'
        },
        xErrorLowField: {
            type: String,
            default: undefined,
            kComposite: 'xErrorLowField'
        },
        xErrorHighField: {
            type: String,
            default: undefined,
            kComposite: 'xErrorHighField'
        },
        yErrorLowField: {
            type: String,
            default: undefined,
            kComposite: 'yErrorLowField'
        },
        yErrorHighField: {
            type: String,
            default: undefined,
            kComposite: 'yErrorHighField'
        },
        explodeField: {
            type: String,
            default: undefined,
            kComposite: 'explodeField'
        },
        field: {
            type: String,
            default: undefined,
            kComposite: 'field'
        },
        fromField: {
            type: String,
            default: undefined,
            kComposite: 'fromField'
        },
        toField: {
            type: String,
            default: undefined,
            kComposite: 'toField'
        },
        noteTextField: {
            type: String,
            default: undefined,
            kComposite: 'noteTextField'
        },
        lowerField: {
            type: String,
            default: undefined,
            kComposite: 'lowerField'
        },
        q1Field: {
            type: String,
            default: undefined,
            kComposite: 'q1Field'
        },
        medianField: {
            type: String,
            default: undefined,
            kComposite: 'medianField'
        },
        q3Field: {
            type: String,
            default: undefined,
            kComposite: 'q3Field'
        },
        upperField: {
            type: String,
            default: undefined,
            kComposite: 'upperField'
        },
        meanField: {
            type: String,
            default: undefined,
            kComposite: 'meanField'
        },
        outliersField: {
            type: String,
            default: undefined,
            kComposite: 'outliersField'
        },
        gap: {
            type: Number,
            default: undefined,
            kComposite: 'gap'
        },
        highField: {
            type: String,
            default: undefined,
            kComposite: 'highField'
        },
        highlightBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'highlight.border.color'
        },
        highlightBorderOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'highlight.border.opacity'
        },
        highlightBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'highlight.border.width'
        },
        highlightColor: {
            type: String,
            default: undefined,
            kComposite: 'highlight.color'
        },
        highlightlineDashType: {
            type: String,
            default: undefined,
            kComposite: 'highlight.line.dashType'
        },
        highlightlineColor: {
            type: String,
            default: undefined,
            kComposite: 'highlight.line.color'
        },
        highlightlineOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'highlight.line.opacity'
        },
        highlightlineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'highlight.line.width'
        },
        highlightOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'highlight.opacity'
        },
        highlightToggle: {
            type: Function,
            default: undefined,
            kComposite: 'highlight.toggle'
        },
        highlightVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'highlight.visible'
        },
        highlightVisual: {
            type: Function,
            default: undefined,
            kComposite: 'highlight.visual'
        },
        holeSize: {
            type: Number,
            default: undefined,
            kComposite: 'holeSize'
        },
        labelsAlign: {
            type: String,
            default: undefined,
            kComposite: 'labels.align'
        },
        labelsBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.background'
        },
        labelsBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.border.color'
        },
        labelsBorderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.border.dashType'
        },
        labelsBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'labels.border.width'
        },
        labelsColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.color'
        },
        labelsDistance: {
            type: Number,
            default: undefined,
            kComposite: 'labels.distance'
        },
        labelsFont: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.font'
        },
        labelsFormat: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.format'
        },
        labelsmargin: {
            type: Number,
            default: undefined,
            kComposite: 'labels.margin'
        },
        labelsmarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'labels.margin.bottom'
        },
        labelsmarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'labels.margin.left'
        },
        labelsmarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'labels.margin.right'
        },
        labelsmarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'labels.margin.top'
        },
        labelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'labels.padding'
        },
        labelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'labels.padding.bottom'
        },
        labelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'labels.padding.left'
        },
        labelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'labels.padding.right'
        },
        labelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'labels.padding.top'
        },
        labelsPosition: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.position'
        },
        labelsRotation: {
            type: [String, Number],
            default: undefined,
            kComposite: 'labels.rotation'
        },
        labelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.template'
        },
        labelsVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'labels.visible'
        },
        labelsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'labels.visual'
        },
        labelsFromBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.from.background'
        },
        labelsFromBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.from.border.color'
        },
        labelsFromBorderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.from.border.dashType'
        },
        labelsFromBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'labels.from.border.width'
        },
        labelsFromColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.from.color'
        },
        labelsFromFont: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.from.font'
        },
        labelsFromFormat: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.from.format'
        },
        labelsFrommargin: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.margin'
        },
        labelsFrommarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.margin.bottom'
        },
        labelsFrommarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.margin.left'
        },
        labelsFrommarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.margin.right'
        },
        labelsFrommarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.margin.top'
        },
        labelsFromPadding: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.padding'
        },
        labelsFromPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.padding.bottom'
        },
        labelsFromPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.padding.left'
        },
        labelsFromPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.padding.right'
        },
        labelsFromPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'labels.from.padding.top'
        },
        labelsFromPosition: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.from.position'
        },
        labelsFromTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.from.template'
        },
        labelsFromVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'labels.from.visible'
        },
        labelsToBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.to.background'
        },
        labelsToBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.to.border.color'
        },
        labelsToBorderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.to.border.dashType'
        },
        labelsToBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'labels.to.border.width'
        },
        labelsToColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.to.color'
        },
        labelsToFont: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.to.font'
        },
        labelsToFormat: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.to.format'
        },
        labelsTomargin: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.margin'
        },
        labelsTomarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.margin.bottom'
        },
        labelsTomarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.margin.left'
        },
        labelsTomarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.margin.right'
        },
        labelsTomarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.margin.top'
        },
        labelsToPadding: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.padding'
        },
        labelsToPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.padding.bottom'
        },
        labelsToPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.padding.left'
        },
        labelsToPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.padding.right'
        },
        labelsToPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'labels.to.padding.top'
        },
        labelsToPosition: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.to.position'
        },
        labelsToTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'labels.to.template'
        },
        labelsToVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'labels.to.visible'
        },
        line: {
            type: String,
            default: undefined,
            kComposite: 'line'
        },
        lineColor: {
            type: String,
            default: undefined,
            kComposite: 'line.color'
        },
        lineOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'line.opacity'
        },
        lineWidth: {
            type: String,
            default: undefined,
            kComposite: 'line.width'
        },
        lineStyle: {
            type: String,
            default: undefined,
            kComposite: 'line.style'
        },
        lowField: {
            type: String,
            default: undefined,
            kComposite: 'lowField'
        },
        margin: {
            type: Number,
            default: undefined,
            kComposite: 'margin'
        },
        marginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'margin.bottom'
        },
        marginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'margin.left'
        },
        marginRight: {
            type: Number,
            default: undefined,
            kComposite: 'margin.right'
        },
        marginTop: {
            type: Number,
            default: undefined,
            kComposite: 'margin.top'
        },
        markersBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markers.background'
        },
        markersBorder: {
            type: Function,
            default: undefined,
            kComposite: 'markers.border'
        },
        markersBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markers.border.color'
        },
        markersBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'markers.border.width'
        },
        markersFromBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markers.from.background'
        },
        markersFromBorder: {
            type: Function,
            default: undefined,
            kComposite: 'markers.from.border'
        },
        markersFromBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markers.from.border.color'
        },
        markersFromBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'markers.from.border.width'
        },
        markersFromSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'markers.from.size'
        },
        markersFromType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markers.from.type'
        },
        markersFromVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'markers.from.visible'
        },
        markersFromVisual: {
            type: Function,
            default: undefined,
            kComposite: 'markers.from.visual'
        },
        markersFromRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'markers.from.rotation'
        },
        markersSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'markers.size'
        },
        markersToBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markers.to.background'
        },
        markersToBorder: {
            type: Function,
            default: undefined,
            kComposite: 'markers.to.border'
        },
        markersToBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markers.to.border.color'
        },
        markersToBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'markers.to.border.width'
        },
        markersToSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'markers.to.size'
        },
        markersToType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markers.to.type'
        },
        markersToVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'markers.to.visible'
        },
        markersToVisual: {
            type: Function,
            default: undefined,
            kComposite: 'markers.to.visual'
        },
        markersToRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'markers.to.rotation'
        },
        markersType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markers.type'
        },
        markersVisible: {
            type: [Boolean, Function],
            default: undefined,
            kComposite: 'markers.visible'
        },
        markersVisual: {
            type: Function,
            default: undefined,
            kComposite: 'markers.visual'
        },
        markersRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'markers.rotation'
        },
        outliersBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'outliers.background'
        },
        outliersBorder: {
            type: Function,
            default: undefined,
            kComposite: 'outliers.border'
        },
        outliersBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'outliers.border.color'
        },
        outliersBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'outliers.border.width'
        },
        outliersSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'outliers.size'
        },
        outliersType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'outliers.type'
        },
        outliersRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'outliers.rotation'
        },
        extremesBackground: {
            type: [String, Function],
            default: undefined,
            kComposite: 'extremes.background'
        },
        extremesBorder: {
            type: Function,
            default: undefined,
            kComposite: 'extremes.border'
        },
        extremesBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'extremes.border.color'
        },
        extremesBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'extremes.border.width'
        },
        extremesSize: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'extremes.size'
        },
        extremesType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'extremes.type'
        },
        extremesRotation: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'extremes.rotation'
        },
        maxSize: {
            type: Number,
            default: undefined,
            kComposite: 'maxSize'
        },
        minSize: {
            type: Number,
            default: undefined,
            kComposite: 'minSize'
        },
        missingValues: {
            type: String,
            default: undefined,
            kComposite: 'missingValues'
        },
        kStyle: {
            type: String,
            default: undefined,
            kComposite: 'style'
        },
        name: {
            type: String,
            default: undefined,
            kComposite: 'name'
        },
        negativeColor: {
            type: String,
            default: undefined,
            kComposite: 'negativeColor'
        },
        negativeValuesColor: {
            type: String,
            default: undefined,
            kComposite: 'negativeValues.color'
        },
        negativeValuesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'negativeValues.visible'
        },
        opacity: {
            type: Number,
            default: undefined,
            kComposite: 'opacity'
        },
        openField: {
            type: String,
            default: undefined,
            kComposite: 'openField'
        },
        overlayGradient: {
            type: String,
            default: undefined,
            kComposite: 'overlay.gradient'
        },
        padding: {
            type: Number,
            default: undefined,
            kComposite: 'padding'
        },
        size: {
            type: Number,
            default: undefined,
            kComposite: 'size'
        },
        sizeField: {
            type: String,
            default: undefined,
            kComposite: 'sizeField'
        },
        spacing: {
            type: Number,
            default: undefined,
            kComposite: 'spacing'
        },
        stack: {
            type: [Boolean, String],
            default: undefined,
            kComposite: 'stack'
        },
        stackType: {
            type: String,
            default: undefined,
            kComposite: 'stack.type'
        },
        stackGroup: {
            type: String,
            default: undefined,
            kComposite: 'stack.group'
        },
        startAngle: {
            type: Number,
            default: undefined,
            kComposite: 'startAngle'
        },
        targetBorder: {
            type: Function,
            default: undefined,
            kComposite: 'target.border'
        },
        targetBorderColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'target.border.color'
        },
        targetBorderDashType: {
            type: [String, Function],
            default: undefined,
            kComposite: 'target.border.dashType'
        },
        targetBorderWidth: {
            type: [Number, Function],
            default: undefined,
            kComposite: 'target.border.width'
        },
        targetColor: {
            type: [String, Function],
            default: undefined,
            kComposite: 'target.color'
        },
        targetlineWidth: {
            type: [Object, Function],
            default: undefined,
            kComposite: 'target.line.width'
        },
        targetField: {
            type: String,
            default: undefined,
            kComposite: 'targetField'
        },
        tooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.background'
        },
        tooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.border.color'
        },
        tooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.border.width'
        },
        tooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.color'
        },
        tooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.font'
        },
        tooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.format'
        },
        tooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding'
        },
        tooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding.bottom'
        },
        tooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding.left'
        },
        tooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding.right'
        },
        tooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.padding.top'
        },
        tooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'tooltip.template'
        },
        tooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.visible'
        },
        type: {
            type: String,
            default: undefined,
            kComposite: 'type'
        },
        visible: {
            type: Boolean,
            default: undefined,
            kComposite: 'visible'
        },
        visibleInLegend: {
            type: Boolean,
            default: undefined,
            kComposite: 'visibleInLegend'
        },
        visibleInLegendField: {
            type: String,
            default: undefined,
            kComposite: 'visibleInLegendField'
        },
        visual: {
            type: Function,
            default: undefined,
            kComposite: 'visual'
        },
        width: {
            type: Number,
            default: undefined,
            kComposite: 'width'
        },
        xAxis: {
            type: String,
            default: undefined,
            kComposite: 'xAxis'
        },
        xField: {
            type: String,
            default: undefined,
            kComposite: 'xField'
        },
        yAxis: {
            type: String,
            default: undefined,
            kComposite: 'yAxis'
        },
        yField: {
            type: String,
            default: undefined,
            kComposite: 'yField'
        },
        notesPosition: {
            type: String,
            default: undefined,
            kComposite: 'notes.position'
        },
        notesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'notes.icon.background'
        },
        notesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'notes.icon.border.color'
        },
        notesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'notes.icon.border.width'
        },
        notesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'notes.icon.size'
        },
        notesIconType: {
            type: String,
            default: undefined,
            kComposite: 'notes.icon.type'
        },
        notesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'notes.icon.visible'
        },
        notesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'notes.label.background'
        },
        notesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'notes.label.border.color'
        },
        notesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'notes.label.border.dashType'
        },
        notesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'notes.label.border.width'
        },
        notesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'notes.label.color'
        },
        notesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'notes.label.font'
        },
        notesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'notes.label.template'
        },
        notesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'notes.label.visible'
        },
        notesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'notes.label.rotation'
        },
        notesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'notes.label.format'
        },
        notesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'notes.label.position'
        },
        noteslineDashType: {
            type: String,
            default: undefined,
            kComposite: 'notes.line.dashType'
        },
        noteslineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'notes.line.width'
        },
        noteslineColor: {
            type: String,
            default: undefined,
            kComposite: 'notes.line.color'
        },
        noteslineLength: {
            type: Number,
            default: undefined,
            kComposite: 'notes.line.length'
        },
        notesVisual: {
            type: Function,
            default: undefined,
            kComposite: 'notes.visual'
        },
        zIndex: {
            type: Number,
            default: undefined,
            kComposite: 'zIndex'
        }
    }
};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _KendoChartBase = __webpack_require__(46);

var _KendoChartBase2 = _interopRequireDefault(_KendoChartBase);

var _StockChartProps = __webpack_require__(166);

var _StockChartProps2 = _interopRequireDefault(_StockChartProps);

var _AxisDefaults = __webpack_require__(47);

var _AxisDefaults2 = _interopRequireDefault(_AxisDefaults);

var _CategoryAxis = __webpack_require__(48);

var _CategoryAxis2 = _interopRequireDefault(_CategoryAxis);

var _ChartArea = __webpack_require__(49);

var _ChartArea2 = _interopRequireDefault(_ChartArea);

var _Legend = __webpack_require__(50);

var _Legend2 = _interopRequireDefault(_Legend);

var _Panes = __webpack_require__(51);

var _Panes2 = _interopRequireDefault(_Panes);

var _Pannable = __webpack_require__(52);

var _Pannable2 = _interopRequireDefault(_Pannable);

var _Pdf = __webpack_require__(53);

var _Pdf2 = _interopRequireDefault(_Pdf);

var _PlotArea = __webpack_require__(54);

var _PlotArea2 = _interopRequireDefault(_PlotArea);

var _Series = __webpack_require__(55);

var _Series2 = _interopRequireDefault(_Series);

var _SeriesDefaults = __webpack_require__(56);

var _SeriesDefaults2 = _interopRequireDefault(_SeriesDefaults);

var _Title = __webpack_require__(57);

var _Title2 = _interopRequireDefault(_Title);

var _Tooltip = __webpack_require__(58);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _ValueAxis = __webpack_require__(59);

var _ValueAxis2 = _interopRequireDefault(_ValueAxis);

var _XAxis = __webpack_require__(60);

var _XAxis2 = _interopRequireDefault(_XAxis);

var _YAxis = __webpack_require__(61);

var _YAxis2 = _interopRequireDefault(_YAxis);

var _Zoomable = __webpack_require__(62);

var _Zoomable2 = _interopRequireDefault(_Zoomable);

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _Navigator = __webpack_require__(167);

var _Navigator2 = _interopRequireDefault(_Navigator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _StockChartProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_KendoChartBase2.default, _Navigator2.default, _kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _AxisDefaults2.default, _CategoryAxis2.default, _ChartArea2.default, _Legend2.default, _Panes2.default, _Pannable2.default, _Pdf2.default, _PlotArea2.default, _Series2.default, _SeriesDefaults2.default, _Title2.default, _Tooltip2.default, _ValueAxis2.default, _XAxis2.default, _YAxis2.default, _Zoomable2.default],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoStockChart(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoStockChart();
        }
    }
};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dateField: {
        type: String,
        default: undefined
    },
    navigator: {
        type: Object,
        default: undefined
    }
};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        navigatorCategoryAxisAutoBaseUnitStepsSeconds: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.seconds'
        },
        navigatorCategoryAxisAutoBaseUnitStepsMinutes: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.minutes'
        },
        navigatorCategoryAxisAutoBaseUnitStepsHours: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.hours'
        },
        navigatorCategoryAxisAutoBaseUnitStepsDays: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.days'
        },
        navigatorCategoryAxisAutoBaseUnitStepsWeeks: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.weeks'
        },
        navigatorCategoryAxisAutoBaseUnitStepsMonths: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.months'
        },
        navigatorCategoryAxisAutoBaseUnitStepsYears: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.years'
        },
        navigatorCategoryAxisAxisCrossingValue: {
            type: [Object, Date, Array],
            default: undefined,
            kComposite: 'navigator.categoryAxis.axisCrossingValue'
        },
        navigatorCategoryAxisBackground: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.background'
        },
        navigatorCategoryAxisBaseUnit: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.baseUnit'
        },
        navigatorCategoryAxisBaseUnitStep: {
            type: Object,
            default: undefined,
            kComposite: 'navigator.categoryAxis.baseUnitStep'
        },
        navigatorCategoryAxisCategories: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.categories'
        },
        navigatorCategoryAxisColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.color'
        },
        navigatorCategoryAxisCrosshairColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.color'
        },
        navigatorCategoryAxisCrosshairOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.opacity'
        },
        navigatorCategoryAxisCrosshairTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.background'
        },
        navigatorCategoryAxisCrosshairTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.border.color'
        },
        navigatorCategoryAxisCrosshairTooltipBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.border.dashType'
        },
        navigatorCategoryAxisCrosshairTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.border.width'
        },
        navigatorCategoryAxisCrosshairTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.color'
        },
        navigatorCategoryAxisCrosshairTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.font'
        },
        navigatorCategoryAxisCrosshairTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.format'
        },
        navigatorCategoryAxisCrosshairTooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.padding'
        },
        navigatorCategoryAxisCrosshairTooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.padding.bottom'
        },
        navigatorCategoryAxisCrosshairTooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.padding.left'
        },
        navigatorCategoryAxisCrosshairTooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.padding.right'
        },
        navigatorCategoryAxisCrosshairTooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.padding.top'
        },
        navigatorCategoryAxisCrosshairTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.template'
        },
        navigatorCategoryAxisCrosshairTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.visible'
        },
        navigatorCategoryAxisCrosshairVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.visible'
        },
        navigatorCategoryAxisCrosshairWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.width'
        },
        navigatorCategoryAxisField: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.field'
        },
        navigatorCategoryAxisJustified: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.justified'
        },
        navigatorCategoryAxisLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.background'
        },
        navigatorCategoryAxisLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.border.color'
        },
        navigatorCategoryAxisLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.border.dashType'
        },
        navigatorCategoryAxisLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.border.width'
        },
        navigatorCategoryAxisLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.color'
        },
        navigatorCategoryAxisLabelsCulture: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.culture'
        },
        navigatorCategoryAxisLabelsDateFormatsDays: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.dateFormats.days'
        },
        navigatorCategoryAxisLabelsDateFormatsHours: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.dateFormats.hours'
        },
        navigatorCategoryAxisLabelsDateFormatsMonths: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.dateFormats.months'
        },
        navigatorCategoryAxisLabelsDateFormatsWeeks: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.dateFormats.weeks'
        },
        navigatorCategoryAxisLabelsDateFormatsYears: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.dateFormats.years'
        },
        navigatorCategoryAxisLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.font'
        },
        navigatorCategoryAxisLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.format'
        },
        navigatorCategoryAxisLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.margin'
        },
        navigatorCategoryAxisLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.margin.bottom'
        },
        navigatorCategoryAxisLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.margin.left'
        },
        navigatorCategoryAxisLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.margin.right'
        },
        navigatorCategoryAxisLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.margin.top'
        },
        navigatorCategoryAxisLabelsMirror: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.mirror'
        },
        navigatorCategoryAxisLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.padding'
        },
        navigatorCategoryAxisLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.padding.bottom'
        },
        navigatorCategoryAxisLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.padding.left'
        },
        navigatorCategoryAxisLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.padding.right'
        },
        navigatorCategoryAxisLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.padding.top'
        },
        navigatorCategoryAxisLabelsRotation: {
            type: [Number, String],
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.rotation'
        },
        navigatorCategoryAxisLabelsSkip: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.skip'
        },
        navigatorCategoryAxisLabelsStep: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.step'
        },
        navigatorCategoryAxisLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.template'
        },
        navigatorCategoryAxisLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.visible'
        },
        navigatorCategoryAxisLineColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.line.color'
        },
        navigatorCategoryAxisLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.line.dashType'
        },
        navigatorCategoryAxisLineVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.line.visible'
        },
        navigatorCategoryAxisLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.line.width'
        },
        navigatorCategoryAxisMajorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorGridLines.color'
        },
        navigatorCategoryAxisMajorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorGridLines.dashType'
        },
        navigatorCategoryAxisMajorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorGridLines.visible'
        },
        navigatorCategoryAxisMajorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorGridLines.width'
        },
        navigatorCategoryAxisMajorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorGridLines.step'
        },
        navigatorCategoryAxisMajorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorGridLines.skip'
        },
        navigatorCategoryAxisMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorTicks.color'
        },
        navigatorCategoryAxisMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorTicks.size'
        },
        navigatorCategoryAxisMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorTicks.visible'
        },
        navigatorCategoryAxisMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorTicks.width'
        },
        navigatorCategoryAxisMajorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorTicks.step'
        },
        navigatorCategoryAxisMajorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorTicks.skip'
        },
        navigatorCategoryAxisMax: {
            type: Object,
            default: undefined,
            kComposite: 'navigator.categoryAxis.max'
        },
        navigatorCategoryAxisMaxDateGroups: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.maxDateGroups'
        },
        navigatorCategoryAxisMin: {
            type: Object,
            default: undefined,
            kComposite: 'navigator.categoryAxis.min'
        },
        navigatorCategoryAxisMinorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorGridLines.color'
        },
        navigatorCategoryAxisMinorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorGridLines.dashType'
        },
        navigatorCategoryAxisMinorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorGridLines.visible'
        },
        navigatorCategoryAxisMinorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorGridLines.width'
        },
        navigatorCategoryAxisMinorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorGridLines.step'
        },
        navigatorCategoryAxisMinorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorGridLines.skip'
        },
        navigatorCategoryAxisMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorTicks.color'
        },
        navigatorCategoryAxisMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorTicks.size'
        },
        navigatorCategoryAxisMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorTicks.visible'
        },
        navigatorCategoryAxisMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorTicks.width'
        },
        navigatorCategoryAxisMinorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorTicks.step'
        },
        navigatorCategoryAxisMinorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorTicks.skip'
        },
        navigatorCategoryAxisPlotBands: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.plotBands'
        }, navigatorCategoryAxisReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.reverse'
        },
        navigatorCategoryAxisRoundToBaseUnit: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.roundToBaseUnit'
        },
        navigatorCategoryAxisTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.background'
        },
        navigatorCategoryAxisTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.border.color'
        },
        navigatorCategoryAxisTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.border.dashType'
        },
        navigatorCategoryAxisTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.border.width'
        },
        navigatorCategoryAxisTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.color'
        },
        navigatorCategoryAxisTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.font'
        },
        navigatorCategoryAxisTitleMargin: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.margin'
        },
        navigatorCategoryAxisTitleMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.margin.bottom'
        },
        navigatorCategoryAxisTitleMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.margin.left'
        },
        navigatorCategoryAxisTitleMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.margin.right'
        },
        navigatorCategoryAxisTitleMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.margin.top'
        },
        navigatorCategoryAxisTitlePadding: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.padding'
        },
        navigatorCategoryAxisTitlePaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.padding.bottom'
        },
        navigatorCategoryAxisTitlePaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.padding.left'
        },
        navigatorCategoryAxisTitlePaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.padding.right'
        },
        navigatorCategoryAxisTitlePaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.padding.top'
        },
        navigatorCategoryAxisTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.position'
        },
        navigatorCategoryAxisTitleRotation: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.rotation'
        },
        navigatorCategoryAxisTitleText: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.text'
        },
        navigatorCategoryAxisTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.visible'
        },
        navigatorCategoryAxisVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.visible'
        },
        navigatorCategoryAxisWeekStartDay: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.weekStartDay'
        },
        navigatorCategoryAxisNotesPosition: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.position'
        },
        navigatorCategoryAxisNotesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.icon.background'
        },
        navigatorCategoryAxisNotesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.icon.border.color'
        },
        navigatorCategoryAxisNotesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.icon.border.width'
        },
        navigatorCategoryAxisNotesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.icon.size'
        },
        navigatorCategoryAxisNotesIconType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.icon.type'
        },
        navigatorCategoryAxisNotesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.icon.visible'
        },
        navigatorCategoryAxisNotesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.background'
        },
        navigatorCategoryAxisNotesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.border.color'
        },
        navigatorCategoryAxisNotesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.border.dashType'
        },
        navigatorCategoryAxisNotesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.border.width'
        },
        navigatorCategoryAxisNotesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.color'
        },
        navigatorCategoryAxisNotesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.font'
        },
        navigatorCategoryAxisNotesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.template'
        },
        navigatorCategoryAxisNotesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.visible'
        },
        navigatorCategoryAxisNotesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.rotation'
        },
        navigatorCategoryAxisNotesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.format'
        },
        navigatorCategoryAxisNotesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.position'
        },
        navigatorCategoryAxisNotesLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.line.width'
        },
        navigatorCategoryAxisNotesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.line.color'
        },
        navigatorCategoryAxisNotesLineLength: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.line.length'
        },
        navigatorCategoryAxisNotesData: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.data'
        },
        navigatorDataSource: {
            type: Object,
            default: undefined,
            kComposite: 'navigator.dataSource'
        },
        navigatorAutoBind: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.autoBind'
        },
        navigatorDateField: {
            type: String,
            default: undefined,
            kComposite: 'navigator.dateField'
        },
        navigatorPaneBackground: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.background'
        },
        navigatorPaneBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.border.color'
        },
        navigatorPaneBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.border.dashType'
        },
        navigatorPaneBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.border.width'
        },
        navigatorPaneHeight: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.height'
        },
        navigatorPaneMargin: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.margin'
        },
        navigatorPaneMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.margin.bottom'
        },
        navigatorPaneMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.margin.left'
        },
        navigatorPaneMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.margin.right'
        },
        navigatorPaneMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.margin.top'
        },
        navigatorPaneName: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.name'
        },
        navigatorPanePadding: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.padding'
        },
        navigatorPanePaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.padding.bottom'
        },
        navigatorPanePaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.padding.left'
        },
        navigatorPanePaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.padding.right'
        },
        navigatorPanePaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.padding.top'
        },
        navigatorPaneTitle: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.title'
        },
        navigatorPaneTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.title.background'
        },
        navigatorPaneTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.title.border.color'
        },
        navigatorPaneTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.title.border.dashType'
        },
        navigatorPaneTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.title.border.width'
        },
        navigatorPaneTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.title.color'
        },
        navigatorPaneTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.title.font'
        },
        navigatorPaneTitleMargin: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.title.margin'
        },
        navigatorPaneTitleMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.title.margin.bottom'
        },
        navigatorPaneTitleMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.title.margin.left'
        },
        navigatorPaneTitleMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.title.margin.right'
        },
        navigatorPaneTitleMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.title.margin.top'
        },
        navigatorPaneTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.title.position'
        },
        navigatorPaneTitleText: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.title.text'
        },
        navigatorPaneTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.pane.title.visible'
        },
        navigatorVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.visible'
        },
        navigatorSeries: {
            type: [Array, Object],
            default: undefined,
            kComposite: 'navigator.series'
        },
        navigatorSelectFrom: {
            type: [Date, String],
            default: undefined,
            kComposite: 'navigator.select.from'
        },
        navigatorSelectMousewheel: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.select.mousewheel'
        },
        navigatorSelectMousewheelReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.select.mousewheel.reverse'
        },
        navigatorSelectMousewheelZoom: {
            type: String,
            default: undefined,
            kComposite: 'navigator.select.mousewheel.zoom'
        },
        navigatorSelectTo: {
            type: [Date, String],
            default: undefined,
            kComposite: 'navigator.select.to'
        },
        navigatorHintVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.hint.visible'
        },
        navigatorHintTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'navigator.hint.template'
        },
        navigatorHintFormat: {
            type: String,
            default: undefined,
            kComposite: 'navigator.hint.format'
        }
    }
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _SparklineProps = __webpack_require__(169);

var _SparklineProps2 = _interopRequireDefault(_SparklineProps);

var _KendoSparklineSeriesItem = __webpack_require__(12);

var _KendoSparklineSeriesItem2 = _interopRequireDefault(_KendoSparklineSeriesItem);

var _CategoryAxis = __webpack_require__(171);

var _CategoryAxis2 = _interopRequireDefault(_CategoryAxis);

var _ChartArea = __webpack_require__(172);

var _ChartArea2 = _interopRequireDefault(_ChartArea);

var _PlotArea = __webpack_require__(173);

var _PlotArea2 = _interopRequireDefault(_PlotArea);

var _SeriesDefaults = __webpack_require__(174);

var _SeriesDefaults2 = _interopRequireDefault(_SeriesDefaults);

var _Tooltip = __webpack_require__(175);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _ValueAxis = __webpack_require__(176);

var _ValueAxis2 = _interopRequireDefault(_ValueAxis);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _SparklineProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _CategoryAxis2.default, _ChartArea2.default, _PlotArea2.default, _SeriesDefaults2.default, _Tooltip2.default, _ValueAxis2.default],
    mounted: function mounted() {
        this._resolveChildren();

        kendo.jQuery(this.$el).kendoSparkline(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoSparkline();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('series', _KendoSparklineSeriesItem2.default.name);
        }
    }
};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    axisDefaults: {
        type: Object,
        default: undefined
    },
    categoryAxis: {
        type: [Array, Object],
        default: undefined
    },
    chartArea: {
        type: Object,
        default: undefined
    },
    data: {
        type: Array,
        default: undefined
    },
    dataSource: {
        type: Object,
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    plotArea: {
        type: Object,
        default: undefined
    },
    pointWidth: {
        type: Number,
        default: undefined
    },
    renderAs: {
        type: String,
        default: undefined
    },
    series: {
        type: Array,
        default: undefined
    },
    seriesColors: {
        type: Array,
        default: undefined
    },
    seriesDefaults: {
        type: Object,
        default: undefined
    },
    theme: {
        type: String,
        default: undefined
    },
    tooltip: {
        type: Object,
        default: undefined
    },
    transitions: {
        type: Boolean,
        default: undefined
    },
    type: {
        type: String,
        default: undefined
    },
    valueAxis: {
        type: [Array, Object],
        default: undefined
    },

    // Events
    axisLabelClick: {
        type: Function,
        default: undefined
    },
    dataBound: {
        type: Function,
        default: undefined
    },
    dragStart: {
        type: Function,
        default: undefined
    },
    drag: {
        type: Function,
        default: undefined
    },
    dragEnd: {
        type: Function,
        default: undefined
    },
    plotAreaClick: {
        type: Function,
        default: undefined
    },
    seriesClick: {
        type: Function,
        default: undefined
    },
    seriesOver: {
        type: Function,
        default: undefined
    },
    seriesHover: {
        type: Function,
        default: undefined
    },
    zoomStart: {
        type: Function,
        default: undefined
    },
    zoom: {
        type: Function,
        default: undefined
    },
    zoomEnd: Function
};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        type: {
            type: String,
            default: undefined
        },
        dashType: {
            type: String,
            default: undefined
        },
        data: {
            type: Array,
            default: undefined
        },
        explodeField: {
            type: String,
            default: undefined
        },
        currentField: {
            type: String,
            default: undefined
        },
        targetField: {
            type: String,
            default: undefined
        },
        field: {
            type: String,
            default: undefined
        },
        name: {
            type: String,
            default: undefined
        },
        highlightBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'highlight.border.width'
        },
        highlightBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'highlight.border.color'
        },
        highlightBorderOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'highlight.border.opacity'
        },
        highlightColor: {
            type: String,
            default: undefined,
            kComposite: 'highlight.color'
        },
        highlightOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'highlight.opacity'
        },
        highlightVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'highlight.visible'
        },
        aggregate: [String, Function],
        axis: String,
        borderColor: { type: [String, Function], default: undefined,
            kComposite: 'border.color' },
        borderDashType: { type: [String, Function], default: undefined,
            kComposite: 'border.dashType' },
        borderOpacity: { type: [Number, Function], default: undefined,
            kComposite: 'border.opacity' },
        borderWidth: { type: [Number, Function], default: undefined,
            kComposite: 'border.width' },
        categoryField: String,
        color: [String, Function],
        colorField: String,
        connectorsColor: { type: String, default: undefined,
            kComposite: 'connectors.color' },
        connectorsPadding: { type: Number, default: undefined,
            kComposite: 'connectors.padding' },
        connectorsWidth: { type: Number, default: undefined,
            kComposite: 'connectors.width' },
        gap: Number,
        labelsAlign: { type: String, default: undefined,
            kComposite: 'labels.align' },
        labelsBackground: { type: [String, Function], default: undefined,
            kComposite: 'labels.background' },
        labelsBorderColor: { type: [String, Function], default: undefined,
            kComposite: 'labels.border.color' },
        labelsBorderDashType: { type: [String, Function], default: undefined,
            kComposite: 'labels.border.dashType' },
        labelsBorderWidth: { type: [Number, Function], default: undefined,
            kComposite: 'labels.border.width' },
        labelsColor: { type: [String, Function], default: undefined,
            kComposite: 'labels.color' },
        labelsDistance: { type: Number, default: undefined,
            kComposite: 'labels.distance' },
        labelsFont: { type: [String, Function], default: undefined,
            kComposite: 'labels.font' },
        labelsFormat: { type: [String, Function], default: undefined,
            kComposite: 'labels.format' },
        labelsMargin: { type: [Number, Object], default: undefined,
            kComposite: 'labels.margin' },
        labelsPadding: { type: [Number, Object], default: undefined,
            kComposite: 'labels.padding' },
        labelsPosition: { type: [String, Function], default: undefined,
            kComposite: 'labels.position' },
        labelsTemplate: { type: [String, Function], default: undefined,
            kComposite: 'labels.template' },
        labelsVisible: { type: [Boolean, Function], default: undefined,
            kComposite: 'labels.visible' },
        line: String,
        lineColor: { type: String, default: undefined,
            kComposite: 'line.color' },
        lineOpacity: { type: Number, default: undefined,
            kComposite: 'line.opacity' },
        lineWidth: { type: String, default: undefined,
            kComposite: 'line.width' },
        lineStyle: { type: String, default: undefined,
            kComposite: 'line.style' },
        markersBackground: { type: [String, Function], default: undefined,
            kComposite: 'markers.background' },
        markersBorder: { type: Function, default: undefined,
            kComposite: 'markers.border' },
        markersBorderColor: { type: [String, Function], default: undefined,
            kComposite: 'markers.border.color' },
        markersBorderWidth: { type: [Number, Function], default: undefined,
            kComposite: 'markers.border.width' },
        markersSize: { type: [Number, Function], default: undefined,
            kComposite: 'markers.size' },
        markersType: { type: [String, Function], default: undefined,
            kComposite: 'markers.type' },
        markersVisible: { type: [Boolean, Function], default: undefined,
            kComposite: 'markers.visible' },
        markersRotation: { type: [Number, Function], default: undefined,
            kComposite: 'markers.rotation' },
        missingValues: String,
        kStyle: String,
        negativeColor: String,
        opacity: Number,
        overlayGradient: { type: String, default: undefined,
            kComposite: 'overlay.gradient' },
        padding: Number,
        size: Number,
        startAngle: Number,
        spacing: Number,
        stack: [Boolean, String],
        stackType: { type: String, default: undefined,
            kComposite: 'stack.type' },
        stackGroup: { type: String, default: undefined,
            kComposite: 'stack.group' },
        tooltipBackground: { type: String, default: undefined,
            kComposite: 'tooltip.background' },
        tooltipBorderColor: { type: String, default: undefined,
            kComposite: 'tooltip.border.color' },
        tooltipBorderWidth: { type: Number, default: undefined,
            kComposite: 'tooltip.border.width' },
        tooltipColor: { type: String, default: undefined,
            kComposite: 'tooltip.color' },
        tooltipFont: { type: String, default: undefined,
            kComposite: 'tooltip.font' },
        tooltipFormat: { type: String, default: undefined,
            kComposite: 'tooltip.format' },
        tooltipPadding: { type: [Number, Object], default: undefined,
            kComposite: 'tooltip.padding' },
        tooltipTemplate: { type: [String, Function], default: undefined,
            kComposite: 'tooltip.template' },
        tooltipVisible: { type: Boolean, default: undefined,
            kComposite: 'tooltip.visible' },
        width: Number,
        targetLineWidth: { type: [Object, Function], default: undefined,
            kComposite: 'target.line.width' },
        targetColor: { type: [String, Function], default: undefined,
            kComposite: 'target.color' },
        targetBorder: { type: Function, default: undefined,
            kComposite: 'target.border' },
        targetBorderColor: { type: [String, Function], default: undefined,
            kComposite: 'target.border.color' },
        targetBorderDashType: { type: [String, Function], default: undefined,
            kComposite: 'target.border.dashType' },
        targetBorderWidth: { type: Number, default: undefined,
            kComposite: 'target.border.width' },
        notesPosition: { type: String, default: undefined,
            kComposite: 'notes.position' },
        notesIconBackground: { type: String, default: undefined,
            kComposite: 'notes.icon.background' },
        notesIconBorderColor: { type: String, default: undefined,
            kComposite: 'notes.icon.border.color' },
        notesIconBorderWidth: { type: Number, default: undefined,
            kComposite: 'notes.icon.border.width' },
        notesIconSize: { type: Number, default: undefined,
            kComposite: 'notes.icon.size' },
        notesIconType: { type: String, default: undefined,
            kComposite: 'notes.icon.type' },
        notesIconVisible: { type: Boolean, default: undefined,
            kComposite: 'notes.icon.visible' },
        notesLabelBackground: { type: String, default: undefined,
            kComposite: 'notes.label.background' },
        notesLabelBorderColor: { type: String, default: undefined,
            kComposite: 'notes.label.border.color' },
        notesLabelBorderDashType: { type: String, default: undefined,
            kComposite: 'notes.label.border.dashType' },
        notesLabelBorderWidth: { type: Number, default: undefined,
            kComposite: 'notes.label.border.width' },
        notesLabelColor: { type: String, default: undefined,
            kComposite: 'notes.label.color' },
        notesLabelFont: { type: String, default: undefined,
            kComposite: 'notes.label.font' },
        notesLabelTemplate: { type: [String, Function], default: undefined,
            kComposite: 'notes.label.template' },
        notesLabelVisible: { type: Boolean, default: undefined,
            kComposite: 'notes.label.visible' },
        notesLabelRotation: { type: Number, default: undefined,
            kComposite: 'notes.label.rotation' },
        notesLabelFormat: { type: String, default: undefined,
            kComposite: 'notes.label.format' },
        notesLabelPosition: { type: String, default: undefined,
            kComposite: 'notes.label.position' },
        notesLineWidth: { type: Number, default: undefined,
            kComposite: 'notes.line.width' },
        notesLineColor: { type: String, default: undefined,
            kComposite: 'notes.line.color' },
        notesLineLength: { type: Number, default: undefined,
            kComposite: 'notes.line.length' },
        zIndex: Number
    }
};

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        categoryAxisCategoryAxisItemAxisCrossingValue: {
            type: [Object, Date, Array],
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.axisCrossingValue'
        },
        categoryAxisCategoryAxisItemCategories: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.categories'
        },
        categoryAxisCategoryAxisItemColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.color'
        },
        categoryAxisCategoryAxisItemField: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.field'
        },
        categoryAxisCategoryAxisItemJustified: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.justified'
        },
        categoryAxisCategoryAxisItemLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.background'
        },
        categoryAxisCategoryAxisItemLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.border.color'
        },
        categoryAxisCategoryAxisItemLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.border.dashType'
        },
        categoryAxisCategoryAxisItemLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.border.width'
        },
        categoryAxisCategoryAxisItemLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.color'
        },
        categoryAxisCategoryAxisItemLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.font'
        },
        categoryAxisCategoryAxisItemLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.format'
        },
        categoryAxisCategoryAxisItemLabelsMargin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.margin'
        },
        categoryAxisCategoryAxisItemLabelsMirror: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.mirror'
        },
        categoryAxisCategoryAxisItemLabelsPadding: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.padding'
        },
        categoryAxisCategoryAxisItemLabelsRotation: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.rotation'
        },
        categoryAxisCategoryAxisItemLabelsSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.skip'
        },
        categoryAxisCategoryAxisItemLabelsStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.step'
        },
        categoryAxisCategoryAxisItemLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.template'
        },
        categoryAxisCategoryAxisItemLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.visible'
        },
        categoryAxisCategoryAxisItemLabelsCulture: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.culture'
        },
        categoryAxisCategoryAxisItemLabelsDateFormats: {
            type: Object,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.dateFormats'
        },
        categoryAxisCategoryAxisItemLineColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.line.color'
        },
        categoryAxisCategoryAxisItemLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.line.dashType'
        },
        categoryAxisCategoryAxisItemLineVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.line.visible'
        },
        categoryAxisCategoryAxisItemLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.line.width'
        },
        categoryAxisCategoryAxisItemMajorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorGridLines.color'
        },
        categoryAxisCategoryAxisItemMajorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorGridLines.dashType'
        },
        categoryAxisCategoryAxisItemMajorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorGridLines.visible'
        },
        categoryAxisCategoryAxisItemMajorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorGridLines.width'
        },
        categoryAxisCategoryAxisItemMajorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorGridLines.step'
        },
        categoryAxisCategoryAxisItemMajorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorGridLines.skip'
        },
        categoryAxisCategoryAxisItemMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorTicks.size'
        },
        categoryAxisCategoryAxisItemMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorTicks.visible'
        },
        categoryAxisCategoryAxisItemMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorTicks.color'
        },
        categoryAxisCategoryAxisItemMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorTicks.width'
        },
        categoryAxisCategoryAxisItemMajorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorTicks.step'
        },
        categoryAxisCategoryAxisItemMajorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorTicks.skip'
        },
        categoryAxisCategoryAxisItemMinorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorGridLines.color'
        },
        categoryAxisCategoryAxisItemMinorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorGridLines.dashType'
        },
        categoryAxisCategoryAxisItemMinorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorGridLines.visible'
        },
        categoryAxisCategoryAxisItemMinorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorGridLines.width'
        },
        categoryAxisCategoryAxisItemMinorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorGridLines.step'
        },
        categoryAxisCategoryAxisItemMinorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorGridLines.skip'
        },
        categoryAxisCategoryAxisItemMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorTicks.size'
        },
        categoryAxisCategoryAxisItemMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorTicks.visible'
        },
        categoryAxisCategoryAxisItemMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorTicks.color'
        },
        categoryAxisCategoryAxisItemMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorTicks.width'
        },
        categoryAxisCategoryAxisItemMinorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorTicks.step'
        },
        categoryAxisCategoryAxisItemMinorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorTicks.skip'
        },
        categoryAxisCategoryAxisItemName: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.name'
        },
        categoryAxisCategoryAxisItemPlotBands: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.plotBands'
        }, categoryAxisCategoryAxisItemReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.reverse'
        },
        categoryAxisCategoryAxisItemTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.background'
        },
        categoryAxisCategoryAxisItemTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.border.color'
        },
        categoryAxisCategoryAxisItemTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.border.dashType'
        },
        categoryAxisCategoryAxisItemTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.border.width'
        },
        categoryAxisCategoryAxisItemTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.color'
        },
        categoryAxisCategoryAxisItemTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.font'
        },
        categoryAxisCategoryAxisItemTitleMargin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.margin'
        },
        categoryAxisCategoryAxisItemTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.position'
        },
        categoryAxisCategoryAxisItemTitleRotation: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.rotation'
        },
        categoryAxisCategoryAxisItemTitleText: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.text'
        },
        categoryAxisCategoryAxisItemTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.visible'
        },
        categoryAxisCategoryAxisItemType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.type'
        },
        categoryAxisCategoryAxisItemAutoBaseUnitSteps: {
            type: Object,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.autoBaseUnitSteps'
        },
        categoryAxisCategoryAxisItemBaseUnit: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.baseUnit'
        },
        categoryAxisCategoryAxisItemBaseUnitStep: {
            type: Object,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.baseUnitStep'
        },
        categoryAxisCategoryAxisItemMax: {
            type: Object,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.max'
        },
        categoryAxisCategoryAxisItemMin: {
            type: Object,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.min'
        },
        categoryAxisCategoryAxisItemRoundToBaseUnit: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.roundToBaseUnit'
        },
        categoryAxisCategoryAxisItemWeekStartDay: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.weekStartDay'
        },
        categoryAxisCategoryAxisItemMaxDateGroups: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.maxDateGroups'
        },
        categoryAxisCategoryAxisItemVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.visible'
        },
        categoryAxisCategoryAxisItemCrosshairColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.color'
        },
        categoryAxisCategoryAxisItemCrosshairWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.width'
        },
        categoryAxisCategoryAxisItemCrosshairOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.opacity'
        },
        categoryAxisCategoryAxisItemCrosshairDashType: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.dashType'
        },
        categoryAxisCategoryAxisItemCrosshairVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.visible'
        },
        categoryAxisCategoryAxisItemCrosshairTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.background'
        },
        categoryAxisCategoryAxisItemCrosshairTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.border.color'
        },
        categoryAxisCategoryAxisItemCrosshairTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.border.width'
        },
        categoryAxisCategoryAxisItemCrosshairTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.color'
        },
        categoryAxisCategoryAxisItemCrosshairTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.font'
        },
        categoryAxisCategoryAxisItemCrosshairTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.format'
        },
        categoryAxisCategoryAxisItemCrosshairTooltipPadding: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.padding'
        },
        categoryAxisCategoryAxisItemCrosshairTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.template'
        },
        categoryAxisCategoryAxisItemCrosshairTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.visible'
        },
        categoryAxisCategoryAxisItemNotesPosition: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.position'
        },
        categoryAxisCategoryAxisItemNotesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.icon.background'
        },
        categoryAxisCategoryAxisItemNotesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.icon.border.color'
        },
        categoryAxisCategoryAxisItemNotesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.icon.border.width'
        },
        categoryAxisCategoryAxisItemNotesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.icon.size'
        },
        categoryAxisCategoryAxisItemNotesIconType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.icon.type'
        },
        categoryAxisCategoryAxisItemNotesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.icon.visible'
        },
        categoryAxisCategoryAxisItemNotesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.background'
        },
        categoryAxisCategoryAxisItemNotesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.border.color'
        },
        categoryAxisCategoryAxisItemNotesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.border.dashType'
        },
        categoryAxisCategoryAxisItemNotesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.border.width'
        },
        categoryAxisCategoryAxisItemNotesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.color'
        },
        categoryAxisCategoryAxisItemNotesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.font'
        },
        categoryAxisCategoryAxisItemNotesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.template'
        },
        categoryAxisCategoryAxisItemNotesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.visible'
        },
        categoryAxisCategoryAxisItemNotesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.rotation'
        },
        categoryAxisCategoryAxisItemNotesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.format'
        },
        categoryAxisCategoryAxisItemNotesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.position'
        },
        categoryAxisCategoryAxisItemNotesLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.line.width'
        },
        categoryAxisCategoryAxisItemNotesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.line.color'
        },
        categoryAxisCategoryAxisItemNotesLineLength: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.line.length'
        },
        categoryAxisCategoryAxisItemNotesData: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.data'
        } }
};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        chartAreaBackground: {
            type: String,
            default: undefined,
            kComposite: 'chartArea.background'
        },
        chartAreaOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.opacity'
        },
        chartAreaBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'chartArea.border.color'
        },
        chartAreaBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'chartArea.border.dashType'
        },
        chartAreaBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.border.width'
        },
        chartAreaHeight: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.height'
        },
        chartAreaMargin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'chartArea.margin'
        },
        chartAreaWidth: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.width'
        }
    }
};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        plotAreaBackground: {
            type: String,
            default: undefined,
            kComposite: 'plotArea.background'
        },
        plotAreaOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.opacity'
        },
        plotAreaBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'plotArea.border.color'
        },
        plotAreaBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'plotArea.border.dashType'
        },
        plotAreaBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.border.width'
        },
        plotAreaMargin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'plotArea.margin'
        }
    }
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        seriesDefaultsArea: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.area'
        },
        seriesDefaultsBar: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.bar'
        },
        seriesDefaultsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.border.color'
        },
        seriesDefaultsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.border.dashType'
        },
        seriesDefaultsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.border.width'
        },
        seriesDefaultsColumn: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.column'
        },
        seriesDefaultsGap: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.gap'
        },
        seriesDefaultsLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.background'
        },
        seriesDefaultsLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.border.color'
        },
        seriesDefaultsLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.border.dashType'
        },
        seriesDefaultsLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.border.width'
        },
        seriesDefaultsLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.color'
        },
        seriesDefaultsLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.font'
        },
        seriesDefaultsLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.format'
        },
        seriesDefaultsLabelsMargin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'seriesDefaults.labels.margin'
        },
        seriesDefaultsLabelsPadding: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'seriesDefaults.labels.padding'
        },
        seriesDefaultsLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'seriesDefaults.labels.template'
        },
        seriesDefaultsLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.labels.visible'
        },
        seriesDefaultsLine: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.line'
        },
        seriesDefaultsOverlay: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.overlay'
        },
        seriesDefaultsPie: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.pie'
        },
        seriesDefaultsSpacing: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.spacing'
        },
        seriesDefaultsStack: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.stack'
        },
        seriesDefaultsStackType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.stack.type'
        },
        seriesDefaultsType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.type'
        },
        seriesDefaultsTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.background'
        },
        seriesDefaultsTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.border.color'
        },
        seriesDefaultsTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.border.width'
        },
        seriesDefaultsTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.color'
        },
        seriesDefaultsTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.font'
        },
        seriesDefaultsTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.format'
        },
        seriesDefaultsTooltipPadding: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.padding'
        },
        seriesDefaultsTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.template'
        },
        seriesDefaultsTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.visible'
        }
    }
};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        tooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.background'
        },
        tooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.border.color'
        },
        tooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.border.width'
        },
        tooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.color'
        },
        tooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.font'
        },
        tooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.format'
        },
        tooltipPadding: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'tooltip.padding'
        },
        tooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'tooltip.template'
        },
        tooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.visible'
        },
        tooltipShared: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.shared'
        },
        tooltipSharedTemplate: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.sharedTemplate'
        }
    }
};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        valueAxisValueAxisItemAxisCrossingValue: {
            type: [Object, Date, Array],
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.axisCrossingValue'
        },
        valueAxisValueAxisItemColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.color'
        },
        valueAxisValueAxisItemLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.background'
        },
        valueAxisValueAxisItemLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.border.color'
        },
        valueAxisValueAxisItemLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.border.dashType'
        },
        valueAxisValueAxisItemLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.border.width'
        },
        valueAxisValueAxisItemLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.color'
        },
        valueAxisValueAxisItemLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.font'
        },
        valueAxisValueAxisItemLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.format'
        },
        valueAxisValueAxisItemLabelsMargin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.margin'
        },
        valueAxisValueAxisItemLabelsMirror: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.mirror'
        },
        valueAxisValueAxisItemLabelsPadding: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.padding'
        },
        valueAxisValueAxisItemLabelsRotation: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.rotation'
        },
        valueAxisValueAxisItemLabelsSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.skip'
        },
        valueAxisValueAxisItemLabelsStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.step'
        },
        valueAxisValueAxisItemLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.template'
        },
        valueAxisValueAxisItemLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.labels.visible'
        },
        valueAxisValueAxisItemLineColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.line.color'
        },
        valueAxisValueAxisItemLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.line.dashType'
        },
        valueAxisValueAxisItemLineVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.line.visible'
        },
        valueAxisValueAxisItemLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.line.width'
        },
        valueAxisValueAxisItemMajorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorGridLines.color'
        },
        valueAxisValueAxisItemMajorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorGridLines.visible'
        },
        valueAxisValueAxisItemMajorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorGridLines.width'
        },
        valueAxisValueAxisItemMajorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorGridLines.step'
        },
        valueAxisValueAxisItemMajorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorGridLines.skip'
        },
        valueAxisValueAxisItemMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorTicks.size'
        },
        valueAxisValueAxisItemMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorTicks.visible'
        },
        valueAxisValueAxisItemMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorTicks.color'
        },
        valueAxisValueAxisItemMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorTicks.width'
        },
        valueAxisValueAxisItemMajorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorTicks.step'
        },
        valueAxisValueAxisItemMajorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorTicks.skip'
        },
        valueAxisValueAxisItemMajorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.majorUnit'
        },
        valueAxisValueAxisItemMax: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.max'
        },
        valueAxisValueAxisItemMin: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.min'
        },
        valueAxisValueAxisItemMinorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorGridLines.color'
        },
        valueAxisValueAxisItemMinorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorGridLines.dashType'
        },
        valueAxisValueAxisItemMinorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorGridLines.visible'
        },
        valueAxisValueAxisItemMinorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorGridLines.width'
        },
        valueAxisValueAxisItemMinorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorGridLines.step'
        },
        valueAxisValueAxisItemMinorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorGridLines.skip'
        },
        valueAxisValueAxisItemMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorTicks.size'
        },
        valueAxisValueAxisItemMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorTicks.color'
        },
        valueAxisValueAxisItemMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorTicks.width'
        },
        valueAxisValueAxisItemMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorTicks.visible'
        },
        valueAxisValueAxisItemMinorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorTicks.step'
        },
        valueAxisValueAxisItemMinorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorTicks.skip'
        },
        valueAxisValueAxisItemMinorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.minorUnit'
        },
        valueAxisValueAxisItemName: {
            type: Object,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.name'
        },
        valueAxisValueAxisItemNarrowRange: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.narrowRange'
        },
        valueAxisValueAxisItemPlotBands: {
            type: Array,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.plotBands'
        }, valueAxisValueAxisItemReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.reverse'
        },
        valueAxisValueAxisItemTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.background'
        },
        valueAxisValueAxisItemTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.border.color'
        },
        valueAxisValueAxisItemTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.border.dashType'
        },
        valueAxisValueAxisItemTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.border.width'
        },
        valueAxisValueAxisItemTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.color'
        },
        valueAxisValueAxisItemTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.font'
        },
        valueAxisValueAxisItemTitleMargin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.margin'
        },
        valueAxisValueAxisItemTitlePadding: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.padding'
        },
        valueAxisValueAxisItemTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.position'
        },
        valueAxisValueAxisItemTitleRotation: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.rotation'
        },
        valueAxisValueAxisItemTitleText: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.text'
        },
        valueAxisValueAxisItemTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.title.visible'
        },
        valueAxisValueAxisItemVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.visible'
        },
        valueAxisValueAxisItemCrosshairColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.color'
        },
        valueAxisValueAxisItemCrosshairWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.width'
        },
        valueAxisValueAxisItemCrosshairOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.opacity'
        },
        valueAxisValueAxisItemCrosshairDashType: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.dashType'
        },
        valueAxisValueAxisItemCrosshairVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.visible'
        },
        valueAxisValueAxisItemCrosshairTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.background'
        },
        valueAxisValueAxisItemCrosshairTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.border.color'
        },
        valueAxisValueAxisItemCrosshairTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.border.width'
        },
        valueAxisValueAxisItemCrosshairTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.color'
        },
        valueAxisValueAxisItemCrosshairTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.font'
        },
        valueAxisValueAxisItemCrosshairTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.format'
        },
        valueAxisValueAxisItemCrosshairTooltipPadding: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.padding'
        },
        valueAxisValueAxisItemCrosshairTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.template'
        },
        valueAxisValueAxisItemCrosshairTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.visible'
        },
        valueAxisValueAxisItemNotesPosition: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.position'
        },
        valueAxisValueAxisItemNotesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.icon.background'
        },
        valueAxisValueAxisItemNotesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.icon.border.color'
        },
        valueAxisValueAxisItemNotesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.icon.border.width'
        },
        valueAxisValueAxisItemNotesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.icon.size'
        },
        valueAxisValueAxisItemNotesIconType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.icon.type'
        },
        valueAxisValueAxisItemNotesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.icon.visible'
        },
        valueAxisValueAxisItemNotesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.background'
        },
        valueAxisValueAxisItemNotesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.border.color'
        },
        valueAxisValueAxisItemNotesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.border.dashType'
        },
        valueAxisValueAxisItemNotesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.border.width'
        },
        valueAxisValueAxisItemNotesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.color'
        },
        valueAxisValueAxisItemNotesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.font'
        },
        valueAxisValueAxisItemNotesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.template'
        },
        valueAxisValueAxisItemNotesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.visible'
        },
        valueAxisValueAxisItemNotesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.rotation'
        },
        valueAxisValueAxisItemNotesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.format'
        },
        valueAxisValueAxisItemNotesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.label.position'
        },
        valueAxisValueAxisItemNotesLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.line.width'
        },
        valueAxisValueAxisItemNotesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.line.color'
        },
        valueAxisValueAxisItemNotesLineLength: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.line.length'
        },
        valueAxisValueAxisItemNotesData: {
            type: Array,
            default: undefined,
            kComposite: 'valueAxis.valueAxisItem.notes.data'
        } }
};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoChart = __webpack_require__(45);

var _KendoChart2 = _interopRequireDefault(_KendoChart);

var _KendoChartSeriesItem = __webpack_require__(11);

var _KendoChartSeriesItem2 = _interopRequireDefault(_KendoChartSeriesItem);

var _KendoStockChart = __webpack_require__(63);

var _KendoStockChart2 = _interopRequireDefault(_KendoStockChart);

var _KendoSparkline = __webpack_require__(64);

var _KendoSparkline2 = _interopRequireDefault(_KendoSparkline);

var _KendoSparklineSeriesItem = __webpack_require__(12);

var _KendoSparklineSeriesItem2 = _interopRequireDefault(_KendoSparklineSeriesItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoChartInstaller = function () {
    function KendoChartInstaller() {
        _classCallCheck(this, KendoChartInstaller);
    }

    _createClass(KendoChartInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoChart2.default.name, _KendoChart2.default);
            Vue.component(_KendoChartSeriesItem2.default.name, _KendoChartSeriesItem2.default);
            Vue.component(_KendoStockChart2.default.name, _KendoStockChart2.default);
            Vue.component(_KendoSparkline2.default.name, _KendoSparkline2.default);
            Vue.component(_KendoSparklineSeriesItem2.default.name, _KendoSparklineSeriesItem2.default);
        }
    }]);

    return KendoChartInstaller;
}();

exports.default = KendoChartInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoChartInstaller);
}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatToolbarButton = exports.KendoChatToolbarButton = exports.ChatInstaller = exports.Chat = exports.KendoChat = undefined;

var _KendoChat = __webpack_require__(65);

var _KendoChat2 = _interopRequireDefault(_KendoChat);

var _kendoChatInstaller = __webpack_require__(184);

var _kendoChatInstaller2 = _interopRequireDefault(_kendoChatInstaller);

var _KendoChatToolbarButton = __webpack_require__(13);

var _KendoChatToolbarButton2 = _interopRequireDefault(_KendoChatToolbarButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoChat = _KendoChat2.default;
exports.Chat = _KendoChat2.default;
exports.ChatInstaller = _kendoChatInstaller2.default;
exports.KendoChatToolbarButton = _KendoChatToolbarButton2.default;
exports.ChatToolbarButton = _KendoChatToolbarButton2.default;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _ChatProps = __webpack_require__(180);

var _ChatProps2 = _interopRequireDefault(_ChatProps);

var _Messages = __webpack_require__(181);

var _Messages2 = _interopRequireDefault(_Messages);

var _User = __webpack_require__(182);

var _User2 = _interopRequireDefault(_User);

var _Toolbar = __webpack_require__(183);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _KendoChatToolbarButton = __webpack_require__(13);

var _KendoChatToolbarButton2 = _interopRequireDefault(_KendoChatToolbarButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _ChatProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _Messages2.default, _Toolbar2.default, _User2.default],
    mounted: function mounted() {
        this._resolveChildren();
        kendo.jQuery(this.$el).kendoChat(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoChat();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('toolbarButtons', _KendoChatToolbarButton2.default.name);

            if (this.widgetOptions.toolbar && this.widgetOptions.toolbarButtons && this.widgetOptions.toolbarButtons.length) {

                this.widgetOptions.toolbar.buttons = this.widgetOptions.toolbarButtons;
            }
        }
    }
};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    messages: {
        type: Object,
        default: undefined
    },
    user: {
        type: Object,
        default: undefined
    },
    toolbar: {
        type: Object,
        default: undefined
    },

    // Events
    actionClick: {
        type: Function,
        default: undefined
    },
    post: {
        type: Function,
        default: undefined
    },
    sendMessage: {
        type: Function,
        default: undefined
    },
    typingEnd: {
        type: Function,
        default: undefined
    },
    typingStart: {
        type: Function,
        default: undefined
    },
    toolClick: {
        type: Function,
        default: undefined
    }
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesPlaceholder: {
            type: String,
            default: undefined,
            kComposite: 'messages.placeholder'
        }
    }
};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        userIconUrl: {
            type: String,
            default: undefined,
            kComposite: 'user.iconUrl'
        },
        userName: {
            type: String,
            default: undefined,
            kComposite: 'user.name'
        }
    }
};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        toolbarAnimation: {
            type: Boolean,
            default: undefined,
            kComposite: 'toolbar.animation'
        },
        toolbarAnimationCollapseEffects: {
            type: String,
            default: undefined,
            kComposite: 'toolbar.animation.collapse.effects'
        },
        toolbarAnimationCollapseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'toolbar.animation.collapse.duration'
        },
        toolbarAnimationExpandEffects: {
            type: String,
            default: undefined,
            kComposite: 'toolbar.animation.expand.effects'
        },
        toolbarAnimationExpandDuration: {
            type: Number,
            default: undefined,
            kComposite: 'toolbar.animation.expand.duration'
        },
        toolbarButtons: {
            type: Array,
            default: undefined,
            kComposite: 'toolbar.buttons'
        },
        toolbarScrollable: {
            type: Boolean,
            default: undefined,
            kComposite: 'toolbar.scrollable'
        },
        toolbarToggleable: {
            type: Boolean,
            default: undefined,
            kComposite: 'toolbar.toggleable'
        }
    }
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoChat = __webpack_require__(65);

var _KendoChat2 = _interopRequireDefault(_KendoChat);

var _KendoChatToolbarButton = __webpack_require__(13);

var _KendoChatToolbarButton2 = _interopRequireDefault(_KendoChatToolbarButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoChatInstaller = function () {
    function KendoChatInstaller() {
        _classCallCheck(this, KendoChatInstaller);
    }

    _createClass(KendoChatInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoChat2.default.name, _KendoChat2.default);
            Vue.component(_KendoChatToolbarButton2.default.name, _KendoChatToolbarButton2.default);
        }
    }]);

    return KendoChatInstaller;
}();

exports.default = KendoChatInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoChatInstaller);
}

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DataSourceInstaller = exports.KendoDataSourceInstaller = exports.PivotRow = exports.KendoPivotRow = exports.PivotMeasure = exports.KendoPivotMeasure = exports.PivotColumn = exports.KendoPivotColumn = exports.PivotDataSource = exports.KendoPivotDataSource = exports.GanttDependencyDataSource = exports.KendoGanttDependencyDataSource = exports.GanttDataSource = exports.KendoGanttDataSource = exports.TreeListDataSource = exports.KendoTreeListDataSource = exports.SchedulerDataSource = exports.KendoSchedulerDataSource = exports.HierarchicalDataSource = exports.KendoHierarchicalDataSource = exports.DataSource = exports.KendoDataSource = undefined;

var _KendoDataSource = __webpack_require__(66);

var _KendoDataSource2 = _interopRequireDefault(_KendoDataSource);

var _KendoHierarchicalDataSource = __webpack_require__(68);

var _KendoHierarchicalDataSource2 = _interopRequireDefault(_KendoHierarchicalDataSource);

var _KendoSchedulerDataSource = __webpack_require__(69);

var _KendoSchedulerDataSource2 = _interopRequireDefault(_KendoSchedulerDataSource);

var _KendoTreeListDataSource = __webpack_require__(70);

var _KendoTreeListDataSource2 = _interopRequireDefault(_KendoTreeListDataSource);

var _KendoGanttDataSource = __webpack_require__(71);

var _KendoGanttDataSource2 = _interopRequireDefault(_KendoGanttDataSource);

var _KendoGanttDependencyDataSource = __webpack_require__(72);

var _KendoGanttDependencyDataSource2 = _interopRequireDefault(_KendoGanttDependencyDataSource);

var _KendoPivotDataSource = __webpack_require__(73);

var _KendoPivotDataSource2 = _interopRequireDefault(_KendoPivotDataSource);

var _KendoPivotColumn = __webpack_require__(14);

var _KendoPivotColumn2 = _interopRequireDefault(_KendoPivotColumn);

var _KendoPivotMeasure = __webpack_require__(15);

var _KendoPivotMeasure2 = _interopRequireDefault(_KendoPivotMeasure);

var _KendoPivotRow = __webpack_require__(16);

var _KendoPivotRow2 = _interopRequireDefault(_KendoPivotRow);

var _kendoDatasourceInstaller = __webpack_require__(209);

var _kendoDatasourceInstaller2 = _interopRequireDefault(_kendoDatasourceInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoDataSource = _KendoDataSource2.default;
exports.DataSource = _KendoDataSource2.default;
exports.KendoHierarchicalDataSource = _KendoHierarchicalDataSource2.default;
exports.HierarchicalDataSource = _KendoHierarchicalDataSource2.default;
exports.KendoSchedulerDataSource = _KendoSchedulerDataSource2.default;
exports.SchedulerDataSource = _KendoSchedulerDataSource2.default;
exports.KendoTreeListDataSource = _KendoTreeListDataSource2.default;
exports.TreeListDataSource = _KendoTreeListDataSource2.default;
exports.KendoGanttDataSource = _KendoGanttDataSource2.default;
exports.GanttDataSource = _KendoGanttDataSource2.default;
exports.KendoGanttDependencyDataSource = _KendoGanttDependencyDataSource2.default;
exports.GanttDependencyDataSource = _KendoGanttDependencyDataSource2.default;
exports.KendoPivotDataSource = _KendoPivotDataSource2.default;
exports.PivotDataSource = _KendoPivotDataSource2.default;
exports.KendoPivotColumn = _KendoPivotColumn2.default;
exports.PivotColumn = _KendoPivotColumn2.default;
exports.KendoPivotMeasure = _KendoPivotMeasure2.default;
exports.PivotMeasure = _KendoPivotMeasure2.default;
exports.KendoPivotRow = _KendoPivotRow2.default;
exports.PivotRow = _KendoPivotRow2.default;
exports.KendoDataSourceInstaller = _kendoDatasourceInstaller2.default;
exports.DataSourceInstaller = _kendoDatasourceInstaller2.default;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _KendoDataSourceBase = __webpack_require__(5);

var _KendoDataSourceBase2 = _interopRequireDefault(_KendoDataSourceBase);

var _Filter = __webpack_require__(2);

var _Filter2 = _interopRequireDefault(_Filter);

var _Group = __webpack_require__(3);

var _Group2 = _interopRequireDefault(_Group);

var _Schema = __webpack_require__(67);

var _Schema2 = _interopRequireDefault(_Schema);

var _Sort = __webpack_require__(4);

var _Sort2 = _interopRequireDefault(_Sort);

var _Transport = __webpack_require__(6);

var _Transport2 = _interopRequireDefault(_Transport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mixins: [_KendoDataSourceBase2.default, _kendoBaseComponentsVueWrapper.KendoBaseComponent, _Filter2.default, _Group2.default, _Schema2.default, _Sort2.default, _Transport2.default],
    mounted: function mounted() {
        this.kendoDataSource = new kendo.data.DataSource(this.widgetOptions);
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return this.kendoDataSource || new kendo.data.DataSource(this.widgetOptions);
        }
    }
};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _DataSourceProps = __webpack_require__(188);

var _DataSourceProps2 = _interopRequireDefault(_DataSourceProps);

var _Filter = __webpack_require__(2);

var _Filter2 = _interopRequireDefault(_Filter);

var _Group = __webpack_require__(3);

var _Group2 = _interopRequireDefault(_Group);

var _Schema = __webpack_require__(67);

var _Schema2 = _interopRequireDefault(_Schema);

var _Sort = __webpack_require__(4);

var _Sort2 = _interopRequireDefault(_Sort);

var _Transport = __webpack_require__(6);

var _Transport2 = _interopRequireDefault(_Transport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _DataSourceProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _Filter2.default, _Group2.default, _Schema2.default, _Sort2.default, _Transport2.default],
    mounted: function mounted() {
        var _this = this;

        this.$watch(function () {
            return [_this.filter, _this.filterValue, _this.filterField, _this.filterFilters, _this.filterLogic, _this.filterOperator].join();
        }, function () {
            _this.kendoDataSource.filter(_this.widgetOptions.filter);
        }, { deep: true });

        this.$watch(function () {
            return [_this.group, _this.groupField, _this.groupDir, _this.groupAggregates].join();
        }, function () {
            _this.kendoDataSource.group(_this.widgetOptions.group);
        }, { deep: true });

        this.$watch(function () {
            return [_this.aggregate, _this.aggregateAggregate, _this.aggregateField].join();
        }, function () {
            _this.kendoDataSource.aggregate(_this.widgetOptions.aggregate);
        }, { deep: true });

        this.$watch(function () {
            return [_this.sort, _this.sortDir, _this.sortField, _this.sortCompare].join();
        }, function () {
            _this.kendoDataSource.sort(_this.widgetOptions.sort);
        }, { deep: true });

        this.$watch(function () {
            return [_this.page].join();
        }, function () {
            _this.kendoDataSource.page(_this.widgetOptions.page);
        }, { deep: true });

        this.$watch(function () {
            return [_this.pageSize].join();
        }, function () {
            _this.kendoDataSource.pageSize(_this.widgetOptions.pageSize);
        }, { deep: true });

        this.$watch(function () {
            return [_this.data].join();
        }, function () {
            _this.kendoDataSource.data(_this.widgetOptions.data);
        }, { deep: true });
    }
};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    aggregate: {
        type: Array,
        default: undefined
    },
    autoSync: {
        type: Boolean,
        default: undefined
    },
    batch: {
        type: Boolean,
        default: undefined
    },
    data: {
        type: [Array, String],
        default: undefined
    },
    filter: {
        type: [Array, Object],
        default: undefined
    },
    group: {
        type: [Array, Object],
        default: undefined
    },
    inPlaceSort: {
        type: Boolean,
        default: undefined
    },
    offlineStorage: {
        type: [String, Object],
        default: undefined
    },
    page: {
        type: [String, Number],
        default: undefined
    },
    pageSize: {
        type: [String, Number],
        default: undefined
    },
    schema: {
        type: Object,
        default: undefined
    },
    serverAggregates: {
        type: Boolean,
        default: undefined
    },
    serverFiltering: {
        type: Boolean,
        default: undefined
    },
    serverGrouping: {
        type: Boolean,
        default: undefined
    },
    serverPaging: {
        type: Boolean,
        default: undefined
    },
    serverSorting: {
        type: Boolean,
        default: undefined
    },
    sort: {
        type: [Array, Object],
        default: undefined
    },
    transport: {
        type: Object,
        default: undefined
    },
    type: {
        type: String,
        default: undefined
    },

    // Events
    change: {
        type: Function,
        default: undefined
    },
    error: {
        type: Function,
        default: undefined
    },
    push: {
        type: Function,
        default: undefined
    },
    requestEnd: {
        type: Function,
        default: undefined
    },
    requestStart: {
        type: Function,
        default: undefined
    },
    sync: Function
};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _KendoDataSourceBase = __webpack_require__(5);

var _KendoDataSourceBase2 = _interopRequireDefault(_KendoDataSourceBase);

var _Schema = __webpack_require__(190);

var _Schema2 = _interopRequireDefault(_Schema);

var _Filter = __webpack_require__(2);

var _Filter2 = _interopRequireDefault(_Filter);

var _Group = __webpack_require__(3);

var _Group2 = _interopRequireDefault(_Group);

var _Sort = __webpack_require__(4);

var _Sort2 = _interopRequireDefault(_Sort);

var _Transport = __webpack_require__(6);

var _Transport2 = _interopRequireDefault(_Transport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _KendoDataSourceBase2.default, _Schema2.default, _Filter2.default, _Group2.default, _Sort2.default, _Transport2.default],
    mounted: function mounted() {
        this.kendoDataSource = new kendo.data.HierarchicalDataSource(this.widgetOptions);
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return this.kendoDataSource || new kendo.data.HierarchicalDataSource(this.widgetOptions);
        }
    }
};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        schemaModel: {
            type: Object,
            default: undefined,
            kComposite: 'schema.model'
        },
        schemaModelHasChildren: {
            type: [Boolean, String, Function],
            default: undefined,
            kComposite: 'schema.model.hasChildren'
        },
        schemaModelChildren: {
            type: [String, Object],
            default: undefined,
            kComposite: 'schema.model.children'
        },
        schemaAggregates: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.aggregates'
        },
        schemaData: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.data'
        },
        schemaErrors: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.errors'
        },
        schemaGroups: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.groups'
        },
        schemaModelId: {
            type: String,
            default: undefined,
            kComposite: 'schema.model.id'
        },
        schemaModelFields: {
            type: Object,
            default: undefined,
            kComposite: 'schema.model.fields'
        },
        schemaParse: {
            type: Function,
            default: undefined,
            kComposite: 'schema.parse'
        },
        schemaTotal: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.total'
        },
        schemaType: {
            type: String,
            default: undefined,
            kComposite: 'schema.type'
        }
    }
};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _KendoDataSourceBase = __webpack_require__(5);

var _KendoDataSourceBase2 = _interopRequireDefault(_KendoDataSourceBase);

var _Schema = __webpack_require__(192);

var _Schema2 = _interopRequireDefault(_Schema);

var _Filter = __webpack_require__(2);

var _Filter2 = _interopRequireDefault(_Filter);

var _Group = __webpack_require__(3);

var _Group2 = _interopRequireDefault(_Group);

var _Sort = __webpack_require__(4);

var _Sort2 = _interopRequireDefault(_Sort);

var _Transport = __webpack_require__(6);

var _Transport2 = _interopRequireDefault(_Transport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _KendoDataSourceBase2.default, _Filter2.default, _Group2.default, _Schema2.default, _Sort2.default, _Transport2.default],
    mounted: function mounted() {
        this.kendoDataSource = new kendo.data.SchedulerDataSource(this.widgetOptions);
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return this.kendoDataSource || new kendo.data.SchedulerDataSource(this.widgetOptions);
        }
    }
};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        schemaModel: {
            type: Object,
            default: undefined,
            kComposite: 'schema.model'
        },
        schemaTimezone: {
            type: String,
            default: undefined,
            kComposite: 'schema.timezone'
        },
        schemaAggregates: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.aggregates'
        },
        schemaData: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.data'
        },
        schemaErrors: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.errors'
        },
        schemaGroups: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.groups'
        },
        schemaModelId: {
            type: String,
            default: undefined,
            kComposite: 'schema.model.id'
        },
        schemaModelFields: {
            type: Object,
            default: undefined,
            kComposite: 'schema.model.fields'
        },
        schemaParse: {
            type: Function,
            default: undefined,
            kComposite: 'schema.parse'
        },
        schemaTotal: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.total'
        },
        schemaType: {
            type: String,
            default: undefined,
            kComposite: 'schema.type'
        }
    }
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _KendoDataSourceBase = __webpack_require__(5);

var _KendoDataSourceBase2 = _interopRequireDefault(_KendoDataSourceBase);

var _TreeListDataSourceProps = __webpack_require__(194);

var _TreeListDataSourceProps2 = _interopRequireDefault(_TreeListDataSourceProps);

var _Schema = __webpack_require__(195);

var _Schema2 = _interopRequireDefault(_Schema);

var _Filter = __webpack_require__(2);

var _Filter2 = _interopRequireDefault(_Filter);

var _Group = __webpack_require__(3);

var _Group2 = _interopRequireDefault(_Group);

var _Sort = __webpack_require__(4);

var _Sort2 = _interopRequireDefault(_Sort);

var _Transport = __webpack_require__(6);

var _Transport2 = _interopRequireDefault(_Transport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _TreeListDataSourceProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _KendoDataSourceBase2.default, _Filter2.default, _Group2.default, _Schema2.default, _Sort2.default, _Transport2.default],
    mounted: function mounted() {
        this.kendoDataSource = new kendo.data.TreeListDataSource(this.widgetOptions);
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return this.kendoDataSource || new kendo.dataTreeListDataSource(this.widgetOptions);
        }
    }
};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    schema: {
        type: Object,
        default: undefined
    }
};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        schemaModel: {
            type: Object,
            default: undefined,
            kComposite: 'schema.model'
        },
        schemaAggregates: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.aggregates'
        },
        schemaData: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.data'
        },
        schemaErrors: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.errors'
        },
        schemaGroups: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.groups'
        },
        schemaModelId: {
            type: String,
            default: undefined,
            kComposite: 'schema.model.id'
        },
        schemaModelFields: {
            type: Object,
            default: undefined,
            kComposite: 'schema.model.fields'
        },
        schemaParse: {
            type: Function,
            default: undefined,
            kComposite: 'schema.parse'
        },
        schemaTotal: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.total'
        },
        schemaType: {
            type: String,
            default: undefined,
            kComposite: 'schema.type'
        }
    }
};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _KendoDataSourceBase = __webpack_require__(5);

var _KendoDataSourceBase2 = _interopRequireDefault(_KendoDataSourceBase);

var _GanttDataSourceProps = __webpack_require__(197);

var _GanttDataSourceProps2 = _interopRequireDefault(_GanttDataSourceProps);

var _Schema = __webpack_require__(198);

var _Schema2 = _interopRequireDefault(_Schema);

var _Filter = __webpack_require__(2);

var _Filter2 = _interopRequireDefault(_Filter);

var _Group = __webpack_require__(3);

var _Group2 = _interopRequireDefault(_Group);

var _Sort = __webpack_require__(4);

var _Sort2 = _interopRequireDefault(_Sort);

var _Transport = __webpack_require__(6);

var _Transport2 = _interopRequireDefault(_Transport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _GanttDataSourceProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _KendoDataSourceBase2.default, _Filter2.default, _Group2.default, _Schema2.default, _Sort2.default, _Transport2.default],
    mounted: function mounted() {
        this.kendoDataSource = new kendo.data.GanttDataSource(this.widgetOptions);
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return this.kendoDataSource || new kendo.data.GanttDataSource(this.widgetOptions);
        }
    }
};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    schema: {
        type: Object,
        default: undefined
    }
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        schemaModel: {
            type: Object,
            default: undefined,
            kComposite: 'schema.model'
        },
        schemaAggregates: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.aggregates'
        },
        schemaData: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.data'
        },
        schemaErrors: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.errors'
        },
        schemaGroups: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.groups'
        },
        schemaModelId: {
            type: String,
            default: undefined,
            kComposite: 'schema.model.id'
        },
        schemaModelFields: {
            type: Object,
            default: undefined,
            kComposite: 'schema.model.fields'
        },
        schemaParse: {
            type: Function,
            default: undefined,
            kComposite: 'schema.parse'
        },
        schemaTotal: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.total'
        },
        schemaType: {
            type: String,
            default: undefined,
            kComposite: 'schema.type'
        }
    }
};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _KendoDataSourceBase = __webpack_require__(5);

var _KendoDataSourceBase2 = _interopRequireDefault(_KendoDataSourceBase);

var _GanttDependencyDataSourceProps = __webpack_require__(200);

var _GanttDependencyDataSourceProps2 = _interopRequireDefault(_GanttDependencyDataSourceProps);

var _Schema = __webpack_require__(201);

var _Schema2 = _interopRequireDefault(_Schema);

var _Filter = __webpack_require__(2);

var _Filter2 = _interopRequireDefault(_Filter);

var _Group = __webpack_require__(3);

var _Group2 = _interopRequireDefault(_Group);

var _Sort = __webpack_require__(4);

var _Sort2 = _interopRequireDefault(_Sort);

var _Transport = __webpack_require__(6);

var _Transport2 = _interopRequireDefault(_Transport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _GanttDependencyDataSourceProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _KendoDataSourceBase2.default, _Filter2.default, _Group2.default, _Schema2.default, _Sort2.default, _Transport2.default],
    mounted: function mounted() {
        this.kendoDataSource = new kendo.data.GanttDependencyDataSource(this.widgetOptions);
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return this.kendoDataSource || new kendo.data.GanttDependencyDataSource(this.widgetOptions);
        }
    }
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    schema: {
        type: Object,
        default: undefined
    }
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        schemaModel: {
            type: Object,
            default: undefined,
            kComposite: 'schema.model'
        },
        schemaAggregates: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.aggregates'
        },
        schemaData: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.data'
        },
        schemaErrors: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.errors'
        },
        schemaGroups: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.groups'
        },
        schemaModelId: {
            type: String,
            default: undefined,
            kComposite: 'schema.model.id'
        },
        schemaModelFields: {
            type: Object,
            default: undefined,
            kComposite: 'schema.model.fields'
        },
        schemaParse: {
            type: Function,
            default: undefined,
            kComposite: 'schema.parse'
        },
        schemaTotal: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.total'
        },
        schemaType: {
            type: String,
            default: undefined,
            kComposite: 'schema.type'
        }
    }
};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _KendoDataSourceBase = __webpack_require__(5);

var _KendoDataSourceBase2 = _interopRequireDefault(_KendoDataSourceBase);

var _PivotDataSourceProps = __webpack_require__(203);

var _PivotDataSourceProps2 = _interopRequireDefault(_PivotDataSourceProps);

var _KendoPivotColumn = __webpack_require__(14);

var _KendoPivotColumn2 = _interopRequireDefault(_KendoPivotColumn);

var _KendoPivotMeasure = __webpack_require__(15);

var _KendoPivotMeasure2 = _interopRequireDefault(_KendoPivotMeasure);

var _KendoPivotRow = __webpack_require__(16);

var _KendoPivotRow2 = _interopRequireDefault(_KendoPivotRow);

var _Schema = __webpack_require__(207);

var _Schema2 = _interopRequireDefault(_Schema);

var _Transport = __webpack_require__(208);

var _Transport2 = _interopRequireDefault(_Transport);

var _Filter = __webpack_require__(2);

var _Filter2 = _interopRequireDefault(_Filter);

var _Group = __webpack_require__(3);

var _Group2 = _interopRequireDefault(_Group);

var _Sort = __webpack_require__(4);

var _Sort2 = _interopRequireDefault(_Sort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _PivotDataSourceProps2.default,
    mixins: [_KendoDataSourceBase2.default, _kendoBaseComponentsVueWrapper.KendoBaseComponent, _Filter2.default, _Group2.default, _Schema2.default, _Sort2.default, _Transport2.default],
    mounted: function mounted() {
        this._resolveChildren();

        this.kendoDataSource = new kendo.data.PivotDataSource(this.widgetOptions);
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return this.kendoDataSource || new kendo.data.PivotDataSource(this.widgetOptions);
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('columns', _KendoPivotColumn2.default.name);
            this.resolveChildren('measures', _KendoPivotMeasure2.default.name);
            this.resolveChildren('rows', _KendoPivotRow2.default.name);
        }
    }
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    columns: {
        type: Array,
        default: undefined
    },
    measures: {
        type: Array,
        default: undefined
    },
    rows: {
        type: Array,
        default: undefined
    },
    transport: {
        type: Object,
        default: undefined
    },
    schema: {
        type: Object,
        default: undefined
    }
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        expand: {
            type: Boolean,
            default: undefined,
            kComposite: 'expand'
        },
        name: {
            type: String,
            default: undefined,
            kComposite: 'name'
        }
    }
};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        values: {
            type: Array,
            default: undefined,
            kComposite: 'values'
        },
        axis: {
            type: String,
            default: undefined,
            kComposite: 'axis'
        }
    }
};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        expand: {
            type: Boolean,
            default: undefined,
            kComposite: 'expand'
        },
        name: {
            type: String,
            default: undefined,
            kComposite: 'name'
        }
    }
};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        schemaAxes: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.axes'
        },
        schemaCatalogs: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.catalogs'
        },
        schemaCubes: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.cubes'
        },
        schemaCube: {
            type: Object,
            default: undefined,
            kComposite: 'schema.cube'
        },
        schemaData: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.data'
        },
        schemaDimensions: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.dimensions'
        },
        schemaHierarchies: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.hierarchies'
        },
        schemaLevels: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.levels'
        },
        schemaMeasures: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.measures'
        },
        schemaAggregates: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.aggregates'
        },
        schemaErrors: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.errors'
        },
        schemaGroups: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.groups'
        },
        schemaModelId: {
            type: String,
            default: undefined,
            kComposite: 'schema.model.id'
        },
        schemaModelFields: {
            type: Object,
            default: undefined,
            kComposite: 'schema.model.fields'
        },
        schemaParse: {
            type: Function,
            default: undefined,
            kComposite: 'schema.parse'
        },
        schemaTotal: {
            type: [Function, String],
            default: undefined,
            kComposite: 'schema.total'
        },
        schemaType: {
            type: String,
            default: undefined,
            kComposite: 'schema.type'
        }
    }
};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        transportDiscover: {
            type: [Object, String, Function],
            default: undefined,
            kComposite: 'transport.discover'
        },
        transportConnectionCatalog: {
            type: String,
            default: undefined,
            kComposite: 'transport.connection.catalog'
        },
        transportConnectionCube: {
            type: String,
            default: undefined,
            kComposite: 'transport.connection.cube'
        },
        transportCreate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.create'
        },
        transportCreateCache: {
            type: Boolean,
            default: undefined,
            kComposite: 'transport.create.cache'
        },
        transportCreateContentType: {
            type: String,
            default: undefined,
            kComposite: 'transport.create.contentType'
        },
        transportCreateData: {
            type: [Object, Function],
            default: undefined,
            kComposite: 'transport.create.data'
        },
        transportCreateDataType: {
            type: String,
            default: undefined,
            kComposite: 'transport.create.dataType'
        },
        transportCreateType: {
            type: String,
            default: undefined,
            kComposite: 'transport.create.type'
        },
        transportCreateUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.create.url'
        },
        transportDestroy: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.destroy'
        },
        transportDestroyCache: {
            type: Boolean,
            default: undefined,
            kComposite: 'transport.destroy.cache'
        },
        transportDestroyContentType: {
            type: String,
            default: undefined,
            kComposite: 'transport.destroy.contentType'
        },
        transportDestroyData: {
            type: [Object, Function],
            default: undefined,
            kComposite: 'transport.destroy.data'
        },
        transportDestroyDataType: {
            type: String,
            default: undefined,
            kComposite: 'transport.destroy.dataType'
        },
        transportDestroyType: {
            type: String,
            default: undefined,
            kComposite: 'transport.destroy.type'
        },
        transportDestroyUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.destroy.url'
        },
        transportParameterMap: {
            type: Function,
            default: undefined,
            kComposite: 'transport.parameterMap'
        },
        transportPush: {
            type: Function,
            default: undefined,
            kComposite: 'transport.push'
        },
        transportRead: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.read'
        },
        transportReadCache: {
            type: Boolean,
            default: undefined,
            kComposite: 'transport.read.cache'
        },
        transportReadContentType: {
            type: String,
            default: undefined,
            kComposite: 'transport.read.contentType'
        },
        transportReadData: {
            type: [Object, Function],
            default: undefined,
            kComposite: 'transport.read.data'
        },
        transportReadDataType: {
            type: String,
            default: undefined,
            kComposite: 'transport.read.dataType'
        },
        transportReadType: {
            type: String,
            default: undefined,
            kComposite: 'transport.read.type'
        },
        transportReadUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.read.url'
        },
        transportSignalrClientCreate: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.client.create'
        },
        transportSignalrClientDestroy: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.client.destroy'
        },
        transportSignalrClientRead: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.client.read'
        },
        transportSignalrClientUpdate: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.client.update'
        },
        transportSignalrHub: {
            type: Object,
            default: undefined,
            kComposite: 'transport.signalr.hub'
        },
        transportSignalrPromise: {
            type: Object,
            default: undefined,
            kComposite: 'transport.signalr.promise'
        },
        transportSignalrServerCreate: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.server.create'
        },
        transportSignalrServerDestroy: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.server.destroy'
        },
        transportSignalrServerRead: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.server.read'
        },
        transportSignalrServerUpdate: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.server.update'
        },
        transportSubmit: {
            type: Function,
            default: undefined,
            kComposite: 'transport.submit'
        },
        transportUpdate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.update'
        },
        transportUpdateCache: {
            type: Boolean,
            default: undefined,
            kComposite: 'transport.update.cache'
        },
        transportUpdateContentType: {
            type: String,
            default: undefined,
            kComposite: 'transport.update.contentType'
        },
        transportUpdateData: {
            type: [Object, Function],
            default: undefined,
            kComposite: 'transport.update.data'
        },
        transportUpdateDataType: {
            type: String,
            default: undefined,
            kComposite: 'transport.update.dataType'
        },
        transportUpdateType: {
            type: String,
            default: undefined,
            kComposite: 'transport.update.type'
        },
        transportUpdateUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.update.url'
        }
    }
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoDataSource = __webpack_require__(66);

var _KendoDataSource2 = _interopRequireDefault(_KendoDataSource);

var _KendoHierarchicalDataSource = __webpack_require__(68);

var _KendoHierarchicalDataSource2 = _interopRequireDefault(_KendoHierarchicalDataSource);

var _KendoSchedulerDataSource = __webpack_require__(69);

var _KendoSchedulerDataSource2 = _interopRequireDefault(_KendoSchedulerDataSource);

var _KendoTreeListDataSource = __webpack_require__(70);

var _KendoTreeListDataSource2 = _interopRequireDefault(_KendoTreeListDataSource);

var _KendoGanttDataSource = __webpack_require__(71);

var _KendoGanttDataSource2 = _interopRequireDefault(_KendoGanttDataSource);

var _KendoGanttDependencyDataSource = __webpack_require__(72);

var _KendoGanttDependencyDataSource2 = _interopRequireDefault(_KendoGanttDependencyDataSource);

var _KendoPivotDataSource = __webpack_require__(73);

var _KendoPivotDataSource2 = _interopRequireDefault(_KendoPivotDataSource);

var _KendoPivotColumn = __webpack_require__(14);

var _KendoPivotColumn2 = _interopRequireDefault(_KendoPivotColumn);

var _KendoPivotMeasure = __webpack_require__(15);

var _KendoPivotMeasure2 = _interopRequireDefault(_KendoPivotMeasure);

var _KendoPivotRow = __webpack_require__(16);

var _KendoPivotRow2 = _interopRequireDefault(_KendoPivotRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoDataSourceInstaller = function () {
    function KendoDataSourceInstaller() {
        _classCallCheck(this, KendoDataSourceInstaller);
    }

    _createClass(KendoDataSourceInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoDataSource2.default.name, _KendoDataSource2.default);
            Vue.component(_KendoHierarchicalDataSource2.default.name, _KendoHierarchicalDataSource2.default);
            Vue.component(_KendoSchedulerDataSource2.default.name, _KendoSchedulerDataSource2.default);
            Vue.component(_KendoTreeListDataSource2.default.name, _KendoTreeListDataSource2.default);
            Vue.component(_KendoGanttDataSource2.default.name, _KendoGanttDataSource2.default);
            Vue.component(_KendoGanttDependencyDataSource2.default.name, _KendoGanttDependencyDataSource2.default);
            Vue.component(_KendoPivotDataSource2.default.name, _KendoPivotDataSource2.default);
            Vue.component(_KendoPivotColumn2.default.name, _KendoPivotColumn2.default);
            Vue.component(_KendoPivotMeasure2.default.name, _KendoPivotMeasure2.default);
            Vue.component(_KendoPivotRow2.default.name, _KendoPivotRow2.default);
        }
    }]);

    return KendoDataSourceInstaller;
}();

exports.default = KendoDataSourceInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoDataSourceInstaller);
}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KendoDateRangePicker = exports.DateRangePicker = exports.KendoMultiViewCalendar = exports.MultiViewCalendar = exports.TimePicker = exports.KendoTimePicker = exports.DateTimePicker = exports.KendoDateTimePicker = exports.DatePicker = exports.KendoDatePicker = exports.DateInput = exports.KendoDateInput = exports.Calendar = exports.KendoCalendar = exports.DateinputsInstaller = exports.KendoDateinputsInstaller = undefined;

var _kendoDateinputsInstaller = __webpack_require__(211);

var _kendoDateinputsInstaller2 = _interopRequireDefault(_kendoDateinputsInstaller);

var _KendoCalendar = __webpack_require__(74);

var _KendoCalendar2 = _interopRequireDefault(_KendoCalendar);

var _KendoDateInput = __webpack_require__(75);

var _KendoDateInput2 = _interopRequireDefault(_KendoDateInput);

var _KendoDatePicker = __webpack_require__(76);

var _KendoDatePicker2 = _interopRequireDefault(_KendoDatePicker);

var _KendoDateRangePicker = __webpack_require__(80);

var _KendoDateRangePicker2 = _interopRequireDefault(_KendoDateRangePicker);

var _KendoDateTimePicker = __webpack_require__(77);

var _KendoDateTimePicker2 = _interopRequireDefault(_KendoDateTimePicker);

var _KendoTimePicker = __webpack_require__(78);

var _KendoTimePicker2 = _interopRequireDefault(_KendoTimePicker);

var _KendoMultiViewCalendar = __webpack_require__(79);

var _KendoMultiViewCalendar2 = _interopRequireDefault(_KendoMultiViewCalendar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoDateinputsInstaller = _kendoDateinputsInstaller2.default;
exports.DateinputsInstaller = _kendoDateinputsInstaller2.default;
exports.KendoCalendar = _KendoCalendar2.default;
exports.Calendar = _KendoCalendar2.default;
exports.KendoDateInput = _KendoDateInput2.default;
exports.DateInput = _KendoDateInput2.default;
exports.KendoDatePicker = _KendoDatePicker2.default;
exports.DatePicker = _KendoDatePicker2.default;
exports.KendoDateTimePicker = _KendoDateTimePicker2.default;
exports.DateTimePicker = _KendoDateTimePicker2.default;
exports.KendoTimePicker = _KendoTimePicker2.default;
exports.TimePicker = _KendoTimePicker2.default;
exports.MultiViewCalendar = _KendoMultiViewCalendar2.default;
exports.KendoMultiViewCalendar = _KendoMultiViewCalendar2.default;
exports.DateRangePicker = _KendoDateRangePicker2.default;
exports.KendoDateRangePicker = _KendoDateRangePicker2.default;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoCalendar = __webpack_require__(74);

var _KendoCalendar2 = _interopRequireDefault(_KendoCalendar);

var _KendoDateInput = __webpack_require__(75);

var _KendoDateInput2 = _interopRequireDefault(_KendoDateInput);

var _KendoDatePicker = __webpack_require__(76);

var _KendoDatePicker2 = _interopRequireDefault(_KendoDatePicker);

var _KendoDateTimePicker = __webpack_require__(77);

var _KendoDateTimePicker2 = _interopRequireDefault(_KendoDateTimePicker);

var _KendoTimePicker = __webpack_require__(78);

var _KendoTimePicker2 = _interopRequireDefault(_KendoTimePicker);

var _KendoMultiViewCalendar = __webpack_require__(79);

var _KendoMultiViewCalendar2 = _interopRequireDefault(_KendoMultiViewCalendar);

var _KendoDateRangePicker = __webpack_require__(80);

var _KendoDateRangePicker2 = _interopRequireDefault(_KendoDateRangePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoDateinputsInstaller = function () {
    function KendoDateinputsInstaller() {
        _classCallCheck(this, KendoDateinputsInstaller);
    }

    _createClass(KendoDateinputsInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoCalendar2.default.name, _KendoCalendar2.default);
            Vue.component(_KendoDateInput2.default.name, _KendoDateInput2.default);
            Vue.component(_KendoDatePicker2.default.name, _KendoDatePicker2.default);
            Vue.component(_KendoDateTimePicker2.default.name, _KendoDateTimePicker2.default);
            Vue.component(_KendoTimePicker2.default.name, _KendoTimePicker2.default);
            Vue.component(_KendoMultiViewCalendar2.default.name, _KendoMultiViewCalendar2.default);
            Vue.component(_KendoDateRangePicker2.default.name, _KendoDateRangePicker2.default);
        }
    }]);

    return KendoDateinputsInstaller;
}();

exports.default = KendoDateinputsInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoDateinputsInstaller);
}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _CalendarProps = __webpack_require__(213);

var _CalendarProps2 = _interopRequireDefault(_CalendarProps);

var _Messages = __webpack_require__(214);

var _Messages2 = _interopRequireDefault(_Messages);

var _Month = __webpack_require__(17);

var _Month2 = _interopRequireDefault(_Month);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _CalendarProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _Messages2.default, _Month2.default],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoCalendar(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoCalendar();
        }
    }
};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: Date,
        default: undefined
    },
    culture: {
        type: String,
        default: undefined
    },
    dates: {
        type: Array,
        default: undefined
    },
    depth: {
        type: String,
        default: undefined
    },
    disableDates: {
        type: [Array, Function],
        default: undefined
    },
    footer: {
        type: [String, Function],
        default: undefined
    },
    format: {
        type: String,
        default: undefined
    },
    max: {
        type: Date,
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    min: {
        type: Date,
        default: undefined
    },
    month: {
        type: Object,
        default: undefined
    },
    selectable: {
        type: String,
        default: undefined
    },
    selectDates: {
        type: Array,
        default: undefined
    },
    weekNumber: {
        type: Boolean,
        default: undefined
    },
    start: {
        type: String,
        default: undefined
    },
    value: {
        type: Date,
        default: undefined
    },

    // Events
    change: Function,
    navigate: Function
};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesWeekColumnHeader: {
            type: String,
            default: undefined,
            kComposite: 'messages.weekColumnHeader'
        }
    }
};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _DateInputProps = __webpack_require__(216);

var _DateInputProps2 = _interopRequireDefault(_DateInputProps);

var _Messages = __webpack_require__(217);

var _Messages2 = _interopRequireDefault(_Messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: _DateInputProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseInputComponent, _Messages2.default],
    mounted: function mounted() {
        var that = this;
        kendo.jQuery(that.$el).kendoDateInput(that.widgetOptions);
        var widget = that.kendoWidget();

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', widget.value());
            } else {
                that.$emit('changemodel', widget.value());
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoDateInput();
        }
    }
};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: [String, Date],
        default: undefined
    },
    format: {
        type: String,
        default: undefined
    },
    max: {
        type: Date,
        default: undefined
    },
    min: {
        type: Date,
        default: undefined
    },
    value: {
        type: [String, Date],
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },

    // Events
    change: Function
};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesYear: {
            type: String,
            default: undefined,
            kComposite: 'messages.year'
        },
        messagesMonth: {
            type: String,
            default: undefined,
            kComposite: 'messages.month'
        },
        messagesDay: {
            type: String,
            default: undefined,
            kComposite: 'messages.day'
        },
        messagesWeekday: {
            type: String,
            default: undefined,
            kComposite: 'messages.weekday'
        },
        messagesHour: {
            type: String,
            default: undefined,
            kComposite: 'messages.hour'
        },
        messagesMinute: {
            type: String,
            default: undefined,
            kComposite: 'messages.minute'
        },
        messagesSecond: {
            type: String,
            default: undefined,
            kComposite: 'messages.second'
        },
        messagesDayperiod: {
            type: String,
            default: undefined,
            kComposite: 'messages.dayperiod'
        }
    }
};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _DatePickerProps = __webpack_require__(219);

var _DatePickerProps2 = _interopRequireDefault(_DatePickerProps);

var _Animation = __webpack_require__(18);

var _Animation2 = _interopRequireDefault(_Animation);

var _Month = __webpack_require__(17);

var _Month2 = _interopRequireDefault(_Month);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: _DatePickerProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseInputComponent, _Animation2.default, _Month2.default],
    mounted: function mounted() {
        var that = this;
        kendo.jQuery(that.$el).kendoDatePicker(that.widgetOptions);
        var widget = that.kendoWidget();

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', widget.value());
            } else {
                that.$emit('changemodel', widget.value());
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoDatePicker();
        }
    }
};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: [String, Date],
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    ARIATemplate: {
        type: String,
        default: undefined
    },
    culture: {
        type: String,
        default: undefined
    },
    dateInput: {
        type: Boolean,
        default: undefined
    },
    dates: {
        type: Array,
        default: undefined
    },
    depth: {
        type: String,
        default: undefined
    },
    disableDates: {
        type: [Array, Function],
        default: undefined
    },
    footer: {
        type: [String, Function],
        default: undefined
    },
    format: {
        type: String,
        default: undefined
    },
    max: {
        type: Date,
        default: undefined
    },
    min: {
        type: Date,
        default: undefined
    },
    month: {
        type: Object,
        default: undefined
    },
    weekNumber: {
        type: Boolean,
        default: undefined
    },
    parseFormats: {
        type: Array,
        default: undefined
    },
    start: {
        type: String,
        default: undefined
    },
    value: {
        type: [String, Date],
        default: undefined
    },

    // Events
    change: Function,
    close: Function,
    open: Function
};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _DateTimePickerProps = __webpack_require__(221);

var _DateTimePickerProps2 = _interopRequireDefault(_DateTimePickerProps);

var _Animation = __webpack_require__(18);

var _Animation2 = _interopRequireDefault(_Animation);

var _Month = __webpack_require__(17);

var _Month2 = _interopRequireDefault(_Month);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: _DateTimePickerProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseInputComponent, _Animation2.default, _Month2.default],
    mounted: function mounted() {
        var that = this;
        kendo.jQuery(that.$el).kendoDateTimePicker(that.widgetOptions);
        var widget = that.kendoWidget();

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', widget.value());
            } else {
                that.$emit('changemodel', widget.value());
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoDateTimePicker();
        }
    }
};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: [String, Date],
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    ARIATemplate: {
        type: String,
        default: undefined
    },
    culture: {
        type: String,
        default: undefined
    },
    dateInput: {
        type: Boolean,
        default: undefined
    },
    dates: {
        type: Array,
        default: undefined
    },
    depth: {
        type: String,
        default: undefined
    },
    disableDates: {
        type: [Array, Function],
        default: undefined
    },
    footer: {
        type: String,
        default: undefined
    },
    format: {
        type: String,
        default: undefined
    },
    interval: {
        type: Number,
        default: undefined
    },
    max: {
        type: Date,
        default: undefined
    },
    min: {
        type: Date,
        default: undefined
    },
    month: {
        type: Object,
        default: undefined
    },
    weekNumber: {
        type: Boolean,
        default: undefined
    },
    parseFormats: {
        type: Array,
        default: undefined
    },
    start: {
        type: String,
        default: undefined
    },
    timeFormat: {
        type: String,
        default: undefined
    },
    value: {
        type: [String, Date],
        default: undefined
    },

    // Events
    change: Function,
    close: Function,
    open: Function
};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _TimePickerProps = __webpack_require__(223);

var _TimePickerProps2 = _interopRequireDefault(_TimePickerProps);

var _Animation = __webpack_require__(18);

var _Animation2 = _interopRequireDefault(_Animation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _TimePickerProps2.default,
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseInputComponent, _Animation2.default],
    mounted: function mounted() {
        var that = this;
        kendo.jQuery(that.$el).kendoTimePicker(that.widgetOptions);
        var widget = that.kendoWidget();

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', widget);
        } else {
            this.$emit('kendowidgetready', widget);
        }

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', widget.value());
            } else {
                that.$emit('changemodel', widget.value());
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoTimePicker();
        }
    }
};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: [String, Date],
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    culture: {
        type: String,
        default: undefined
    },
    dateInput: {
        type: Boolean,
        default: undefined
    },
    dates: {
        type: Array,
        default: undefined
    },
    format: {
        type: String,
        default: undefined
    },
    interval: {
        type: Number,
        default: undefined
    },
    max: {
        type: Date,
        default: undefined
    },
    min: {
        type: Date,
        default: undefined
    },
    parseFormats: {
        type: Array,
        default: undefined
    },
    value: {
        type: [String, Date],
        default: undefined
    },

    // Events
    change: Function,
    close: Function,
    open: Function
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _MultiViewCalendarProps = __webpack_require__(225);

var _MultiViewCalendarProps2 = _interopRequireDefault(_MultiViewCalendarProps);

var _Messages = __webpack_require__(226);

var _Messages2 = _interopRequireDefault(_Messages);

var _Month = __webpack_require__(227);

var _Month2 = _interopRequireDefault(_Month);

var _Range = __webpack_require__(228);

var _Range2 = _interopRequireDefault(_Range);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _MultiViewCalendarProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _Messages2.default, _Month2.default, _Range2.default],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoMultiViewCalendar(this.widgetOptions);

        if (this.v3) {
            this.ready();
        }

        this.$emit('kendowidgetready', this.kendoWidget());
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoMultiViewCalendar();
        }
    }
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    culture: String,
    dates: Array,
    depth: String,
    disableDates: [Array, Function],
    footer: [String, Function],
    format: String,
    max: Date,
    messages: Object,
    min: Date,
    month: Object,
    views: Number,
    range: Object,
    selectable: String,
    selectDates: Array,
    showViewHeader: Boolean,
    weekNumber: Boolean,
    start: String,
    value: Date,

    // Events
    change: Function,
    navigate: Function
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesWeekColumnHeader: {
            type: String,
            default: undefined,
            kComposite: 'messages.weekColumnHeader'
        }
    }
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        monthContent: {
            type: String,
            default: undefined,
            kComposite: 'month.content'
        },
        monthWeekNumber: {
            type: String,
            default: undefined,
            kComposite: 'month.weekNumber'
        },
        monthEmpty: {
            type: String,
            default: undefined,
            kComposite: 'month.empty'
        }
    }
};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        rangeStart: {
            type: Date,
            default: undefined,
            kComposite: 'range.start'
        },
        rangeEnd: {
            type: Date,
            default: undefined,
            kComposite: 'range.end'
        }
    }
};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _DateRangePickerProps = __webpack_require__(230);

var _DateRangePickerProps2 = _interopRequireDefault(_DateRangePickerProps);

var _Messages = __webpack_require__(231);

var _Messages2 = _interopRequireDefault(_Messages);

var _Month = __webpack_require__(232);

var _Month2 = _interopRequireDefault(_Month);

var _Range = __webpack_require__(233);

var _Range2 = _interopRequireDefault(_Range);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _DateRangePickerProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _Messages2.default, _Month2.default, _Range2.default],

    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoDateRangePicker(this.widgetOptions);

        if (this.v3) {
            this.ready();
        }

        this.$emit('kendowidgetready', this.kendoWidget());
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoDateRangePicker();
        }
    }
};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    ARIATemplate: {
        type: String,
        default: undefined
    },
    culture: {
        type: String,
        default: undefined
    },
    dates: {
        type: Array,
        default: undefined
    },
    depth: {
        type: String,
        default: undefined
    },
    disableDates: {
        type: [Array, Function],
        default: undefined
    },
    footer: {
        type: [String, Function],
        default: undefined
    },
    format: {
        type: String,
        default: undefined
    },
    max: {
        type: Date,
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    min: {
        type: Date,
        default: undefined
    },
    month: {
        type: Object,
        default: undefined
    },
    labels: {
        type: Boolean,
        default: undefined
    },
    weekNumber: {
        type: Boolean,
        default: undefined
    },
    range: {
        type: Object,
        default: undefined
    },
    start: {
        type: String,
        default: undefined
    },

    // Events
    change: Function,
    close: Function,
    open: Function
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesStartLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.startLabel'
        },
        messagesEndLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.endLabel'
        }
    }
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        monthContent: {
            type: String,
            default: undefined,
            kComposite: 'month.content'
        },
        monthWeekNumber: {
            type: String,
            default: undefined,
            kComposite: 'month.weekNumber'
        },
        monthEmpty: {
            type: String,
            default: undefined,
            kComposite: 'month.empty'
        }
    }
};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        rangeStart: {
            type: Date,
            default: undefined,
            kComposite: 'range.start'
        },
        rangeEnd: {
            type: Date,
            default: undefined,
            kComposite: 'range.end'
        }
    }
};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DiagramInstaller = exports.KendoDiagramInstaller = exports.DiagramShape = exports.KendoDiagramShape = exports.DiagramConnection = exports.KendoDiagramConnection = exports.Diagram = exports.KendoDiagram = undefined;

var _KendoDiagram = __webpack_require__(81);

var _KendoDiagram2 = _interopRequireDefault(_KendoDiagram);

var _KendoDiagramConnection = __webpack_require__(19);

var _KendoDiagramConnection2 = _interopRequireDefault(_KendoDiagramConnection);

var _KendoDiagramShape = __webpack_require__(20);

var _KendoDiagramShape2 = _interopRequireDefault(_KendoDiagramShape);

var _kendoDiagramInstaller = __webpack_require__(246);

var _kendoDiagramInstaller2 = _interopRequireDefault(_kendoDiagramInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoDiagram = _KendoDiagram2.default;
exports.Diagram = _KendoDiagram2.default;
exports.KendoDiagramConnection = _KendoDiagramConnection2.default;
exports.DiagramConnection = _KendoDiagramConnection2.default;
exports.KendoDiagramShape = _KendoDiagramShape2.default;
exports.DiagramShape = _KendoDiagramShape2.default;
exports.KendoDiagramInstaller = _kendoDiagramInstaller2.default;
exports.DiagramInstaller = _kendoDiagramInstaller2.default;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _DiagramProps = __webpack_require__(236);

var _DiagramProps2 = _interopRequireDefault(_DiagramProps);

var _KendoDiagramConnection = __webpack_require__(19);

var _KendoDiagramConnection2 = _interopRequireDefault(_KendoDiagramConnection);

var _KendoDiagramShape = __webpack_require__(20);

var _KendoDiagramShape2 = _interopRequireDefault(_KendoDiagramShape);

var _ConnectionDefaults = __webpack_require__(239);

var _ConnectionDefaults2 = _interopRequireDefault(_ConnectionDefaults);

var _Editable = __webpack_require__(240);

var _Editable2 = _interopRequireDefault(_Editable);

var _Layout = __webpack_require__(241);

var _Layout2 = _interopRequireDefault(_Layout);

var _Pannable = __webpack_require__(242);

var _Pannable2 = _interopRequireDefault(_Pannable);

var _Pdf = __webpack_require__(243);

var _Pdf2 = _interopRequireDefault(_Pdf);

var _Selectable = __webpack_require__(244);

var _Selectable2 = _interopRequireDefault(_Selectable);

var _ShapeDefaults = __webpack_require__(245);

var _ShapeDefaults2 = _interopRequireDefault(_ShapeDefaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _DiagramProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _ConnectionDefaults2.default, _Editable2.default, _Layout2.default, _Pannable2.default, _Pdf2.default, _Selectable2.default, _ShapeDefaults2.default],
    mounted: function mounted() {
        this._resolveChildren();
        this.setInnerDataSource('connectionsDataSourceRef', 'connectionsDataSource');
        kendo.jQuery(this.$el).kendoDiagram(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoDiagram();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('connections', _KendoDiagramConnection2.default.name);
            this.resolveChildren('shapes', _KendoDiagramShape2.default.name);
        }
    }
};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    autoBind: {
        type: Boolean,
        default: undefined
    },
    connectionDefaults: {
        type: Object,
        default: undefined
    },
    connections: {
        type: Array,
        default: undefined
    },
    connectionsDataSource: {
        type: [Object, Array],
        default: undefined
    },
    connectionsDataSourceRef: {
        type: String,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    editable: {
        type: [Boolean, Object],
        default: undefined
    },
    layout: {
        type: Object,
        default: undefined
    },
    pannable: {
        type: [Boolean, Object],
        default: undefined
    },
    pdf: {
        type: Object,
        default: undefined
    },
    selectable: {
        type: [Boolean, Object],
        default: undefined
    },
    shapeDefaults: {
        type: Object,
        default: undefined
    },
    shapes: {
        type: Array,
        default: undefined
    },
    template: {
        type: [String, Function],
        default: undefined
    },
    theme: {
        type: String,
        default: undefined
    },
    zoom: {
        type: Number,
        default: undefined
    },
    zoomMax: {
        type: Number,
        default: undefined
    },
    zoomMin: {
        type: Number,
        default: undefined
    },
    zoomRate: {
        type: Number,
        default: undefined
    },

    // Events
    add: {
        type: Function,
        default: undefined
    },
    cancel: {
        type: Function,
        default: undefined
    },
    change: {
        type: Function,
        default: undefined
    },
    click: {
        type: Function,
        default: undefined
    },
    dataBound: {
        type: Function,
        default: undefined
    },
    drag: {
        type: Function,
        default: undefined
    },
    dragEnd: {
        type: Function,
        default: undefined
    },
    dragStart: {
        type: Function,
        default: undefined
    },
    edit: {
        type: Function,
        default: undefined
    },
    itemBoundsChange: {
        type: Function,
        default: undefined
    },
    itemRotate: {
        type: Function,
        default: undefined
    },
    mouseEnter: {
        type: Function,
        default: undefined
    },
    mouseLeave: {
        type: Function,
        default: undefined
    },
    pan: {
        type: Function,
        default: undefined
    },
    remove: {
        type: Function,
        default: undefined
    },
    save: {
        type: Function,
        default: undefined
    },
    select: {
        type: Function,
        default: undefined
    },
    toolBarClick: {
        type: Function,
        default: undefined
    },
    zoomEnd: {
        type: Function,
        default: undefined
    },
    zoomStart: Function
};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        contentColor: {
            type: String,
            default: undefined,
            kComposite: 'content.color'
        },
        contentFontFamily: {
            type: String,
            default: undefined,
            kComposite: 'content.fontFamily'
        },
        contentFontSize: {
            type: Number,
            default: undefined,
            kComposite: 'content.fontSize'
        },
        contentFontStyle: {
            type: String,
            default: undefined,
            kComposite: 'content.fontStyle'
        },
        contentFontWeight: {
            type: String,
            default: undefined,
            kComposite: 'content.fontWeight'
        },
        contentTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'content.template'
        },
        contentText: {
            type: String,
            default: undefined,
            kComposite: 'content.text'
        },
        contentVisual: {
            type: Function,
            default: undefined,
            kComposite: 'content.visual'
        },
        editable: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable'
        },
        editableTools: {
            type: Array,
            default: undefined,
            kComposite: 'editable.tools'
        },
        endCap: {
            type: String,
            default: undefined,
            kComposite: 'endCap'
        },
        endCapFill: {
            type: String,
            default: undefined,
            kComposite: 'endCap.fill'
        },
        endCapFillColor: {
            type: String,
            default: undefined,
            kComposite: 'endCap.fill.color'
        },
        endCapStroke: {
            type: String,
            default: undefined,
            kComposite: 'endCap.stroke'
        },
        endCapStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'endCap.stroke.color'
        },
        endCapStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'endCap.stroke.dashType'
        },
        endCapStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'endCap.stroke.width'
        },
        endCapType: {
            type: String,
            default: undefined,
            kComposite: 'endCap.type'
        },
        from: {
            type: [String, Number],
            default: undefined,
            kComposite: 'from'
        },
        fromX: {
            type: Number,
            default: undefined,
            kComposite: 'from.x'
        },
        fromY: {
            type: Number,
            default: undefined,
            kComposite: 'from.y'
        },
        fromConnector: {
            type: String,
            default: undefined,
            kComposite: 'fromConnector'
        },
        hoverStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'hover.stroke.color'
        },
        points: {
            type: Array,
            default: undefined,
            kComposite: 'points'
        },
        selectionHandlesFill: {
            type: String,
            default: undefined,
            kComposite: 'selection.handles.fill'
        },
        selectionHandlesFillColor: {
            type: String,
            default: undefined,
            kComposite: 'selection.handles.fill.color'
        },
        selectionHandlesStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'selection.handles.stroke.color'
        },
        selectionHandlesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'selection.handles.width'
        },
        selectionHandlesHeight: {
            type: Number,
            default: undefined,
            kComposite: 'selection.handles.height'
        },
        startCap: {
            type: String,
            default: undefined,
            kComposite: 'startCap'
        },
        startCapFill: {
            type: String,
            default: undefined,
            kComposite: 'startCap.fill'
        },
        startCapFillColor: {
            type: String,
            default: undefined,
            kComposite: 'startCap.fill.color'
        },
        startCapStroke: {
            type: String,
            default: undefined,
            kComposite: 'startCap.stroke'
        },
        startCapStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'startCap.stroke.color'
        },
        startCapStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'startCap.stroke.dashType'
        },
        startCapStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'startCap.stroke.width'
        },
        startCapType: {
            type: String,
            default: undefined,
            kComposite: 'startCap.type'
        },
        strokeColor: {
            type: String,
            default: undefined,
            kComposite: 'stroke.color'
        },
        strokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'stroke.width'
        },
        to: {
            type: [String, Number],
            default: undefined,
            kComposite: 'to'
        },
        toX: {
            type: Number,
            default: undefined,
            kComposite: 'to.x'
        },
        toY: {
            type: Number,
            default: undefined,
            kComposite: 'to.y'
        },
        toConnector: {
            type: String,
            default: undefined,
            kComposite: 'toConnector'
        },
        type: {
            type: String,
            default: undefined,
            kComposite: 'type'
        }
    }
};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        connectors: {
            type: Array,
            default: undefined,
            kComposite: 'connectors'
        },
        connectorDefaultsWidth: {
            type: Number,
            default: undefined,
            kComposite: 'connectorDefaults.width'
        },
        connectorDefaultsHeight: {
            type: Number,
            default: undefined,
            kComposite: 'connectorDefaults.height'
        },
        connectorDefaultsHoverFill: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.hover.fill'
        },
        connectorDefaultsHoverFillColor: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.hover.fill.color'
        },
        connectorDefaultsHoverFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'connectorDefaults.hover.fill.opacity'
        },
        connectorDefaultsHoverStroke: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.hover.stroke'
        },
        connectorDefaultsHoverStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.hover.stroke.color'
        },
        connectorDefaultsHoverStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.hover.stroke.dashType'
        },
        connectorDefaultsHoverStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'connectorDefaults.hover.stroke.width'
        },
        connectorDefaultsFill: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.fill'
        },
        connectorDefaultsFillColor: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.fill.color'
        },
        connectorDefaultsFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'connectorDefaults.fill.opacity'
        },
        connectorDefaultsStroke: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.stroke'
        },
        connectorDefaultsStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.stroke.color'
        },
        connectorDefaultsStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'connectorDefaults.stroke.dashType'
        },
        connectorDefaultsStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'connectorDefaults.stroke.width'
        },
        contentAlign: {
            type: String,
            default: undefined,
            kComposite: 'content.align'
        },
        contentColor: {
            type: String,
            default: undefined,
            kComposite: 'content.color'
        },
        contentFontFamily: {
            type: String,
            default: undefined,
            kComposite: 'content.fontFamily'
        },
        contentFontSize: {
            type: Number,
            default: undefined,
            kComposite: 'content.fontSize'
        },
        contentFontStyle: {
            type: String,
            default: undefined,
            kComposite: 'content.fontStyle'
        },
        contentFontWeight: {
            type: String,
            default: undefined,
            kComposite: 'content.fontWeight'
        },
        contentTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'content.template'
        },
        contentText: {
            type: String,
            default: undefined,
            kComposite: 'content.text'
        },
        editable: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable'
        },
        editableConnect: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.connect'
        },
        editableTools: {
            type: Array,
            default: undefined,
            kComposite: 'editable.tools'
        },
        fill: {
            type: String,
            default: undefined,
            kComposite: 'fill'
        },
        fillColor: {
            type: String,
            default: undefined,
            kComposite: 'fill.color'
        },
        fillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'fill.opacity'
        },
        fillGradientType: {
            type: String,
            default: undefined,
            kComposite: 'fill.gradient.type'
        },
        fillGradientCenter: {
            type: Array,
            default: undefined,
            kComposite: 'fill.gradient.center'
        },
        fillGradientRadius: {
            type: Number,
            default: undefined,
            kComposite: 'fill.gradient.radius'
        },
        fillGradientStart: {
            type: Array,
            default: undefined,
            kComposite: 'fill.gradient.start'
        },
        fillGradientEnd: {
            type: Array,
            default: undefined,
            kComposite: 'fill.gradient.end'
        },
        fillGradientStops: {
            type: Array,
            default: undefined,
            kComposite: 'fill.gradient.stops'
        },
        height: {
            type: Number,
            default: undefined,
            kComposite: 'height'
        },
        hoverFill: {
            type: String,
            default: undefined,
            kComposite: 'hover.fill'
        },
        hoverFillColor: {
            type: String,
            default: undefined,
            kComposite: 'hover.fill.color'
        },
        hoverFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'hover.fill.opacity'
        },
        id: {
            type: String,
            default: undefined,
            kComposite: 'id'
        },
        minHeight: {
            type: Number,
            default: undefined,
            kComposite: 'minHeight'
        },
        minWidth: {
            type: Number,
            default: undefined,
            kComposite: 'minWidth'
        },
        path: {
            type: String,
            default: undefined,
            kComposite: 'path'
        },
        rotationAngle: {
            type: Number,
            default: undefined,
            kComposite: 'rotation.angle'
        },
        source: {
            type: String,
            default: undefined,
            kComposite: 'source'
        },
        strokeColor: {
            type: String,
            default: undefined,
            kComposite: 'stroke.color'
        },
        strokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'stroke.dashType'
        },
        strokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'stroke.width'
        },
        type: {
            type: String,
            default: undefined,
            kComposite: 'type'
        },
        visual: {
            type: Function,
            default: undefined,
            kComposite: 'visual'
        },
        width: {
            type: Number,
            default: undefined,
            kComposite: 'width'
        },
        x: {
            type: Number,
            default: undefined,
            kComposite: 'x'
        },
        y: {
            type: Number,
            default: undefined,
            kComposite: 'y'
        }
    }
};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        connectionDefaultsContentColor: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.content.color'
        },
        connectionDefaultsContentFontFamily: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.content.fontFamily'
        },
        connectionDefaultsContentFontSize: {
            type: Number,
            default: undefined,
            kComposite: 'connectionDefaults.content.fontSize'
        },
        connectionDefaultsContentFontStyle: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.content.fontStyle'
        },
        connectionDefaultsContentFontWeight: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.content.fontWeight'
        },
        connectionDefaultsContentTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'connectionDefaults.content.template'
        },
        connectionDefaultsContentText: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.content.text'
        },
        connectionDefaultsContentVisual: {
            type: Function,
            default: undefined,
            kComposite: 'connectionDefaults.content.visual'
        },
        connectionDefaultsEditable: {
            type: Boolean,
            default: undefined,
            kComposite: 'connectionDefaults.editable'
        },
        connectionDefaultsEditableDrag: {
            type: Boolean,
            default: undefined,
            kComposite: 'connectionDefaults.editable.drag'
        },
        connectionDefaultsEditableRemove: {
            type: Boolean,
            default: undefined,
            kComposite: 'connectionDefaults.editable.remove'
        },
        connectionDefaultsEditableTools: {
            type: Array,
            default: undefined,
            kComposite: 'connectionDefaults.editable.tools'
        }, connectionDefaultsEndCap: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.endCap'
        },
        connectionDefaultsEndCapFill: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.endCap.fill'
        },
        connectionDefaultsEndCapFillColor: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.endCap.fill.color'
        },
        connectionDefaultsEndCapStroke: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.endCap.stroke'
        },
        connectionDefaultsEndCapStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.endCap.stroke.color'
        },
        connectionDefaultsEndCapStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.endCap.stroke.dashType'
        },
        connectionDefaultsEndCapStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'connectionDefaults.endCap.stroke.width'
        },
        connectionDefaultsEndCapType: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.endCap.type'
        },
        connectionDefaultsFromConnector: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.fromConnector'
        },
        connectionDefaultsHoverStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.hover.stroke.color'
        },
        connectionDefaultsSelectable: {
            type: Boolean,
            default: undefined,
            kComposite: 'connectionDefaults.selectable'
        },
        connectionDefaultsSelectionHandlesFill: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.selection.handles.fill'
        },
        connectionDefaultsSelectionHandlesFillColor: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.selection.handles.fill.color'
        },
        connectionDefaultsSelectionHandlesStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.selection.handles.stroke.color'
        },
        connectionDefaultsSelectionHandlesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'connectionDefaults.selection.handles.width'
        },
        connectionDefaultsSelectionHandlesHeight: {
            type: Number,
            default: undefined,
            kComposite: 'connectionDefaults.selection.handles.height'
        },
        connectionDefaultsStartCap: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.startCap'
        },
        connectionDefaultsStartCapFill: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.startCap.fill'
        },
        connectionDefaultsStartCapFillColor: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.startCap.fill.color'
        },
        connectionDefaultsStartCapStroke: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.startCap.stroke'
        },
        connectionDefaultsStartCapStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.startCap.stroke.color'
        },
        connectionDefaultsStartCapStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.startCap.stroke.dashType'
        },
        connectionDefaultsStartCapStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'connectionDefaults.startCap.stroke.width'
        },
        connectionDefaultsStartCapType: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.startCap.type'
        },
        connectionDefaultsStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.stroke.color'
        },
        connectionDefaultsStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'connectionDefaults.stroke.width'
        },
        connectionDefaultsToConnector: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.toConnector'
        },
        connectionDefaultsType: {
            type: String,
            default: undefined,
            kComposite: 'connectionDefaults.type'
        }
    }
};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        editableConnectionTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'editable.connectionTemplate'
        },
        editableDrag: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.drag'
        },
        editableDragSnap: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.drag.snap'
        },
        editableDragSnapSize: {
            type: Number,
            default: undefined,
            kComposite: 'editable.drag.snap.size'
        },
        editableRemove: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.remove'
        },
        editableResize: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.resize'
        },
        editableResizeHandlesFill: {
            type: String,
            default: undefined,
            kComposite: 'editable.resize.handles.fill'
        },
        editableResizeHandlesFillColor: {
            type: String,
            default: undefined,
            kComposite: 'editable.resize.handles.fill.color'
        },
        editableResizeHandlesFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'editable.resize.handles.fill.opacity'
        },
        editableResizeHandlesHeight: {
            type: Number,
            default: undefined,
            kComposite: 'editable.resize.handles.height'
        },
        editableResizeHandlesHoverFill: {
            type: String,
            default: undefined,
            kComposite: 'editable.resize.handles.hover.fill'
        },
        editableResizeHandlesHoverFillColor: {
            type: String,
            default: undefined,
            kComposite: 'editable.resize.handles.hover.fill.color'
        },
        editableResizeHandlesHoverFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'editable.resize.handles.hover.fill.opacity'
        },
        editableResizeHandlesHoverStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'editable.resize.handles.hover.stroke.color'
        },
        editableResizeHandlesHoverStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'editable.resize.handles.hover.stroke.dashType'
        },
        editableResizeHandlesHoverStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'editable.resize.handles.hover.stroke.width'
        },
        editableResizeHandlesStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'editable.resize.handles.stroke.color'
        },
        editableResizeHandlesStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'editable.resize.handles.stroke.dashType'
        },
        editableResizeHandlesStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'editable.resize.handles.stroke.width'
        },
        editableResizeHandlesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'editable.resize.handles.width'
        },
        editableRotate: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.rotate'
        },
        editableRotateFillColor: {
            type: String,
            default: undefined,
            kComposite: 'editable.rotate.fill.color'
        },
        editableRotateFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'editable.rotate.fill.opacity'
        },
        editableRotateStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'editable.rotate.stroke.color'
        },
        editableRotateStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'editable.rotate.stroke.width'
        },
        editableShapeTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'editable.shapeTemplate'
        },
        editableTools: {
            type: Array,
            default: undefined,
            kComposite: 'editable.tools'
        } }
};

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        layoutEndRadialAngle: {
            type: Number,
            default: undefined,
            kComposite: 'layout.endRadialAngle'
        },
        layoutGridComponentSpacingX: {
            type: Number,
            default: undefined,
            kComposite: 'layout.grid.componentSpacingX'
        },
        layoutGridComponentSpacingY: {
            type: Number,
            default: undefined,
            kComposite: 'layout.grid.componentSpacingY'
        },
        layoutGridOffsetX: {
            type: Number,
            default: undefined,
            kComposite: 'layout.grid.offsetX'
        },
        layoutGridOffsetY: {
            type: Number,
            default: undefined,
            kComposite: 'layout.grid.offsetY'
        },
        layoutGridWidth: {
            type: Number,
            default: undefined,
            kComposite: 'layout.grid.width'
        },
        layoutHorizontalSeparation: {
            type: Number,
            default: undefined,
            kComposite: 'layout.horizontalSeparation'
        },
        layoutIterations: {
            type: Number,
            default: undefined,
            kComposite: 'layout.iterations'
        },
        layoutLayerSeparation: {
            type: Number,
            default: undefined,
            kComposite: 'layout.layerSeparation'
        },
        layoutNodeDistance: {
            type: Number,
            default: undefined,
            kComposite: 'layout.nodeDistance'
        },
        layoutRadialFirstLevelSeparation: {
            type: Number,
            default: undefined,
            kComposite: 'layout.radialFirstLevelSeparation'
        },
        layoutRadialSeparation: {
            type: Number,
            default: undefined,
            kComposite: 'layout.radialSeparation'
        },
        layoutStartRadialAngle: {
            type: Number,
            default: undefined,
            kComposite: 'layout.startRadialAngle'
        },
        layoutSubtype: {
            type: String,
            default: undefined,
            kComposite: 'layout.subtype'
        },
        layoutTipOverTreeStartLevel: {
            type: Number,
            default: undefined,
            kComposite: 'layout.tipOverTreeStartLevel'
        },
        layoutType: {
            type: String,
            default: undefined,
            kComposite: 'layout.type'
        },
        layoutUnderneathHorizontalOffset: {
            type: Number,
            default: undefined,
            kComposite: 'layout.underneathHorizontalOffset'
        },
        layoutUnderneathVerticalSeparation: {
            type: Number,
            default: undefined,
            kComposite: 'layout.underneathVerticalSeparation'
        },
        layoutUnderneathVerticalTopOffset: {
            type: Number,
            default: undefined,
            kComposite: 'layout.underneathVerticalTopOffset'
        },
        layoutVerticalSeparation: {
            type: Number,
            default: undefined,
            kComposite: 'layout.verticalSeparation'
        }
    }
};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        pannableKey: {
            type: String,
            default: undefined,
            kComposite: 'pannable.key'
        }
    }
};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        pdfAuthor: {
            type: String,
            default: undefined,
            kComposite: 'pdf.author'
        },
        pdfCreator: {
            type: String,
            default: undefined,
            kComposite: 'pdf.creator'
        },
        pdfDate: {
            type: Date,
            default: undefined,
            kComposite: 'pdf.date'
        },
        pdfFileName: {
            type: String,
            default: undefined,
            kComposite: 'pdf.fileName'
        },
        pdfForceProxy: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.forceProxy'
        },
        pdfKeywords: {
            type: String,
            default: undefined,
            kComposite: 'pdf.keywords'
        },
        pdfLandscape: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.landscape'
        },
        pdfMarginBottom: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.bottom'
        },
        pdfMarginLeft: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.left'
        },
        pdfMarginRight: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.right'
        },
        pdfMarginTop: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.top'
        },
        pdfPaperSize: {
            type: [String, Array],
            default: undefined,
            kComposite: 'pdf.paperSize'
        },
        pdfProxyURL: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyURL'
        },
        pdfProxyTarget: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyTarget'
        },
        pdfSubject: {
            type: String,
            default: undefined,
            kComposite: 'pdf.subject'
        },
        pdfTitle: {
            type: String,
            default: undefined,
            kComposite: 'pdf.title'
        }
    }
};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        selectableKey: {
            type: String,
            default: undefined,
            kComposite: 'selectable.key'
        },
        selectableMultiple: {
            type: Boolean,
            default: undefined,
            kComposite: 'selectable.multiple'
        },
        selectableStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'selectable.stroke.color'
        },
        selectableStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'selectable.stroke.dashType'
        },
        selectableStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'selectable.stroke.width'
        }
    }
};

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        shapeDefaultsConnectors: {
            type: Array,
            default: undefined,
            kComposite: 'shapeDefaults.connectors'
        }, shapeDefaultsConnectorDefaultsWidth: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.width'
        },
        shapeDefaultsConnectorDefaultsHeight: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.height'
        },
        shapeDefaultsConnectorDefaultsHoverFill: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.hover.fill'
        },
        shapeDefaultsConnectorDefaultsHoverFillColor: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.hover.fill.color'
        },
        shapeDefaultsConnectorDefaultsHoverFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.hover.fill.opacity'
        },
        shapeDefaultsConnectorDefaultsHoverStroke: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.hover.stroke'
        },
        shapeDefaultsConnectorDefaultsHoverStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.hover.stroke.color'
        },
        shapeDefaultsConnectorDefaultsHoverStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.hover.stroke.dashType'
        },
        shapeDefaultsConnectorDefaultsHoverStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.hover.stroke.width'
        },
        shapeDefaultsConnectorDefaultsFill: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.fill'
        },
        shapeDefaultsConnectorDefaultsFillColor: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.fill.color'
        },
        shapeDefaultsConnectorDefaultsFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.fill.opacity'
        },
        shapeDefaultsConnectorDefaultsStroke: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.stroke'
        },
        shapeDefaultsConnectorDefaultsStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.stroke.color'
        },
        shapeDefaultsConnectorDefaultsStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.stroke.dashType'
        },
        shapeDefaultsConnectorDefaultsStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.stroke.width'
        },
        shapeDefaultsContent: {
            type: Object,
            default: undefined,
            kComposite: 'shapeDefaults.content'
        },
        shapeDefaultsContentAlign: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.content.align'
        },
        shapeDefaultsContentColor: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.content.color'
        },
        shapeDefaultsContentFontFamily: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.content.fontFamily'
        },
        shapeDefaultsContentFontSize: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.content.fontSize'
        },
        shapeDefaultsContentFontStyle: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.content.fontStyle'
        },
        shapeDefaultsContentFontWeight: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.content.fontWeight'
        },
        shapeDefaultsContentTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'shapeDefaults.content.template'
        },
        shapeDefaultsContentText: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.content.text'
        },
        shapeDefaultsEditable: {
            type: Boolean,
            default: undefined,
            kComposite: 'shapeDefaults.editable'
        },
        shapeDefaultsEditableConnect: {
            type: Boolean,
            default: undefined,
            kComposite: 'shapeDefaults.editable.connect'
        },
        shapeDefaultsEditableDrag: {
            type: Boolean,
            default: undefined,
            kComposite: 'shapeDefaults.editable.drag'
        },
        shapeDefaultsEditableRemove: {
            type: Boolean,
            default: undefined,
            kComposite: 'shapeDefaults.editable.remove'
        },
        shapeDefaultsEditableTools: {
            type: Array,
            default: undefined,
            kComposite: 'shapeDefaults.editable.tools'
        }, shapeDefaultsFill: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.fill'
        },
        shapeDefaultsFillColor: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.fill.color'
        },
        shapeDefaultsFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.fill.opacity'
        },
        shapeDefaultsFillGradientType: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.fill.gradient.type'
        },
        shapeDefaultsFillGradientCenter: {
            type: Array,
            default: undefined,
            kComposite: 'shapeDefaults.fill.gradient.center'
        },
        shapeDefaultsFillGradientRadius: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.fill.gradient.radius'
        },
        shapeDefaultsFillGradientStart: {
            type: Array,
            default: undefined,
            kComposite: 'shapeDefaults.fill.gradient.start'
        },
        shapeDefaultsFillGradientEnd: {
            type: Array,
            default: undefined,
            kComposite: 'shapeDefaults.fill.gradient.end'
        },
        shapeDefaultsFillGradientStops: {
            type: Array,
            default: undefined,
            kComposite: 'shapeDefaults.fill.gradient.stops'
        }, shapeDefaultsHeight: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.height'
        },
        shapeDefaultsHoverFill: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.hover.fill'
        },
        shapeDefaultsHoverFillColor: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.hover.fill.color'
        },
        shapeDefaultsHoverFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.hover.fill.opacity'
        },
        shapeDefaultsMinHeight: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.minHeight'
        },
        shapeDefaultsMinWidth: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.minWidth'
        },
        shapeDefaultsPath: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.path'
        },
        shapeDefaultsRotationAngle: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.rotation.angle'
        },
        shapeDefaultsSelectable: {
            type: Boolean,
            default: undefined,
            kComposite: 'shapeDefaults.selectable'
        },
        shapeDefaultsSource: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.source'
        },
        shapeDefaultsStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.stroke.color'
        },
        shapeDefaultsStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.stroke.dashType'
        },
        shapeDefaultsStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.stroke.width'
        },
        shapeDefaultsType: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.type'
        },
        shapeDefaultsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'shapeDefaults.visual'
        },
        shapeDefaultsWidth: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.width'
        },
        shapeDefaultsX: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.x'
        },
        shapeDefaultsY: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.y'
        }
    }
};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoDiagram = __webpack_require__(81);

var _KendoDiagram2 = _interopRequireDefault(_KendoDiagram);

var _KendoDiagramConnection = __webpack_require__(19);

var _KendoDiagramConnection2 = _interopRequireDefault(_KendoDiagramConnection);

var _KendoDiagramShape = __webpack_require__(20);

var _KendoDiagramShape2 = _interopRequireDefault(_KendoDiagramShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoDiagramInstaller = function () {
    function KendoDiagramInstaller() {
        _classCallCheck(this, KendoDiagramInstaller);
    }

    _createClass(KendoDiagramInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoDiagram2.default.name, _KendoDiagram2.default);
            Vue.component(_KendoDiagramConnection2.default.name, _KendoDiagramConnection2.default);
            Vue.component(_KendoDiagramShape2.default.name, _KendoDiagramShape2.default);
        }
    }]);

    return KendoDiagramInstaller;
}();

exports.default = KendoDiagramInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoDiagramInstaller);
}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogInstaller = exports.KendoDialogInstaller = exports.DialogAction = exports.KendoDialogAction = exports.Dialog = exports.KendoDialog = undefined;

var _KendoDialog = __webpack_require__(82);

var _KendoDialog2 = _interopRequireDefault(_KendoDialog);

var _KendoDialogAction = __webpack_require__(21);

var _KendoDialogAction2 = _interopRequireDefault(_KendoDialogAction);

var _kendoDialogInstaller = __webpack_require__(254);

var _kendoDialogInstaller2 = _interopRequireDefault(_kendoDialogInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoDialog = _KendoDialog2.default;
exports.Dialog = _KendoDialog2.default;
exports.KendoDialogAction = _KendoDialogAction2.default;
exports.DialogAction = _KendoDialogAction2.default;
exports.KendoDialogInstaller = _kendoDialogInstaller2.default;
exports.DialogInstaller = _kendoDialogInstaller2.default;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _DialogProps = __webpack_require__(249);

var _DialogProps2 = _interopRequireDefault(_DialogProps);

var _KendoDialogAction = __webpack_require__(21);

var _KendoDialogAction2 = _interopRequireDefault(_KendoDialogAction);

var _Animation = __webpack_require__(251);

var _Animation2 = _interopRequireDefault(_Animation);

var _Messages = __webpack_require__(252);

var _Messages2 = _interopRequireDefault(_Messages);

var _Modal = __webpack_require__(253);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _DialogProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _Animation2.default, _Messages2.default, _Modal2.default],
    mounted: function mounted() {
        this._resolveChildren();

        kendo.jQuery(this.$el).kendoDialog(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoDialog();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('actions', _KendoDialogAction2.default.name);
        },
        toggleClasses: function toggleClasses() {}
    }
};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    actions: {
        type: Array,
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    buttonLayout: {
        type: String,
        default: undefined
    },
    closable: {
        type: Boolean,
        default: undefined
    },
    content: {
        type: String,
        default: undefined
    },
    height: {
        type: [Number, String],
        default: undefined
    },
    maxHeight: {
        type: Number,
        default: undefined
    },
    maxWidth: {
        type: Number,
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    minHeight: {
        type: Number,
        default: undefined
    },
    minWidth: {
        type: Number,
        default: undefined
    },
    modal: {
        type: [Boolean, Object],
        default: undefined
    },
    title: {
        type: [String, Boolean],
        default: undefined
    },
    visible: {
        type: Boolean,
        default: undefined
    },
    width: {
        type: [Number, String],
        default: undefined
    },
    size: {
        type: String,
        default: undefined
    },

    // Events
    close: {
        type: Function,
        default: undefined
    },
    hide: {
        type: Function,
        default: undefined
    },
    initOpen: {
        type: Function,
        default: undefined
    },
    open: {
        type: Function,
        default: undefined
    },
    show: Function
};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        text: {
            type: String,
            default: undefined
        },
        action: {
            type: Function,
            default: undefined
        },
        primary: {
            type: Boolean,
            default: undefined
        }
    }
};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        animationCloseEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.close.effects'
        },
        animationCloseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.close.duration'
        },
        animationOpenEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.open.effects'
        },
        animationOpenDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.open.duration'
        }
    }
};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesClose: {
            type: String,
            default: undefined,
            kComposite: 'messages.close'
        },
        messagesPromptInput: {
            type: String,
            default: undefined,
            kComposite: 'messages.promptInput'
        }
    }
};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        modalPreventScroll: {
            type: Boolean,
            default: undefined,
            kComposite: 'modal.preventScroll'
        }
    }
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoDialog = __webpack_require__(82);

var _KendoDialog2 = _interopRequireDefault(_KendoDialog);

var _KendoDialogAction = __webpack_require__(21);

var _KendoDialogAction2 = _interopRequireDefault(_KendoDialogAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoDialogInstaller = function () {
    function KendoDialogInstaller() {
        _classCallCheck(this, KendoDialogInstaller);
    }

    _createClass(KendoDialogInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoDialog2.default.name, _KendoDialog2.default);
            Vue.component(_KendoDialogAction2.default.name, _KendoDialogAction2.default);
        }
    }]);

    return KendoDialogInstaller;
}();

exports.default = KendoDialogInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoDialogInstaller);
}

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiColumnComboBoxColumn = exports.KendoMultiColumnComboBoxColumn = exports.MultiColumnComboBox = exports.KendoMultiColumnComboBox = exports.DropdownsInstaller = exports.KendoDropdownsInstaller = exports.MultiSelect = exports.KendoMultiSelect = exports.ComboBox = exports.KendoComboBox = exports.DropDownList = exports.KendoDropDownList = exports.AutoComplete = exports.KendoAutoComplete = undefined;

var _KendoAutoComplete = __webpack_require__(83);

var _KendoAutoComplete2 = _interopRequireDefault(_KendoAutoComplete);

var _KendoDropDownList = __webpack_require__(84);

var _KendoDropDownList2 = _interopRequireDefault(_KendoDropDownList);

var _KendoComboBox = __webpack_require__(85);

var _KendoComboBox2 = _interopRequireDefault(_KendoComboBox);

var _KendoMultiColumnComboBox = __webpack_require__(86);

var _KendoMultiColumnComboBox2 = _interopRequireDefault(_KendoMultiColumnComboBox);

var _KendoMultiColumnComboBoxColumn = __webpack_require__(22);

var _KendoMultiColumnComboBoxColumn2 = _interopRequireDefault(_KendoMultiColumnComboBoxColumn);

var _KendoMultiSelect = __webpack_require__(87);

var _KendoMultiSelect2 = _interopRequireDefault(_KendoMultiSelect);

var _kendoDropdownsInstaller = __webpack_require__(267);

var _kendoDropdownsInstaller2 = _interopRequireDefault(_kendoDropdownsInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoAutoComplete = _KendoAutoComplete2.default;
exports.AutoComplete = _KendoAutoComplete2.default;
exports.KendoDropDownList = _KendoDropDownList2.default;
exports.DropDownList = _KendoDropDownList2.default;
exports.KendoComboBox = _KendoComboBox2.default;
exports.ComboBox = _KendoComboBox2.default;
exports.KendoMultiSelect = _KendoMultiSelect2.default;
exports.MultiSelect = _KendoMultiSelect2.default;
exports.KendoDropdownsInstaller = _kendoDropdownsInstaller2.default;
exports.DropdownsInstaller = _kendoDropdownsInstaller2.default;
exports.KendoMultiColumnComboBox = _KendoMultiColumnComboBox2.default;
exports.MultiColumnComboBox = _KendoMultiColumnComboBox2.default;
exports.KendoMultiColumnComboBoxColumn = _KendoMultiColumnComboBoxColumn2.default;
exports.MultiColumnComboBoxColumn = _KendoMultiColumnComboBoxColumn2.default;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _AutoCompleteProps = __webpack_require__(257);

var _AutoCompleteProps2 = _interopRequireDefault(_AutoCompleteProps);

var _Animation = __webpack_require__(7);

var _Animation2 = _interopRequireDefault(_Animation);

var _Virtual = __webpack_require__(8);

var _Virtual2 = _interopRequireDefault(_Virtual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: _AutoCompleteProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _Animation2.default, _Virtual2.default],
    model: {
        event: 'changemodel'
    },
    mounted: function mounted() {
        var that = this;
        var widgetElement = that.$el;
        kendo.jQuery(widgetElement).kendoAutoComplete(that.widgetOptions);
        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', widgetElement.value);
            } else {
                that.$emit('changemodel', widgetElement.value);
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            var widgetElement = this.$el;

            return kendo.jQuery(widgetElement).getKendoAutoComplete();
        }
    }
};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: [String, Number],
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    autoWidth: {
        type: Boolean,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    clearButton: {
        type: Boolean,
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    delay: {
        type: Number,
        default: undefined
    },
    enable: {
        type: Boolean,
        default: undefined
    },
    enforceMinLength: {
        type: Boolean,
        default: undefined
    },
    filter: {
        type: String,
        default: undefined
    },
    fixedGroupTemplate: {
        type: [String, Function],
        default: undefined
    },
    footerTemplate: {
        type: [String, Function],
        default: undefined
    },
    groupTemplate: {
        type: [String, Function],
        default: undefined
    },
    height: {
        type: Number,
        default: undefined
    },
    highlightFirst: {
        type: Boolean,
        default: undefined
    },
    ignoreCase: {
        type: Boolean,
        default: undefined
    },
    minLength: {
        type: Number,
        default: undefined
    },
    noDataTemplate: {
        type: [String, Function],
        default: undefined
    },
    placeholder: {
        type: String,
        default: undefined
    },
    popup: {
        type: Object,
        default: undefined
    },
    separator: {
        type: [String, Array],
        default: undefined
    },
    suggest: {
        type: Boolean,
        default: undefined
    },
    headerTemplate: {
        type: [String, Function],
        default: undefined
    },
    template: {
        type: [String, Function],
        default: undefined
    },
    value: {
        type: [String, Number],
        default: undefined
    },
    valuePrimitive: {
        type: Boolean,
        default: undefined
    },
    virtual: {
        type: [Boolean, Object],
        default: undefined
    },

    // Events
    change: Function,
    close: Function,
    dataBound: {
        type: Function,
        default: undefined
    },
    filtering: Function,
    open: Function,
    select: Function
};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _DropDownListProps = __webpack_require__(259);

var _DropDownListProps2 = _interopRequireDefault(_DropDownListProps);

var _Animation = __webpack_require__(7);

var _Animation2 = _interopRequireDefault(_Animation);

var _Popup = __webpack_require__(9);

var _Popup2 = _interopRequireDefault(_Popup);

var _Virtual = __webpack_require__(8);

var _Virtual2 = _interopRequireDefault(_Virtual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: _DropDownListProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _Animation2.default, _Popup2.default, _Virtual2.default],
    model: {
        event: 'changemodel'
    },
    mounted: function mounted() {
        var that = this;
        var widgetElement = that.$el;

        kendo.jQuery(widgetElement).kendoDropDownList(that.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', widgetElement.value);
            } else {
                that.$emit('changemodel', widgetElement.value);
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            var widgetElement = this.$el;

            return kendo.jQuery(widgetElement).getKendoDropDownList();
        }
    }
};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: [String, Number],
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    autoWidth: {
        type: Boolean,
        default: undefined
    },
    cascadeFrom: {
        type: String,
        default: undefined
    },
    cascadeFromField: {
        type: String,
        default: undefined
    },
    cascadeFromParentField: {
        type: String,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    dataValueField: {
        type: String,
        default: undefined
    },
    delay: {
        type: Number,
        default: undefined
    },
    enable: {
        type: Boolean,
        default: undefined
    },
    enforceMinLength: {
        type: Boolean,
        default: undefined
    },
    filter: {
        type: String,
        default: undefined
    },
    fixedGroupTemplate: {
        type: [String, Function],
        default: undefined
    },
    footerTemplate: {
        type: [String, Function],
        default: undefined
    },
    groupTemplate: {
        type: [String, Function],
        default: undefined
    },
    height: {
        type: Number,
        default: undefined
    },
    ignoreCase: {
        type: Boolean,
        default: undefined
    },
    index: {
        type: Number,
        default: undefined
    },
    minLength: {
        type: Number,
        default: undefined
    },
    noDataTemplate: {
        type: [String, Function],
        default: undefined
    },
    popup: {
        type: Object,
        default: undefined
    },
    optionLabel: {
        type: [String, Object],
        default: undefined
    },
    optionLabelTemplate: {
        type: [String, Function],
        default: undefined
    },
    headerTemplate: {
        type: [String, Function],
        default: undefined
    },
    template: {
        type: [String, Function],
        default: undefined
    },
    valueTemplate: {
        type: [String, Function],
        default: undefined
    },
    text: {
        type: String,
        default: undefined
    },
    value: {
        type: [String, Number],
        default: undefined
    },
    valuePrimitive: {
        type: Boolean,
        default: undefined
    },
    virtual: {
        type: [Boolean, Object],
        default: undefined
    },

    // Events
    change: Function,
    close: Function,
    dataBound: {
        type: Function,
        default: undefined
    },
    filtering: Function,
    open: Function,
    select: Function,
    cascade: Function
};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _ComboBoxProps = __webpack_require__(261);

var _ComboBoxProps2 = _interopRequireDefault(_ComboBoxProps);

var _Animation = __webpack_require__(7);

var _Animation2 = _interopRequireDefault(_Animation);

var _Popup = __webpack_require__(9);

var _Popup2 = _interopRequireDefault(_Popup);

var _Virtual = __webpack_require__(8);

var _Virtual2 = _interopRequireDefault(_Virtual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: _ComboBoxProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _Animation2.default, _Popup2.default, _Virtual2.default],
    model: {
        event: 'changemodel'
    },
    mounted: function mounted() {
        var that = this;
        var widgetElement = that.$el;

        kendo.jQuery(widgetElement).kendoComboBox(that.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', widgetElement.value);
            } else {
                that.$emit('changemodel', widgetElement.value);
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            var widgetElement = this.$el;

            return kendo.jQuery(widgetElement).getKendoComboBox();
        }
    }
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: [String, Number],
        default: undefined
    },
    animation: {
        type: Object,
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    autoWidth: {
        type: Boolean,
        default: undefined
    },
    cascadeFrom: {
        type: String,
        default: undefined
    },
    cascadeFromField: {
        type: String,
        default: undefined
    },
    cascadeFromParentField: {
        type: String,
        default: undefined
    },
    clearButton: {
        type: Boolean,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    dataValueField: {
        type: String,
        default: undefined
    },
    delay: {
        type: Number,
        default: undefined
    },
    enable: {
        type: Boolean,
        default: undefined
    },
    enforceMinLength: {
        type: Boolean,
        default: undefined
    },
    filter: {
        type: String,
        default: undefined
    },
    fixedGroupTemplate: {
        type: [String, Function],
        default: undefined
    },
    footerTemplate: {
        type: [String, Function],
        default: undefined
    },
    groupTemplate: {
        type: [String, Function],
        default: undefined
    },
    height: {
        type: Number,
        default: undefined
    },
    highlightFirst: {
        type: Boolean,
        default: undefined
    },
    ignoreCase: {
        type: Boolean,
        default: undefined
    },
    index: {
        type: Number,
        default: undefined
    },
    minLength: {
        type: Number,
        default: undefined
    },
    noDataTemplate: {
        type: [String, Function],
        default: undefined
    },
    placeholder: {
        type: String,
        default: undefined
    },
    popup: {
        type: Object,
        default: undefined
    },
    suggest: {
        type: Boolean,
        default: undefined
    },
    syncValueAndText: {
        type: Boolean,
        default: undefined
    },
    headerTemplate: {
        type: [String, Function],
        default: undefined
    },
    template: {
        type: [String, Function],
        default: undefined
    },
    text: {
        type: String,
        default: undefined
    },
    value: {
        type: [String, Number],
        default: undefined
    },
    valuePrimitive: {
        type: Boolean,
        default: undefined
    },
    virtual: {
        type: [Boolean, Object],
        default: undefined
    },

    // Events
    change: {
        type: Function,
        default: undefined
    },
    close: {
        type: Function,
        default: undefined
    },
    dataBound: {
        type: Function,
        default: undefined
    },
    filtering: {
        type: Function,
        default: undefined
    },
    open: {
        type: Function,
        default: undefined
    },
    select: {
        type: Function,
        default: undefined
    },
    cascade: Function
};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _MultiColumnComboBoxProps = __webpack_require__(263);

var _MultiColumnComboBoxProps2 = _interopRequireDefault(_MultiColumnComboBoxProps);

var _KendoMultiColumnComboBoxColumn = __webpack_require__(22);

var _KendoMultiColumnComboBoxColumn2 = _interopRequireDefault(_KendoMultiColumnComboBoxColumn);

var _Animation = __webpack_require__(7);

var _Animation2 = _interopRequireDefault(_Animation);

var _Popup = __webpack_require__(9);

var _Popup2 = _interopRequireDefault(_Popup);

var _Virtual = __webpack_require__(8);

var _Virtual2 = _interopRequireDefault(_Virtual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: _MultiColumnComboBoxProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _Animation2.default, _Popup2.default, _Virtual2.default],
    model: {
        event: 'changemodel'
    },
    mounted: function mounted() {
        var that = this;
        var widgetElement = that.$el;
        that._resolveChildren();
        kendo.jQuery(this.$el).kendoMultiColumnComboBox(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', widgetElement.value);
            } else {
                that.$emit('changemodel', widgetElement.value);
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            var widgetElement = this.$el;
            return kendo.jQuery(widgetElement).getKendoMultiColumnComboBox();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('columns', _KendoMultiColumnComboBoxColumn2.default.name);
        }
    }
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: String,
        default: undefined
    },
    animation: {
        type: Object,
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    cascadeFrom: {
        type: String,
        default: undefined
    },
    cascadeFromField: {
        type: String,
        default: undefined
    },
    cascadeFromParentField: {
        type: String,
        default: undefined
    },
    columns: {
        type: Array,
        default: undefined
    },
    clearButton: {
        type: Boolean,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    dataValueField: {
        type: String,
        default: undefined
    },
    dropDownWidth: {
        type: [String, Number],
        default: undefined
    },
    delay: {
        type: Number,
        default: undefined
    },
    enable: {
        type: Boolean,
        default: undefined
    },
    enforceMinLength: {
        type: Boolean,
        default: undefined
    },
    filter: {
        type: String,
        default: undefined
    },
    filterFields: {
        type: Array,
        default: undefined
    },
    fixedGroupTemplate: {
        type: [String, Function],
        default: undefined
    },
    footerTemplate: {
        type: [String, Function],
        default: undefined
    },
    groupTemplate: {
        type: [String, Function],
        default: undefined
    },
    height: {
        type: Number,
        default: undefined
    },
    highlightFirst: {
        type: Boolean,
        default: undefined
    },
    ignoreCase: {
        type: Boolean,
        default: undefined
    },
    index: {
        type: Number,
        default: undefined
    },
    minLength: {
        type: Number,
        default: undefined
    },
    noDataTemplate: {
        type: [String, Function],
        default: undefined
    },
    placeholder: {
        type: String,
        default: undefined
    },
    popup: {
        type: Object,
        default: undefined
    },
    suggest: {
        type: Boolean,
        default: undefined
    },
    syncValueAndText: {
        type: Boolean,
        default: undefined
    },
    headerTemplate: {
        type: [String, Function],
        default: undefined
    },
    text: {
        type: String,
        default: undefined
    },
    value: {
        type: String,
        default: undefined
    },
    valuePrimitive: {
        type: Boolean,
        default: undefined
    },
    virtual: {
        type: [Boolean, Object],
        default: undefined
    },

    // Events
    change: Function,
    close: Function,
    dataBound: {
        type: Function,
        default: undefined
    },
    filtering: Function,
    open: Function,
    select: Function,
    cascade: Function
};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        field: {
            type: String,
            default: undefined
        },
        title: {
            type: String,
            default: undefined
        },
        template: {
            type: [String, Function],
            default: undefined
        },
        headerTemplate: {
            type: [String, Function],
            default: undefined
        },
        width: {
            type: [String, Number],
            default: undefined
        }
    }
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _MultiSelectProps = __webpack_require__(266);

var _MultiSelectProps2 = _interopRequireDefault(_MultiSelectProps);

var _Animation = __webpack_require__(7);

var _Animation2 = _interopRequireDefault(_Animation);

var _Popup = __webpack_require__(9);

var _Popup2 = _interopRequireDefault(_Popup);

var _Virtual = __webpack_require__(8);

var _Virtual2 = _interopRequireDefault(_Virtual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _MultiSelectProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _Animation2.default, _Popup2.default, _Virtual2.default],
    mounted: function mounted() {
        var that = this;
        var widgetElement = that.$el;

        kendo.jQuery(widgetElement).kendoMultiSelect(that.widgetOptions);

        if (this.v3) {
            this.ready();
        }

        that.$emit('kendowidgetready', that.kendoWidget());

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', that.kendoWidget().value());
            } else {
                that.$emit('changemodel', that.kendoWidget().value());
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            var widgetElement = this.$el;

            return kendo.jQuery(widgetElement).getKendoMultiSelect();
        }
    },
    model: {
        event: 'changemodel'
    }
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: [Array, Number],
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    autoClose: {
        type: Boolean,
        default: undefined
    },
    autoWidth: {
        type: Boolean,
        default: undefined
    },
    clearButton: {
        type: Boolean,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    dataValueField: {
        type: String,
        default: undefined
    },
    delay: {
        type: Number,
        default: undefined
    },
    enable: {
        type: Boolean,
        default: undefined
    },
    enforceMinLength: {
        type: Boolean,
        default: undefined
    },
    filter: {
        type: String,
        default: undefined
    },
    fixedGroupTemplate: {
        type: [String, Function],
        default: undefined
    },
    footerTemplate: {
        type: [String, Function],
        default: undefined
    },
    groupTemplate: {
        type: [String, Function],
        default: undefined
    },
    height: {
        type: Number,
        default: undefined
    },
    highlightFirst: {
        type: Boolean,
        default: undefined
    },
    ignoreCase: {
        type: Boolean,
        default: undefined
    },
    minLength: {
        type: Number,
        default: undefined
    },
    maxSelectedItems: {
        type: Number,
        default: undefined
    },
    noDataTemplate: {
        type: [String, Function],
        default: undefined
    },
    placeholder: {
        type: String,
        default: undefined
    },
    popup: {
        type: Object,
        default: undefined
    },
    headerTemplate: {
        type: [String, Function],
        default: undefined
    },
    itemTemplate: {
        type: [String, Function],
        default: undefined
    },
    tagTemplate: {
        type: [String, Function],
        default: undefined
    },
    tagMode: {
        type: String,
        default: undefined
    },
    value: {
        type: [Array, Number],
        default: undefined
    },
    valuePrimitive: {
        type: Boolean,
        default: undefined
    },
    virtual: {
        type: [Boolean, Object],
        default: undefined
    },

    // Events
    change: Function,
    close: Function,
    dataBound: {
        type: Function,
        default: undefined
    },
    filtering: Function,
    open: Function,
    select: Function,
    deselect: Function
};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoAutoComplete = __webpack_require__(83);

var _KendoAutoComplete2 = _interopRequireDefault(_KendoAutoComplete);

var _KendoDropDownList = __webpack_require__(84);

var _KendoDropDownList2 = _interopRequireDefault(_KendoDropDownList);

var _KendoComboBox = __webpack_require__(85);

var _KendoComboBox2 = _interopRequireDefault(_KendoComboBox);

var _KendoMultiSelect = __webpack_require__(87);

var _KendoMultiSelect2 = _interopRequireDefault(_KendoMultiSelect);

var _KendoMultiColumnComboBox = __webpack_require__(86);

var _KendoMultiColumnComboBox2 = _interopRequireDefault(_KendoMultiColumnComboBox);

var _KendoMultiColumnComboBoxColumn = __webpack_require__(22);

var _KendoMultiColumnComboBoxColumn2 = _interopRequireDefault(_KendoMultiColumnComboBoxColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoDropdownsInstaller = function () {
    function KendoDropdownsInstaller() {
        _classCallCheck(this, KendoDropdownsInstaller);
    }

    _createClass(KendoDropdownsInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoAutoComplete2.default.name, _KendoAutoComplete2.default);
            Vue.component(_KendoDropDownList2.default.name, _KendoDropDownList2.default);
            Vue.component(_KendoComboBox2.default.name, _KendoComboBox2.default);
            Vue.component(_KendoMultiSelect2.default.name, _KendoMultiSelect2.default);
            Vue.component(_KendoMultiColumnComboBox2.default.name, _KendoMultiColumnComboBox2.default);
            Vue.component(_KendoMultiColumnComboBoxColumn2.default.name, _KendoMultiColumnComboBoxColumn2.default);
        }
    }]);

    return KendoDropdownsInstaller;
}();

exports.default = KendoDropdownsInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoDropdownsInstaller);
}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DropDownTreeInstaller = exports.KendoDropDownTreeInstaller = exports.DropDownTree = exports.KendoDropDownTree = undefined;

var _KendoDropDownTree = __webpack_require__(88);

var _KendoDropDownTree2 = _interopRequireDefault(_KendoDropDownTree);

var _kendoDropdowntreeInstaller = __webpack_require__(275);

var _kendoDropdowntreeInstaller2 = _interopRequireDefault(_kendoDropdowntreeInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoDropDownTree = _KendoDropDownTree2.default;
exports.DropDownTree = _KendoDropDownTree2.default;
exports.KendoDropDownTreeInstaller = _kendoDropdowntreeInstaller2.default;
exports.DropDownTreeInstaller = _kendoDropdowntreeInstaller2.default;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _DropDownTreeProps = __webpack_require__(270);

var _DropDownTreeProps2 = _interopRequireDefault(_DropDownTreeProps);

var _Animation = __webpack_require__(271);

var _Animation2 = _interopRequireDefault(_Animation);

var _Checkboxes = __webpack_require__(272);

var _Checkboxes2 = _interopRequireDefault(_Checkboxes);

var _Messages = __webpack_require__(273);

var _Messages2 = _interopRequireDefault(_Messages);

var _Popup = __webpack_require__(274);

var _Popup2 = _interopRequireDefault(_Popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: _DropDownTreeProps2.default,
    model: {
        event: 'changemodel'
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _Animation2.default, _Checkboxes2.default, _Messages2.default, _Popup2.default],
    mounted: function mounted() {
        var that = this;

        kendo.jQuery(this.$el).kendoDropDownTree(that.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', that.kendoWidget().value());
            } else {
                that.$emit('changemodel', that.kendoWidget().value());
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoDropDownTree();
        }
    }
};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: [String, Array],
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    autoClose: {
        type: Boolean,
        default: undefined
    },
    autoWidth: {
        type: Boolean,
        default: undefined
    },
    checkAll: {
        type: Boolean,
        default: undefined
    },
    checkAllTemplate: {
        type: [String, Function],
        default: undefined
    },
    checkboxes: {
        type: [Boolean, Object],
        default: undefined
    },
    clearButton: {
        type: Boolean,
        default: undefined
    },
    dataImageUrlField: {
        type: String,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataSpriteCssClassField: {
        type: String,
        default: undefined
    },
    dataTextField: {
        type: [String, Array],
        default: undefined
    },
    dataUrlField: {
        type: String,
        default: undefined
    },
    dataValueField: {
        type: [String, Array],
        default: undefined
    },
    delay: {
        type: Number,
        default: undefined
    },
    enable: {
        type: Boolean,
        default: undefined
    },
    enforceMinLength: {
        type: Boolean,
        default: undefined
    },
    filter: {
        type: String,
        default: undefined
    },
    footerTemplate: {
        type: [String, Function],
        default: undefined
    },
    height: {
        type: [String, Number],
        default: undefined
    },
    ignoreCase: {
        type: Boolean,
        default: undefined
    },
    loadOnDemand: {
        type: Boolean,
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    minLength: {
        type: Number,
        default: undefined
    },
    noDataTemplate: {
        type: [String, Function],
        default: undefined
    },
    placeholder: {
        type: String,
        default: undefined
    },
    popup: {
        type: Object,
        default: undefined
    },
    headerTemplate: {
        type: [String, Function],
        default: undefined
    },
    valueTemplate: {
        type: [String, Function],
        default: undefined
    },
    tagMode: {
        type: String,
        default: undefined
    },
    template: {
        type: [String, Function],
        default: undefined
    },
    text: {
        type: String,
        default: undefined
    },
    value: {
        type: [String, Array],
        default: undefined
    },
    valuePrimitive: {
        type: Boolean,
        default: undefined
    },

    // Events
    change: Function,
    close: Function,
    dataBound: {
        type: Function,
        default: undefined
    },
    filtering: Function,
    open: Function,
    select: Function
};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        animationCloseEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.close.effects'
        },
        animationCloseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.close.duration'
        },
        animationOpenEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.open.effects'
        },
        animationOpenDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.open.duration'
        }
    }
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        checkboxesCheckChildren: {
            type: Boolean,
            default: undefined,
            kComposite: 'checkboxes.checkChildren'
        },
        checkboxesName: {
            type: String,
            default: undefined,
            kComposite: 'checkboxes.name'
        },
        checkboxesTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'checkboxes.template'
        }
    }
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesClear: {
            type: String,
            default: undefined,
            kComposite: 'messages.clear'
        },
        messagesDeleteTag: {
            type: String,
            default: undefined,
            kComposite: 'messages.deleteTag'
        },
        messagesSingleTag: {
            type: String,
            default: undefined,
            kComposite: 'messages.singleTag'
        }
    }
};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        popupAppendTo: {
            type: String,
            default: undefined,
            kComposite: 'popup.appendTo'
        },
        popupOrigin: {
            type: String,
            default: undefined,
            kComposite: 'popup.origin'
        },
        popupPosition: {
            type: String,
            default: undefined,
            kComposite: 'popup.position'
        }
    }
};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoDropDownTree = __webpack_require__(88);

var _KendoDropDownTree2 = _interopRequireDefault(_KendoDropDownTree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoDropDownTreeInstaller = function () {
    function KendoDropDownTreeInstaller() {
        _classCallCheck(this, KendoDropDownTreeInstaller);
    }

    _createClass(KendoDropDownTreeInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoDropDownTree2.default.name, _KendoDropDownTree2.default);
        }
    }]);

    return KendoDropDownTreeInstaller;
}();

exports.default = KendoDropDownTreeInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoDropDownTreeInstaller);
}

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EditorInstaller = exports.KendoEditorInstaller = exports.EditorTool = exports.KendoEditorTool = exports.Editor = exports.KendoEditor = undefined;

var _KendoEditor = __webpack_require__(89);

var _KendoEditor2 = _interopRequireDefault(_KendoEditor);

var _KendoEditorTool = __webpack_require__(23);

var _KendoEditorTool2 = _interopRequireDefault(_KendoEditorTool);

var _kendoEditorInstaller = __webpack_require__(289);

var _kendoEditorInstaller2 = _interopRequireDefault(_kendoEditorInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoEditor = _KendoEditor2.default;
exports.Editor = _KendoEditor2.default;
exports.KendoEditorTool = _KendoEditorTool2.default;
exports.EditorTool = _KendoEditorTool2.default;
exports.KendoEditorInstaller = _kendoEditorInstaller2.default;
exports.EditorInstaller = _kendoEditorInstaller2.default;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _EditorProps = __webpack_require__(278);

var _EditorProps2 = _interopRequireDefault(_EditorProps);

var _KendoEditorTool = __webpack_require__(23);

var _KendoEditorTool2 = _interopRequireDefault(_KendoEditorTool);

var _Deserialization = __webpack_require__(280);

var _Deserialization2 = _interopRequireDefault(_Deserialization);

var _FileBrowser = __webpack_require__(281);

var _FileBrowser2 = _interopRequireDefault(_FileBrowser);

var _ImageBrowser = __webpack_require__(282);

var _ImageBrowser2 = _interopRequireDefault(_ImageBrowser);

var _Immutables = __webpack_require__(283);

var _Immutables2 = _interopRequireDefault(_Immutables);

var _Messages = __webpack_require__(284);

var _Messages2 = _interopRequireDefault(_Messages);

var _PasteCleanup = __webpack_require__(285);

var _PasteCleanup2 = _interopRequireDefault(_PasteCleanup);

var _Pdf = __webpack_require__(286);

var _Pdf2 = _interopRequireDefault(_Pdf);

var _Resizable = __webpack_require__(287);

var _Resizable2 = _interopRequireDefault(_Resizable);

var _Serialization = __webpack_require__(288);

var _Serialization2 = _interopRequireDefault(_Serialization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: _EditorProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _Deserialization2.default, _FileBrowser2.default, _ImageBrowser2.default, _Immutables2.default, _Messages2.default, _PasteCleanup2.default, _Pdf2.default, _Resizable2.default, _Serialization2.default],
    mounted: function mounted() {
        var that = this;

        that._resolveChildren();

        kendo.jQuery(that.$el).kendoEditor(that.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', that.kendoWidget().value());
            } else {
                that.$emit('changemodel', that.kendoWidget().value());
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoEditor();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('tools', _KendoEditorTool2.default.name);
        }
    },
    model: {
        event: 'changemodel'
    }
};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: String,
        default: undefined
    },
    deserialization: {
        type: Object,
        default: undefined
    },
    domain: {
        type: String,
        default: undefined
    },
    encoded: {
        type: Boolean,
        default: undefined
    },
    immutables: {
        type: [Boolean, Object],
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    pasteCleanup: {
        type: Object,
        default: undefined
    },
    pdf: {
        type: Object,
        default: undefined
    },
    resizable: {
        type: [Boolean, Object],
        default: undefined
    },
    serialization: {
        type: Object,
        default: undefined
    },
    stylesheets: {
        type: Array,
        default: undefined
    },
    tools: {
        type: Array,
        default: undefined
    },
    imageBrowser: {
        type: Object,
        default: undefined
    },
    fileBrowser: {
        type: Object,
        default: undefined
    },
    tag: {
        type: String,
        default: undefined
    },
    value: {
        type: String,
        default: undefined
    },
    placeholder: {
        type: String,
        default: undefined
    },

    // Events
    change: Function,
    execute: Function,
    keydown: Function,
    keyup: Function,
    paste: Function,
    pdfExport: Function,
    select: Function
};

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        name: {
            type: String,
            default: undefined,
            kComposite: 'name'
        },
        tooltip: {
            type: String,
            default: undefined,
            kComposite: 'tooltip'
        },
        exec: {
            type: Function,
            default: undefined,
            kComposite: 'exec'
        },
        items: {
            type: Array,
            default: undefined,
            kComposite: 'items'
        },
        palette: {
            type: [String, Array],
            default: undefined,
            kComposite: 'palette'
        },
        columns: {
            type: Number,
            default: undefined,
            kComposite: 'columns'
        },
        template: {
            type: [String, Function],
            default: undefined,
            kComposite: 'template'
        }
    }
};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        deserializationCustom: {
            type: Function,
            default: undefined,
            kComposite: 'deserialization.custom'
        }
    }
};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        fileBrowserFileTypes: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.fileTypes'
        },
        fileBrowserPath: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.path'
        },
        fileBrowserTransportRead: {
            type: [String, Function],
            default: undefined,
            kComposite: 'fileBrowser.transport.read'
        },
        fileBrowserTransportReadContentType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.read.contentType'
        },
        fileBrowserTransportReadData: {
            type: [Object, String, Function],
            default: undefined,
            kComposite: 'fileBrowser.transport.read.data'
        },
        fileBrowserTransportReadDataType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.read.dataType'
        },
        fileBrowserTransportReadType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.read.type'
        },
        fileBrowserTransportReadUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'fileBrowser.transport.read.url'
        },
        fileBrowserTransportUploadUrl: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.uploadUrl'
        },
        fileBrowserTransportFileUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'fileBrowser.transport.fileUrl'
        },
        fileBrowserTransportDestroy: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.destroy'
        },
        fileBrowserTransportDestroyContentType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.destroy.contentType'
        },
        fileBrowserTransportDestroyData: {
            type: [Object, String, Function],
            default: undefined,
            kComposite: 'fileBrowser.transport.destroy.data'
        },
        fileBrowserTransportDestroyDataType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.destroy.dataType'
        },
        fileBrowserTransportDestroyType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.destroy.type'
        },
        fileBrowserTransportDestroyUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'fileBrowser.transport.destroy.url'
        },
        fileBrowserTransportCreate: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.create'
        },
        fileBrowserTransportCreateContentType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.create.contentType'
        },
        fileBrowserTransportCreateData: {
            type: [Object, String, Function],
            default: undefined,
            kComposite: 'fileBrowser.transport.create.data'
        },
        fileBrowserTransportCreateDataType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.create.dataType'
        },
        fileBrowserTransportCreateType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.create.type'
        },
        fileBrowserTransportCreateUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'fileBrowser.transport.create.url'
        },
        fileBrowserSchemaModelId: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.id'
        },
        fileBrowserSchemaModelFieldsName: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.fields.name'
        },
        fileBrowserSchemaModelFieldsNameField: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.fields.name.field'
        },
        fileBrowserSchemaModelFieldsNameParse: {
            type: Function,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.fields.name.parse'
        },
        fileBrowserSchemaModelFieldsType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.fields.type'
        },
        fileBrowserSchemaModelFieldsTypeParse: {
            type: Function,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.fields.type.parse'
        },
        fileBrowserSchemaModelFieldsTypeField: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.fields.type.field'
        },
        fileBrowserSchemaModelFieldsSize: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.fields.size'
        },
        fileBrowserSchemaModelFieldsSizeField: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.fields.size.field'
        },
        fileBrowserSchemaModelFieldsSizeParse: {
            type: Function,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.fields.size.parse'
        },
        fileBrowserMessagesUploadFile: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.uploadFile'
        },
        fileBrowserMessagesOrderBy: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.orderBy'
        },
        fileBrowserMessagesOrderByName: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.orderByName'
        },
        fileBrowserMessagesOrderBySize: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.orderBySize'
        },
        fileBrowserMessagesDirectoryNotFound: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.directoryNotFound'
        },
        fileBrowserMessagesEmptyFolder: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.emptyFolder'
        },
        fileBrowserMessagesDeleteFile: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.deleteFile'
        },
        fileBrowserMessagesInvalidFileType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.invalidFileType'
        },
        fileBrowserMessagesOverwriteFile: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.overwriteFile'
        },
        fileBrowserMessagesSearch: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.search'
        }
    }
};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        imageBrowserFileTypes: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.fileTypes'
        },
        imageBrowserPath: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.path'
        },
        imageBrowserTransportRead: {
            type: [String, Function],
            default: undefined,
            kComposite: 'imageBrowser.transport.read'
        },
        imageBrowserTransportReadContentType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.read.contentType'
        },
        imageBrowserTransportReadData: {
            type: [Object, String, Function],
            default: undefined,
            kComposite: 'imageBrowser.transport.read.data'
        },
        imageBrowserTransportReadDataType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.read.dataType'
        },
        imageBrowserTransportReadType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.read.type'
        },
        imageBrowserTransportReadUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'imageBrowser.transport.read.url'
        },
        imageBrowserTransportThumbnailUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'imageBrowser.transport.thumbnailUrl'
        },
        imageBrowserTransportUploadUrl: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.uploadUrl'
        },
        imageBrowserTransportImageUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'imageBrowser.transport.imageUrl'
        },
        imageBrowserTransportDestroy: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.destroy'
        },
        imageBrowserTransportDestroyContentType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.destroy.contentType'
        },
        imageBrowserTransportDestroyData: {
            type: [Object, String, Function],
            default: undefined,
            kComposite: 'imageBrowser.transport.destroy.data'
        },
        imageBrowserTransportDestroyDataType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.destroy.dataType'
        },
        imageBrowserTransportDestroyType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.destroy.type'
        },
        imageBrowserTransportDestroyUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'imageBrowser.transport.destroy.url'
        },
        imageBrowserTransportCreate: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.create'
        },
        imageBrowserTransportCreateContentType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.create.contentType'
        },
        imageBrowserTransportCreateData: {
            type: [Object, String, Function],
            default: undefined,
            kComposite: 'imageBrowser.transport.create.data'
        },
        imageBrowserTransportCreateDataType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.create.dataType'
        },
        imageBrowserTransportCreateType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.create.type'
        },
        imageBrowserTransportCreateUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'imageBrowser.transport.create.url'
        },
        imageBrowserSchemaModelId: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.id'
        },
        imageBrowserSchemaModelFieldsName: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.fields.name'
        },
        imageBrowserSchemaModelFieldsNameField: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.fields.name.field'
        },
        imageBrowserSchemaModelFieldsNameParse: {
            type: Function,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.fields.name.parse'
        },
        imageBrowserSchemaModelFieldsType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.fields.type'
        },
        imageBrowserSchemaModelFieldsTypeParse: {
            type: Function,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.fields.type.parse'
        },
        imageBrowserSchemaModelFieldsTypeField: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.fields.type.field'
        },
        imageBrowserSchemaModelFieldsSize: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.fields.size'
        },
        imageBrowserSchemaModelFieldsSizeField: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.fields.size.field'
        },
        imageBrowserSchemaModelFieldsSizeParse: {
            type: Function,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.fields.size.parse'
        },
        imageBrowserMessagesUploadFile: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.uploadFile'
        },
        imageBrowserMessagesOrderBy: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.orderBy'
        },
        imageBrowserMessagesOrderByName: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.orderByName'
        },
        imageBrowserMessagesOrderBySize: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.orderBySize'
        },
        imageBrowserMessagesDirectoryNotFound: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.directoryNotFound'
        },
        imageBrowserMessagesEmptyFolder: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.emptyFolder'
        },
        imageBrowserMessagesDeleteFile: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.deleteFile'
        },
        imageBrowserMessagesInvalidFileType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.invalidFileType'
        },
        imageBrowserMessagesOverwriteFile: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.overwriteFile'
        },
        imageBrowserMessagesSearch: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.search'
        }
    }
};

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        immutablesDeserialization: {
            type: Function,
            default: undefined,
            kComposite: 'immutables.deserialization'
        },
        immutablesSerialization: {
            type: [String, Function],
            default: undefined,
            kComposite: 'immutables.serialization'
        }
    }
};

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesAccessibilityTab: {
            type: String,
            default: undefined,
            kComposite: 'messages.accessibilityTab'
        },
        messagesAddColumnLeft: {
            type: String,
            default: undefined,
            kComposite: 'messages.addColumnLeft'
        },
        messagesAddColumnRight: {
            type: String,
            default: undefined,
            kComposite: 'messages.addColumnRight'
        },
        messagesAddRowAbove: {
            type: String,
            default: undefined,
            kComposite: 'messages.addRowAbove'
        },
        messagesAddRowBelow: {
            type: String,
            default: undefined,
            kComposite: 'messages.addRowBelow'
        },
        messagesAlignCenter: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignCenter'
        },
        messagesAlignCenterBottom: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignCenterBottom'
        },
        messagesAlignCenterMiddle: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignCenterMiddle'
        },
        messagesAlignCenterTop: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignCenterTop'
        },
        messagesAlignLeft: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignLeft'
        },
        messagesAlignLeftBottom: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignLeftBottom'
        },
        messagesAlignLeftMiddle: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignLeftMiddle'
        },
        messagesAlignLeftTop: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignLeftTop'
        },
        messagesAlignRemove: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignRemove'
        },
        messagesAlignRight: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignRight'
        },
        messagesAlignRightBottom: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignRightBottom'
        },
        messagesAlignRightMiddle: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignRightMiddle'
        },
        messagesAlignRightTop: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignRightTop'
        },
        messagesAlignment: {
            type: String,
            default: undefined,
            kComposite: 'messages.alignment'
        },
        messagesAssociateCellsWithHeaders: {
            type: String,
            default: undefined,
            kComposite: 'messages.associateCellsWithHeaders'
        },
        messagesBackColor: {
            type: String,
            default: undefined,
            kComposite: 'messages.backColor'
        },
        messagesBackground: {
            type: String,
            default: undefined,
            kComposite: 'messages.background'
        },
        messagesBold: {
            type: String,
            default: undefined,
            kComposite: 'messages.bold'
        },
        messagesBorder: {
            type: String,
            default: undefined,
            kComposite: 'messages.border'
        },
        messagesStyle: {
            type: String,
            default: undefined,
            kComposite: 'messages.style'
        },
        messagesCaption: {
            type: String,
            default: undefined,
            kComposite: 'messages.caption'
        },
        messagesCellMargin: {
            type: String,
            default: undefined,
            kComposite: 'messages.cellMargin'
        },
        messagesCellPadding: {
            type: String,
            default: undefined,
            kComposite: 'messages.cellPadding'
        },
        messagesCellSpacing: {
            type: String,
            default: undefined,
            kComposite: 'messages.cellSpacing'
        },
        messagesCellTab: {
            type: String,
            default: undefined,
            kComposite: 'messages.cellTab'
        },
        messagesCleanFormatting: {
            type: String,
            default: undefined,
            kComposite: 'messages.cleanFormatting'
        },
        messagesCollapseBorders: {
            type: String,
            default: undefined,
            kComposite: 'messages.collapseBorders'
        },
        messagesColumns: {
            type: String,
            default: undefined,
            kComposite: 'messages.columns'
        },
        messagesCreateLink: {
            type: String,
            default: undefined,
            kComposite: 'messages.createLink'
        },
        messagesCreateTable: {
            type: String,
            default: undefined,
            kComposite: 'messages.createTable'
        },
        messagesCreateTableHint: {
            type: String,
            default: undefined,
            kComposite: 'messages.createTableHint'
        },
        messagesCssClass: {
            type: String,
            default: undefined,
            kComposite: 'messages.cssClass'
        },
        messagesDeleteColumn: {
            type: String,
            default: undefined,
            kComposite: 'messages.deleteColumn'
        },
        messagesDeleteRow: {
            type: String,
            default: undefined,
            kComposite: 'messages.deleteRow'
        },
        messagesDialogCancel: {
            type: String,
            default: undefined,
            kComposite: 'messages.dialogCancel'
        },
        messagesDialogInsert: {
            type: String,
            default: undefined,
            kComposite: 'messages.dialogInsert'
        },
        messagesDialogOk: {
            type: String,
            default: undefined,
            kComposite: 'messages.dialogOk'
        },
        messagesDialogUpdate: {
            type: String,
            default: undefined,
            kComposite: 'messages.dialogUpdate'
        },
        messagesEditAreaTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.editAreaTitle'
        },
        messagesFileTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.fileTitle'
        },
        messagesFileWebAddress: {
            type: String,
            default: undefined,
            kComposite: 'messages.fileWebAddress'
        },
        messagesFontName: {
            type: String,
            default: undefined,
            kComposite: 'messages.fontName'
        },
        messagesFontNameInherit: {
            type: String,
            default: undefined,
            kComposite: 'messages.fontNameInherit'
        },
        messagesFontSize: {
            type: String,
            default: undefined,
            kComposite: 'messages.fontSize'
        },
        messagesFontSizeInherit: {
            type: String,
            default: undefined,
            kComposite: 'messages.fontSizeInherit'
        },
        messagesForeColor: {
            type: String,
            default: undefined,
            kComposite: 'messages.foreColor'
        },
        messagesFormatBlock: {
            type: String,
            default: undefined,
            kComposite: 'messages.formatBlock'
        },
        messagesFormatting: {
            type: String,
            default: undefined,
            kComposite: 'messages.formatting'
        },
        messagesHeight: {
            type: String,
            default: undefined,
            kComposite: 'messages.height'
        },
        messagesId: {
            type: String,
            default: undefined,
            kComposite: 'messages.id'
        },
        messagesImageAltText: {
            type: String,
            default: undefined,
            kComposite: 'messages.imageAltText'
        },
        messagesImageHeight: {
            type: String,
            default: undefined,
            kComposite: 'messages.imageHeight'
        },
        messagesImageWebAddress: {
            type: String,
            default: undefined,
            kComposite: 'messages.imageWebAddress'
        },
        messagesImageWidth: {
            type: String,
            default: undefined,
            kComposite: 'messages.imageWidth'
        },
        messagesIndent: {
            type: String,
            default: undefined,
            kComposite: 'messages.indent'
        },
        messagesInsertFile: {
            type: String,
            default: undefined,
            kComposite: 'messages.insertFile'
        },
        messagesInsertHtml: {
            type: String,
            default: undefined,
            kComposite: 'messages.insertHtml'
        },
        messagesInsertImage: {
            type: String,
            default: undefined,
            kComposite: 'messages.insertImage'
        },
        messagesInsertOrderedList: {
            type: String,
            default: undefined,
            kComposite: 'messages.insertOrderedList'
        },
        messagesInsertUnorderedList: {
            type: String,
            default: undefined,
            kComposite: 'messages.insertUnorderedList'
        },
        messagesItalic: {
            type: String,
            default: undefined,
            kComposite: 'messages.italic'
        },
        messagesOverflowAnchor: {
            type: String,
            default: undefined,
            kComposite: 'messages.overflowAnchor'
        },
        messagesJustifyCenter: {
            type: String,
            default: undefined,
            kComposite: 'messages.justifyCenter'
        },
        messagesJustifyFull: {
            type: String,
            default: undefined,
            kComposite: 'messages.justifyFull'
        },
        messagesJustifyLeft: {
            type: String,
            default: undefined,
            kComposite: 'messages.justifyLeft'
        },
        messagesJustifyRight: {
            type: String,
            default: undefined,
            kComposite: 'messages.justifyRight'
        },
        messagesLinkOpenInNewWindow: {
            type: String,
            default: undefined,
            kComposite: 'messages.linkOpenInNewWindow'
        },
        messagesLinkText: {
            type: String,
            default: undefined,
            kComposite: 'messages.linkText'
        },
        messagesLinkToolTip: {
            type: String,
            default: undefined,
            kComposite: 'messages.linkToolTip'
        },
        messagesLinkWebAddress: {
            type: String,
            default: undefined,
            kComposite: 'messages.linkWebAddress'
        },
        messagesOutdent: {
            type: String,
            default: undefined,
            kComposite: 'messages.outdent'
        },
        messagesPrint: {
            type: String,
            default: undefined,
            kComposite: 'messages.print'
        },
        messagesRows: {
            type: String,
            default: undefined,
            kComposite: 'messages.rows'
        },
        messagesSelectAllCells: {
            type: String,
            default: undefined,
            kComposite: 'messages.selectAllCells'
        },
        messagesStrikethrough: {
            type: String,
            default: undefined,
            kComposite: 'messages.strikethrough'
        },
        messagesSubscript: {
            type: String,
            default: undefined,
            kComposite: 'messages.subscript'
        },
        messagesSummary: {
            type: String,
            default: undefined,
            kComposite: 'messages.summary'
        },
        messagesSuperscript: {
            type: String,
            default: undefined,
            kComposite: 'messages.superscript'
        },
        messagesTableTab: {
            type: String,
            default: undefined,
            kComposite: 'messages.tableTab'
        },
        messagesTableWizard: {
            type: String,
            default: undefined,
            kComposite: 'messages.tableWizard'
        },
        messagesUnderline: {
            type: String,
            default: undefined,
            kComposite: 'messages.underline'
        },
        messagesUnits: {
            type: String,
            default: undefined,
            kComposite: 'messages.units'
        },
        messagesUnlink: {
            type: String,
            default: undefined,
            kComposite: 'messages.unlink'
        },
        messagesViewHtml: {
            type: String,
            default: undefined,
            kComposite: 'messages.viewHtml'
        },
        messagesWidth: {
            type: String,
            default: undefined,
            kComposite: 'messages.width'
        },
        messagesWrapText: {
            type: String,
            default: undefined,
            kComposite: 'messages.wrapText'
        }
    }
};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        pasteCleanupAll: {
            type: Boolean,
            default: undefined,
            kComposite: 'pasteCleanup.all'
        },
        pasteCleanupCss: {
            type: Boolean,
            default: undefined,
            kComposite: 'pasteCleanup.css'
        },
        pasteCleanupCustom: {
            type: Function,
            default: undefined,
            kComposite: 'pasteCleanup.custom'
        },
        pasteCleanupKeepNewLines: {
            type: Boolean,
            default: undefined,
            kComposite: 'pasteCleanup.keepNewLines'
        },
        pasteCleanupMsAllFormatting: {
            type: Boolean,
            default: undefined,
            kComposite: 'pasteCleanup.msAllFormatting'
        },
        pasteCleanupMsConvertLists: {
            type: Boolean,
            default: undefined,
            kComposite: 'pasteCleanup.msConvertLists'
        },
        pasteCleanupMsTags: {
            type: Boolean,
            default: undefined,
            kComposite: 'pasteCleanup.msTags'
        },
        pasteCleanupNone: {
            type: Boolean,
            default: undefined,
            kComposite: 'pasteCleanup.none'
        },
        pasteCleanupSpan: {
            type: Boolean,
            default: undefined,
            kComposite: 'pasteCleanup.span'
        }
    }
};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        pdfAuthor: {
            type: String,
            default: undefined,
            kComposite: 'pdf.author'
        },
        pdfAvoidLinks: {
            type: [Boolean, String],
            default: undefined,
            kComposite: 'pdf.avoidLinks'
        },
        pdfCreator: {
            type: String,
            default: undefined,
            kComposite: 'pdf.creator'
        },
        pdfDate: {
            type: Date,
            default: undefined,
            kComposite: 'pdf.date'
        },
        pdfFileName: {
            type: String,
            default: undefined,
            kComposite: 'pdf.fileName'
        },
        pdfForceProxy: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.forceProxy'
        },
        pdfKeywords: {
            type: String,
            default: undefined,
            kComposite: 'pdf.keywords'
        },
        pdfLandscape: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.landscape'
        },
        pdfMarginBottom: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.bottom'
        },
        pdfMarginLeft: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.left'
        },
        pdfMarginRight: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.right'
        },
        pdfMarginTop: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.top'
        },
        pdfPaperSize: {
            type: [String, Array],
            default: undefined,
            kComposite: 'pdf.paperSize'
        },
        pdfProxyURL: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyURL'
        },
        pdfProxyTarget: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyTarget'
        },
        pdfSubject: {
            type: String,
            default: undefined,
            kComposite: 'pdf.subject'
        },
        pdfTitle: {
            type: String,
            default: undefined,
            kComposite: 'pdf.title'
        }
    }
};

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        resizableContent: {
            type: Boolean,
            default: undefined,
            kComposite: 'resizable.content'
        },
        resizableMin: {
            type: Number,
            default: undefined,
            kComposite: 'resizable.min'
        },
        resizableMax: {
            type: Number,
            default: undefined,
            kComposite: 'resizable.max'
        },
        resizableToolbar: {
            type: Boolean,
            default: undefined,
            kComposite: 'resizable.toolbar'
        }
    }
};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        serializationCustom: {
            type: Function,
            default: undefined,
            kComposite: 'serialization.custom'
        },
        serializationEntities: {
            type: Boolean,
            default: undefined,
            kComposite: 'serialization.entities'
        },
        serializationScripts: {
            type: Boolean,
            default: undefined,
            kComposite: 'serialization.scripts'
        },
        serializationSemantic: {
            type: Boolean,
            default: undefined,
            kComposite: 'serialization.semantic'
        }
    }
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoEditor = __webpack_require__(89);

var _KendoEditor2 = _interopRequireDefault(_KendoEditor);

var _KendoEditorTool = __webpack_require__(23);

var _KendoEditorTool2 = _interopRequireDefault(_KendoEditorTool);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoEditorInstaller = function () {
    function KendoEditorInstaller() {
        _classCallCheck(this, KendoEditorInstaller);
    }

    _createClass(KendoEditorInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoEditor2.default.name, _KendoEditor2.default);
            Vue.component(_KendoEditorTool2.default.name, _KendoEditorTool2.default);
        }
    }]);

    return KendoEditorInstaller;
}();

exports.default = KendoEditorInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoEditorInstaller);
}

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GanttInstaller = exports.KendoGanttInstaller = exports.GanttView = exports.KendoGanttView = exports.GanttColumn = exports.KendoGanttColumn = exports.Gantt = exports.KendoGantt = undefined;

var _KendoGantt = __webpack_require__(90);

var _KendoGantt2 = _interopRequireDefault(_KendoGantt);

var _KendoGanttColumn = __webpack_require__(24);

var _KendoGanttColumn2 = _interopRequireDefault(_KendoGanttColumn);

var _KendoGanttView = __webpack_require__(25);

var _KendoGanttView2 = _interopRequireDefault(_KendoGanttView);

var _kendoGanttInstaller = __webpack_require__(304);

var _kendoGanttInstaller2 = _interopRequireDefault(_kendoGanttInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoGantt = _KendoGantt2.default;
exports.Gantt = _KendoGantt2.default;
exports.KendoGanttColumn = _KendoGanttColumn2.default;
exports.GanttColumn = _KendoGanttColumn2.default;
exports.KendoGanttView = _KendoGanttView2.default;
exports.GanttView = _KendoGanttView2.default;
exports.KendoGanttInstaller = _kendoGanttInstaller2.default;
exports.GanttInstaller = _kendoGanttInstaller2.default;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _GanttProps = __webpack_require__(292);

var _GanttProps2 = _interopRequireDefault(_GanttProps);

var _KendoGanttColumn = __webpack_require__(24);

var _KendoGanttColumn2 = _interopRequireDefault(_KendoGanttColumn);

var _KendoGanttView = __webpack_require__(25);

var _KendoGanttView2 = _interopRequireDefault(_KendoGanttView);

var _KendoGanttToolbar = __webpack_require__(91);

var _KendoGanttToolbar2 = _interopRequireDefault(_KendoGanttToolbar);

var _Assignments = __webpack_require__(296);

var _Assignments2 = _interopRequireDefault(_Assignments);

var _CurrentTimeMarker = __webpack_require__(297);

var _CurrentTimeMarker2 = _interopRequireDefault(_CurrentTimeMarker);

var _Editable = __webpack_require__(298);

var _Editable2 = _interopRequireDefault(_Editable);

var _Messages = __webpack_require__(299);

var _Messages2 = _interopRequireDefault(_Messages);

var _Pdf = __webpack_require__(300);

var _Pdf2 = _interopRequireDefault(_Pdf);

var _Range = __webpack_require__(301);

var _Range2 = _interopRequireDefault(_Range);

var _Resources = __webpack_require__(302);

var _Resources2 = _interopRequireDefault(_Resources);

var _Tooltip = __webpack_require__(303);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _GanttProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _Assignments2.default, _CurrentTimeMarker2.default, _Editable2.default, _Messages2.default, _Pdf2.default, _Range2.default, _Resources2.default, _Tooltip2.default],
    mounted: function mounted() {
        this._resolveChildren();
        this.setInnerDataSource('dependenciesDataSourceRef', 'dependencies');
        kendo.jQuery(this.$el).kendoGantt(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoGantt();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('columns', _KendoGanttColumn2.default.name);
            this.resolveChildren('views', _KendoGanttView2.default.name);
            this.resolveChildren('toolbar', _KendoGanttToolbar2.default.name);
        }
    }
};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    assignments: {
        type: Object,
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    columnResizeHandleWidth: {
        type: Number,
        default: undefined
    },
    columns: {
        type: Array,
        default: undefined
    },
    currentTimeMarker: {
        type: [Boolean, Object],
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    date: {
        type: Date,
        default: undefined
    },
    dependencies: {
        type: [Object, Array],
        default: undefined
    },
    dependenciesDataSourceRef: {
        type: String,
        default: undefined
    },
    editable: {
        type: [Boolean, Object],
        default: undefined
    },
    navigatable: {
        type: Boolean,
        default: undefined
    },
    workDayStart: {
        type: Date,
        default: undefined
    },
    workDayEnd: {
        type: Date,
        default: undefined
    },
    workWeekStart: {
        type: Number,
        default: undefined
    },
    workWeekEnd: {
        type: Number,
        default: undefined
    },
    hourSpan: {
        type: Number,
        default: undefined
    },
    snap: {
        type: Boolean,
        default: undefined
    },
    height: {
        type: [Number, String],
        default: undefined
    },
    listWidth: {
        type: [Number, String],
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    pdf: {
        type: Object,
        default: undefined
    },
    range: {
        type: Object,
        default: undefined
    },
    resizable: {
        type: Boolean,
        default: undefined
    },
    selectable: {
        type: Boolean,
        default: undefined
    },
    showWorkDays: {
        type: Boolean,
        default: undefined
    },
    showWorkHours: {
        type: Boolean,
        default: undefined
    },
    taskTemplate: {
        type: [String, Function],
        default: undefined
    },
    toolbar: {
        type: [String, Function, Array],
        default: undefined
    },
    tooltip: {
        type: Object,
        default: undefined
    },
    views: {
        type: Array,
        default: undefined
    },
    resources: {
        type: Object,
        default: undefined
    },
    rowHeight: {
        type: [Number, String],
        default: undefined
    },

    // Events
    dataBinding: {
        type: Function,
        default: undefined
    },
    dataBound: {
        type: Function,
        default: undefined
    },
    add: {
        type: Function,
        default: undefined
    },
    edit: {
        type: Function,
        default: undefined
    },
    remove: {
        type: Function,
        default: undefined
    },
    cancel: {
        type: Function,
        default: undefined
    },
    save: {
        type: Function,
        default: undefined
    },
    change: {
        type: Function,
        default: undefined
    },
    columnResize: {
        type: Function,
        default: undefined
    },
    navigate: {
        type: Function,
        default: undefined
    },
    moveStart: {
        type: Function,
        default: undefined
    },
    move: {
        type: Function,
        default: undefined
    },
    moveEnd: {
        type: Function,
        default: undefined
    },
    pdfExport: {
        type: Function,
        default: undefined
    },
    resizeStart: {
        type: Function,
        default: undefined
    },
    resize: {
        type: Function,
        default: undefined
    },
    resizeEnd: Function
};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        field: {
            type: String,
            default: undefined,
            kComposite: 'field'
        },
        title: {
            type: String,
            default: undefined,
            kComposite: 'title'
        },
        format: {
            type: String,
            default: undefined,
            kComposite: 'format'
        },
        width: {
            type: [String, Number],
            default: undefined,
            kComposite: 'width'
        },
        editable: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable'
        },
        sortable: {
            type: Boolean,
            default: undefined,
            kComposite: 'sortable'
        }
    }
};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        date: {
            type: Date,
            default: undefined,
            kComposite: 'date'
        },
        rangeStart: {
            type: Date,
            default: undefined,
            kComposite: 'range.start'
        },
        rangeEnd: {
            type: Date,
            default: undefined,
            kComposite: 'range.end'
        },
        type: {
            type: String,
            default: undefined,
            kComposite: 'type'
        },
        selected: {
            type: Boolean,
            default: undefined,
            kComposite: 'selected'
        },
        slotSize: {
            type: [Number, String],
            default: undefined,
            kComposite: 'slotSize'
        },
        timeHeaderTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'timeHeaderTemplate'
        },
        dayHeaderTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'dayHeaderTemplate'
        },
        weekHeaderTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'weekHeaderTemplate'
        },
        monthHeaderTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'monthHeaderTemplate'
        },
        yearHeaderTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'yearHeaderTemplate'
        },
        resizeTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'resizeTooltipFormat'
        }
    }
};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        name: {
            type: String,
            default: undefined,
            kComposite: 'name'
        },
        template: {
            type: [String, Function],
            default: undefined,
            kComposite: 'template'
        },
        text: {
            type: String,
            default: undefined,
            kComposite: 'text'
        }
    }
};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        assignmentsDataSource: {
            type: [Object, Array],
            default: undefined,
            kComposite: 'assignments.dataSource'
        },
        assignmentsDataResourceIdField: {
            type: String,
            default: undefined,
            kComposite: 'assignments.dataResourceIdField'
        },
        assignmentsDataTaskIdField: {
            type: String,
            default: undefined,
            kComposite: 'assignments.dataTaskIdField'
        },
        assignmentsDataValueField: {
            type: String,
            default: undefined,
            kComposite: 'assignments.dataValueField'
        }
    }
};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        currentTimeMarkerUpdateInterval: {
            type: Number,
            default: undefined,
            kComposite: 'currentTimeMarker.updateInterval'
        }
    }
};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        editableConfirmation: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.confirmation'
        },
        editableCreate: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.create'
        },
        editableDependencyCreate: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.dependencyCreate'
        },
        editableDependencyDestroy: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.dependencyDestroy'
        },
        editableDragPercentComplete: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.dragPercentComplete'
        },
        editableDestroy: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.destroy'
        },
        editableMove: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.move'
        },
        editableReorder: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.reorder'
        },
        editableResize: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.resize'
        },
        editableTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'editable.template'
        },
        editableUpdate: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.update'
        }
    }
};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesActionsAddChild: {
            type: String,
            default: undefined,
            kComposite: 'messages.actions.addChild'
        },
        messagesActionsAppend: {
            type: String,
            default: undefined,
            kComposite: 'messages.actions.append'
        },
        messagesActionsInsertAfter: {
            type: String,
            default: undefined,
            kComposite: 'messages.actions.insertAfter'
        },
        messagesActionsInsertBefore: {
            type: String,
            default: undefined,
            kComposite: 'messages.actions.insertBefore'
        },
        messagesActionsPdf: {
            type: String,
            default: undefined,
            kComposite: 'messages.actions.pdf'
        },
        messagesCancel: {
            type: String,
            default: undefined,
            kComposite: 'messages.cancel'
        },
        messagesDeleteDependencyConfirmation: {
            type: String,
            default: undefined,
            kComposite: 'messages.deleteDependencyConfirmation'
        },
        messagesDeleteDependencyWindowTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.deleteDependencyWindowTitle'
        },
        messagesDeleteTaskConfirmation: {
            type: String,
            default: undefined,
            kComposite: 'messages.deleteTaskConfirmation'
        },
        messagesDeleteTaskWindowTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.deleteTaskWindowTitle'
        },
        messagesDestroy: {
            type: String,
            default: undefined,
            kComposite: 'messages.destroy'
        },
        messagesEditorAssignButton: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.assignButton'
        },
        messagesEditorEditorTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.editorTitle'
        },
        messagesEditorEnd: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.end'
        },
        messagesEditorPercentComplete: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.percentComplete'
        },
        messagesEditorResources: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.resources'
        },
        messagesEditorResourcesEditorTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.resourcesEditorTitle'
        },
        messagesEditorResourcesHeader: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.resourcesHeader'
        },
        messagesEditorStart: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.start'
        },
        messagesEditorTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.title'
        },
        messagesEditorUnitsHeader: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.unitsHeader'
        },
        messagesSave: {
            type: String,
            default: undefined,
            kComposite: 'messages.save'
        },
        messagesViewsDay: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.day'
        },
        messagesViewsEnd: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.end'
        },
        messagesViewsMonth: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.month'
        },
        messagesViewsStart: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.start'
        },
        messagesViewsWeek: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.week'
        },
        messagesViewsYear: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.year'
        }
    }
};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        pdfAuthor: {
            type: String,
            default: undefined,
            kComposite: 'pdf.author'
        },
        pdfAvoidLinks: {
            type: [Boolean, String],
            default: undefined,
            kComposite: 'pdf.avoidLinks'
        },
        pdfCreator: {
            type: String,
            default: undefined,
            kComposite: 'pdf.creator'
        },
        pdfDate: {
            type: Date,
            default: undefined,
            kComposite: 'pdf.date'
        },
        pdfFileName: {
            type: String,
            default: undefined,
            kComposite: 'pdf.fileName'
        },
        pdfForceProxy: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.forceProxy'
        },
        pdfKeywords: {
            type: String,
            default: undefined,
            kComposite: 'pdf.keywords'
        },
        pdfLandscape: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.landscape'
        },
        pdfMarginBottom: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.bottom'
        },
        pdfMarginLeft: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.left'
        },
        pdfMarginRight: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.right'
        },
        pdfMarginTop: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.top'
        },
        pdfPaperSize: {
            type: [String, Array],
            default: undefined,
            kComposite: 'pdf.paperSize'
        },
        pdfProxyURL: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyURL'
        },
        pdfProxyTarget: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyTarget'
        },
        pdfSubject: {
            type: String,
            default: undefined,
            kComposite: 'pdf.subject'
        },
        pdfTitle: {
            type: String,
            default: undefined,
            kComposite: 'pdf.title'
        }
    }
};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        rangeStart: {
            type: Date,
            default: undefined,
            kComposite: 'range.start'
        },
        rangeEnd: {
            type: Date,
            default: undefined,
            kComposite: 'range.end'
        }
    }
};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        resourcesDataFormatField: {
            type: String,
            default: undefined,
            kComposite: 'resources.dataFormatField'
        },
        resourcesDataColorField: {
            type: String,
            default: undefined,
            kComposite: 'resources.dataColorField'
        },
        resourcesDataSource: {
            type: [Object, Array],
            default: undefined,
            kComposite: 'resources.dataSource'
        },
        resourcesDataTextField: {
            type: String,
            default: undefined,
            kComposite: 'resources.dataTextField'
        },
        resourcesField: {
            type: String,
            default: undefined,
            kComposite: 'resources.field'
        }
    }
};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        tooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'tooltip.template'
        },
        tooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.visible'
        }
    }
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoGantt = __webpack_require__(90);

var _KendoGantt2 = _interopRequireDefault(_KendoGantt);

var _KendoGanttColumn = __webpack_require__(24);

var _KendoGanttColumn2 = _interopRequireDefault(_KendoGanttColumn);

var _KendoGanttView = __webpack_require__(25);

var _KendoGanttView2 = _interopRequireDefault(_KendoGanttView);

var _KendoGanttToolbar = __webpack_require__(91);

var _KendoGanttToolbar2 = _interopRequireDefault(_KendoGanttToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoGanttInstaller = function () {
    function KendoGanttInstaller() {
        _classCallCheck(this, KendoGanttInstaller);
    }

    _createClass(KendoGanttInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoGantt2.default.name, _KendoGantt2.default);
            Vue.component(_KendoGanttColumn2.default.name, _KendoGanttColumn2.default);
            Vue.component(_KendoGanttView2.default.name, _KendoGanttView2.default);
            Vue.component(_KendoGanttToolbar2.default.name, _KendoGanttToolbar2.default);
        }
    }]);

    return KendoGanttInstaller;
}();

exports.default = KendoGanttInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoGanttInstaller);
}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GaugesInstaller = exports.KendoGaugesInstaller = exports.RadialGaugePointer = exports.KendoRadialGaugePointer = exports.RadialGauge = exports.KendoRadialGauge = exports.LinearGaugePointer = exports.KendoLinearGaugePointer = exports.LinearGauge = exports.KendoLinearGauge = exports.ArcGaugeColor = exports.KendoArcGaugeColor = exports.ArcGauge = exports.KendoArcGauge = undefined;

var _KendoArcGauge = __webpack_require__(92);

var _KendoArcGauge2 = _interopRequireDefault(_KendoArcGauge);

var _KendoArcGaugeColor = __webpack_require__(26);

var _KendoArcGaugeColor2 = _interopRequireDefault(_KendoArcGaugeColor);

var _KendoLinearGauge = __webpack_require__(93);

var _KendoLinearGauge2 = _interopRequireDefault(_KendoLinearGauge);

var _KendoLinearGaugePointer = __webpack_require__(28);

var _KendoLinearGaugePointer2 = _interopRequireDefault(_KendoLinearGaugePointer);

var _KendoRadialGauge = __webpack_require__(94);

var _KendoRadialGauge2 = _interopRequireDefault(_KendoRadialGauge);

var _KendoRadialGaugePointer = __webpack_require__(29);

var _KendoRadialGaugePointer2 = _interopRequireDefault(_KendoRadialGaugePointer);

var _kendoGaugesInstaller = __webpack_require__(318);

var _kendoGaugesInstaller2 = _interopRequireDefault(_kendoGaugesInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoArcGauge = _KendoArcGauge2.default;
exports.ArcGauge = _KendoArcGauge2.default;
exports.KendoArcGaugeColor = _KendoArcGaugeColor2.default;
exports.ArcGaugeColor = _KendoArcGaugeColor2.default;
exports.KendoLinearGauge = _KendoLinearGauge2.default;
exports.LinearGauge = _KendoLinearGauge2.default;
exports.KendoLinearGaugePointer = _KendoLinearGaugePointer2.default;
exports.LinearGaugePointer = _KendoLinearGaugePointer2.default;
exports.KendoRadialGauge = _KendoRadialGauge2.default;
exports.RadialGauge = _KendoRadialGauge2.default;
exports.KendoRadialGaugePointer = _KendoRadialGaugePointer2.default;
exports.RadialGaugePointer = _KendoRadialGaugePointer2.default;
exports.KendoGaugesInstaller = _kendoGaugesInstaller2.default;
exports.GaugesInstaller = _kendoGaugesInstaller2.default;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _ArcGaugeProps = __webpack_require__(307);

var _ArcGaugeProps2 = _interopRequireDefault(_ArcGaugeProps);

var _KendoArcGaugeColor = __webpack_require__(26);

var _KendoArcGaugeColor2 = _interopRequireDefault(_KendoArcGaugeColor);

var _GaugeArea = __webpack_require__(27);

var _GaugeArea2 = _interopRequireDefault(_GaugeArea);

var _Scale = __webpack_require__(309);

var _Scale2 = _interopRequireDefault(_Scale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _ArcGaugeProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _GaugeArea2.default, _Scale2.default],
    mounted: function mounted() {
        this._resolveChildren();

        kendo.jQuery(this.$el).kendoArcGauge(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoArcGauge();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('colors', _KendoArcGaugeColor2.default.name);
        }
    }
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    centerTemplate: {
        type: [String, Function],
        default: undefined
    },
    color: {
        type: String,
        default: undefined
    },
    colors: {
        type: Array,
        default: undefined
    },
    gaugeArea: {
        type: Object,
        default: undefined
    },
    opacity: {
        type: Number,
        default: undefined
    },
    renderAs: {
        type: String,
        default: undefined
    },
    scale: {
        type: Object,
        default: undefined
    },
    theme: {
        type: String,
        default: undefined
    },
    transitions: {
        type: Boolean,
        default: undefined
    },
    value: {
        type: Number,
        default: undefined

        // Events
    } };

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        color: {
            type: String,
            default: undefined,
            kComposite: 'color'
        },

        from: {
            type: Number,
            default: undefined,
            kComposite: 'from'
        },

        to: {
            type: Number,
            default: undefined,
            kComposite: 'to'
        }
    }
};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        scaleEndAngle: {
            type: Number,
            default: undefined,
            kComposite: 'scale.endAngle'
        },

        scaleLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.background'
        },

        scaleLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.border.color'
        },

        scaleLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.border.dashType'
        },

        scaleLabelsBorderOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.border.opacity'
        },

        scaleLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.border.width'
        },

        scaleLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.color'
        },

        scaleLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.font'
        },

        scaleLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.format'
        },

        scaleLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin'
        },

        scaleLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.top'
        },

        scaleLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.bottom'
        },

        scaleLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.left'
        },

        scaleLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.right'
        },

        scaleLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding'
        },

        scaleLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.top'
        },

        scaleLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.bottom'
        },

        scaleLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.left'
        },

        scaleLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.right'
        },

        scaleLabelsPosition: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.position'
        },

        scaleLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'scale.labels.template'
        },

        scaleLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.labels.visible'
        },

        scaleMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.majorTicks.color'
        },

        scaleMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'scale.majorTicks.size'
        },

        scaleMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.majorTicks.visible'
        },

        scaleMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'scale.majorTicks.width'
        },

        scaleMajorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'scale.majorUnit'
        },

        scaleMax: {
            type: Number,
            default: undefined,
            kComposite: 'scale.max'
        },

        scaleMin: {
            type: Number,
            default: undefined,
            kComposite: 'scale.min'
        },

        scaleMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.minorTicks.color'
        },

        scaleMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'scale.minorTicks.size'
        },

        scaleMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.minorTicks.visible'
        },

        scaleMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'scale.minorTicks.width'
        },

        scaleMinorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'scale.minorUnit'
        },

        scaleRangeLineCap: {
            type: String,
            default: undefined,
            kComposite: 'scale.rangeLineCap'
        },

        scaleRangePlaceholderColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.rangePlaceholderColor'
        },

        scaleRangeSize: {
            type: Number,
            default: undefined,
            kComposite: 'scale.rangeSize'
        },

        scaleRangeDistance: {
            type: Number,
            default: undefined,
            kComposite: 'scale.rangeDistance'
        },

        scaleReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.reverse'
        },

        scaleStartAngle: {
            type: Number,
            default: undefined,
            kComposite: 'scale.startAngle'
        }

    }
};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _LinearGaugeProps = __webpack_require__(311);

var _LinearGaugeProps2 = _interopRequireDefault(_LinearGaugeProps);

var _KendoLinearGaugePointer = __webpack_require__(28);

var _KendoLinearGaugePointer2 = _interopRequireDefault(_KendoLinearGaugePointer);

var _GaugeArea = __webpack_require__(27);

var _GaugeArea2 = _interopRequireDefault(_GaugeArea);

var _Scale = __webpack_require__(313);

var _Scale2 = _interopRequireDefault(_Scale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _LinearGaugeProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _GaugeArea2.default, _Scale2.default],
    mounted: function mounted() {
        this._resolveChildren();

        kendo.jQuery(this.$el).kendoLinearGauge(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoLinearGauge();
        },
        resolvePointers: function resolvePointers() {
            this.resolveChildren('pointer', _KendoLinearGaugePointer2.default.name);
        },
        _resolveChildren: function _resolveChildren() {
            this.resolvePointers();
        }
    }
};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    gaugeArea: {
        type: Object,
        default: undefined
    },
    pointer: {
        type: Array,
        default: undefined
    },
    renderAs: {
        type: String,
        default: undefined
    },
    scale: {
        type: Object,
        default: undefined
    },
    transitions: {
        type: Boolean,
        default: undefined

        // Events
    } };

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        borderColor: {
            type: String,
            default: undefined,
            kComposite: 'border.color'
        },
        borderDashType: {
            type: String,
            default: undefined,
            kComposite: 'border.dashType'
        },
        borderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'border.width'
        },
        color: {
            type: String,
            default: undefined,
            kComposite: 'color'
        },
        margin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'margin'
        },
        opacity: {
            type: Number,
            default: undefined,
            kComposite: 'opacity'
        },
        shape: {
            type: String,
            default: undefined,
            kComposite: 'shape'
        },
        size: {
            type: Number,
            default: undefined,
            kComposite: 'size'
        },
        trackBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'track.border.color'
        },
        trackBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'track.border.dashType'
        },
        trackBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'track.border.width'
        },
        trackColor: {
            type: String,
            default: undefined,
            kComposite: 'track.color'
        },
        trackOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'track.opacity'
        },
        trackSize: {
            type: Number,
            default: undefined,
            kComposite: 'track.size'
        },
        trackVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'track.visible'
        },
        value: {
            type: Number,
            default: undefined,
            kComposite: 'value'
        }
    }
};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        scaleLineColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.line.color'
        },
        scaleLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'scale.line.dashType'
        },
        scaleLineVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.line.visible'
        },
        scaleLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'scale.line.width'
        },
        scaleLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.background'
        },
        scaleLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.border.color'
        },
        scaleLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.border.dashType'
        },
        scaleLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.border.width'
        },
        scaleLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.color'
        },
        scaleLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.font'
        },
        scaleLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.format'
        },
        scaleLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin'
        },
        scaleLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.top'
        },
        scaleLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.bottom'
        },
        scaleLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.left'
        },
        scaleLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.right'
        },
        scaleLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding'
        },
        scaleLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.top'
        },
        scaleLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.bottom'
        },
        scaleLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.left'
        },
        scaleLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.right'
        },
        scaleLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'scale.labels.template'
        },
        scaleLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.labels.visible'
        },
        scaleMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.majorTicks.color'
        },
        scaleMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'scale.majorTicks.size'
        },
        scaleMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.majorTicks.visible'
        },
        scaleMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'scale.majorTicks.width'
        },
        scaleMajorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'scale.majorUnit'
        },
        scaleMax: {
            type: Number,
            default: undefined,
            kComposite: 'scale.max'
        },
        scaleMin: {
            type: Number,
            default: undefined,
            kComposite: 'scale.min'
        },
        scaleMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.minorTicks.color'
        },
        scaleMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'scale.minorTicks.size'
        },
        scaleMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.minorTicks.visible'
        },
        scaleMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'scale.minorTicks.width'
        },
        scaleMinorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'scale.minorUnit'
        },
        scaleMirror: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.mirror'
        },
        scaleRanges: {
            type: Array,
            default: undefined,
            kComposite: 'scale.ranges'
        },
        scaleRangePlaceholderColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.rangePlaceholderColor'
        },
        scaleRangeSize: {
            type: Number,
            default: undefined,
            kComposite: 'scale.rangeSize'
        },
        scaleReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.reverse'
        },
        scaleVertical: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.vertical'
        }
    }
};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _RadialGaugeProps = __webpack_require__(315);

var _RadialGaugeProps2 = _interopRequireDefault(_RadialGaugeProps);

var _KendoRadialGaugePointer = __webpack_require__(29);

var _KendoRadialGaugePointer2 = _interopRequireDefault(_KendoRadialGaugePointer);

var _GaugeArea = __webpack_require__(27);

var _GaugeArea2 = _interopRequireDefault(_GaugeArea);

var _Scale = __webpack_require__(317);

var _Scale2 = _interopRequireDefault(_Scale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _RadialGaugeProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _GaugeArea2.default, _Scale2.default],
    mounted: function mounted() {
        this._resolveChildren();

        kendo.jQuery(this.$el).kendoRadialGauge(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoRadialGauge();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('pointer', _KendoRadialGaugePointer2.default.name);
        }
    }
};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    gaugeArea: {
        type: Object,
        default: undefined
    },
    pointer: {
        type: Array,
        default: undefined
    },
    renderAs: {
        type: String,
        default: undefined
    },
    scale: {
        type: Object,
        default: undefined
    },
    transitions: {
        type: Boolean,
        default: undefined

        // Events
    } };

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        cap: Object,
        capColor: {
            type: String,
            default: undefined,
            kComposite: 'cap.color'
        },
        capSize: {
            type: Number,
            default: undefined,
            kComposite: 'cap.size'
        },
        color: {
            type: String,
            default: undefined,
            kComposite: 'color'
        },
        value: {
            type: Number,
            default: undefined,
            kComposite: 'value'
        }
    }
};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        scaleEndAngle: {
            type: Number,
            default: undefined,
            kComposite: 'scale.endAngle'
        },
        scaleLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.background'
        },
        scaleLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.border.color'
        },
        scaleLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.border.dashType'
        },
        scaleLabelsBorderOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.border.opacity'
        },
        scaleLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.border.width'
        },
        scaleLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.color'
        },
        scaleLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.font'
        },
        scaleLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.format'
        },
        scaleLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin'
        },
        scaleLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.top'
        },
        scaleLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.bottom'
        },
        scaleLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.left'
        },
        scaleLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.right'
        },
        scaleLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding'
        },
        scaleLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.top'
        },
        scaleLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.bottom'
        },
        scaleLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.left'
        },
        scaleLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.right'
        },
        scaleLabelsPosition: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.position'
        },
        scaleLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'scale.labels.template'
        },
        scaleLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.labels.visible'
        },
        scaleMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.majorTicks.color'
        },
        scaleMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'scale.majorTicks.size'
        },
        scaleMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.majorTicks.visible'
        },
        scaleMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'scale.majorTicks.width'
        },
        scaleMajorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'scale.majorUnit'
        },
        scaleMax: {
            type: Number,
            default: undefined,
            kComposite: 'scale.max'
        },
        scaleMin: {
            type: Number,
            default: undefined,
            kComposite: 'scale.min'
        },
        scaleMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.minorTicks.color'
        },
        scaleMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'scale.minorTicks.size'
        },
        scaleMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.minorTicks.visible'
        },
        scaleMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'scale.minorTicks.width'
        },
        scaleMinorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'scale.minorUnit'
        },
        scaleRanges: {
            type: Array,
            default: undefined,
            kComposite: 'scale.ranges'
        },
        scaleRangePlaceholderColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.rangePlaceholderColor'
        },
        scaleRangeSize: {
            type: Number,
            default: undefined,
            kComposite: 'scale.rangeSize'
        },
        scaleRangeDistance: {
            type: Number,
            default: undefined,
            kComposite: 'scale.rangeDistance'
        },
        scaleReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.reverse'
        },
        scaleStartAngle: {
            type: Number,
            default: undefined,
            kComposite: 'scale.startAngle'
        }
    }
};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoArcGauge = __webpack_require__(92);

var _KendoArcGauge2 = _interopRequireDefault(_KendoArcGauge);

var _KendoLinearGauge = __webpack_require__(93);

var _KendoLinearGauge2 = _interopRequireDefault(_KendoLinearGauge);

var _KendoRadialGauge = __webpack_require__(94);

var _KendoRadialGauge2 = _interopRequireDefault(_KendoRadialGauge);

var _KendoArcGaugeColor = __webpack_require__(26);

var _KendoArcGaugeColor2 = _interopRequireDefault(_KendoArcGaugeColor);

var _KendoLinearGaugePointer = __webpack_require__(28);

var _KendoLinearGaugePointer2 = _interopRequireDefault(_KendoLinearGaugePointer);

var _KendoRadialGaugePointer = __webpack_require__(29);

var _KendoRadialGaugePointer2 = _interopRequireDefault(_KendoRadialGaugePointer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoGaugesInstaller = function () {
    function KendoGaugesInstaller() {
        _classCallCheck(this, KendoGaugesInstaller);
    }

    _createClass(KendoGaugesInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoArcGauge2.default.name, _KendoArcGauge2.default);
            Vue.component(_KendoArcGaugeColor2.default.name, _KendoArcGaugeColor2.default);
            Vue.component(_KendoLinearGauge2.default.name, _KendoLinearGauge2.default);
            Vue.component(_KendoLinearGaugePointer2.default.name, _KendoLinearGaugePointer2.default);
            Vue.component(_KendoRadialGauge2.default.name, _KendoRadialGauge2.default);
            Vue.component(_KendoRadialGaugePointer2.default.name, _KendoRadialGaugePointer2.default);
        }
    }]);

    return KendoGaugesInstaller;
}();

exports.default = KendoGaugesInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoGaugesInstaller);
}

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridInstaller = exports.KendoGridInstaller = exports.GridColumn = exports.KendoGridColumn = exports.Grid = exports.KendoGrid = undefined;

var _KendoGrid = __webpack_require__(95);

var _KendoGrid2 = _interopRequireDefault(_KendoGrid);

var _KendoGridColumn = __webpack_require__(30);

var _KendoGridColumn2 = _interopRequireDefault(_KendoGridColumn);

var _kendoGridInstaller = __webpack_require__(336);

var _kendoGridInstaller2 = _interopRequireDefault(_kendoGridInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoGrid = _KendoGrid2.default;
exports.Grid = _KendoGrid2.default;
exports.KendoGridColumn = _KendoGridColumn2.default;
exports.GridColumn = _KendoGridColumn2.default;
exports.KendoGridInstaller = _kendoGridInstaller2.default;
exports.GridInstaller = _kendoGridInstaller2.default;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _KendoGridColumn = __webpack_require__(30);

var _KendoGridColumn2 = _interopRequireDefault(_KendoGridColumn);

var _KendoGridToolbar = __webpack_require__(96);

var _KendoGridToolbar2 = _interopRequireDefault(_KendoGridToolbar);

var _GridProps = __webpack_require__(323);

var _GridProps2 = _interopRequireDefault(_GridProps);

var _AllowCopy = __webpack_require__(324);

var _AllowCopy2 = _interopRequireDefault(_AllowCopy);

var _ColumnMenu = __webpack_require__(325);

var _ColumnMenu2 = _interopRequireDefault(_ColumnMenu);

var _Editable = __webpack_require__(326);

var _Editable2 = _interopRequireDefault(_Editable);

var _Excel = __webpack_require__(327);

var _Excel2 = _interopRequireDefault(_Excel);

var _Filterable = __webpack_require__(328);

var _Filterable2 = _interopRequireDefault(_Filterable);

var _Groupable = __webpack_require__(329);

var _Groupable2 = _interopRequireDefault(_Groupable);

var _Messages = __webpack_require__(330);

var _Messages2 = _interopRequireDefault(_Messages);

var _NoRecords = __webpack_require__(331);

var _NoRecords2 = _interopRequireDefault(_NoRecords);

var _Pageable = __webpack_require__(332);

var _Pageable2 = _interopRequireDefault(_Pageable);

var _Pdf = __webpack_require__(333);

var _Pdf2 = _interopRequireDefault(_Pdf);

var _Scrollable = __webpack_require__(334);

var _Scrollable2 = _interopRequireDefault(_Scrollable);

var _Sortable = __webpack_require__(335);

var _Sortable2 = _interopRequireDefault(_Sortable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _GridProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _AllowCopy2.default, _ColumnMenu2.default, _Editable2.default, _Excel2.default, _Filterable2.default, _Groupable2.default, _Messages2.default, _NoRecords2.default, _Pageable2.default, _Pdf2.default, _Scrollable2.default, _Sortable2.default],
    mounted: function mounted() {
        this._resolveChildren();
        kendo.jQuery(this.$el).kendoGrid(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoGrid();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('columns', _KendoGridColumn2.default.name);
            this.resolveChildren('toolbar', _KendoGridToolbar2.default.name);
        }
    }
};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        aggregates: Array,
        attributes: Object,
        columns: Array,
        command: String | Array,
        editable: Function,
        editor: Function,
        encoded: Boolean,
        field: String,
        filterable: Boolean | Object,
        filterableCellDataSource: {
            type: Object,
            default: undefined,
            kComposite: 'filterable.cell.dataSource'
        },
        filterableCellDataTextField: {
            type: String,
            default: undefined,
            kComposite: 'filterable.cell.dataTextField'
        },
        filterableCellDelay: {
            type: Number,
            default: undefined,
            kComposite: 'filterable.cell.delay'
        },
        filterableCellInputWidth: {
            type: Number,
            default: undefined,
            kComposite: 'filterable.cell.inputWidth'
        },
        filterableCellSuggestionOperator: {
            type: String,
            default: undefined,
            kComposite: 'filterable.cell.suggestionOperator'
        },
        filterableCellMinLength: {
            type: Number,
            default: undefined,
            kComposite: 'filterable.cell.minLength'
        },
        filterableCellEnabled: {
            type: Boolean,
            default: undefined,
            kComposite: 'filterable.cell.enabled'
        },
        filterableCellOperator: {
            type: String,
            default: undefined,
            kComposite: 'filterable.cell.operator'
        },
        filterableCellShowOperators: {
            type: Boolean,
            default: undefined,
            kComposite: 'filterable.cell.showOperators'
        },
        filterableCellTemplate: {
            type: Function,
            default: undefined,
            kComposite: 'filterable.cell.template'
        },
        filterableMulti: {
            type: Boolean,
            default: undefined,
            kComposite: 'filterable.multi'
        },
        filterableDataSource: {
            type: [Object, Array],
            default: undefined,
            kComposite: 'filterable.dataSource'
        },
        filterableCheckAll: {
            type: Boolean,
            default: undefined,
            kComposite: 'filterable.checkAll'
        },
        filterableItemTemplate: {
            type: Function,
            default: undefined,
            kComposite: 'filterable.itemTemplate'
        },
        filterableOperators: {
            type: Object,
            default: undefined,
            kComposite: 'filterable.operators'
        },
        filterableSearch: {
            type: Boolean,
            default: undefined,
            kComposite: 'filterable.search'
        },
        filterableIgnoreCase: {
            type: Boolean,
            default: undefined,
            kComposite: 'filterable.ignoreCase'
        },
        filterableUi: {
            type: [String, Function],
            default: undefined,
            kComposite: 'filterable.ui'
        },
        footerAttributes: {
            type: Object,
            default: undefined,
            kComposite: 'footerAttributes'
        },
        footerTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'footerTemplate'
        },
        format: String,
        groupable: Boolean | Object,
        groupableSortCompare: {
            type: Function,
            default: undefined,
            kComposite: 'groupable.sort.compare'
        },
        groupableSortDir: {
            type: String,
            default: undefined,
            kComposite: 'groupable.sort.dir'
        },
        groupHeaderTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'groupHeaderTemplate'
        },
        groupHeaderColumnTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'groupHeaderColumnTemplate'
        },
        groupFooterTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'groupFooterTemplate'
        },
        headerAttributes: {
            type: Object,
            default: undefined,
            kComposite: 'headerAttributes'
        },
        headerTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'headerTemplate'
        },
        hidden: {
            type: Boolean,
            default: undefined,
            kComposite: 'hidden'
        },
        locked: Boolean,
        lockable: Boolean,
        media: String,
        minResizableWidth: {
            type: Number,
            default: undefined,
            kComposite: 'minResizableWidth'
        },
        minScreenWidth: {
            type: Number,
            default: undefined,
            kComposite: 'minScreenWidth'
        },
        selectable: Boolean,
        sortable: Boolean,
        sortableCompare: {
            type: Function,
            default: undefined,
            kComposite: 'sortable.compare'
        },
        sortableInitialDirection: {
            type: String,
            default: undefined,
            kComposite: 'sortable.initialDirection'
        },
        template: String | Function,
        title: String,
        width: String | Number,
        values: Array,
        menu: Boolean
    }
};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        iconClass: {
            type: String,
            default: undefined,
            kComposite: 'iconClass'
        },
        name: {
            type: String,
            default: undefined,
            kComposite: 'name'
        },
        template: {
            type: [String, Function],
            default: undefined,
            kComposite: 'template'
        },
        text: {
            type: String,
            default: undefined,
            kComposite: 'text'
        }
    }
};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    allowCopy: {
        type: [Boolean, Object],
        default: undefined
    },
    altRowTemplate: {
        type: [String, Function],
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    columnResizeHandleWidth: {
        type: Number,
        default: undefined
    },
    columns: {
        type: Array,
        default: undefined
    },
    columnMenu: {
        type: [Boolean, Object],
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    detailTemplate: {
        type: [String, Function],
        default: undefined
    },
    editable: {
        type: [Boolean, Object, String],
        default: undefined
    },
    excel: {
        type: Object,
        default: undefined
    },
    filterable: {
        type: [Boolean, Object],
        default: undefined
    },
    groupable: {
        type: [Boolean, Object],
        default: undefined
    },
    height: {
        type: [Number, String],
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    mobile: {
        type: [Boolean, String],
        default: undefined
    },
    navigatable: {
        type: Boolean,
        default: undefined
    },
    noRecords: {
        type: [Boolean, Object],
        default: undefined
    },
    pageable: {
        type: [Boolean, Object],
        default: undefined
    },
    pdf: {
        type: Object,
        default: undefined
    },
    persistSelection: {
        type: Boolean,
        default: undefined
    },
    reorderable: {
        type: Boolean,
        default: undefined
    },
    resizable: {
        type: Boolean,
        default: undefined
    },
    rowTemplate: {
        type: [String, Function],
        default: undefined
    },
    scrollable: {
        type: [Boolean, Object],
        default: undefined
    },
    selectable: {
        type: [Boolean, String],
        default: undefined
    },
    sortable: {
        type: [Boolean, Object],
        default: undefined
    },
    toolbar: {
        type: [String, Function, Array],
        default: undefined
    },

    // Events
    beforeEdit: {
        type: Function,
        default: undefined
    },
    cancel: {
        type: Function,
        default: undefined
    },
    cellClose: {
        type: Function,
        default: undefined
    },
    change: {
        type: Function,
        default: undefined
    },
    columnHide: {
        type: Function,
        default: undefined
    },
    columnMenuInit: {
        type: Function,
        default: undefined
    },
    columnMenuOpen: {
        type: Function,
        default: undefined
    },
    columnReorder: {
        type: Function,
        default: undefined
    },
    columnResize: {
        type: Function,
        default: undefined
    },
    columnShow: {
        type: Function,
        default: undefined
    },
    dataBinding: {
        type: Function,
        default: undefined
    },
    dataBound: {
        type: Function,
        default: undefined
    },
    detailCollapse: {
        type: Function,
        default: undefined
    },
    detailExpand: {
        type: Function,
        default: undefined
    },
    detailInit: {
        type: Function,
        default: undefined
    },
    edit: {
        type: Function,
        default: undefined
    },
    excelExport: {
        type: Function,
        default: undefined
    },
    filter: {
        type: Function,
        default: undefined
    },
    group: {
        type: Function,
        default: undefined
    },
    groupCollapse: {
        type: Function,
        default: undefined
    },
    groupExpand: {
        type: Function,
        default: undefined
    },
    page: {
        type: Function,
        default: undefined
    },
    pdfExport: {
        type: Function,
        default: undefined
    },
    filterMenuInit: {
        type: Function,
        default: undefined
    },
    filterMenuOpen: {
        type: Function,
        default: undefined
    },
    remove: {
        type: Function,
        default: undefined
    },
    save: {
        type: Function,
        default: undefined
    },
    saveChanges: {
        type: Function,
        default: undefined
    },
    sort: {
        type: Function,
        default: undefined
    },
    columnLock: {
        type: Function,
        default: undefined
    },
    columnUnlock: {
        type: Function,
        default: undefined
    },
    navigate: Function
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        allowCopyDelimeter: {
            type: String | Object,
            default: undefined,
            kComposite: 'allowCopy.delimeter'
        }
    }
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        columnMenuColumns: {
            type: Boolean,
            default: undefined,
            kComposite: 'columnMenu.columns'
        },
        columnMenuFilterable: {
            type: Boolean,
            default: undefined,
            kComposite: 'columnMenu.filterable'
        },
        columnMenuSortable: {
            type: Boolean,
            default: undefined,
            kComposite: 'columnMenu.sortable'
        },
        columnMenuMessagesColumns: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.columns'
        },
        columnMenuMessagesFilter: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.filter'
        },
        columnMenuMessagesSortAscending: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.sortAscending'
        },
        columnMenuMessagesSortDescending: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.sortDescending'
        },
        columnMenuMessagesSettings: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.settings'
        },
        columnMenuMessagesDone: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.done'
        },
        columnMenuMessagesLock: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.lock'
        },
        columnMenuMessagesUnlock: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.unlock'
        }
    }
};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        editableConfirmation: {
            type: [Boolean, String, Function],
            default: undefined,
            kComposite: 'editable.confirmation'
        },
        editableCancelDelete: {
            type: String,
            default: undefined,
            kComposite: 'editable.cancelDelete'
        },
        editableConfirmDelete: {
            type: String,
            default: undefined,
            kComposite: 'editable.confirmDelete'
        },
        editableCreateAt: {
            type: String,
            default: undefined,
            kComposite: 'editable.createAt'
        },
        editableDestroy: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.destroy'
        },
        editableMode: {
            type: String,
            default: undefined,
            kComposite: 'editable.mode'
        },
        editableTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'editable.template'
        },
        editableUpdate: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.update'
        },
        editableWindow: {
            type: Object,
            default: undefined,
            kComposite: 'editable.window'
        }
    }
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        excelAllPages: {
            type: Boolean,
            default: undefined,
            kComposite: 'excel.allPages'
        },
        excelFileName: {
            type: String,
            default: undefined,
            kComposite: 'excel.fileName'
        },
        excelFilterable: {
            type: Boolean,
            default: undefined,
            kComposite: 'excel.filterable'
        },
        excelForceProxy: {
            type: Boolean,
            default: undefined,
            kComposite: 'excel.forceProxy'
        },
        excelProxyURL: {
            type: String,
            default: undefined,
            kComposite: 'excel.proxyURL'
        }
    }
};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        filterableExtra: {
            type: Boolean,
            default: undefined,
            kComposite: 'filterable.extra'
        },
        filterableMessagesAnd: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.and'
        },
        filterableMessagesClear: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.clear'
        },
        filterableMessagesFilter: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.filter'
        },
        filterableMessagesInfo: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.info'
        },
        filterableMessagesIsFalse: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.isFalse'
        },
        filterableMessagesIsTrue: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.isTrue'
        },
        filterableMessagesOr: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.or'
        },
        filterableMessagesSearch: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.search'
        },
        filterableMessagesSelectValue: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.selectValue'
        },
        filterableMessagesCancel: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.cancel'
        },
        filterableMessagesSelectedItemsFormat: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.selectedItemsFormat'
        },
        filterableMessagesOperator: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.operator'
        },
        filterableMessagesValue: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.value'
        },
        filterableMessagesCheckAll: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.checkAll'
        },
        filterableMode: {
            type: String,
            default: undefined,
            kComposite: 'filterable.mode'
        },
        filterableOperatorsStringEq: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.eq'
        },
        filterableOperatorsStringNeq: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.neq'
        },
        filterableOperatorsStringIsnull: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.isnull'
        },
        filterableOperatorsStringIsnotnull: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.isnotnull'
        },
        filterableOperatorsStringIsempty: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.isempty'
        },
        filterableOperatorsStringIsnotempty: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.isnotempty'
        },
        filterableOperatorsStringStartswith: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.startswith'
        },
        filterableOperatorsStringContains: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.contains'
        },
        filterableOperatorsStringDoesnotcontain: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.doesnotcontain'
        },
        filterableOperatorsStringEndswith: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.string.endswith'
        },
        filterableOperatorsNumberEq: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.number.eq'
        },
        filterableOperatorsNumberNeq: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.number.neq'
        },
        filterableOperatorsNumberIsnull: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.number.isnull'
        },
        filterableOperatorsNumberIsnotnull: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.number.isnotnull'
        },
        filterableOperatorsNumberGte: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.number.gte'
        },
        filterableOperatorsNumberGt: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.number.gt'
        },
        filterableOperatorsNumberLte: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.number.lte'
        },
        filterableOperatorsNumberLt: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.number.lt'
        },
        filterableOperatorsDateEq: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.date.eq'
        },
        filterableOperatorsDateNeq: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.date.neq'
        },
        filterableOperatorsDateIsnull: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.date.isnull'
        },
        filterableOperatorsDateIsnotnull: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.date.isnotnull'
        },
        filterableOperatorsDateGte: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.date.gte'
        },
        filterableOperatorsDateGt: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.date.gt'
        },
        filterableOperatorsDateLte: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.date.lte'
        },
        filterableOperatorsDateLt: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.date.lt'
        },
        filterableOperatorsEnumsEq: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.enums.eq'
        },
        filterableOperatorsEnumsNeq: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.enums.neq'
        },
        filterableOperatorsEnumsIsnull: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.enums.isnull'
        },
        filterableOperatorsEnumsIsnotnull: {
            type: String,
            default: undefined,
            kComposite: 'filterable.operators.enums.isnotnull'
        }
    }
};

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        groupableEnabled: {
            type: Boolean,
            default: undefined,
            kComposite: 'groupable.enabled'
        },
        groupableShowFooter: {
            type: Boolean,
            default: undefined,
            kComposite: 'groupable.showFooter'
        },
        groupableSortCompare: {
            type: Function,
            default: undefined,
            kComposite: 'groupable.sort.compare'
        },
        groupableSortDir: {
            type: String,
            default: undefined,
            kComposite: 'groupable.sort.dir'
        },
        groupableMessagesEmpty: {
            type: String,
            default: undefined,
            kComposite: 'groupable.messages.empty'
        }
    }
};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesCommandsCancel: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.cancel'
        },
        messagesCommandsCanceledit: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.canceledit'
        },
        messagesCommandsCreate: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.create'
        },
        messagesCommandsDestroy: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.destroy'
        },
        messagesCommandsEdit: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.edit'
        },
        messagesCommandsExcel: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.excel'
        },
        messagesCommandsSave: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.save'
        },
        messagesCommandsUpdate: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.update'
        },
        messagesNoRecords: {
            type: String,
            default: undefined,
            kComposite: 'messages.noRecords'
        },
        messagesExpandCollapseColumnHeader: {
            type: String,
            default: undefined,
            kComposite: 'messages.expandCollapseColumnHeader'
        }
    }
};

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        noRecordsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'noRecords.template'
        }
    }
};

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        pageableAlwaysVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.alwaysVisible'
        },
        pageablePageSize: {
            type: Number,
            default: undefined,
            kComposite: 'pageable.pageSize'
        },
        pageablePreviousNext: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.previousNext'
        },
        pageableNumeric: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.numeric'
        },
        pageableButtonCount: {
            type: Number,
            default: undefined,
            kComposite: 'pageable.buttonCount'
        },
        pageableInput: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.input'
        },
        pageablePageSizes: {
            type: [Boolean, Array],
            default: undefined,
            kComposite: 'pageable.pageSizes'
        },
        pageableRefresh: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.refresh'
        },
        pageableResponsive: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.responsive'
        },
        pageableInfo: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.info'
        },
        pageableMessagesDisplay: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.display'
        },
        pageableMessagesEmpty: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.empty'
        },
        pageableMessagesPage: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.page'
        },
        pageableMessagesOf: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.of'
        },
        pageableMessagesItemsPerPage: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.itemsPerPage'
        },
        pageableMessagesFirst: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.first'
        },
        pageableMessagesLast: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.last'
        },
        pageableMessagesNext: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.next'
        },
        pageableMessagesPrevious: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.previous'
        },
        pageableMessagesRefresh: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.refresh'
        },
        pageableMessagesMorePages: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.morePages'
        }
    }
};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        pdfAllPages: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.allPages'
        },
        pdfAuthor: {
            type: String,
            default: undefined,
            kComposite: 'pdf.author'
        },
        pdfAvoidLinks: {
            type: [Boolean, String],
            default: undefined,
            kComposite: 'pdf.avoidLinks'
        },
        pdfCreator: {
            type: String,
            default: undefined,
            kComposite: 'pdf.creator'
        },
        pdfDate: {
            type: Date,
            default: undefined,
            kComposite: 'pdf.date'
        },
        pdfFileName: {
            type: String,
            default: undefined,
            kComposite: 'pdf.fileName'
        },
        pdfForceProxy: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.forceProxy'
        },
        pdfKeywords: {
            type: String,
            default: undefined,
            kComposite: 'pdf.keywords'
        },
        pdfLandscape: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.landscape'
        },
        pdfMarginBottom: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.bottom'
        },
        pdfMarginLeft: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.left'
        },
        pdfMarginRight: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.right'
        },
        pdfMarginTop: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.top'
        },
        pdfPaperSize: {
            type: [String, Array],
            default: undefined,
            kComposite: 'pdf.paperSize'
        },
        pdfTemplate: {
            type: String,
            default: undefined,
            kComposite: 'pdf.template'
        },
        pdfRepeatHeaders: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.repeatHeaders'
        },
        pdfScale: {
            type: Number,
            default: undefined,
            kComposite: 'pdf.scale'
        },
        pdfProxyURL: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyURL'
        },
        pdfProxyTarget: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyTarget'
        },
        pdfSubject: {
            type: String,
            default: undefined,
            kComposite: 'pdf.subject'
        },
        pdfTitle: {
            type: String,
            default: undefined,
            kComposite: 'pdf.title'
        }
    }
};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        scrollableVirtual: {
            type: Boolean,
            default: undefined,
            kComposite: 'scrollable.virtual'
        },
        scrollableEndless: {
            type: Boolean,
            default: undefined,
            kComposite: 'scrollable.endless'
        }
    }
};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        sortableAllowUnsort: {
            type: Boolean,
            default: undefined,
            kComposite: 'sortable.allowUnsort'
        },
        sortableShowIndexes: {
            type: Boolean,
            default: undefined,
            kComposite: 'sortable.showIndexes'
        },
        sortableInitialDirection: {
            type: String,
            default: undefined,
            kComposite: 'sortable.initialDirection'
        },
        sortableMode: {
            type: String,
            default: undefined,
            kComposite: 'sortable.mode'
        }
    }
};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoGrid = __webpack_require__(95);

var _KendoGrid2 = _interopRequireDefault(_KendoGrid);

var _KendoGridColumn = __webpack_require__(30);

var _KendoGridColumn2 = _interopRequireDefault(_KendoGridColumn);

var _KendoGridToolbar = __webpack_require__(96);

var _KendoGridToolbar2 = _interopRequireDefault(_KendoGridToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoGridInstaller = function () {
    function KendoGridInstaller() {
        _classCallCheck(this, KendoGridInstaller);
    }

    _createClass(KendoGridInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoGrid2.default.name, _KendoGrid2.default);
            Vue.component(_KendoGridColumn2.default.name, _KendoGridColumn2.default);
            Vue.component(_KendoGridToolbar2.default.name, _KendoGridToolbar2.default);
        }
    }]);

    return KendoGridInstaller;
}();

exports.default = KendoGridInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoGridInstaller);
}

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = exports.KendoSwitch = exports.RangeSlider = exports.KendoRangeSlider = exports.Slider = exports.KendoSlider = exports.MaskedTextBox = exports.KendoMaskedTextBox = exports.FlatColorPicker = exports.KendoFlatColorPicker = exports.ColorPalette = exports.KendoColorPalette = exports.ColorPicker = exports.KendoColorPicker = exports.NumericTextBox = exports.KendoNumericTextBox = exports.InputsInstaller = exports.KendoInputsInstaller = undefined;

var _kendoInputsInstaller = __webpack_require__(338);

var _kendoInputsInstaller2 = _interopRequireDefault(_kendoInputsInstaller);

var _KendoNumericTextBox = __webpack_require__(97);

var _KendoNumericTextBox2 = _interopRequireDefault(_KendoNumericTextBox);

var _KendoColorPicker = __webpack_require__(98);

var _KendoColorPicker2 = _interopRequireDefault(_KendoColorPicker);

var _KendoColorPalette = __webpack_require__(100);

var _KendoColorPalette2 = _interopRequireDefault(_KendoColorPalette);

var _KendoFlatColorPicker = __webpack_require__(101);

var _KendoFlatColorPicker2 = _interopRequireDefault(_KendoFlatColorPicker);

var _KendoMaskedTextBox = __webpack_require__(102);

var _KendoMaskedTextBox2 = _interopRequireDefault(_KendoMaskedTextBox);

var _KendoSlider = __webpack_require__(103);

var _KendoSlider2 = _interopRequireDefault(_KendoSlider);

var _KendoRangeSlider = __webpack_require__(105);

var _KendoRangeSlider2 = _interopRequireDefault(_KendoRangeSlider);

var _KendoSwitch = __webpack_require__(106);

var _KendoSwitch2 = _interopRequireDefault(_KendoSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoInputsInstaller = _kendoInputsInstaller2.default;
exports.InputsInstaller = _kendoInputsInstaller2.default;
exports.KendoNumericTextBox = _KendoNumericTextBox2.default;
exports.NumericTextBox = _KendoNumericTextBox2.default;
exports.KendoColorPicker = _KendoColorPicker2.default;
exports.ColorPicker = _KendoColorPicker2.default;
exports.KendoColorPalette = _KendoColorPalette2.default;
exports.ColorPalette = _KendoColorPalette2.default;
exports.KendoFlatColorPicker = _KendoFlatColorPicker2.default;
exports.FlatColorPicker = _KendoFlatColorPicker2.default;
exports.KendoMaskedTextBox = _KendoMaskedTextBox2.default;
exports.MaskedTextBox = _KendoMaskedTextBox2.default;
exports.KendoSlider = _KendoSlider2.default;
exports.Slider = _KendoSlider2.default;
exports.KendoRangeSlider = _KendoRangeSlider2.default;
exports.RangeSlider = _KendoRangeSlider2.default;
exports.KendoSwitch = _KendoSwitch2.default;
exports.Switch = _KendoSwitch2.default;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoNumericTextBox = __webpack_require__(97);

var _KendoNumericTextBox2 = _interopRequireDefault(_KendoNumericTextBox);

var _KendoColorPicker = __webpack_require__(98);

var _KendoColorPicker2 = _interopRequireDefault(_KendoColorPicker);

var _KendoColorPalette = __webpack_require__(100);

var _KendoColorPalette2 = _interopRequireDefault(_KendoColorPalette);

var _KendoFlatColorPicker = __webpack_require__(101);

var _KendoFlatColorPicker2 = _interopRequireDefault(_KendoFlatColorPicker);

var _KendoMaskedTextBox = __webpack_require__(102);

var _KendoMaskedTextBox2 = _interopRequireDefault(_KendoMaskedTextBox);

var _KendoSlider = __webpack_require__(103);

var _KendoSlider2 = _interopRequireDefault(_KendoSlider);

var _KendoRangeSlider = __webpack_require__(105);

var _KendoRangeSlider2 = _interopRequireDefault(_KendoRangeSlider);

var _KendoSwitch = __webpack_require__(106);

var _KendoSwitch2 = _interopRequireDefault(_KendoSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoInputsInstaller = function () {
    function KendoInputsInstaller() {
        _classCallCheck(this, KendoInputsInstaller);
    }

    _createClass(KendoInputsInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoNumericTextBox2.default.name, _KendoNumericTextBox2.default);
            Vue.component(_KendoColorPicker2.default.name, _KendoColorPicker2.default);
            Vue.component(_KendoColorPalette2.default.name, _KendoColorPalette2.default);
            Vue.component(_KendoFlatColorPicker2.default.name, _KendoFlatColorPicker2.default);
            Vue.component(_KendoMaskedTextBox2.default.name, _KendoMaskedTextBox2.default);
            Vue.component(_KendoSlider2.default.name, _KendoSlider2.default);
            Vue.component(_KendoRangeSlider2.default.name, _KendoRangeSlider2.default);
            Vue.component(_KendoSwitch2.default.name, _KendoSwitch2.default);
        }
    }]);

    return KendoInputsInstaller;
}();

exports.default = KendoInputsInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoInputsInstaller);
}

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _NumericTextBoxProps = __webpack_require__(340);

var _NumericTextBoxProps2 = _interopRequireDefault(_NumericTextBoxProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: _NumericTextBoxProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseInputComponent],
    mounted: function mounted() {
        var that = this;
        kendo.jQuery(that.$el).kendoNumericTextBox(that.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            var kendoWidget = that.kendoWidget();
            var inputElement = kendoWidget.element;
            if (that.v3) {
                that.$emit('update:modelValue', inputElement.val());
            } else {
                that.$emit('changemodel', inputElement.val());
            }
        });

        that.kendoWidget().bind('spin', function () {
            var kendoWidget = that.kendoWidget();
            var inputElement = kendoWidget.element;
            if (that.v3) {
                if (that.getListeners()['onUpdate:modelValue']) {
                    that.$emit('update:modelValue', inputElement.val());
                }
            } else {
                that.$emit('changemodel', inputElement.val());
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoNumericTextBox();
        }
    }
};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: [Number, String],
        default: undefined
    },
    culture: {
        type: String,
        default: undefined
    },
    decimals: {
        type: Number,
        default: undefined
    },
    downArrowText: {
        type: String,
        default: undefined
    },
    factor: {
        type: Number,
        default: undefined
    },
    format: {
        type: String,
        default: undefined
    },
    max: {
        type: Number,
        default: undefined
    },
    min: {
        type: Number,
        default: undefined
    },
    placeholder: {
        type: String,
        default: undefined
    },
    restrictDecimals: {
        type: Boolean,
        default: undefined
    },
    round: {
        type: Boolean,
        default: undefined
    },
    spinners: {
        type: Boolean,
        default: undefined
    },
    step: {
        type: Number,
        default: undefined
    },
    upArrowText: {
        type: String,
        default: undefined
    },
    value: {
        type: [Number, String],
        default: undefined
    },

    // Events
    change: Function,
    spin: Function
};

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _ColorPickerProps = __webpack_require__(342);

var _ColorPickerProps2 = _interopRequireDefault(_ColorPickerProps);

var _Messages = __webpack_require__(343);

var _Messages2 = _interopRequireDefault(_Messages);

var _TileSize = __webpack_require__(99);

var _TileSize2 = _interopRequireDefault(_TileSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: _ColorPickerProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseInputComponent, _Messages2.default, _TileSize2.default],
    mounted: function mounted() {
        var that = this;
        kendo.jQuery(that.$el).kendoColorPicker(that.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            var kendoWidget = that.kendoWidget();
            var inputElement = kendoWidget.element;
            if (that.v3) {
                that.$emit('update:modelValue', inputElement.val());
            } else {
                that.$emit('changemodel', inputElement.val());
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoColorPicker();
        }
    }
};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: String,
        default: undefined
    },
    buttons: {
        type: Boolean,
        default: undefined
    },
    clearButton: {
        type: Boolean,
        default: undefined
    },
    columns: {
        type: Number,
        default: undefined
    },
    tileSize: {
        type: [Number, Object],
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    palette: {
        type: [String, Array],
        default: undefined
    },
    opacity: {
        type: Boolean,
        default: undefined
    },
    preview: {
        type: Boolean,
        default: undefined
    },
    toolIcon: {
        type: String,
        default: undefined
    },
    value: {
        type: String,
        default: undefined
    },

    // Events
    change: Function,
    select: Function,
    open: Function,
    close: Function
};

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesApply: {
            type: String,
            default: undefined,
            kComposite: 'messages.apply'
        },
        messagesCancel: {
            type: String,
            default: undefined,
            kComposite: 'messages.cancel'
        },
        messagesPreviewInput: {
            type: String,
            default: undefined,
            kComposite: 'messages.previewInput'
        }
    }
};

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _ColorPaletteProps = __webpack_require__(345);

var _ColorPaletteProps2 = _interopRequireDefault(_ColorPaletteProps);

var _TileSize = __webpack_require__(99);

var _TileSize2 = _interopRequireDefault(_TileSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _ColorPaletteProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _TileSize2.default],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoColorPalette(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoColorPalette();
        }
    }
};

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    palette: {
        type: [String, Array],
        default: undefined
    },
    columns: {
        type: Number,
        default: undefined
    },
    tileSize: {
        type: [Number, Object],
        default: undefined
    },
    value: {
        type: String,
        default: undefined
    },

    // Events
    change: Function
};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _FlatColorPickerProps = __webpack_require__(347);

var _FlatColorPickerProps2 = _interopRequireDefault(_FlatColorPickerProps);

var _Messages = __webpack_require__(348);

var _Messages2 = _interopRequireDefault(_Messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _FlatColorPickerProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _Messages2.default],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoFlatColorPicker(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoFlatColorPicker();
        }
    }
};

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    opacity: {
        type: Boolean,
        default: undefined
    },
    buttons: {
        type: Boolean,
        default: undefined
    },
    value: {
        type: String,
        default: undefined
    },
    preview: {
        type: Boolean,
        default: undefined
    },
    autoupdate: {
        type: Boolean,
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },

    // Events
    change: Function
};

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesApply: {
            type: String,
            default: undefined,
            kComposite: 'messages.apply'
        },
        messagesCancel: {
            type: String,
            default: undefined,
            kComposite: 'messages.cancel'
        }
    }
};

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _MaskedTextBoxProps = __webpack_require__(350);

var _MaskedTextBoxProps2 = _interopRequireDefault(_MaskedTextBoxProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: _MaskedTextBoxProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseInputComponent],
    mounted: function mounted() {
        var that = this;
        kendo.jQuery(that.$el).kendoMaskedTextBox(that.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            var kendoWidget = that.kendoWidget();
            var inputElement = kendoWidget.element;
            if (that.v3) {
                that.$emit('update:modelValue', inputElement.val());
            } else {
                that.$emit('changemodel', inputElement.val());
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoMaskedTextBox();
        }
    }
};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: String,
        default: undefined
    },
    clearPromptChar: {
        type: Boolean,
        default: undefined
    },
    culture: {
        type: String,
        default: undefined
    },
    mask: {
        type: String,
        default: undefined
    },
    promptChar: {
        type: String,
        default: undefined
    },
    rules: {
        type: Object,
        default: undefined
    },
    unmaskOnPost: {
        type: Boolean,
        default: undefined
    },
    value: {
        type: String,
        default: undefined
    },

    // Events
    change: Function
};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _SliderProps = __webpack_require__(352);

var _SliderProps2 = _interopRequireDefault(_SliderProps);

var _Tooltip = __webpack_require__(104);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: _SliderProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseInputComponent, _Tooltip2.default],
    mounted: function mounted() {
        var that = this;
        kendo.jQuery(that.$el).kendoSlider(that.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            var kendoWidget = that.kendoWidget();
            var inputElement = kendoWidget.element;
            if (that.v3) {
                that.$emit('update:modelValue', inputElement.val());
            } else {
                that.$emit('changemodel', inputElement.val());
            }
        });

        that.kendoWidget().bind('slide', function () {
            var kendoWidget = that.kendoWidget();
            var inputElement = kendoWidget.element;
            if (that.v3) {
                if (that.getListeners()['onUpdate:modelValue']) {
                    that.$emit('update:modelValue', inputElement.val());
                }
            } else {
                that.$emit('changemodel', inputElement.val());
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoSlider();
        }
    }
};

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: [Number, String],
        default: undefined
    },
    decreaseButtonTitle: {
        type: String,
        default: undefined
    },
    dragHandleTitle: {
        type: String,
        default: undefined
    },
    increaseButtonTitle: {
        type: String,
        default: undefined
    },
    largeStep: {
        type: Number,
        default: undefined
    },
    max: {
        type: Number,
        default: undefined
    },
    min: {
        type: Number,
        default: undefined
    },
    orientation: {
        type: String,
        default: undefined
    },
    showButtons: {
        type: Boolean,
        default: undefined
    },
    smallStep: {
        type: Number,
        default: undefined
    },
    tickPlacement: {
        type: String,
        default: undefined
    },
    tooltip: {
        type: Object,
        default: undefined
    },
    value: {
        type: [String, Number],
        default: undefined
    },

    // Events
    change: Function,
    slide: Function
};

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _RangeSliderProps = __webpack_require__(354);

var _RangeSliderProps2 = _interopRequireDefault(_RangeSliderProps);

var _Tooltip = __webpack_require__(104);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: _RangeSliderProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseInputComponent, _Tooltip2.default],
    mounted: function mounted() {
        var that = this;
        kendo.jQuery(that.$el).kendoRangeSlider(that.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', that.kendoWidget().value());
            } else {
                that.$emit('changemodel', that.kendoWidget().value());
            }
        });

        that.kendoWidget().bind('slide', function () {
            if (that.v3) {
                if (that.getListeners()['onUpdate:modelValue']) {
                    that.$emit('update:modelValue', that.kendoWidget().value());
                }
            } else {
                that.$emit('changemodel', that.kendoWidget().value());
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoRangeSlider();
        }
    },
    computed: {
        nameAttr: function nameAttr() {
            return this.$attrs.name;
        },
        selectionStartName: function selectionStartName() {
            var nameAttr = this.nameAttr;
            return nameAttr ? nameAttr + '[0]' : null;
        },
        selectionEndName: function selectionEndName() {
            var nameAttr = this.nameAttr;
            return nameAttr ? nameAttr + '[1]' : null;
        }
    }
};

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: Array,
        default: undefined
    },
    largeStep: {
        type: Number,
        default: undefined
    },
    leftDragHandleTitle: {
        type: String,
        default: undefined
    },
    max: {
        type: Number,
        default: undefined
    },
    min: {
        type: Number,
        default: undefined
    },
    orientation: {
        type: String,
        default: undefined
    },
    rightDragHandleTitle: {
        type: String,
        default: undefined
    },
    selectionEnd: {
        type: Number,
        default: undefined
    },
    selectionStart: {
        type: Number,
        default: undefined
    },
    smallStep: {
        type: Number,
        default: undefined
    },
    tickPlacement: {
        type: String,
        default: undefined
    },
    tooltip: {
        type: Object,
        default: undefined
    },
    value: {
        type: Array,
        default: undefined
    },

    // Events
    change: Function,
    slide: Function
};

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _SwitchProps = __webpack_require__(356);

var _SwitchProps2 = _interopRequireDefault(_SwitchProps);

var _ObsoleteSwitchProps = __webpack_require__(357);

var _ObsoleteSwitchProps2 = _interopRequireDefault(_ObsoleteSwitchProps);

var _Messages = __webpack_require__(358);

var _Messages2 = _interopRequireDefault(_Messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: Object.assign({}, _SwitchProps2.default, _ObsoleteSwitchProps2.default),
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _Messages2.default],
    updated: function updated() {
        var kWidget = this.kendoWidget();

        if (this.modelValue !== kWidget.check()) {
            kWidget.check(this.modelValue);
        }
    },
    mounted: function mounted() {
        var that = this;

        that.widgetOptions.messages = that.widgetOptions.messages || {};

        // Obsolete props
        if (that.widgetOptions.onLabel) {
            that.widgetOptions.messages.checked = that.widgetOptions.onLabel;
        }

        if (that.widgetOptions.offLabel) {
            that.widgetOptions.messages.unchecked = that.widgetOptions.offLabel;
        }

        if (that.widgetOptions.enable == false) {
            that.widgetOptions.enabled = that.widgetOptions.enable;
        }
        kendo.jQuery(that.$el).kendoSwitch(that.widgetOptions);

        that.$_kendoSwitch = that.kendoWidget();
        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }

        that.kendoWidget().bind('change', function () {
            if (that.v3) {
                that.$emit('update:modelValue', that.kendoWidget().check());
            } else {
                that.$emit('changemodel', that.kendoWidget().check());
            }
        });
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoSwitch();
        }
    },
    destroyed: function destroyed() {
        var switchInstance = this.kendoWidget() || this.$_kendoSwitch;
        switchInstance.destroy();
        switchInstance.wrapper.remove();
    },

    watch: {
        checked: function checked(value) {
            var kWidget = this.kendoWidget();

            if (value != kWidget.check()) {
                kWidget.check(value);
            }
        }
    },
    model: {
        event: 'changemodel',
        prop: 'checked'
    }
};

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: Boolean,
        default: undefined
    },
    checked: {
        type: Boolean,
        default: undefined
    },
    enabled: {
        type: Boolean,
        default: undefined
    },
    readonly: {
        type: Boolean,
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    width: {
        type: [Number, String],
        default: undefined
    },

    // Events
    change: Function
};

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    enable: {
        type: Boolean,
        default: undefined
    },
    onLabel: {
        type: String,
        default: undefined
    },
    offLabel: {
        type: String,
        default: undefined
    }
};

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesChecked: {
            type: String,
            default: undefined,
            kComposite: 'messages.checked'
        },
        messagesUnchecked: {
            type: String,
            default: undefined,
            kComposite: 'messages.unchecked'
        }
    }
};

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LayoutInstaller = exports.KendoLayoutInstaller = exports.SplitterPane = exports.KendoSplitterPane = exports.Splitter = exports.KendoSplitter = exports.TabStrip = exports.KendoTabStrip = exports.PanelBarItem = exports.KendoPanelBarItem = exports.PanelBar = exports.KendoPanelBar = exports.MenuItem = exports.KendoMenuItem = exports.ContextMenu = exports.KendoContextMenu = exports.Menu = exports.KendoMenu = undefined;

var _KendoMenu = __webpack_require__(107);

var _KendoMenu2 = _interopRequireDefault(_KendoMenu);

var _KendoMenuItem = __webpack_require__(109);

var _KendoMenuItem2 = _interopRequireDefault(_KendoMenuItem);

var _KendoContextMenu = __webpack_require__(110);

var _KendoContextMenu2 = _interopRequireDefault(_KendoContextMenu);

var _KendoPanelBar = __webpack_require__(111);

var _KendoPanelBar2 = _interopRequireDefault(_KendoPanelBar);

var _KendoPanelBarItem = __webpack_require__(112);

var _KendoPanelBarItem2 = _interopRequireDefault(_KendoPanelBarItem);

var _KendoTabStrip = __webpack_require__(113);

var _KendoTabStrip2 = _interopRequireDefault(_KendoTabStrip);

var _KendoSplitter = __webpack_require__(114);

var _KendoSplitter2 = _interopRequireDefault(_KendoSplitter);

var _KendoSplitterPane = __webpack_require__(32);

var _KendoSplitterPane2 = _interopRequireDefault(_KendoSplitterPane);

var _kendoLayoutInstaller = __webpack_require__(375);

var _kendoLayoutInstaller2 = _interopRequireDefault(_kendoLayoutInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoMenu = _KendoMenu2.default;
exports.Menu = _KendoMenu2.default;
exports.KendoContextMenu = _KendoContextMenu2.default;
exports.ContextMenu = _KendoContextMenu2.default;
exports.KendoMenuItem = _KendoMenuItem2.default;
exports.MenuItem = _KendoMenuItem2.default;
exports.KendoPanelBar = _KendoPanelBar2.default;
exports.PanelBar = _KendoPanelBar2.default;
exports.KendoPanelBarItem = _KendoPanelBarItem2.default;
exports.PanelBarItem = _KendoPanelBarItem2.default;
exports.KendoTabStrip = _KendoTabStrip2.default;
exports.TabStrip = _KendoTabStrip2.default;
exports.KendoSplitter = _KendoSplitter2.default;
exports.Splitter = _KendoSplitter2.default;
exports.KendoSplitterPane = _KendoSplitterPane2.default;
exports.SplitterPane = _KendoSplitterPane2.default;
exports.KendoLayoutInstaller = _kendoLayoutInstaller2.default;
exports.LayoutInstaller = _kendoLayoutInstaller2.default;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _MenuProps = __webpack_require__(361);

var _MenuProps2 = _interopRequireDefault(_MenuProps);

var _OpenOnClick = __webpack_require__(362);

var _OpenOnClick2 = _interopRequireDefault(_OpenOnClick);

var _Animation = __webpack_require__(108);

var _Animation2 = _interopRequireDefault(_Animation);

var _Scrollable = __webpack_require__(31);

var _Scrollable2 = _interopRequireDefault(_Scrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _MenuProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _kendoBaseComponentsVueWrapper.KendoSharedMethods, _Animation2.default, _OpenOnClick2.default, _Scrollable2.default],
    mounted: function mounted() {
        this._resolveChildren();

        kendo.jQuery(this.$el).kendoMenu(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoMenu();
        },
        _resolveChildren: function _resolveChildren() {
            var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
            var hasDataSource = this.v3 ? !this.$props.dataSource : this.$options.propsData && !this.$options.propsData['dataSource'];
            if (hasDataSource && defaultSlot) {
                var items = this.resolveInnerTags('kendo-menu-item');

                if (items.length) {
                    this.widgetOptions['dataSource'] = items;
                }
            }
        }
    }
};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    closeOnClick: {
        type: Boolean,
        default: undefined
    },
    dataImageUrlField: {
        type: String,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataSpriteCssClassField: {
        type: String,
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    dataUrlField: {
        type: String,
        default: undefined
    },
    dataContentField: {
        type: String,
        default: undefined
    },
    direction: {
        type: String,
        default: undefined
    },
    hoverDelay: {
        type: Number,
        default: undefined
    },
    openOnClick: {
        type: [Boolean, Object],
        default: undefined
    },
    orientation: {
        type: String,
        default: undefined
    },
    popupCollision: {
        type: String,
        default: undefined
    },
    scrollable: {
        type: [Boolean, Object],
        default: undefined
    },

    // Events
    close: Function,
    open: Function,
    activate: Function,
    deactivate: Function,
    select: Function
};

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        openOnClickRootMenuItems: {
            type: Boolean,
            default: undefined,
            kComposite: 'openOnClick.rootMenuItems'
        },
        openOnClickSubMenuItems: {
            type: Boolean,
            default: undefined,
            kComposite: 'openOnClick.subMenuItems'
        }
    }
};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _ContextMenuProps = __webpack_require__(364);

var _ContextMenuProps2 = _interopRequireDefault(_ContextMenuProps);

var _Animation = __webpack_require__(365);

var _Animation2 = _interopRequireDefault(_Animation);

var _Scrollable = __webpack_require__(31);

var _Scrollable2 = _interopRequireDefault(_Scrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _ContextMenuProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _kendoBaseComponentsVueWrapper.KendoSharedMethods, _Animation2.default, _Scrollable2.default],
    mounted: function mounted() {
        this._resolveChildren();

        kendo.jQuery(this.$el).kendoContextMenu(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoContextMenu();
        },
        _resolveChildren: function _resolveChildren() {
            var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
            var hasDataSource = this.v3 ? !this.$props.dataSource : this.$options.propsData && !this.$options.propsData['dataSource'];
            if (hasDataSource && defaultSlot) {
                var items = this.resolveInnerTags('kendo-menu-item');

                if (items.length) {
                    this.widgetOptions['dataSource'] = items;
                }
            }
        }
    }
};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    alignToAnchor: {
        type: Boolean,
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    appendTo: {
        type: String,
        default: undefined
    },
    closeOnClick: {
        type: Boolean,
        default: undefined
    },
    copyAnchorStyles: {
        type: Boolean,
        default: undefined
    },
    dataImageUrlField: {
        type: String,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataSpriteCssClassField: {
        type: String,
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    dataUrlField: {
        type: String,
        default: undefined
    },
    dataContentField: {
        type: String,
        default: undefined
    },
    direction: {
        type: String,
        default: undefined
    },
    filter: {
        type: String,
        default: undefined
    },
    hoverDelay: {
        type: Number,
        default: undefined
    },
    orientation: {
        type: String,
        default: undefined
    },
    popupCollision: {
        type: String,
        default: undefined
    },
    scrollable: {
        type: [Boolean, Object],
        default: undefined
    },
    showOn: {
        type: String,
        default: undefined
    },
    target: {
        type: String,
        default: undefined
    },

    // Events
    close: Function,
    open: Function,
    activate: Function,
    deactivate: Function,
    select: Function
};

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        animationCloseEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.close.effects'
        },
        animationCloseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.close.duration'
        },
        animationOpenEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.open.effects'
        },
        animationOpenDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.open.duration'
        }
    }
};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _PanelBarProps = __webpack_require__(367);

var _PanelBarProps2 = _interopRequireDefault(_PanelBarProps);

var _Animation = __webpack_require__(368);

var _Animation2 = _interopRequireDefault(_Animation);

var _Messages = __webpack_require__(369);

var _Messages2 = _interopRequireDefault(_Messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _PanelBarProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _kendoBaseComponentsVueWrapper.KendoSharedMethods, _Animation2.default, _Messages2.default],
    mounted: function mounted() {
        this._resolveChildren();

        kendo.jQuery(this.$el).kendoPanelBar(this.widgetOptions);
        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoPanelBar();
        },
        _resolveChildren: function _resolveChildren() {
            var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
            var hasDataSource = this.v3 ? !this.$props.dataSource : this.$options.propsData && !this.$options.propsData['dataSource'];
            if (hasDataSource && defaultSlot) {
                var items = this.resolveInnerTags('kendo-panelbar-item');

                if (items.length) {
                    this.widgetOptions['dataSource'] = items;
                }
            }
        }
    }
};

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    contentUrls: {
        type: Array,
        default: undefined
    },
    dataImageUrlField: {
        type: String,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataSpriteCssClassField: {
        type: String,
        default: undefined
    },
    dataTextField: {
        type: [String, Array],
        default: undefined
    },
    dataUrlField: {
        type: String,
        default: undefined
    },
    expandMode: {
        type: String,
        default: undefined
    },
    loadOnDemand: {
        type: Boolean,
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    template: {
        type: [String, Function],
        default: undefined
    },

    // Events
    activate: Function,
    collapse: Function,
    contentLoad: {
        type: Function,
        default: undefined
    },
    dataBound: {
        type: Function,
        default: undefined
    },
    error: Function,
    expand: Function,
    select: Function
};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        animationCollapseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.collapse.duration'
        },
        animationCollapseEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.collapse.effects'
        },
        animationExpandDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.expand.duration'
        },
        animationExpandEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.expand.effects'
        }
    }
};

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesLoading: {
            type: String,
            default: undefined,
            kComposite: 'messages.loading'
        },
        messagesRequestFailed: {
            type: String,
            default: undefined,
            kComposite: 'messages.requestFailed'
        },
        messagesRetry: {
            type: String,
            default: undefined,
            kComposite: 'messages.retry'
        }
    }
};

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _TabStripProps = __webpack_require__(371);

var _TabStripProps2 = _interopRequireDefault(_TabStripProps);

var _Animation = __webpack_require__(108);

var _Animation2 = _interopRequireDefault(_Animation);

var _Scrollable = __webpack_require__(31);

var _Scrollable2 = _interopRequireDefault(_Scrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _TabStripProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _Animation2.default, _Scrollable2.default],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoTabStrip(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoTabStrip();
        }
    }
};

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    collapsible: {
        type: Boolean,
        default: undefined
    },
    contentUrls: {
        type: Array,
        default: undefined
    },
    dataContentField: {
        type: String,
        default: undefined
    },
    dataContentUrlField: {
        type: String,
        default: undefined
    },
    dataImageUrlField: {
        type: String,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataSpriteCssClass: {
        type: String,
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    dataUrlField: {
        type: String,
        default: undefined
    },
    navigatable: {
        type: Boolean,
        default: undefined
    },
    scrollable: {
        type: [Boolean, Object],
        default: undefined
    },
    tabPosition: {
        type: String,
        default: undefined
    },
    value: {
        type: String,
        default: undefined
    },

    // Events
    activate: Function,
    contentLoad: {
        type: Function,
        default: undefined
    },
    error: Function,
    select: Function,
    show: Function
};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _SplitterProps = __webpack_require__(373);

var _SplitterProps2 = _interopRequireDefault(_SplitterProps);

var _KendoSplitterPane = __webpack_require__(32);

var _KendoSplitterPane2 = _interopRequireDefault(_KendoSplitterPane);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _SplitterProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent],
    mounted: function mounted() {
        this._resolveChildren();

        kendo.jQuery(this.$el).kendoSplitter(this.widgetOptions);
        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoSplitter();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('panes', _KendoSplitterPane2.default.name);
        }
    }
};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    orientation: {
        type: String,
        default: undefined
    },
    panes: {
        type: Array,
        default: undefined
    },

    // Events
    collapse: Function,
    contentLoad: {
        type: Function,
        default: undefined
    },
    error: Function,
    expand: Function,
    layoutChange: {
        type: Function,
        default: undefined
    },
    resize: Function
};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        collapsed: {
            type: Boolean,
            default: undefined
        },
        collapsedSize: {
            type: String,
            default: undefined
        },
        collapsible: {
            type: Boolean,
            default: undefined
        },
        contentUrl: {
            type: String,
            default: undefined
        },
        max: {
            type: String,
            default: undefined
        },
        min: {
            type: String,
            default: undefined
        },
        resizable: {
            type: Boolean,
            default: undefined
        },
        scrollable: {
            type: Boolean,
            default: undefined
        },
        size: {
            type: String,
            default: undefined
        }
    }
};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoMenu = __webpack_require__(107);

var _KendoMenu2 = _interopRequireDefault(_KendoMenu);

var _KendoMenuItem = __webpack_require__(109);

var _KendoMenuItem2 = _interopRequireDefault(_KendoMenuItem);

var _KendoContextMenu = __webpack_require__(110);

var _KendoContextMenu2 = _interopRequireDefault(_KendoContextMenu);

var _KendoPanelBar = __webpack_require__(111);

var _KendoPanelBar2 = _interopRequireDefault(_KendoPanelBar);

var _KendoPanelBarItem = __webpack_require__(112);

var _KendoPanelBarItem2 = _interopRequireDefault(_KendoPanelBarItem);

var _KendoTabStrip = __webpack_require__(113);

var _KendoTabStrip2 = _interopRequireDefault(_KendoTabStrip);

var _KendoSplitter = __webpack_require__(114);

var _KendoSplitter2 = _interopRequireDefault(_KendoSplitter);

var _KendoSplitterPane = __webpack_require__(32);

var _KendoSplitterPane2 = _interopRequireDefault(_KendoSplitterPane);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoLayoutInstaller = function () {
    function KendoLayoutInstaller() {
        _classCallCheck(this, KendoLayoutInstaller);
    }

    _createClass(KendoLayoutInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoMenu2.default.name, _KendoMenu2.default);
            Vue.component(_KendoContextMenu2.default.name, _KendoContextMenu2.default);
            Vue.component(_KendoMenuItem2.default.name, _KendoMenuItem2.default);
            Vue.component(_KendoPanelBar2.default.name, _KendoPanelBar2.default);
            Vue.component(_KendoPanelBarItem2.default.name, _KendoPanelBarItem2.default);
            Vue.component(_KendoTabStrip2.default.name, _KendoTabStrip2.default);
            Vue.component(_KendoSplitter2.default.name, _KendoSplitter2.default);
            Vue.component(_KendoSplitterPane2.default.name, _KendoSplitterPane2.default);
        }
    }]);

    return KendoLayoutInstaller;
}();

exports.default = KendoLayoutInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoLayoutInstaller);
}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListBoxInstaller = exports.KendoListBoxInstaller = exports.ListBox = exports.KendoListBox = undefined;

var _KendoListBox = __webpack_require__(115);

var _KendoListBox2 = _interopRequireDefault(_KendoListBox);

var _kendoListboxInstaller = __webpack_require__(382);

var _kendoListboxInstaller2 = _interopRequireDefault(_kendoListboxInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoListBox = _KendoListBox2.default;
exports.ListBox = _KendoListBox2.default;
exports.KendoListBoxInstaller = _kendoListboxInstaller2.default;
exports.ListBoxInstaller = _kendoListboxInstaller2.default;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _ListBoxProps = __webpack_require__(378);

var _ListBoxProps2 = _interopRequireDefault(_ListBoxProps);

var _Draggable = __webpack_require__(379);

var _Draggable2 = _interopRequireDefault(_Draggable);

var _Messages = __webpack_require__(380);

var _Messages2 = _interopRequireDefault(_Messages);

var _Toolbar = __webpack_require__(381);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _ListBoxProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _Draggable2.default, _Messages2.default, _Toolbar2.default],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoListBox(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoListBox();
        }
    }
};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    autoBind: {
        type: Boolean,
        default: undefined
    },
    connectWith: {
        type: String,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    dataValueField: {
        type: String,
        default: undefined
    },
    draggable: {
        type: [Boolean, Object],
        default: undefined
    },
    dropSources: {
        type: Array,
        default: undefined
    },
    navigatable: {
        type: Boolean,
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    selectable: {
        type: String,
        default: undefined
    },
    template: {
        type: [String, Function],
        default: undefined
    },
    toolbar: {
        type: Object,
        default: undefined
    },

    // Events
    add: Function,
    change: Function,
    dataBound: {
        type: Function,
        default: undefined
    },
    dragstart: Function,
    drag: Function,
    drop: Function,
    dragend: Function,
    remove: Function,
    reorder: Function
};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        draggableEnabled: {
            type: Boolean,
            default: undefined,
            kComposite: 'draggable.enabled'
        },
        draggableHint: {
            type: [Function, String],
            default: undefined,
            kComposite: 'draggable.hint'
        },
        draggablePlaceholder: {
            type: [Function, String],
            default: undefined,
            kComposite: 'draggable.placeholder'
        }
    }
};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesToolsMoveDown: {
            type: String,
            default: undefined,
            kComposite: 'messages.tools.moveDown'
        },
        messagesToolsMoveUp: {
            type: String,
            default: undefined,
            kComposite: 'messages.tools.moveUp'
        },
        messagesToolsRemove: {
            type: String,
            default: undefined,
            kComposite: 'messages.tools.remove'
        },
        messagesToolsTransferAllFrom: {
            type: String,
            default: undefined,
            kComposite: 'messages.tools.transferAllFrom'
        },
        messagesToolsTransferAllTo: {
            type: String,
            default: undefined,
            kComposite: 'messages.tools.transferAllTo'
        },
        messagesToolsTransferFrom: {
            type: String,
            default: undefined,
            kComposite: 'messages.tools.transferFrom'
        },
        messagesToolsTransferTo: {
            type: String,
            default: undefined,
            kComposite: 'messages.tools.transferTo'
        }
    }
};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        toolbarPosition: {
            type: String,
            default: undefined,
            kComposite: 'toolbar.position'
        },
        toolbarTools: {
            type: Array,
            default: undefined,
            kComposite: 'toolbar.tools'
        }
    }
};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoListBox = __webpack_require__(115);

var _KendoListBox2 = _interopRequireDefault(_KendoListBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoListBoxInstaller = function () {
    function KendoListBoxInstaller() {
        _classCallCheck(this, KendoListBoxInstaller);
    }

    _createClass(KendoListBoxInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoListBox2.default.name, _KendoListBox2.default);
        }
    }]);

    return KendoListBoxInstaller;
}();

exports.default = KendoListBoxInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoListBoxInstaller);
}

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ListViewInstaller = exports.KendoListViewInstaller = exports.Pager = exports.KendoPager = exports.ListView = exports.KendoListView = undefined;

var _KendoListView = __webpack_require__(116);

var _KendoListView2 = _interopRequireDefault(_KendoListView);

var _KendoPager = __webpack_require__(117);

var _KendoPager2 = _interopRequireDefault(_KendoPager);

var _kendoListviewInstaller = __webpack_require__(389);

var _kendoListviewInstaller2 = _interopRequireDefault(_kendoListviewInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoListView = _KendoListView2.default;
exports.ListView = _KendoListView2.default;
exports.KendoPager = _KendoPager2.default;
exports.Pager = _KendoPager2.default;
exports.KendoListViewInstaller = _kendoListviewInstaller2.default;
exports.ListViewInstaller = _kendoListviewInstaller2.default;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _ListViewProps = __webpack_require__(385);

var _ListViewProps2 = _interopRequireDefault(_ListViewProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _ListViewProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoListView(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoListView();
        }
    }
};

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    autoBind: {
        type: Boolean,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    editTemplate: {
        type: [String, Function],
        default: undefined
    },
    navigatable: {
        type: Boolean,
        default: undefined
    },
    selectable: {
        type: [Boolean, String],
        default: undefined
    },
    template: {
        type: [String, Function],
        default: undefined
    },
    altTemplate: {
        type: [String, Function],
        default: undefined
    },
    height: {
        type: [Number, String],
        default: undefined
    },
    scrollable: {
        type: [Boolean, String],
        default: undefined
    },

    // Events
    cancel: Function,
    change: Function,
    dataBound: {
        type: Function,
        default: undefined
    },
    dataBinding: {
        type: Function,
        default: undefined
    },
    edit: Function,
    remove: Function,
    save: Function
};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _PagerProps = __webpack_require__(387);

var _PagerProps2 = _interopRequireDefault(_PagerProps);

var _Messages = __webpack_require__(388);

var _Messages2 = _interopRequireDefault(_Messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _PagerProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _Messages2.default],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoPager(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoPager();
        }
    }
};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    autoBind: {
        type: Boolean,
        default: undefined
    },
    buttonCount: {
        type: Number,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    selectTemplate: {
        type: String,
        default: undefined
    },
    linkTemplate: {
        type: String,
        default: undefined
    },
    info: {
        type: Boolean,
        default: undefined
    },
    input: {
        type: Boolean,
        default: undefined
    },
    numeric: {
        type: Boolean,
        default: undefined
    },
    pageSizes: {
        type: [Boolean, Array],
        default: undefined
    },
    previousNext: {
        type: Boolean,
        default: undefined
    },
    refresh: {
        type: Boolean,
        default: undefined
    },
    responsive: {
        type: Boolean,
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },

    // Events
    change: Function
};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesDisplay: {
            type: String,
            default: undefined,
            kComposite: 'messages.display'
        },
        messagesEmpty: {
            type: String,
            default: undefined,
            kComposite: 'messages.empty'
        },
        messagesAllPages: {
            type: String,
            default: undefined,
            kComposite: 'messages.allPages'
        },
        messagesPage: {
            type: String,
            default: undefined,
            kComposite: 'messages.page'
        },
        messagesOf: {
            type: String,
            default: undefined,
            kComposite: 'messages.of'
        },
        messagesItemsPerPage: {
            type: String,
            default: undefined,
            kComposite: 'messages.itemsPerPage'
        },
        messagesFirst: {
            type: String,
            default: undefined,
            kComposite: 'messages.first'
        },
        messagesPrevious: {
            type: String,
            default: undefined,
            kComposite: 'messages.previous'
        },
        messagesNext: {
            type: String,
            default: undefined,
            kComposite: 'messages.next'
        },
        messagesLast: {
            type: String,
            default: undefined,
            kComposite: 'messages.last'
        },
        messagesRefresh: {
            type: String,
            default: undefined,
            kComposite: 'messages.refresh'
        }
    }
};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoListView = __webpack_require__(116);

var _KendoListView2 = _interopRequireDefault(_KendoListView);

var _KendoPager = __webpack_require__(117);

var _KendoPager2 = _interopRequireDefault(_KendoPager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoListViewInstaller = function () {
    function KendoListViewInstaller() {
        _classCallCheck(this, KendoListViewInstaller);
    }

    _createClass(KendoListViewInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoListView2.default.name, _KendoListView2.default);
            Vue.component(_KendoPager2.default.name, _KendoPager2.default);
        }
    }]);

    return KendoListViewInstaller;
}();

exports.default = KendoListViewInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoListViewInstaller);
}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapInstaller = exports.KendoMapInstaller = exports.MapLayer = exports.KendoMapLayer = exports.MapMarker = exports.KendoMapMarker = exports.Map = exports.KendoMap = undefined;

var _KendoMap = __webpack_require__(118);

var _KendoMap2 = _interopRequireDefault(_KendoMap);

var _KendoMapMarker = __webpack_require__(33);

var _KendoMapMarker2 = _interopRequireDefault(_KendoMapMarker);

var _KendoMapLayer = __webpack_require__(34);

var _KendoMapLayer2 = _interopRequireDefault(_KendoMapLayer);

var _kendoMapInstaller = __webpack_require__(398);

var _kendoMapInstaller2 = _interopRequireDefault(_kendoMapInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoMap = _KendoMap2.default;
exports.Map = _KendoMap2.default;
exports.KendoMapMarker = _KendoMapMarker2.default;
exports.MapMarker = _KendoMapMarker2.default;
exports.KendoMapLayer = _KendoMapLayer2.default;
exports.MapLayer = _KendoMapLayer2.default;
exports.KendoMapInstaller = _kendoMapInstaller2.default;
exports.MapInstaller = _kendoMapInstaller2.default;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _MapProps = __webpack_require__(392);

var _MapProps2 = _interopRequireDefault(_MapProps);

var _KendoMapMarker = __webpack_require__(33);

var _KendoMapMarker2 = _interopRequireDefault(_KendoMapMarker);

var _KendoMapLayer = __webpack_require__(34);

var _KendoMapLayer2 = _interopRequireDefault(_KendoMapLayer);

var _Controls = __webpack_require__(395);

var _Controls2 = _interopRequireDefault(_Controls);

var _LayerDefaults = __webpack_require__(396);

var _LayerDefaults2 = _interopRequireDefault(_LayerDefaults);

var _MarkerDefaults = __webpack_require__(397);

var _MarkerDefaults2 = _interopRequireDefault(_MarkerDefaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _MapProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _Controls2.default, _LayerDefaults2.default, _MarkerDefaults2.default],
    mounted: function mounted() {
        this._resolveChildren();

        kendo.jQuery(this.$el).kendoMap(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoMap();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('markers', _KendoMapMarker2.default.name);
            this.resolveChildren('layers', _KendoMapLayer2.default.name);
        }
    }
};

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    center: {
        type: Array,
        default: undefined
    },
    controls: {
        type: Object,
        default: undefined
    },
    layerDefaults: {
        type: Object,
        default: undefined
    },
    layers: {
        type: Array,
        default: undefined
    },
    markerDefaults: {
        type: Object,
        default: undefined
    },
    markers: {
        type: Array,
        default: undefined
    },
    minZoom: {
        type: Number,
        default: undefined
    },
    maxZoom: {
        type: Number,
        default: undefined
    },
    minSize: {
        type: Number,
        default: undefined
    },
    pannable: {
        type: Boolean,
        default: undefined
    },
    wraparound: {
        type: Boolean,
        default: undefined
    },
    zoom: {
        type: Number,
        default: undefined
    },
    zoomable: {
        type: Boolean,
        default: undefined
    },

    // Events
    beforeReset: {
        type: Function,
        default: undefined
    },
    click: {
        type: Function,
        default: undefined
    },
    markerActivate: {
        type: Function,
        default: undefined
    },
    markerCreated: {
        type: Function,
        default: undefined
    },
    markerClick: {
        type: Function,
        default: undefined
    },
    pan: {
        type: Function,
        default: undefined
    },
    panEnd: {
        type: Function,
        default: undefined
    },
    reset: {
        type: Function,
        default: undefined
    },
    shapeClick: {
        type: Function,
        default: undefined
    },
    shapeCreated: {
        type: Function,
        default: undefined
    },
    shapeFeatureCreated: {
        type: Function,
        default: undefined
    },
    shapeMouseEnter: {
        type: Function,
        default: undefined
    },
    shapeMouseLeave: {
        type: Function,
        default: undefined
    },
    zoomStart: {
        type: Function,
        default: undefined
    },
    zoomEnd: Function
};

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        location: {
            type: Array,
            default: undefined,
            kComposite: 'location'
        },
        shape: {
            type: String,
            default: undefined,
            kComposite: 'shape'
        },
        title: {
            type: String,
            default: undefined,
            kComposite: 'title'
        },
        tooltipAutoHide: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.autoHide'
        },
        tooltipAnimationCloseEffects: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.animation.close.effects'
        },
        tooltipAnimationCloseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.animation.close.duration'
        },
        tooltipAnimationOpenEffects: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.animation.open.effects'
        },
        tooltipAnimationOpenDuration: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.animation.open.duration'
        },
        tooltipContent: {
            type: [String, Function],
            default: undefined,
            kComposite: 'tooltip.content'
        },
        tooltipContentUrl: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.content.url'
        },
        tooltipTemplate: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.template'
        },
        tooltipCallout: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.callout'
        },
        tooltipIframe: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.iframe'
        },
        tooltipHeight: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.height'
        },
        tooltipWidth: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.width'
        },
        tooltipPosition: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.position'
        },
        tooltipShowAfter: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.showAfter'
        },
        tooltipShowOn: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.showOn'
        }
    }
};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        attribution: {
            type: String,
            default: undefined,
            kComposite: 'attribution'
        },
        autoBind: {
            type: Boolean,
            default: undefined,
            kComposite: 'autoBind'
        },
        dataSource: {
            type: [Object, Array],
            default: undefined,
            kComposite: 'dataSource'
        },
        extent: {
            type: Array,
            default: undefined,
            kComposite: 'extent'
        },
        apiKey: {
            type: String,
            default: undefined,
            kComposite: 'key'
        },
        imagerySet: {
            type: String,
            default: undefined,
            kComposite: 'imagerySet'
        },
        culture: {
            type: String,
            default: undefined,
            kComposite: 'culture'
        },
        locationField: {
            type: String,
            default: undefined,
            kComposite: 'locationField'
        },
        shape: {
            type: String,
            default: undefined,
            kComposite: 'shape'
        },
        tileSize: {
            type: Number,
            default: undefined,
            kComposite: 'tileSize'
        },
        titleField: {
            type: String,
            default: undefined,
            kComposite: 'titleField'
        },
        tooltipAutoHide: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.autoHide'
        },
        tooltipAnimationCloseEffects: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.animation.close.effects'
        },
        tooltipAnimationCloseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.animation.close.duration'
        },
        tooltipAnimationOpenEffects: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.animation.open.effects'
        },
        tooltipAnimationOpenDuration: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.animation.open.duration'
        },
        tooltipContent: {
            type: [String, Function],
            default: undefined,
            kComposite: 'tooltip.content'
        },
        tooltipContentUrl: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.content.url'
        },
        tooltipTemplate: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.template'
        },
        tooltipCallout: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.callout'
        },
        tooltipIframe: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.iframe'
        },
        tooltipHeight: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.height'
        },
        tooltipWidth: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.width'
        },
        tooltipPosition: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.position'
        },
        tooltipShowAfter: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.showAfter'
        },
        tooltipShowOn: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.showOn'
        },
        maxSize: {
            type: Number,
            default: undefined,
            kComposite: 'maxSize'
        },
        minSize: {
            type: Number,
            default: undefined,
            kComposite: 'minSize'
        },
        opacity: {
            type: Number,
            default: undefined,
            kComposite: 'opacity'
        },
        subdomains: {
            type: Array,
            default: undefined,
            kComposite: 'subdomains'
        },
        symbol: {
            type: [String, Function],
            default: undefined,
            kComposite: 'symbol'
        },
        type: {
            type: String,
            default: undefined,
            kComposite: 'type'
        },
        styleFillColor: {
            type: String,
            default: undefined,
            kComposite: 'style.fill.color'
        },
        styleFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'style.fill.opacity'
        },
        styleStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'style.stroke.color'
        },
        styleStrokeDashType: {
            type: Number,
            default: undefined,
            kComposite: 'style.stroke.dashType'
        },
        styleStrokeOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'style.stroke.opacity'
        },
        styleStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'style.stroke.width'
        },
        urlTemplate: {
            type: String,
            default: undefined,
            kComposite: 'urlTemplate'
        },
        valueField: {
            type: String,
            default: undefined,
            kComposite: 'valueField'
        },
        zIndex: {
            type: Number,
            default: undefined,
            kComposite: 'zIndex'
        }
    }
};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        controlsAttribution: {
            type: Boolean,
            default: undefined,
            kComposite: 'controls.attribution'
        },
        controlsAttributionPosition: {
            type: String,
            default: undefined,
            kComposite: 'controls.attribution.position'
        },
        controlsNavigator: {
            type: Boolean,
            default: undefined,
            kComposite: 'controls.navigator'
        },
        controlsNavigatorPosition: {
            type: String,
            default: undefined,
            kComposite: 'controls.navigator.position'
        },
        controlsZoom: {
            type: Boolean,
            default: undefined,
            kComposite: 'controls.zoom'
        },
        controlsZoomPosition: {
            type: String,
            default: undefined,
            kComposite: 'controls.zoom.position'
        }
    }
};

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        layerDefaultsMarkerShape: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.marker.shape'
        },
        layerDefaultsMarkerTooltipAutoHide: {
            type: Boolean,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.autoHide'
        },
        layerDefaultsMarkerTooltipAnimationCloseEffects: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.animation.close.effects'
        },
        layerDefaultsMarkerTooltipAnimationCloseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.animation.close.duration'
        },
        layerDefaultsMarkerTooltipAnimationOpenEffects: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.animation.open.effects'
        },
        layerDefaultsMarkerTooltipAnimationOpenDuration: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.animation.open.duration'
        },
        layerDefaultsMarkerTooltipContent: {
            type: [String, Function],
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.content'
        },
        layerDefaultsMarkerTooltipContentUrl: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.content.url'
        },
        layerDefaultsMarkerTooltipTemplate: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.template'
        },
        layerDefaultsMarkerTooltipCallout: {
            type: Boolean,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.callout'
        },
        layerDefaultsMarkerTooltipIframe: {
            type: Boolean,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.iframe'
        },
        layerDefaultsMarkerTooltipHeight: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.height'
        },
        layerDefaultsMarkerTooltipWidth: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.width'
        },
        layerDefaultsMarkerTooltipPosition: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.position'
        },
        layerDefaultsMarkerTooltipShowAfter: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.showAfter'
        },
        layerDefaultsMarkerTooltipShowOn: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.marker.tooltip.showOn'
        },
        layerDefaultsMarkerOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.marker.opacity'
        },
        layerDefaultsShapeAttribution: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.shape.attribution'
        },
        layerDefaultsShapeOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.shape.opacity'
        },
        layerDefaultsShapeStyleFillColor: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.shape.style.fill.color'
        },
        layerDefaultsShapeStyleFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.shape.style.fill.opacity'
        },
        layerDefaultsShapeStyleStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.shape.style.stroke.color'
        },
        layerDefaultsShapeStyleStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.shape.style.stroke.dashType'
        },
        layerDefaultsShapeStyleStrokeOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.shape.style.stroke.opacity'
        },
        layerDefaultsShapeStyleStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.shape.style.stroke.width'
        },
        layerDefaultsBubbleAttribution: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.bubble.attribution'
        },
        layerDefaultsBubbleOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.bubble.opacity'
        },
        layerDefaultsBubbleMaxSize: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.bubble.maxSize'
        },
        layerDefaultsBubbleMinSize: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.bubble.minSize'
        },
        layerDefaultsBubbleStyleFillColor: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.bubble.style.fill.color'
        },
        layerDefaultsBubbleStyleFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.bubble.style.fill.opacity'
        },
        layerDefaultsBubbleStyleStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.bubble.style.stroke.color'
        },
        layerDefaultsBubbleStyleStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.bubble.style.stroke.dashType'
        },
        layerDefaultsBubbleStyleStrokeOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.bubble.style.stroke.opacity'
        },
        layerDefaultsBubbleStyleStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.bubble.style.stroke.width'
        },
        layerDefaultsBubbleSymbol: {
            type: [String, Function],
            default: undefined,
            kComposite: 'layerDefaults.bubble.symbol'
        },
        layerDefaultsTileSize: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.tileSize'
        },
        layerDefaultsTileUrlTemplate: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.tile.urlTemplate'
        },
        layerDefaultsTileAttribution: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.tile.attribution'
        },
        layerDefaultsTileSubdomains: {
            type: Array,
            default: undefined,
            kComposite: 'layerDefaults.tile.subdomains'
        },
        layerDefaultsTileOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.tile.opacity'
        },
        layerDefaultsBingAttribution: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.bing.attribution'
        },
        layerDefaultsBingOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'layerDefaults.bing.opacity'
        },
        layerDefaultsBingKey: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.bing.key'
        },
        layerDefaultsBingImagerySet: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.bing.imagerySet'
        },
        layerDefaultsBingCulture: {
            type: String,
            default: undefined,
            kComposite: 'layerDefaults.bing.culture'
        }
    }
};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        markerDefaultsShape: {
            type: String,
            default: undefined,
            kComposite: 'markerDefaults.shape'
        },
        markerDefaultsTooltipAutoHide: {
            type: Boolean,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.autoHide'
        },
        markerDefaultsTooltipAnimationCloseEffects: {
            type: String,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.animation.close.effects'
        },
        markerDefaultsTooltipAnimationCloseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.animation.close.duration'
        },
        markerDefaultsTooltipAnimationOpenEffects: {
            type: String,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.animation.open.effects'
        },
        markerDefaultsTooltipAnimationOpenDuration: {
            type: Number,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.animation.open.duration'
        },
        markerDefaultsTooltipContent: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markerDefaults.tooltip.content'
        },
        markerDefaultsTooltipContentUrl: {
            type: String,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.content.url'
        },
        markerDefaultsTooltipTemplate: {
            type: String,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.template'
        },
        markerDefaultsTooltipCallout: {
            type: Boolean,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.callout'
        },
        markerDefaultsTooltipIframe: {
            type: Boolean,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.iframe'
        },
        markerDefaultsTooltipHeight: {
            type: Number,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.height'
        },
        markerDefaultsTooltipWidth: {
            type: Number,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.width'
        },
        markerDefaultsTooltipPosition: {
            type: String,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.position'
        },
        markerDefaultsTooltipShowAfter: {
            type: Number,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.showAfter'
        },
        markerDefaultsTooltipShowOn: {
            type: String,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.showOn'
        }
    }
};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoMap = __webpack_require__(118);

var _KendoMap2 = _interopRequireDefault(_KendoMap);

var _KendoMapMarker = __webpack_require__(33);

var _KendoMapMarker2 = _interopRequireDefault(_KendoMapMarker);

var _KendoMapLayer = __webpack_require__(34);

var _KendoMapLayer2 = _interopRequireDefault(_KendoMapLayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoMapInstaller = function () {
    function KendoMapInstaller() {
        _classCallCheck(this, KendoMapInstaller);
    }

    _createClass(KendoMapInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoMap2.default.name, _KendoMap2.default);
            Vue.component(_KendoMapMarker2.default.name, _KendoMapMarker2.default);
            Vue.component(_KendoMapLayer2.default.name, _KendoMapLayer2.default);
        }
    }]);

    return KendoMapInstaller;
}();

exports.default = KendoMapInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoMapInstaller);
}

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaPlayerInstaller = exports.KendoMediaPlayerInstaller = exports.MediaPlayer = exports.KendoMediaPlayer = undefined;

var _KendoMediaPlayer = __webpack_require__(119);

var _KendoMediaPlayer2 = _interopRequireDefault(_KendoMediaPlayer);

var _kendoMediaplayerInstaller = __webpack_require__(404);

var _kendoMediaplayerInstaller2 = _interopRequireDefault(_kendoMediaplayerInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoMediaPlayer = _KendoMediaPlayer2.default;
exports.MediaPlayer = _KendoMediaPlayer2.default;
exports.KendoMediaPlayerInstaller = _kendoMediaplayerInstaller2.default;
exports.MediaPlayerInstaller = _kendoMediaplayerInstaller2.default;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _MediaPlayerProps = __webpack_require__(401);

var _MediaPlayerProps2 = _interopRequireDefault(_MediaPlayerProps);

var _Media = __webpack_require__(402);

var _Media2 = _interopRequireDefault(_Media);

var _Messages = __webpack_require__(403);

var _Messages2 = _interopRequireDefault(_Messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _MediaPlayerProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _Media2.default, _Messages2.default],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoMediaPlayer(this.widgetOptions);
        if (this.v3) {
            this.ready();
        }
        this.$emit('kendowidgetready', this.kendoWidget());
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoMediaPlayer();
        }
    }
};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    autoPlay: {
        type: Boolean,
        default: undefined
    },
    autoRepeat: {
        type: Boolean,
        default: undefined
    },
    forwardSeek: {
        type: Boolean,
        default: undefined
    },
    fullScreen: {
        type: Boolean,
        default: undefined
    },
    media: {
        type: Object,
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    mute: {
        type: Boolean,
        default: undefined
    },
    navigatable: {
        type: Boolean,
        default: undefined
    },
    volume: {
        type: Number,
        default: undefined
    },

    // Events
    end: Function,
    pause: Function,
    play: Function,
    kendoReady: {
        type: Function,
        default: undefined
    },
    timeChange: {
        type: Function,
        default: undefined
    },
    volumeChange: Function
};

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        mediaSource: {
            type: String,
            default: undefined,
            kComposite: 'media.source'
        },
        mediaTitle: {
            type: String,
            default: undefined,
            kComposite: 'media.title'
        }
    }
};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesPause: {
            type: String,
            default: undefined,
            kComposite: 'messages.pause'
        },
        messagesPlay: {
            type: String,
            default: undefined,
            kComposite: 'messages.play'
        },
        messagesMute: {
            type: String,
            default: undefined,
            kComposite: 'messages.mute'
        },
        messagesUnmute: {
            type: String,
            default: undefined,
            kComposite: 'messages.unmute'
        },
        messagesQuality: {
            type: String,
            default: undefined,
            kComposite: 'messages.quality'
        },
        messagesFullscreen: {
            type: String,
            default: undefined,
            kComposite: 'messages.fullscreen'
        }
    }
};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoMediaPlayer = __webpack_require__(119);

var _KendoMediaPlayer2 = _interopRequireDefault(_KendoMediaPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoMediaPlayerInstaller = function () {
    function KendoMediaPlayerInstaller() {
        _classCallCheck(this, KendoMediaPlayerInstaller);
    }

    _createClass(KendoMediaPlayerInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoMediaPlayer2.default.name, _KendoMediaPlayer2.default);
        }
    }]);

    return KendoMediaPlayerInstaller;
}();

exports.default = KendoMediaPlayerInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoMediaPlayerInstaller);
}

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PivotGridInstaller = exports.KendoPivotGridInstaller = exports.PivotConfigurator = exports.KendoPivotConfigurator = exports.PivotGrid = exports.KendoPivotGrid = undefined;

var _KendoPivotGrid = __webpack_require__(120);

var _KendoPivotGrid2 = _interopRequireDefault(_KendoPivotGrid);

var _KendoPivotConfigurator = __webpack_require__(122);

var _KendoPivotConfigurator2 = _interopRequireDefault(_KendoPivotConfigurator);

var _kendoPivotgridInstaller = __webpack_require__(414);

var _kendoPivotgridInstaller2 = _interopRequireDefault(_kendoPivotgridInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoPivotGrid = _KendoPivotGrid2.default;
exports.PivotGrid = _KendoPivotGrid2.default;
exports.KendoPivotConfigurator = _KendoPivotConfigurator2.default;
exports.PivotConfigurator = _KendoPivotConfigurator2.default;
exports.KendoPivotGridInstaller = _kendoPivotgridInstaller2.default;
exports.PivotGridInstaller = _kendoPivotgridInstaller2.default;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _PivotGridProps = __webpack_require__(407);

var _PivotGridProps2 = _interopRequireDefault(_PivotGridProps);

var _Excel = __webpack_require__(408);

var _Excel2 = _interopRequireDefault(_Excel);

var _Messages = __webpack_require__(409);

var _Messages2 = _interopRequireDefault(_Messages);

var _Pdf = __webpack_require__(410);

var _Pdf2 = _interopRequireDefault(_Pdf);

var _Sortable = __webpack_require__(121);

var _Sortable2 = _interopRequireDefault(_Sortable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _PivotGridProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _Excel2.default, _Messages2.default, _Pdf2.default, _Sortable2.default],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoPivotGrid(this.widgetOptions);
        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoPivotGrid();
        }
    }
};

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dataSource: {
        type: Object,
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    reorderable: {
        type: Boolean,
        default: undefined
    },
    excel: {
        type: Object,
        default: undefined
    },
    pdf: {
        type: Object,
        default: undefined
    },
    filterable: {
        type: Boolean,
        default: undefined
    },
    sortable: {
        type: [Boolean, Object],
        default: undefined
    },
    columnWidth: {
        type: Number,
        default: undefined
    },
    height: {
        type: [Number, String],
        default: undefined
    },
    columnHeaderTemplate: {
        type: [String, Function],
        default: undefined
    },
    dataCellTemplate: {
        type: [String, Function],
        default: undefined
    },
    kpiStatusTemplate: {
        type: [String, Function],
        default: undefined
    },
    kpiTrendTemplate: {
        type: [String, Function],
        default: undefined
    },
    rowHeaderTemplate: {
        type: [String, Function],
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },

    // Events
    dataBinding: {
        type: Function,
        default: undefined
    },
    dataBound: {
        type: Function,
        default: undefined
    },
    expandMember: {
        type: Function,
        default: undefined
    },
    collapseMember: {
        type: Function,
        default: undefined
    },
    excelExport: {
        type: Function,
        default: undefined
    },
    pdfExport: Function
};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        excelFileName: {
            type: String,
            default: undefined,
            kComposite: 'excel.fileName'
        },
        excelFilterable: {
            type: Boolean,
            default: undefined,
            kComposite: 'excel.filterable'
        },
        excelForceProxy: {
            type: Boolean,
            default: undefined,
            kComposite: 'excel.forceProxy'
        },
        excelProxyURL: {
            type: String,
            default: undefined,
            kComposite: 'excel.proxyURL'
        }
    }
};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesMeasureFields: {
            type: String,
            default: undefined,
            kComposite: 'messages.measureFields'
        },
        messagesColumnFields: {
            type: String,
            default: undefined,
            kComposite: 'messages.columnFields'
        },
        messagesRowFields: {
            type: String,
            default: undefined,
            kComposite: 'messages.rowFields'
        },
        messagesFieldMenuInfo: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.info'
        },
        messagesFieldMenuSortAscending: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.sortAscending'
        },
        messagesFieldMenuSortDescending: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.sortDescending'
        },
        messagesFieldMenuFilterFields: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.filterFields'
        },
        messagesFieldMenuFilter: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.filter'
        },
        messagesFieldMenuInclude: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.include'
        },
        messagesFieldMenuTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.title'
        },
        messagesFieldMenuClear: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.clear'
        },
        messagesFieldMenuOk: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.ok'
        },
        messagesFieldMenuCancel: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.cancel'
        },
        messagesFieldMenuOperatorsContains: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.contains'
        },
        messagesFieldMenuOperatorsDoesnotcontain: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.doesnotcontain'
        },
        messagesFieldMenuOperatorsStartswith: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.startswith'
        },
        messagesFieldMenuOperatorsEndswith: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.endswith'
        },
        messagesFieldMenuOperatorsEq: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.eq'
        },
        messagesFieldMenuOperatorsNeq: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.neq'
        }
    }
};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        pdfAuthor: {
            type: String,
            default: undefined,
            kComposite: 'pdf.author'
        },
        pdfAvoidLinks: {
            type: [Boolean, String],
            default: undefined,
            kComposite: 'pdf.avoidLinks'
        },
        pdfCreator: {
            type: String,
            default: undefined,
            kComposite: 'pdf.creator'
        },
        pdfDate: {
            type: Date,
            default: undefined,
            kComposite: 'pdf.date'
        },
        pdfFileName: {
            type: String,
            default: undefined,
            kComposite: 'pdf.fileName'
        },
        pdfForceProxy: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.forceProxy'
        },
        pdfKeywords: {
            type: String,
            default: undefined,
            kComposite: 'pdf.keywords'
        },
        pdfLandscape: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.landscape'
        },
        pdfMarginBottom: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.bottom'
        },
        pdfMarginLeft: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.left'
        },
        pdfMarginRight: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.right'
        },
        pdfMarginTop: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.top'
        },
        pdfPaperSize: {
            type: [String, Array],
            default: undefined,
            kComposite: 'pdf.paperSize'
        },
        pdfProxyURL: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyURL'
        },
        pdfProxyTarget: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyTarget'
        },
        pdfSubject: {
            type: String,
            default: undefined,
            kComposite: 'pdf.subject'
        },
        pdfTitle: {
            type: String,
            default: undefined,
            kComposite: 'pdf.title'
        }
    }
};

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _PivotConfiguratorProps = __webpack_require__(412);

var _PivotConfiguratorProps2 = _interopRequireDefault(_PivotConfiguratorProps);

var _Messages = __webpack_require__(413);

var _Messages2 = _interopRequireDefault(_Messages);

var _Sortable = __webpack_require__(121);

var _Sortable2 = _interopRequireDefault(_Sortable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _PivotConfiguratorProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _Messages2.default, _Sortable2.default],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoPivotConfigurator(this.widgetOptions);
        if (this.v3) {
            this.ready();
        }
        this.$emit('kendowidgetready', this.kendoWidget());
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoPivotConfigurator();
        }
    }
};

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dataSource: {
        type: Object,
        default: undefined
    },
    filterable: {
        type: Boolean,
        default: undefined
    },
    sortable: {
        type: [Boolean, Object],
        default: undefined
    },
    height: {
        type: [Number, String],
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined

        // Events
    } };

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesMeasures: {
            type: String,
            default: undefined,
            kComposite: 'messages.measures'
        },
        messagesColumns: {
            type: String,
            default: undefined,
            kComposite: 'messages.columns'
        },
        messagesRows: {
            type: String,
            default: undefined,
            kComposite: 'messages.rows'
        },
        messagesMeasuresLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.measuresLabel'
        },
        messagesRowsLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.rowsLabel'
        },
        messagesColumnsLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.columnsLabel'
        },
        messagesFieldsLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldsLabel'
        },
        messagesFieldMenuInfo: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.info'
        },
        messagesFieldMenuSortAscending: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.sortAscending'
        },
        messagesFieldMenuSortDescending: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.sortDescending'
        },
        messagesFieldMenuFilterFields: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.filterFields'
        },
        messagesFieldMenuFilter: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.filter'
        },
        messagesFieldMenuInclude: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.include'
        },
        messagesFieldMenuTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.title'
        },
        messagesFieldMenuClear: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.clear'
        },
        messagesFieldMenuOk: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.ok'
        },
        messagesFieldMenuCancel: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.cancel'
        },
        messagesFieldMenuOperatorsContains: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.contains'
        },
        messagesFieldMenuOperatorsDoesnotcontain: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.doesnotcontain'
        },
        messagesFieldMenuOperatorsStartswith: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.startswith'
        },
        messagesFieldMenuOperatorsEndswith: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.endswith'
        },
        messagesFieldMenuOperatorsEq: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.eq'
        },
        messagesFieldMenuOperatorsNeq: {
            type: String,
            default: undefined,
            kComposite: 'messages.fieldMenu.operators.neq'
        }
    }
};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoPivotGrid = __webpack_require__(120);

var _KendoPivotGrid2 = _interopRequireDefault(_KendoPivotGrid);

var _KendoPivotConfigurator = __webpack_require__(122);

var _KendoPivotConfigurator2 = _interopRequireDefault(_KendoPivotConfigurator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoPivotGridInstaller = function () {
    function KendoPivotGridInstaller() {
        _classCallCheck(this, KendoPivotGridInstaller);
    }

    _createClass(KendoPivotGridInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoPivotGrid2.default.name, _KendoPivotGrid2.default);
            Vue.component(_KendoPivotConfigurator2.default.name, _KendoPivotConfigurator2.default);
        }
    }]);

    return KendoPivotGridInstaller;
}();

exports.default = KendoPivotGridInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoPivotGridInstaller);
}

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopupsInstaller = exports.KendoPopupsInstaller = exports.Tooltip = exports.KendoTooltip = exports.Notification = exports.KendoNotification = undefined;

var _KendoNotification = __webpack_require__(123);

var _KendoNotification2 = _interopRequireDefault(_KendoNotification);

var _KendoTooltip = __webpack_require__(125);

var _KendoTooltip2 = _interopRequireDefault(_KendoTooltip);

var _kendoPopupsInstaller = __webpack_require__(423);

var _kendoPopupsInstaller2 = _interopRequireDefault(_kendoPopupsInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoNotification = _KendoNotification2.default;
exports.Notification = _KendoNotification2.default;
exports.KendoTooltip = _KendoTooltip2.default;
exports.Tooltip = _KendoTooltip2.default;
exports.KendoPopupsInstaller = _kendoPopupsInstaller2.default;
exports.PopupsInstaller = _kendoPopupsInstaller2.default;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _NotificationProps = __webpack_require__(417);

var _NotificationProps2 = _interopRequireDefault(_NotificationProps);

var _Position = __webpack_require__(418);

var _Position2 = _interopRequireDefault(_Position);

var _Templates = __webpack_require__(419);

var _Templates2 = _interopRequireDefault(_Templates);

var _Animation = __webpack_require__(124);

var _Animation2 = _interopRequireDefault(_Animation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _NotificationProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _Position2.default, _Templates2.default, _Animation2.default],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoNotification(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoNotification();
        }
    }
};

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    allowHideAfter: {
        type: Number,
        default: undefined
    },
    animation: {
        type: [Object, Boolean],
        default: undefined
    },
    appendTo: {
        type: [String, Object],
        default: undefined
    },
    autoHideAfter: {
        type: Number,
        default: undefined
    },
    button: {
        type: Boolean,
        default: undefined
    },
    height: {
        type: [Number, String],
        default: undefined
    },
    hideOnClick: {
        type: Boolean,
        default: undefined
    },
    position: {
        type: Object,
        default: undefined
    },
    stacking: {
        type: String,
        default: undefined
    },
    templates: {
        type: Array,
        default: undefined
    },
    width: {
        type: [Number, String],
        default: undefined
    },

    // Events
    hide: Function,
    show: Function
};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        positionBottom: {
            type: Number,
            default: undefined,
            kComposite: 'position.bottom'
        },
        positionLeft: {
            type: Number,
            default: undefined,
            kComposite: 'position.left'
        },
        positionPinned: {
            type: Boolean,
            default: undefined,
            kComposite: 'position.pinned'
        },
        positionRight: {
            type: Number,
            default: undefined,
            kComposite: 'position.right'
        },
        positionTop: {
            type: Number,
            default: undefined,
            kComposite: 'position.top'
        }
    }
};

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        templatesTemplateType: {
            type: String,
            default: undefined,
            kComposite: 'templates.template.type'
        },
        templatesTemplateTemplate: {
            type: String,
            default: undefined,
            kComposite: 'templates.template.template'
        }
    }
};

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _TooltipProps = __webpack_require__(421);

var _TooltipProps2 = _interopRequireDefault(_TooltipProps);

var _Animation = __webpack_require__(124);

var _Animation2 = _interopRequireDefault(_Animation);

var _Content = __webpack_require__(422);

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _TooltipProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _Animation2.default, _Content2.default],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoTooltip(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoTooltip();
        }
    }
};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    autoHide: {
        type: Boolean,
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    content: {
        type: [String, Function, Object],
        default: undefined
    },
    callout: {
        type: Boolean,
        default: undefined
    },
    filter: {
        type: String,
        default: undefined
    },
    iframe: {
        type: Boolean,
        default: undefined
    },
    height: {
        type: Number,
        default: undefined
    },
    width: {
        type: Number,
        default: undefined
    },
    position: {
        type: String,
        default: undefined
    },
    showAfter: {
        type: Number,
        default: undefined
    },
    showOn: {
        type: String,
        default: undefined
    },
    hideAfter: {
        type: Number,
        default: undefined
    },
    offset: {
        type: Number,
        default: undefined
    },

    // Events
    contentLoad: {
        type: Function,
        default: undefined
    },
    show: Function,
    hide: Function,
    requestStart: {
        type: Function,
        default: undefined
    },
    error: Function
};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        contentUrl: {
            type: String,
            default: undefined,
            kComposite: 'content.url'
        }
    }
};

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoNotification = __webpack_require__(123);

var _KendoNotification2 = _interopRequireDefault(_KendoNotification);

var _KendoTooltip = __webpack_require__(125);

var _KendoTooltip2 = _interopRequireDefault(_KendoTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoPopupsInstaller = function () {
    function KendoPopupsInstaller() {
        _classCallCheck(this, KendoPopupsInstaller);
    }

    _createClass(KendoPopupsInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoNotification2.default.name, _KendoNotification2.default);
            Vue.component(_KendoTooltip2.default.name, _KendoTooltip2.default);
        }
    }]);

    return KendoPopupsInstaller;
}();

exports.default = KendoPopupsInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoPopupsInstaller);
}

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SchedulerInstaller = exports.KendoSchedulerInstaller = exports.SchedulerView = exports.KendoSchedulerView = exports.SchedulerResource = exports.KendoSchedulerResource = exports.Scheduler = exports.KendoScheduler = undefined;

var _KendoScheduler = __webpack_require__(126);

var _KendoScheduler2 = _interopRequireDefault(_KendoScheduler);

var _KendoSchedulerResource = __webpack_require__(35);

var _KendoSchedulerResource2 = _interopRequireDefault(_KendoSchedulerResource);

var _KendoSchedulerView = __webpack_require__(36);

var _KendoSchedulerView2 = _interopRequireDefault(_KendoSchedulerView);

var _kendoSchedulerInstaller = __webpack_require__(436);

var _kendoSchedulerInstaller2 = _interopRequireDefault(_kendoSchedulerInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoScheduler = _KendoScheduler2.default;
exports.Scheduler = _KendoScheduler2.default;
exports.KendoSchedulerResource = _KendoSchedulerResource2.default;
exports.SchedulerResource = _KendoSchedulerResource2.default;
exports.KendoSchedulerView = _KendoSchedulerView2.default;
exports.SchedulerView = _KendoSchedulerView2.default;
exports.KendoSchedulerInstaller = _kendoSchedulerInstaller2.default;
exports.SchedulerInstaller = _kendoSchedulerInstaller2.default;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _SchedulerProps = __webpack_require__(426);

var _SchedulerProps2 = _interopRequireDefault(_SchedulerProps);

var _KendoSchedulerResource = __webpack_require__(35);

var _KendoSchedulerResource2 = _interopRequireDefault(_KendoSchedulerResource);

var _KendoSchedulerView = __webpack_require__(36);

var _KendoSchedulerView2 = _interopRequireDefault(_KendoSchedulerView);

var _CurrentTimeMarker = __webpack_require__(429);

var _CurrentTimeMarker2 = _interopRequireDefault(_CurrentTimeMarker);

var _Editable = __webpack_require__(430);

var _Editable2 = _interopRequireDefault(_Editable);

var _Footer = __webpack_require__(431);

var _Footer2 = _interopRequireDefault(_Footer);

var _Group = __webpack_require__(432);

var _Group2 = _interopRequireDefault(_Group);

var _Messages = __webpack_require__(433);

var _Messages2 = _interopRequireDefault(_Messages);

var _Pdf = __webpack_require__(434);

var _Pdf2 = _interopRequireDefault(_Pdf);

var _Toolbar = __webpack_require__(435);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _SchedulerProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _CurrentTimeMarker2.default, _Editable2.default, _Footer2.default, _Group2.default, _Messages2.default, _Pdf2.default, _Toolbar2.default],
    mounted: function mounted() {
        this._resolveChildren();

        kendo.jQuery(this.$el).kendoScheduler(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoScheduler();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('resources', _KendoSchedulerResource2.default.name);
            this.resolveChildren('views', _KendoSchedulerView2.default.name);
        }
    }
};

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    allDayEventTemplate: {
        type: [String, Function],
        default: undefined
    },
    allDaySlot: {
        type: Boolean,
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    currentTimeMarker: {
        type: [Boolean, Object],
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    date: {
        type: Date,
        default: undefined
    },
    dateHeaderTemplate: {
        type: [String, Function],
        default: undefined
    },
    editable: {
        type: [Boolean, Object],
        default: undefined
    },
    endTime: {
        type: Date,
        default: undefined
    },
    eventTemplate: {
        type: [String, Function],
        default: undefined
    },
    footer: {
        type: [Boolean, Object],
        default: undefined
    },
    group: {
        type: Object,
        default: undefined
    },
    groupHeaderTemplate: {
        type: [String, Function],
        default: undefined
    },
    height: {
        type: [Number, String],
        default: undefined
    },
    majorTick: {
        type: Number,
        default: undefined
    },
    majorTimeHeaderTemplate: {
        type: [String, Function],
        default: undefined
    },
    max: {
        type: Date,
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    min: {
        type: Date,
        default: undefined
    },
    minorTickCount: {
        type: Number,
        default: undefined
    },
    minorTimeHeaderTemplate: {
        type: [String, Function],
        default: undefined
    },
    mobile: {
        type: [Boolean, String],
        default: undefined
    },
    pdf: {
        type: Object,
        default: undefined
    },
    resources: {
        type: Array,
        default: undefined
    },
    selectable: {
        type: Boolean,
        default: undefined
    },
    showWorkHours: {
        type: Boolean,
        default: undefined
    },
    snap: Boolean,
    startTime: {
        type: Date,
        default: undefined
    },
    timezone: {
        type: String,
        default: undefined
    },
    toolbar: {
        type: Array,
        default: undefined
    },
    views: {
        type: Array,
        default: undefined
    },
    width: {
        type: [Number, String],
        default: undefined
    },
    workDayStart: {
        type: Date,
        default: undefined
    },
    workDayEnd: {
        type: Date,
        default: undefined
    },
    workWeekStart: {
        type: Number,
        default: undefined
    },
    workWeekEnd: {
        type: Number,
        default: undefined
    },

    // Events
    add: {
        type: Function,
        default: undefined
    },
    cancel: {
        type: Function,
        default: undefined
    },
    change: {
        type: Function,
        default: undefined
    },
    dataBinding: {
        type: Function,
        default: undefined
    },
    dataBound: {
        type: Function,
        default: undefined
    },
    edit: {
        type: Function,
        default: undefined
    },
    moveStart: {
        type: Function,
        default: undefined
    },
    move: {
        type: Function,
        default: undefined
    },
    moveEnd: {
        type: Function,
        default: undefined
    },
    navigate: {
        type: Function,
        default: undefined
    },
    pdfExport: {
        type: Function,
        default: undefined
    },
    remove: {
        type: Function,
        default: undefined
    },
    resizeStart: {
        type: Function,
        default: undefined
    },
    resize: {
        type: Function,
        default: undefined
    },
    resizeEnd: {
        type: Function,
        default: undefined
    },
    save: Function
};

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        dataColorField: {
            type: String,
            default: undefined,
            kComposite: 'dataColorField'
        },
        dataSource: {
            type: [Object, Array],
            default: undefined,
            kComposite: 'dataSource'
        },
        dataSourceRef: {
            type: String,
            default: undefined,
            kComposite: 'dataSourceRef'
        },
        dataTextField: {
            type: String,
            default: undefined,
            kComposite: 'dataTextField'
        },
        dataValueField: {
            type: String,
            default: undefined,
            kComposite: 'dataValueField'
        },
        field: {
            type: String,
            default: undefined,
            kComposite: 'field'
        },
        multiple: {
            type: Boolean,
            default: undefined,
            kComposite: 'multiple'
        },
        name: {
            type: String,
            default: undefined,
            kComposite: 'name'
        },
        title: {
            type: String,
            default: undefined,
            kComposite: 'title'
        },
        valuePrimitive: {
            type: Boolean,
            default: undefined,
            kComposite: 'valuePrimitive'
        }
    }
};

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        adaptiveSlotHeight: {
            type: Boolean,
            default: undefined,
            kComposite: 'adaptiveSlotHeight'
        },
        allDayEventTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'allDayEventTemplate'
        },
        allDaySlot: {
            type: Boolean,
            default: undefined,
            kComposite: 'allDaySlot'
        },
        allDaySlotTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'allDaySlotTemplate'
        },
        columnWidth: {
            type: Number,
            default: undefined,
            kComposite: 'columnWidth'
        },
        dateHeaderTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'dateHeaderTemplate'
        },
        dayTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'dayTemplate'
        },
        editable: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable'
        },
        editableCreate: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.create'
        },
        editableDestroy: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.destroy'
        },
        editableUpdate: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.update'
        },
        endTime: {
            type: Date,
            default: undefined,
            kComposite: 'endTime'
        },
        eventHeight: {
            type: [String, Number],
            default: undefined,
            kComposite: 'eventHeight'
        },
        eventSpacing: {
            type: Number,
            default: undefined,
            kComposite: 'eventSpacing'
        },
        eventsPerDay: {
            type: Number,
            default: undefined,
            kComposite: 'eventsPerDay'
        },
        eventTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'eventTemplate'
        },
        eventTimeTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'eventTimeTemplate'
        },
        groupDate: {
            type: Boolean,
            default: undefined,
            kComposite: 'group.date'
        },
        groupOrientation: {
            type: String,
            default: undefined,
            kComposite: 'group.orientation'
        },
        majorTick: {
            type: Number,
            default: undefined,
            kComposite: 'majorTick'
        },
        majorTimeHeaderTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'majorTimeHeaderTemplate'
        },
        minorTickCount: {
            type: Number,
            default: undefined,
            kComposite: 'minorTickCount'
        },
        minorTimeHeaderTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'minorTimeHeaderTemplate'
        },
        selected: {
            type: Boolean,
            default: undefined,
            kComposite: 'selected'
        },
        selectedDateFormat: {
            type: String,
            default: undefined,
            kComposite: 'selectedDateFormat'
        },
        selectedShortDateFormat: {
            type: String,
            default: undefined,
            kComposite: 'selectedShortDateFormat'
        },
        showWorkHours: {
            type: Boolean,
            default: undefined,
            kComposite: 'showWorkHours'
        },
        slotTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'slotTemplate'
        },
        startTime: {
            type: Date,
            default: undefined,
            kComposite: 'startTime'
        },
        title: {
            type: String,
            default: undefined,
            kComposite: 'title'
        },
        type: {
            type: String,
            default: undefined,
            kComposite: 'type'
        },
        virtual: {
            type: Boolean,
            default: undefined,
            kComposite: 'virtual'
        },
        workWeekStart: {
            type: Number,
            default: undefined,
            kComposite: 'workWeekStart'
        },
        workWeekEnd: {
            type: Number,
            default: undefined,
            kComposite: 'workWeekEnd'
        }
    }
};

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        currentTimeMarkerUpdateInterval: {
            type: Number,
            default: undefined,
            kComposite: 'currentTimeMarker.updateInterval'
        },
        currentTimeMarkerUseLocalTimezone: {
            type: Boolean,
            default: undefined,
            kComposite: 'currentTimeMarker.useLocalTimezone'
        }
    }
};

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        editableConfirmation: {
            type: [Boolean, String],
            default: undefined,
            kComposite: 'editable.confirmation'
        },
        editableCreate: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.create'
        },
        editableDestroy: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.destroy'
        },
        editableEditRecurringMode: {
            type: String,
            default: undefined,
            kComposite: 'editable.editRecurringMode'
        },
        editableMove: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.move'
        },
        editableResize: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.resize'
        },
        editableTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'editable.template'
        },
        editableUpdate: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.update'
        },
        editableWindow: {
            type: Object,
            default: undefined,
            kComposite: 'editable.window'
        }
    }
};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        footerCommand: {
            type: [String, Boolean],
            default: undefined,
            kComposite: 'footer.command'
        }
    }
};

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        groupDate: {
            type: Boolean,
            default: undefined,
            kComposite: 'group.date'
        },
        groupResources: {
            type: Array,
            default: undefined,
            kComposite: 'group.resources'
        },
        groupOrientation: {
            type: String,
            default: undefined,
            kComposite: 'group.orientation'
        }
    }
};

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesAllDay: {
            type: String,
            default: undefined,
            kComposite: 'messages.allDay'
        },
        messagesAriaEventLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.ariaEventLabel'
        },
        messagesAriaSlotLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.ariaSlotLabel'
        },
        messagesCancel: {
            type: String,
            default: undefined,
            kComposite: 'messages.cancel'
        },
        messagesDate: {
            type: String,
            default: undefined,
            kComposite: 'messages.date'
        },
        messagesDeleteWindowTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.deleteWindowTitle'
        },
        messagesDestroy: {
            type: String,
            default: undefined,
            kComposite: 'messages.destroy'
        },
        messagesEvent: {
            type: String,
            default: undefined,
            kComposite: 'messages.event'
        },
        messagesDefaultRowText: {
            type: String,
            default: undefined,
            kComposite: 'messages.defaultRowText'
        },
        messagesNext: {
            type: String,
            default: undefined,
            kComposite: 'messages.next'
        },
        messagesPdf: {
            type: String,
            default: undefined,
            kComposite: 'messages.pdf'
        },
        messagesPrevious: {
            type: String,
            default: undefined,
            kComposite: 'messages.previous'
        },
        messagesSave: {
            type: String,
            default: undefined,
            kComposite: 'messages.save'
        },
        messagesShowFullDay: {
            type: String,
            default: undefined,
            kComposite: 'messages.showFullDay'
        },
        messagesShowWorkDay: {
            type: String,
            default: undefined,
            kComposite: 'messages.showWorkDay'
        },
        messagesTime: {
            type: String,
            default: undefined,
            kComposite: 'messages.time'
        },
        messagesToday: {
            type: String,
            default: undefined,
            kComposite: 'messages.today'
        },
        messagesEditableConfirmation: {
            type: String,
            default: undefined,
            kComposite: 'messages.editable.confirmation'
        },
        messagesEditorAllDayEvent: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.allDayEvent'
        },
        messagesEditorDescription: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.description'
        },
        messagesEditorEditorTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.editorTitle'
        },
        messagesEditorEnd: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.end'
        },
        messagesEditorEndTimezone: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.endTimezone'
        },
        messagesEditorRepeat: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.repeat'
        },
        messagesEditorSeparateTimezones: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.separateTimezones'
        },
        messagesEditorStart: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.start'
        },
        messagesEditorStartTimezone: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.startTimezone'
        },
        messagesEditorTimezone: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.timezone'
        },
        messagesEditorTimezoneEditorButton: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.timezoneEditorButton'
        },
        messagesEditorTimezoneEditorTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.timezoneEditorTitle'
        },
        messagesEditorTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.title'
        },
        messagesRecurrenceEditorDailyInterval: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.daily.interval'
        },
        messagesRecurrenceEditorDailyRepeatEvery: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.daily.repeatEvery'
        },
        messagesRecurrenceEditorEndAfter: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.end.after'
        },
        messagesRecurrenceEditorEndOccurrence: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.end.occurrence'
        },
        messagesRecurrenceEditorEndLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.end.label'
        },
        messagesRecurrenceEditorEndNever: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.end.never'
        },
        messagesRecurrenceEditorEndMobileLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.end.mobileLabel'
        },
        messagesRecurrenceEditorEndOn: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.end.on'
        },
        messagesRecurrenceEditorFrequenciesDaily: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.frequencies.daily'
        },
        messagesRecurrenceEditorFrequenciesMonthly: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.frequencies.monthly'
        },
        messagesRecurrenceEditorFrequenciesNever: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.frequencies.never'
        },
        messagesRecurrenceEditorFrequenciesWeekly: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.frequencies.weekly'
        },
        messagesRecurrenceEditorFrequenciesYearly: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.frequencies.yearly'
        },
        messagesRecurrenceEditorMonthlyDay: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.monthly.day'
        },
        messagesRecurrenceEditorMonthlyInterval: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.monthly.interval'
        },
        messagesRecurrenceEditorMonthlyRepeatEvery: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.monthly.repeatEvery'
        },
        messagesRecurrenceEditorMonthlyRepeatOn: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.monthly.repeatOn'
        },
        messagesRecurrenceEditorOffsetPositionsFirst: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.offsetPositions.first'
        },
        messagesRecurrenceEditorOffsetPositionsSecond: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.offsetPositions.second'
        },
        messagesRecurrenceEditorOffsetPositionsThird: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.offsetPositions.third'
        },
        messagesRecurrenceEditorOffsetPositionsFourth: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.offsetPositions.fourth'
        },
        messagesRecurrenceEditorOffsetPositionsLast: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.offsetPositions.last'
        },
        messagesRecurrenceEditorRecurrenceEditorTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.recurrenceEditorTitle'
        },
        messagesRecurrenceEditorWeeklyInterval: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.weekly.interval'
        },
        messagesRecurrenceEditorWeeklyRepeatEvery: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.weekly.repeatEvery'
        },
        messagesRecurrenceEditorWeeklyRepeatOn: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.weekly.repeatOn'
        },
        messagesRecurrenceEditorWeekdaysDay: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.weekdays.day'
        },
        messagesRecurrenceEditorWeekdaysWeekday: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.weekdays.weekday'
        },
        messagesRecurrenceEditorWeekdaysWeekend: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.weekdays.weekend'
        },
        messagesRecurrenceEditorYearlyOf: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.yearly.of'
        },
        messagesRecurrenceEditorYearlyRepeatEvery: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.yearly.repeatEvery'
        },
        messagesRecurrenceEditorYearlyRepeatOn: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.yearly.repeatOn'
        },
        messagesRecurrenceEditorYearlyInterval: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceEditor.yearly.interval'
        },
        messagesRecurrenceMessagesDeleteRecurring: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceMessages.deleteRecurring'
        },
        messagesRecurrenceMessagesDeleteWindowOccurrence: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceMessages.deleteWindowOccurrence'
        },
        messagesRecurrenceMessagesDeleteWindowSeries: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceMessages.deleteWindowSeries'
        },
        messagesRecurrenceMessagesDeleteWindowTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceMessages.deleteWindowTitle'
        },
        messagesRecurrenceMessagesEditRecurring: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceMessages.editRecurring'
        },
        messagesRecurrenceMessagesEditWindowOccurrence: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceMessages.editWindowOccurrence'
        },
        messagesRecurrenceMessagesEditWindowSeries: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceMessages.editWindowSeries'
        },
        messagesRecurrenceMessagesEditWindowTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.recurrenceMessages.editWindowTitle'
        },
        messagesViewsDay: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.day'
        },
        messagesViewsWeek: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.week'
        },
        messagesViewsMonth: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.month'
        },
        messagesViewsAgenda: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.agenda'
        }
    }
};

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        pdfAuthor: {
            type: String,
            default: undefined,
            kComposite: 'pdf.author'
        },
        pdfAvoidLinks: {
            type: [Boolean, String],
            default: undefined,
            kComposite: 'pdf.avoidLinks'
        },
        pdfCreator: {
            type: String,
            default: undefined,
            kComposite: 'pdf.creator'
        },
        pdfDate: {
            type: Date,
            default: undefined,
            kComposite: 'pdf.date'
        },
        pdfFileName: {
            type: String,
            default: undefined,
            kComposite: 'pdf.fileName'
        },
        pdfForceProxy: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.forceProxy'
        },
        pdfKeywords: {
            type: String,
            default: undefined,
            kComposite: 'pdf.keywords'
        },
        pdfLandscape: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.landscape'
        },
        pdfMarginBottom: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.bottom'
        },
        pdfMarginLeft: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.left'
        },
        pdfMarginRight: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.right'
        },
        pdfMarginTop: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.top'
        },
        pdfPaperSize: {
            type: [String, Array],
            default: undefined,
            kComposite: 'pdf.paperSize'
        },
        pdfProxyURL: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyURL'
        },
        pdfProxyTarget: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyTarget'
        },
        pdfSubject: {
            type: String,
            default: undefined,
            kComposite: 'pdf.subject'
        },
        pdfTitle: {
            type: String,
            default: undefined,
            kComposite: 'pdf.title'
        }
    }
};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        toolbarToolbarItemName: {
            type: String,
            default: undefined,
            kComposite: 'toolbar.toolbarItem.name'
        }
    }
};

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoScheduler = __webpack_require__(126);

var _KendoScheduler2 = _interopRequireDefault(_KendoScheduler);

var _KendoSchedulerResource = __webpack_require__(35);

var _KendoSchedulerResource2 = _interopRequireDefault(_KendoSchedulerResource);

var _KendoSchedulerView = __webpack_require__(36);

var _KendoSchedulerView2 = _interopRequireDefault(_KendoSchedulerView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoSchedulerInstaller = function () {
    function KendoSchedulerInstaller() {
        _classCallCheck(this, KendoSchedulerInstaller);
    }

    _createClass(KendoSchedulerInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoScheduler2.default.name, _KendoScheduler2.default);
            Vue.component(_KendoSchedulerResource2.default.name, _KendoSchedulerResource2.default);
            Vue.component(_KendoSchedulerView2.default.name, _KendoSchedulerView2.default);
        }
    }]);

    return KendoSchedulerInstaller;
}();

exports.default = KendoSchedulerInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoSchedulerInstaller);
}

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollViewInstaller = exports.KendoScrollViewInstaller = exports.ScrollView = exports.KendoScrollView = undefined;

var _KendoScrollView = __webpack_require__(127);

var _KendoScrollView2 = _interopRequireDefault(_KendoScrollView);

var _kendoScrollviewInstaller = __webpack_require__(440);

var _kendoScrollviewInstaller2 = _interopRequireDefault(_kendoScrollviewInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoScrollView = _KendoScrollView2.default;
exports.ScrollView = _KendoScrollView2.default;
exports.KendoScrollViewInstaller = _kendoScrollviewInstaller2.default;
exports.ScrollViewInstaller = _kendoScrollviewInstaller2.default;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _ScrollViewProps = __webpack_require__(439);

var _ScrollViewProps2 = _interopRequireDefault(_ScrollViewProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _ScrollViewProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoScrollView(this.widgetOptions);
        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoScrollView();
        }
    }
};

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    autoBind: {
        type: Boolean,
        default: undefined
    },
    bounceVelocityThreshold: {
        type: Number,
        default: undefined
    },
    contentHeight: {
        type: [Number, String],
        default: undefined
    },
    dataSource: {
        type: Object,
        default: undefined
    },
    duration: {
        type: Number,
        default: undefined
    },
    emptyTemplate: {
        type: String,
        default: undefined
    },
    enablePager: {
        type: Boolean,
        default: undefined
    },
    page: {
        type: Number,
        default: undefined
    },
    template: {
        type: String,
        default: undefined
    },
    velocityThreshold: {
        type: Number,
        default: undefined
    },

    // Events
    change: Function,
    refresh: Function
};

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoScrollView = __webpack_require__(127);

var _KendoScrollView2 = _interopRequireDefault(_KendoScrollView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoScrollViewInstaller = function () {
    function KendoScrollViewInstaller() {
        _classCallCheck(this, KendoScrollViewInstaller);
    }

    _createClass(KendoScrollViewInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoScrollView2.default.name, _KendoScrollView2.default);
        }
    }]);

    return KendoScrollViewInstaller;
}();

exports.default = KendoScrollViewInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoScrollViewInstaller);
}

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpreadsheetInstaller = exports.KendoSpreadsheetInstaller = exports.SpreadsheetSheet = exports.KendoSpreadsheetSheet = exports.Spreadsheet = exports.KendoSpreadsheet = undefined;

var _KendoSpreadsheet = __webpack_require__(128);

var _KendoSpreadsheet2 = _interopRequireDefault(_KendoSpreadsheet);

var _KendoSpreadsheetSheet = __webpack_require__(37);

var _KendoSpreadsheetSheet2 = _interopRequireDefault(_KendoSpreadsheetSheet);

var _kendoSpreadsheetInstaller = __webpack_require__(449);

var _kendoSpreadsheetInstaller2 = _interopRequireDefault(_kendoSpreadsheetInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoSpreadsheet = _KendoSpreadsheet2.default;
exports.Spreadsheet = _KendoSpreadsheet2.default;
exports.KendoSpreadsheetSheet = _KendoSpreadsheetSheet2.default;
exports.SpreadsheetSheet = _KendoSpreadsheetSheet2.default;
exports.KendoSpreadsheetInstaller = _kendoSpreadsheetInstaller2.default;
exports.SpreadsheetInstaller = _kendoSpreadsheetInstaller2.default;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _SpreadsheetProps = __webpack_require__(443);

var _SpreadsheetProps2 = _interopRequireDefault(_SpreadsheetProps);

var _KendoSpreadsheetSheet = __webpack_require__(37);

var _KendoSpreadsheetSheet2 = _interopRequireDefault(_KendoSpreadsheetSheet);

var _DefaultCellStyle = __webpack_require__(445);

var _DefaultCellStyle2 = _interopRequireDefault(_DefaultCellStyle);

var _Excel = __webpack_require__(446);

var _Excel2 = _interopRequireDefault(_Excel);

var _Pdf = __webpack_require__(447);

var _Pdf2 = _interopRequireDefault(_Pdf);

var _Toolbar = __webpack_require__(448);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _SpreadsheetProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _DefaultCellStyle2.default, _Excel2.default, _Pdf2.default, _Toolbar2.default],
    mounted: function mounted() {
        this._resolveChildren();

        kendo.jQuery(this.$el).kendoSpreadsheet(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoSpreadsheet();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('sheets', _KendoSpreadsheetSheet2.default.name);
        }
    }
};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    activeSheet: {
        type: String,
        default: undefined
    },
    columnWidth: {
        type: Number,
        default: undefined
    },
    columns: {
        type: Number,
        default: undefined
    },
    defaultCellStyle: {
        type: Object,
        default: undefined
    },
    headerHeight: {
        type: Number,
        default: undefined
    },
    headerWidth: {
        type: Number,
        default: undefined
    },
    excel: {
        type: Object,
        default: undefined
    },
    pdf: {
        type: Object,
        default: undefined
    },
    rowHeight: {
        type: Number,
        default: undefined
    },
    rows: {
        type: Number,
        default: undefined
    },
    sheets: {
        type: Array,
        default: undefined
    },
    sheetsbar: {
        type: Boolean,
        default: undefined
    },
    toolbar: {
        type: [Boolean, Object],
        default: undefined
    },
    useCultureDecimals: {
        type: Boolean,
        default: undefined
    },

    // Events
    insertSheet: {
        type: Function,
        default: undefined
    },
    removeSheet: {
        type: Function,
        default: undefined
    },
    renameSheet: {
        type: Function,
        default: undefined
    },
    selectSheet: {
        type: Function,
        default: undefined
    },
    unhideColumn: {
        type: Function,
        default: undefined
    },
    unhideRow: {
        type: Function,
        default: undefined
    },
    hideColumn: {
        type: Function,
        default: undefined
    },
    hideRow: {
        type: Function,
        default: undefined
    },
    deleteColumn: {
        type: Function,
        default: undefined
    },
    deleteRow: {
        type: Function,
        default: undefined
    },
    insertColumn: {
        type: Function,
        default: undefined
    },
    insertRow: {
        type: Function,
        default: undefined
    },
    select: {
        type: Function,
        default: undefined
    },
    changeFormat: {
        type: Function,
        default: undefined
    },
    changing: {
        type: Function,
        default: undefined
    },
    change: {
        type: Function,
        default: undefined
    },
    render: {
        type: Function,
        default: undefined
    },
    excelExport: {
        type: Function,
        default: undefined
    },
    excelImport: {
        type: Function,
        default: undefined
    },
    pdfExport: {
        type: Function,
        default: undefined
    },
    copy: {
        type: Function,
        default: undefined
    },
    cut: {
        type: Function,
        default: undefined
    },
    paste: {
        type: Function,
        default: undefined
    },
    dataBinding: {
        type: Function,
        default: undefined
    },
    dataBound: Function
};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        activeCell: {
            type: String,
            default: undefined,
            kComposite: 'activeCell'
        },
        name: {
            type: String,
            default: undefined,
            kComposite: 'name'
        },
        columns: {
            type: Array,
            default: undefined,
            kComposite: 'columns'
        },
        dataSource: {
            type: [Object, Array],
            default: undefined,
            kComposite: 'dataSource'
        },
        dataSourceRef: {
            type: String,
            default: undefined,
            kComposite: 'dataSourceRef'
        },
        filterColumns: {
            type: Array,
            default: undefined,
            kComposite: 'filter.columns'
        },
        filterRef: {
            type: String,
            default: undefined,
            kComposite: 'filter.ref'
        },
        frozenColumns: {
            type: Number,
            default: undefined,
            kComposite: 'frozenColumns'
        },
        frozenRows: {
            type: Number,
            default: undefined,
            kComposite: 'frozenRows'
        },
        mergedCells: {
            type: Array,
            default: undefined,
            kComposite: 'mergedCells'
        },
        rows: {
            type: Array,
            default: undefined,
            kComposite: 'rows'
        },
        selection: {
            type: String,
            default: undefined,
            kComposite: 'selection'
        },
        showGridLines: {
            type: Boolean,
            default: undefined,
            kComposite: 'showGridLines'
        },
        sortColumns: {
            type: Array,
            default: undefined,
            kComposite: 'sort.columns'
        },
        sortRef: {
            type: String,
            default: undefined,
            kComposite: 'sort.ref'
        }
    }
};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        defaultCellStyleBackground: {
            type: String,
            default: undefined,
            kComposite: 'defaultCellStyle.background'
        },
        defaultCellStyleColor: {
            type: String,
            default: undefined,
            kComposite: 'defaultCellStyle.color'
        },
        defaultCellStyleFontFamily: {
            type: String,
            default: undefined,
            kComposite: 'defaultCellStyle.fontFamily'
        },
        defaultCellStyleFontSize: {
            type: String,
            default: undefined,
            kComposite: 'defaultCellStyle.fontSize'
        },
        defaultCellStyleItalic: {
            type: Boolean,
            default: undefined,
            kComposite: 'defaultCellStyle.Italic'
        },
        defaultCellStyleBold: {
            type: Boolean,
            default: undefined,
            kComposite: 'defaultCellStyle.bold'
        },
        defaultCellStyleUnderline: {
            type: Boolean,
            default: undefined,
            kComposite: 'defaultCellStyle.underline'
        },
        defaultCellStyleWrap: {
            type: Boolean,
            default: undefined,
            kComposite: 'defaultCellStyle.wrap'
        }
    }
};

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        excelFileName: {
            type: String,
            default: undefined,
            kComposite: 'excel.fileName'
        },
        excelForceProxy: {
            type: Boolean,
            default: undefined,
            kComposite: 'excel.forceProxy'
        },
        excelProxyURL: {
            type: String,
            default: undefined,
            kComposite: 'excel.proxyURL'
        }
    }
};

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        pdfArea: {
            type: String,
            default: undefined,
            kComposite: 'pdf.area'
        },
        pdfAuthor: {
            type: String,
            default: undefined,
            kComposite: 'pdf.author'
        },
        pdfCreator: {
            type: String,
            default: undefined,
            kComposite: 'pdf.creator'
        },
        pdfDate: {
            type: Date,
            default: undefined,
            kComposite: 'pdf.date'
        },
        pdfFileName: {
            type: String,
            default: undefined,
            kComposite: 'pdf.fileName'
        },
        pdfFitWidth: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.fitWidth'
        },
        pdfForceProxy: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.forceProxy'
        },
        pdfGuidelines: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.guidelines'
        },
        pdfHCenter: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.hCenter'
        },
        pdfKeywords: {
            type: String,
            default: undefined,
            kComposite: 'pdf.keywords'
        },
        pdfLandscape: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.landscape'
        },
        pdfMarginBottom: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.bottom'
        },
        pdfMarginLeft: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.left'
        },
        pdfMarginRight: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.right'
        },
        pdfMarginTop: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.top'
        },
        pdfPaperSize: {
            type: [String, Array],
            default: undefined,
            kComposite: 'pdf.paperSize'
        },
        pdfProxyURL: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyURL'
        },
        pdfProxyTarget: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyTarget'
        },
        pdfSubject: {
            type: String,
            default: undefined,
            kComposite: 'pdf.subject'
        },
        pdfTitle: {
            type: String,
            default: undefined,
            kComposite: 'pdf.title'
        },
        pdfVCenter: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.vCenter'
        }
    }
};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        toolbarHome: {
            type: [Boolean, Array],
            default: undefined,
            kComposite: 'toolbar.home'
        },
        toolbarInsert: {
            type: [Boolean, Array],
            default: undefined,
            kComposite: 'toolbar.insert'
        },
        toolbarData: {
            type: [Boolean, Array],
            default: undefined,
            kComposite: 'toolbar.data'
        }
    }
};

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoSpreadsheet = __webpack_require__(128);

var _KendoSpreadsheet2 = _interopRequireDefault(_KendoSpreadsheet);

var _KendoSpreadsheetSheet = __webpack_require__(37);

var _KendoSpreadsheetSheet2 = _interopRequireDefault(_KendoSpreadsheetSheet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoSpreadsheetInstaller = function () {
    function KendoSpreadsheetInstaller() {
        _classCallCheck(this, KendoSpreadsheetInstaller);
    }

    _createClass(KendoSpreadsheetInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoSpreadsheet2.default.name, _KendoSpreadsheet2.default);
            Vue.component(_KendoSpreadsheetSheet2.default.name, _KendoSpreadsheetSheet2.default);
        }
    }]);

    return KendoSpreadsheetInstaller;
}();

exports.default = KendoSpreadsheetInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoSpreadsheetInstaller);
}

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeListColumn = exports.KendoTreeListColumn = exports.TreeListInstaller = exports.KendoTreeListInstaller = exports.TreeList = exports.KendoTreeList = undefined;

var _KendoTreeList = __webpack_require__(129);

var _KendoTreeList2 = _interopRequireDefault(_KendoTreeList);

var _KendoTreeListColumn = __webpack_require__(38);

var _KendoTreeListColumn2 = _interopRequireDefault(_KendoTreeListColumn);

var _kendoTreelistInstaller = __webpack_require__(463);

var _kendoTreelistInstaller2 = _interopRequireDefault(_kendoTreelistInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoTreeList = _KendoTreeList2.default;
exports.TreeList = _KendoTreeList2.default;
exports.KendoTreeListInstaller = _kendoTreelistInstaller2.default;
exports.TreeListInstaller = _kendoTreelistInstaller2.default;
exports.KendoTreeListColumn = _KendoTreeListColumn2.default;
exports.TreeListColumn = _KendoTreeListColumn2.default;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _TreeListProps = __webpack_require__(452);

var _TreeListProps2 = _interopRequireDefault(_TreeListProps);

var _KendoTreeListColumn = __webpack_require__(38);

var _KendoTreeListColumn2 = _interopRequireDefault(_KendoTreeListColumn);

var _ColumnMenu = __webpack_require__(454);

var _ColumnMenu2 = _interopRequireDefault(_ColumnMenu);

var _Editable = __webpack_require__(455);

var _Editable2 = _interopRequireDefault(_Editable);

var _Excel = __webpack_require__(456);

var _Excel2 = _interopRequireDefault(_Excel);

var _Filterable = __webpack_require__(457);

var _Filterable2 = _interopRequireDefault(_Filterable);

var _Messages = __webpack_require__(458);

var _Messages2 = _interopRequireDefault(_Messages);

var _Pageable = __webpack_require__(459);

var _Pageable2 = _interopRequireDefault(_Pageable);

var _Pdf = __webpack_require__(460);

var _Pdf2 = _interopRequireDefault(_Pdf);

var _Sortable = __webpack_require__(461);

var _Sortable2 = _interopRequireDefault(_Sortable);

var _Toolbar = __webpack_require__(462);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _TreeListProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _ColumnMenu2.default, _Editable2.default, _Excel2.default, _Filterable2.default, _Messages2.default, _Pageable2.default, _Pdf2.default, _Sortable2.default, _Toolbar2.default],
    mounted: function mounted() {
        this._resolveChildren();

        kendo.jQuery(this.$el).kendoTreeList(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoTreeList();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('columns', _KendoTreeListColumn2.default.name);
        }
    }
};

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    autoBind: {
        type: Boolean,
        default: undefined
    },
    columns: {
        type: Array,
        default: undefined
    },
    resizable: {
        type: Boolean,
        default: undefined
    },
    reorderable: {
        type: Boolean,
        default: undefined
    },
    columnMenu: {
        type: [Boolean, Object],
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    editable: {
        type: [Boolean, Object],
        default: undefined
    },
    excel: {
        type: Object,
        default: undefined
    },
    filterable: {
        type: [Boolean, Object],
        default: undefined
    },
    height: {
        type: [Number, String],
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    navigatable: {
        type: Boolean,
        default: undefined
    },
    pageable: {
        type: [Boolean, Object],
        default: undefined
    },
    pdf: {
        type: Object,
        default: undefined
    },
    scrollable: {
        type: [Boolean, Object],
        default: undefined
    },
    selectable: {
        type: [Boolean, String],
        default: undefined
    },
    sortable: {
        type: [Boolean, Object],
        default: undefined
    },
    toolbar: {
        type: [String, Function, Array],
        default: undefined
    },

    // Events
    beforeEdit: {
        type: Function,
        default: undefined
    },
    cancel: {
        type: Function,
        default: undefined
    },
    cellClose: {
        type: Function,
        default: undefined
    },
    change: {
        type: Function,
        default: undefined
    },
    collapse: {
        type: Function,
        default: undefined
    },
    dataBinding: {
        type: Function,
        default: undefined
    },
    dataBound: {
        type: Function,
        default: undefined
    },
    dragstart: {
        type: Function,
        default: undefined
    },
    drag: {
        type: Function,
        default: undefined
    },
    dragend: {
        type: Function,
        default: undefined
    },
    drop: {
        type: Function,
        default: undefined
    },
    edit: {
        type: Function,
        default: undefined
    },
    excelExport: {
        type: Function,
        default: undefined
    },
    expand: {
        type: Function,
        default: undefined
    },
    filterMenuInit: {
        type: Function,
        default: undefined
    },
    pdfExport: {
        type: Function,
        default: undefined
    },
    remove: {
        type: Function,
        default: undefined
    },
    save: {
        type: Function,
        default: undefined
    },
    columnShow: {
        type: Function,
        default: undefined
    },
    columnHide: {
        type: Function,
        default: undefined
    },
    columnReorder: {
        type: Function,
        default: undefined
    },
    columnResize: {
        type: Function,
        default: undefined
    },
    columnMenuInit: {
        type: Function,
        default: undefined
    },
    columnLock: {
        type: Function,
        default: undefined
    },
    columnUnlock: Function
};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        attributes: {
            type: Object,
            default: undefined,
            kComposite: 'attributes'
        },
        columns: Array,
        command: {
            type: Array,
            default: undefined,
            kComposite: 'command'
        }, Editor: {
            type: Function,
            default: undefined,
            kComposite: 'editor'
        },
        encoded: {
            type: Boolean,
            default: undefined,
            kComposite: 'encoded'
        },
        expandable: {
            type: Boolean,
            default: undefined,
            kComposite: 'expandable'
        },
        field: {
            type: String,
            default: undefined,
            kComposite: 'field'
        },
        filterable: {
            type: Boolean,
            default: undefined,
            kComposite: 'filterable'
        },
        filterableUi: {
            type: [String, Function],
            default: undefined,
            kComposite: 'filterable.ui'
        },
        footerTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'footerTemplate'
        },
        format: {
            type: String,
            default: undefined,
            kComposite: 'format'
        },
        headerAttributes: {
            type: Object,
            default: undefined,
            kComposite: 'headerAttributes'
        },
        headerTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'headerTemplate'
        },
        minScreenWidth: {
            type: Number,
            default: undefined,
            kComposite: 'minScreenWidth'
        },
        sortable: {
            type: Boolean,
            default: undefined,
            kComposite: 'sortable'
        },
        sortableCompare: {
            type: Function,
            default: undefined,
            kComposite: 'sortable.compare'
        },
        template: {
            type: [String, Function],
            default: undefined,
            kComposite: 'template'
        },
        title: {
            type: String,
            default: undefined,
            kComposite: 'title'
        },
        width: {
            type: [String, Number],
            default: undefined,
            kComposite: 'width'
        },
        hidden: {
            type: Boolean,
            default: undefined,
            kComposite: 'hidden'
        },
        menu: {
            type: Boolean,
            default: undefined,
            kComposite: 'menu'
        },
        locked: {
            type: Boolean,
            default: undefined,
            kComposite: 'locked'
        },
        lockable: {
            type: Boolean,
            default: undefined,
            kComposite: 'lockable'
        }
    }
};

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        columnMenuColumns: {
            type: Boolean,
            default: undefined,
            kComposite: 'columnMenu.columns'
        },
        columnMenuFilterable: {
            type: Boolean,
            default: undefined,
            kComposite: 'columnMenu.filterable'
        },
        columnMenuSortable: {
            type: Boolean,
            default: undefined,
            kComposite: 'columnMenu.sortable'
        },
        columnMenuMessagesColumns: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.columns'
        },
        columnMenuMessagesFilter: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.filter'
        },
        columnMenuMessagesSortAscending: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.sortAscending'
        },
        columnMenuMessagesSortDescending: {
            type: String,
            default: undefined,
            kComposite: 'columnMenu.messages.sortDescending'
        }
    }
};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        editableMode: {
            type: String,
            default: undefined,
            kComposite: 'editable.mode'
        },
        editableMove: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.move'
        },
        editableTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'editable.template'
        },
        editableWindow: {
            type: Object,
            default: undefined,
            kComposite: 'editable.window'
        }
    }
};

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        excelFileName: {
            type: String,
            default: undefined,
            kComposite: 'excel.fileName'
        },
        excelFilterable: {
            type: Boolean,
            default: undefined,
            kComposite: 'excel.filterable'
        },
        excelForceProxy: {
            type: Boolean,
            default: undefined,
            kComposite: 'excel.forceProxy'
        },
        excelProxyURL: {
            type: String,
            default: undefined,
            kComposite: 'excel.proxyURL'
        }
    }
};

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        filterableExtra: {
            type: Boolean,
            default: undefined,
            kComposite: 'filterable.extra'
        },
        filterableMessagesAnd: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.and'
        },
        filterableMessagesClear: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.clear'
        },
        filterableMessagesFilter: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.filter'
        },
        filterableMessagesInfo: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.info'
        },
        filterableMessagesTitle: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.title'
        },
        filterableMessagesIsFalse: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.isFalse'
        },
        filterableMessagesIsTrue: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.isTrue'
        },
        filterableMessagesOr: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.or'
        },
        filterableMessagesSelectValue: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.selectValue'
        },
        filterableMessagesCancel: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.cancel'
        },
        filterableMessagesOperator: {
            type: String,
            default: undefined,
            kComposite: 'filterable.messages.operator'
        }
    }
};

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesCommandsCanceledit: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.canceledit'
        },
        messagesCommandsCreate: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.create'
        },
        messagesCommandsCreatechild: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.createchild'
        },
        messagesCommandsDestroy: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.destroy'
        },
        messagesCommandsEdit: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.edit'
        },
        messagesCommandsExcel: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.excel'
        },
        messagesCommandsPdf: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.pdf'
        },
        messagesCommandsUpdate: {
            type: String,
            default: undefined,
            kComposite: 'messages.commands.update'
        },
        messagesLoading: {
            type: String,
            default: undefined,
            kComposite: 'messages.loading'
        },
        messagesNoRows: {
            type: String,
            default: undefined,
            kComposite: 'messages.noRows'
        },
        messagesRequestFailed: {
            type: String,
            default: undefined,
            kComposite: 'messages.requestFailed'
        },
        messagesRetry: {
            type: String,
            default: undefined,
            kComposite: 'messages.retry'
        }
    }
};

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        pageableAlwaysVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.alwaysVisible'
        },
        pageablePageSize: {
            type: Number,
            default: undefined,
            kComposite: 'pageable.pageSize'
        },
        pageablePreviousNext: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.previousNext'
        },
        pageableNumeric: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.numeric'
        },
        pageableButtonCount: {
            type: Number,
            default: undefined,
            kComposite: 'pageable.buttonCount'
        },
        pageableInput: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.input'
        },
        pageablePageSizes: {
            type: [Boolean, Array],
            default: undefined,
            kComposite: 'pageable.pageSizes'
        },
        pageableRefresh: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.refresh'
        },
        pageableResponsive: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.responsive'
        },
        pageableInfo: {
            type: Boolean,
            default: undefined,
            kComposite: 'pageable.info'
        },
        pageableMessagesDisplay: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.display'
        },
        pageableMessagesEmpty: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.empty'
        },
        pageableMessagesPage: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.page'
        },
        pageableMessagesOf: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.of'
        },
        pageableMessagesItemsPerPage: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.itemsPerPage'
        },
        pageableMessagesFirst: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.first'
        },
        pageableMessagesLast: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.last'
        },
        pageableMessagesNext: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.next'
        },
        pageableMessagesPrevious: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.previous'
        },
        pageableMessagesRefresh: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.refresh'
        },
        pageableMessagesMorePages: {
            type: String,
            default: undefined,
            kComposite: 'pageable.messages.morePages'
        }
    }
};

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        pdfAuthor: {
            type: String,
            default: undefined,
            kComposite: 'pdf.author'
        },
        pdfAvoidLinks: {
            type: [Boolean, String],
            default: undefined,
            kComposite: 'pdf.avoidLinks'
        },
        pdfCreator: {
            type: String,
            default: undefined,
            kComposite: 'pdf.creator'
        },
        pdfDate: {
            type: Date,
            default: undefined,
            kComposite: 'pdf.date'
        },
        pdfFileName: {
            type: String,
            default: undefined,
            kComposite: 'pdf.fileName'
        },
        pdfForceProxy: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.forceProxy'
        },
        pdfKeywords: {
            type: String,
            default: undefined,
            kComposite: 'pdf.keywords'
        },
        pdfLandscape: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.landscape'
        },
        pdfMarginBottom: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.bottom'
        },
        pdfMarginLeft: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.left'
        },
        pdfMarginRight: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.right'
        },
        pdfMarginTop: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.top'
        },
        pdfPaperSize: {
            type: [String, Array],
            default: undefined,
            kComposite: 'pdf.paperSize'
        },
        pdfProxyURL: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyURL'
        },
        pdfProxyTarget: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyTarget'
        },
        pdfSubject: {
            type: String,
            default: undefined,
            kComposite: 'pdf.subject'
        },
        pdfTitle: {
            type: String,
            default: undefined,
            kComposite: 'pdf.title'
        }
    }
};

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        sortableAllowUnsort: {
            type: Boolean,
            default: undefined,
            kComposite: 'sortable.allowUnsort'
        },
        sortableMode: {
            type: String,
            default: undefined,
            kComposite: 'sortable.mode'
        }
    }
};

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        toolbarClick: {
            type: Function,
            default: undefined,
            kComposite: 'toolbar.click'
        },
        toolbarName: {
            type: String,
            default: undefined,
            kComposite: 'toolbar.name'
        },
        toolbarText: {
            type: String,
            default: undefined,
            kComposite: 'toolbar.text'
        }
    }
};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoTreeList = __webpack_require__(129);

var _KendoTreeList2 = _interopRequireDefault(_KendoTreeList);

var _KendoTreeListColumn = __webpack_require__(38);

var _KendoTreeListColumn2 = _interopRequireDefault(_KendoTreeListColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoTreeListInstaller = function () {
    function KendoTreeListInstaller() {
        _classCallCheck(this, KendoTreeListInstaller);
    }

    _createClass(KendoTreeListInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoTreeList2.default.name, _KendoTreeList2.default);
            Vue.component(_KendoTreeListColumn2.default.name, _KendoTreeListColumn2.default);
        }
    }]);

    return KendoTreeListInstaller;
}();

exports.default = KendoTreeListInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoTreeListInstaller);
}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeMapInstaller = exports.KendoTreeMapInstaller = exports.TreeMap = exports.KendoTreeMap = undefined;

var _KendoTreeMap = __webpack_require__(130);

var _KendoTreeMap2 = _interopRequireDefault(_KendoTreeMap);

var _kendoTreemapInstaller = __webpack_require__(467);

var _kendoTreemapInstaller2 = _interopRequireDefault(_kendoTreemapInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoTreeMap = _KendoTreeMap2.default;
exports.TreeMap = _KendoTreeMap2.default;
exports.KendoTreeMapInstaller = _kendoTreemapInstaller2.default;
exports.TreeMapInstaller = _kendoTreemapInstaller2.default;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _TreeMapProps = __webpack_require__(466);

var _TreeMapProps2 = _interopRequireDefault(_TreeMapProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _TreeMapProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoTreeMap(this.widgetOptions);
        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoTreeMap();
        }
    }
};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    type: {
        type: String,
        default: undefined
    },
    theme: {
        type: String,
        default: undefined
    },
    valueField: {
        type: String,
        default: undefined
    },
    colorField: {
        type: String,
        default: undefined
    },
    textField: {
        type: String,
        default: undefined
    },
    template: {
        type: [String, Function],
        default: undefined
    },
    colors: {
        type: Array,
        default: undefined
    },

    // Events
    itemCreated: {
        type: Function,
        default: undefined
    },
    dataBound: {
        type: Function,
        default: undefined
    }
};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoTreeMap = __webpack_require__(130);

var _KendoTreeMap2 = _interopRequireDefault(_KendoTreeMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoTreeMapInstaller = function () {
    function KendoTreeMapInstaller() {
        _classCallCheck(this, KendoTreeMapInstaller);
    }

    _createClass(KendoTreeMapInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoTreeMap2.default.name, _KendoTreeMap2.default);
        }
    }]);

    return KendoTreeMapInstaller;
}();

exports.default = KendoTreeMapInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoTreeMapInstaller);
}

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TreeViewInstaller = exports.KendoTreeViewInstaller = exports.TreeViewItem = exports.KendoTreeViewItem = exports.TreeView = exports.KendoTreeView = undefined;

var _KendoTreeView = __webpack_require__(131);

var _KendoTreeView2 = _interopRequireDefault(_KendoTreeView);

var _KendoTreeViewItem = __webpack_require__(132);

var _KendoTreeViewItem2 = _interopRequireDefault(_KendoTreeViewItem);

var _kendoTreeviewInstaller = __webpack_require__(474);

var _kendoTreeviewInstaller2 = _interopRequireDefault(_kendoTreeviewInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoTreeView = _KendoTreeView2.default;
exports.TreeView = _KendoTreeView2.default;
exports.KendoTreeViewItem = _KendoTreeViewItem2.default;
exports.TreeViewItem = _KendoTreeViewItem2.default;
exports.KendoTreeViewInstaller = _kendoTreeviewInstaller2.default;
exports.TreeViewInstaller = _kendoTreeviewInstaller2.default;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _TreeViewProps = __webpack_require__(470);

var _TreeViewProps2 = _interopRequireDefault(_TreeViewProps);

var _Animation = __webpack_require__(471);

var _Animation2 = _interopRequireDefault(_Animation);

var _Checkboxes = __webpack_require__(472);

var _Checkboxes2 = _interopRequireDefault(_Checkboxes);

var _Messages = __webpack_require__(473);

var _Messages2 = _interopRequireDefault(_Messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _TreeViewProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _kendoBaseComponentsVueWrapper.KendoSharedMethods, _Animation2.default, _Checkboxes2.default, _Messages2.default],
    mounted: function mounted() {
        this._resolveChildren();

        kendo.jQuery(this.$el).kendoTreeView(this.widgetOptions);

        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoTreeView();
        },
        _resolveChildren: function _resolveChildren() {
            var defaultSlot = this.v3 && this.$slots.default && typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default;
            var hasDataSource = this.v3 ? !this.$props.dataSource : this.$options.propsData && !this.$options.propsData['dataSource'];
            if (hasDataSource && defaultSlot) {
                var items = this.resolveInnerTags('kendo-treeview-item');

                if (items.length) {
                    this.widgetOptions['dataSource'] = items;
                }
            }
        }
    }
};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    autoScroll: {
        type: Boolean,
        default: undefined
    },
    checkboxes: {
        type: [Boolean, Object],
        default: undefined
    },
    dataImageUrlField: {
        type: String,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataSpriteCssClassField: {
        type: String,
        default: undefined
    },
    dataTextField: {
        type: [String, Array],
        default: undefined
    },
    dataUrlField: {
        type: String,
        default: undefined
    },
    dragAndDrop: {
        type: Boolean,
        default: undefined
    },
    loadOnDemand: {
        type: Boolean,
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    template: {
        type: [String, Function],
        default: undefined
    },

    // Events
    change: Function,
    check: Function,
    collapse: Function,
    dataBound: {
        type: Function,
        default: undefined
    },
    drag: Function,
    dragend: {
        type: Function,
        default: undefined
    },
    dragstart: {
        type: Function,
        default: undefined
    },
    drop: Function,
    expand: Function,
    navigate: Function,
    select: Function
};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        animationCollapse: {
            type: Boolean,
            default: undefined,
            kComposite: 'animation.collapse'
        },
        animationCollapseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.collapse.duration'
        },
        animationCollapseEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.collapse.effects'
        },
        animationExpand: {
            type: Boolean,
            default: undefined,
            kComposite: 'animation.expand'
        },
        animationExpandDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.expand.duration'
        },
        animationExpandEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.expand.effects'
        }
    }
};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        checkboxesCheckChildren: {
            type: Boolean,
            default: undefined,
            kComposite: 'checkboxes.checkChildren'
        },
        checkboxesName: {
            type: String,
            default: undefined,
            kComposite: 'checkboxes.name'
        },
        checkboxesTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'checkboxes.template'
        }
    }
};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesLoading: {
            type: String,
            default: undefined,
            kComposite: 'messages.loading'
        },
        messagesRequestFailed: {
            type: String,
            default: undefined,
            kComposite: 'messages.requestFailed'
        },
        messagesRetry: {
            type: String,
            default: undefined,
            kComposite: 'messages.retry'
        }
    }
};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoTreeView = __webpack_require__(131);

var _KendoTreeView2 = _interopRequireDefault(_KendoTreeView);

var _KendoTreeViewItem = __webpack_require__(132);

var _KendoTreeViewItem2 = _interopRequireDefault(_KendoTreeViewItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoTreeViewInstaller = function () {
    function KendoTreeViewInstaller() {
        _classCallCheck(this, KendoTreeViewInstaller);
    }

    _createClass(KendoTreeViewInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoTreeView2.default.name, _KendoTreeView2.default);
            Vue.component(_KendoTreeViewItem2.default.name, _KendoTreeViewItem2.default);
        }
    }]);

    return KendoTreeViewInstaller;
}();

exports.default = KendoTreeViewInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoTreeViewInstaller);
}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadInstaller = exports.KendoUploadInstaller = exports.Upload = exports.KendoUpload = undefined;

var _KendoUpload = __webpack_require__(133);

var _KendoUpload2 = _interopRequireDefault(_KendoUpload);

var _kendoUploadInstaller = __webpack_require__(482);

var _kendoUploadInstaller2 = _interopRequireDefault(_kendoUploadInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoUpload = _KendoUpload2.default;
exports.Upload = _KendoUpload2.default;
exports.KendoUploadInstaller = _kendoUploadInstaller2.default;
exports.UploadInstaller = _kendoUploadInstaller2.default;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _UploadProps = __webpack_require__(477);

var _UploadProps2 = _interopRequireDefault(_UploadProps);

var _Async = __webpack_require__(478);

var _Async2 = _interopRequireDefault(_Async);

var _Files = __webpack_require__(479);

var _Files2 = _interopRequireDefault(_Files);

var _Localization = __webpack_require__(480);

var _Localization2 = _interopRequireDefault(_Localization);

var _Validation = __webpack_require__(481);

var _Validation2 = _interopRequireDefault(_Validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _UploadProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _Async2.default, _Files2.default, _Localization2.default, _Validation2.default],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoUpload(this.widgetOptions);
        this.$_upload = this.kendoWidget();
        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.$_upload);
        } else {
            this.$emit('kendowidgetready', this.$_upload);
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            if (this.$el && this.$el.parentElement) {
                return kendo.jQuery(this.$el).getKendoUpload();
            }

            return this.$_upload;
        }
    }
};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    async: {
        type: Object,
        default: undefined
    },
    directory: {
        type: Boolean,
        default: undefined
    },
    directoryDrop: {
        type: Boolean,
        default: undefined
    },
    dropZone: {
        type: String,
        default: undefined
    },
    enabled: {
        type: Boolean,
        default: undefined
    },
    files: {
        type: Array,
        default: undefined
    },
    localization: {
        type: Object,
        default: undefined
    },
    multiple: {
        type: Boolean,
        default: undefined
    },
    showFileList: {
        type: Boolean,
        default: undefined
    },
    template: {
        type: [String, Function],
        default: undefined
    },
    validation: {
        type: Object,
        default: undefined
    },

    // Events
    cancel: Function,
    clear: Function,
    complete: Function,
    error: Function,
    pause: Function,
    progress: Function,
    resume: Function,
    remove: Function,
    select: Function,
    success: Function,
    upload: Function
};

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        asyncAutoUpload: {
            type: Boolean,
            default: undefined,
            kComposite: 'async.autoUpload'
        },
        asyncBatch: {
            type: Boolean,
            default: undefined,
            kComposite: 'async.batch'
        },
        asyncChunkSize: {
            type: Number,
            default: undefined,
            kComposite: 'async.chunkSize'
        },
        asyncConcurrent: {
            type: Boolean,
            default: undefined,
            kComposite: 'async.concurrent'
        },
        asyncAutoRetryAfter: {
            type: Number,
            default: undefined,
            kComposite: 'async.autoRetryAfter'
        },
        asyncMaxAutoRetries: {
            type: Number,
            default: undefined,
            kComposite: 'async.maxAutoRetries'
        },
        asyncRemoveField: {
            type: String,
            default: undefined,
            kComposite: 'async.removeField'
        },
        asyncRemoveUrl: {
            type: String,
            default: undefined,
            kComposite: 'async.removeUrl'
        },
        asyncRemoveVerb: {
            type: String,
            default: undefined,
            kComposite: 'async.removeVerb'
        },
        asyncSaveField: {
            type: String,
            default: undefined,
            kComposite: 'async.saveField'
        },
        asyncSaveUrl: {
            type: String,
            default: undefined,
            kComposite: 'async.saveUrl'
        },
        asyncUseArrayBuffer: {
            type: Boolean,
            default: undefined,
            kComposite: 'async.useArrayBuffer'
        },
        asyncWithCredentials: {
            type: Boolean,
            default: undefined,
            kComposite: 'async.withCredentials'
        }
    }
};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        filesFileExtension: {
            type: String,
            default: undefined,
            kComposite: 'files.file.extension'
        },
        filesFileName: {
            type: String,
            default: undefined,
            kComposite: 'files.file.name'
        },
        filesFileSize: {
            type: Number,
            default: undefined,
            kComposite: 'files.file.size'
        }
    }
};

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        localizationCancel: {
            type: String,
            default: undefined,
            kComposite: 'localization.cancel'
        },
        localizationClearSelectedFiles: {
            type: String,
            default: undefined,
            kComposite: 'localization.clearSelectedFiles'
        },
        localizationDropFilesHere: {
            type: String,
            default: undefined,
            kComposite: 'localization.dropFilesHere'
        },
        localizationHeaderStatusUploaded: {
            type: String,
            default: undefined,
            kComposite: 'localization.headerStatusUploaded'
        },
        localizationHeaderStatusUploading: {
            type: String,
            default: undefined,
            kComposite: 'localization.headerStatusUploading'
        },
        localizationInvalidFileExtension: {
            type: String,
            default: undefined,
            kComposite: 'localization.invalidFileExtension'
        },
        localizationInvalidFiles: {
            type: String,
            default: undefined,
            kComposite: 'localization.invalidFiles'
        },
        localizationInvalidMaxFileSize: {
            type: String,
            default: undefined,
            kComposite: 'localization.invalidMaxFileSize'
        },
        localizationInvalidMinFileSize: {
            type: String,
            default: undefined,
            kComposite: 'localization.invalidMinFileSize'
        },
        localizationRemove: {
            type: String,
            default: undefined,
            kComposite: 'localization.remove'
        },
        localizationRetry: {
            type: String,
            default: undefined,
            kComposite: 'localization.retry'
        },
        localizationSelect: {
            type: String,
            default: undefined,
            kComposite: 'localization.select'
        },
        localizationStatusFailed: {
            type: String,
            default: undefined,
            kComposite: 'localization.statusFailed'
        },
        localizationStatusUploaded: {
            type: String,
            default: undefined,
            kComposite: 'localization.statusUploaded'
        },
        localizationStatusUploading: {
            type: String,
            default: undefined,
            kComposite: 'localization.statusUploading'
        },
        localizationUploadSelectedFiles: {
            type: String,
            default: undefined,
            kComposite: 'localization.uploadSelectedFiles'
        }
    }
};

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        validationAllowedExtensions: {
            type: Array,
            default: undefined,
            kComposite: 'validation.allowedExtensions'
        },
        validationMaxFileSize: {
            type: Number,
            default: undefined,
            kComposite: 'validation.maxFileSize'
        },
        validationMinFileSize: {
            type: Number,
            default: undefined,
            kComposite: 'validation.minFileSize'
        }
    }
};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoUpload = __webpack_require__(133);

var _KendoUpload2 = _interopRequireDefault(_KendoUpload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoUploadInstaller = function () {
    function KendoUploadInstaller() {
        _classCallCheck(this, KendoUploadInstaller);
    }

    _createClass(KendoUploadInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoUpload2.default.name, _KendoUpload2.default);
        }
    }]);

    return KendoUploadInstaller;
}();

exports.default = KendoUploadInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoUploadInstaller);
}

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidatorInstaller = exports.KendoValidatorInstaller = exports.Validator = exports.KendoValidator = undefined;

var _KendoValidator = __webpack_require__(134);

var _KendoValidator2 = _interopRequireDefault(_KendoValidator);

var _kendoValidatorInstaller = __webpack_require__(484);

var _kendoValidatorInstaller2 = _interopRequireDefault(_kendoValidatorInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoValidator = _KendoValidator2.default;
exports.Validator = _KendoValidator2.default;
exports.KendoValidatorInstaller = _kendoValidatorInstaller2.default;
exports.ValidatorInstaller = _kendoValidatorInstaller2.default;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoValidator = __webpack_require__(134);

var _KendoValidator2 = _interopRequireDefault(_KendoValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoValidatorInstaller = function () {
    function KendoValidatorInstaller() {
        _classCallCheck(this, KendoValidatorInstaller);
    }

    _createClass(KendoValidatorInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.directive(_KendoValidator2.default.name, _KendoValidator2.default);
        }
    }]);

    return KendoValidatorInstaller;
}();

exports.default = KendoValidatorInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoValidatorInstaller);
}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WindowInstaller = exports.KendoWindowInstaller = exports.Window = exports.KendoWindow = undefined;

var _KendoWindow = __webpack_require__(135);

var _KendoWindow2 = _interopRequireDefault(_KendoWindow);

var _kendoWindowInstaller = __webpack_require__(494);

var _kendoWindowInstaller2 = _interopRequireDefault(_kendoWindowInstaller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.KendoWindow = _KendoWindow2.default;
exports.Window = _KendoWindow2.default;
exports.KendoWindowInstaller = _kendoWindowInstaller2.default;
exports.WindowInstaller = _kendoWindowInstaller2.default;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = __webpack_require__(1);

var _WindowProps = __webpack_require__(487);

var _WindowProps2 = _interopRequireDefault(_WindowProps);

var _Animation = __webpack_require__(488);

var _Animation2 = _interopRequireDefault(_Animation);

var _Content = __webpack_require__(489);

var _Content2 = _interopRequireDefault(_Content);

var _Draggable = __webpack_require__(490);

var _Draggable2 = _interopRequireDefault(_Draggable);

var _Modal = __webpack_require__(491);

var _Modal2 = _interopRequireDefault(_Modal);

var _Position = __webpack_require__(492);

var _Position2 = _interopRequireDefault(_Position);

var _Title = __webpack_require__(493);

var _Title2 = _interopRequireDefault(_Title);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _WindowProps2.default,
    emits: {
        'kendowidgetready': null
    },
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _Animation2.default, _Content2.default, _Draggable2.default, _Modal2.default, _Position2.default, _Title2.default],
    mounted: function mounted() {
        kendo.jQuery(this.$el).kendoWindow(this.widgetOptions);
        if (this.v3) {
            this.ready();
            this.$emit('kendowidgetready', this.kendoWidget());
        } else {
            this.$emit('kendowidgetready', this.kendoWidget());
        }
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoWindow();
        },
        toggleClasses: function toggleClasses() {}
    }
};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    actions: {
        type: Array,
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    appendTo: {
        type: [Object, String],
        default: undefined
    },
    autoFocus: {
        type: Boolean,
        default: undefined
    },
    content: {
        type: [String, Object],
        default: undefined
    },
    draggable: {
        type: [Boolean, Object],
        default: undefined
    },
    iframe: {
        type: Boolean,
        default: undefined
    },
    height: {
        type: [Number, String],
        default: undefined
    },
    maxHeight: {
        type: Number,
        default: undefined
    },
    maxWidth: {
        type: Number,
        default: undefined
    },
    minHeight: {
        type: Number,
        default: undefined
    },
    minWidth: {
        type: Number,
        default: undefined
    },
    modal: {
        type: [Boolean, Object],
        default: undefined
    },
    pinned: {
        type: Boolean,
        default: undefined
    },
    position: Object,
    resizable: {
        type: Boolean,
        default: undefined
    },
    scrollable: {
        type: Boolean,
        default: undefined
    },
    title: {
        type: [String, Boolean, Object],
        default: undefined
    },
    visible: {
        type: Boolean,
        default: undefined
    },
    width: {
        type: [Number, String],
        default: undefined
    },
    size: {
        type: String,
        default: undefined
    },

    // Events
    activate: Function,
    close: Function,
    deactivate: Function,
    dragend: Function,
    dragstart: Function,
    error: Function,
    maximize: Function,
    minimize: Function,
    open: Function,
    refresh: Function,
    resize: Function
};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        animationCloseEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.close.effects'
        },
        animationCloseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.close.duration'
        },
        animationOpenEffects: {
            type: String,
            default: undefined,
            kComposite: 'animation.open.effects'
        },
        animationOpenDuration: {
            type: Number,
            default: undefined,
            kComposite: 'animation.open.duration'
        }
    }
};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        contentTemplate: {
            type: String,
            default: undefined,
            kComposite: 'content.template'
        }
    }
};

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        draggableContainment: {
            type: String,
            default: undefined,
            kComposite: 'draggable.containment'
        },
        draggableAxis: {
            type: String,
            default: undefined,
            kComposite: 'draggable.axis'
        },
        draggableDragHandle: {
            type: String,
            default: undefined,
            kComposite: 'draggable.dragHandle'
        }
    }
};

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        modalPreventScroll: {
            type: Boolean,
            default: undefined,
            kComposite: 'modal.preventScroll'
        }
    }
};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        positionTop: {
            type: [Number, String],
            default: undefined,
            kComposite: 'position.top'
        },
        positionLeft: {
            type: [Number, String],
            default: undefined,
            kComposite: 'position.left'
        }
    }
};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        titleText: {
            type: String,
            default: undefined,
            kComposite: 'title.text'
        },
        titleEncoded: {
            type: Boolean,
            default: undefined,
            kComposite: 'title.encoded'
        }
    }
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KendoWindow = __webpack_require__(135);

var _KendoWindow2 = _interopRequireDefault(_KendoWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KendoWindowInstaller = function () {
    function KendoWindowInstaller() {
        _classCallCheck(this, KendoWindowInstaller);
    }

    _createClass(KendoWindowInstaller, null, [{
        key: 'install',
        value: function install(Vue) {
            Vue.component(_KendoWindow2.default.name, _KendoWindow2.default);
        }
    }]);

    return KendoWindowInstaller;
}();

exports.default = KendoWindowInstaller;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoWindowInstaller);
}

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// kendo-all-vue-wrapper.min.js